import React from "react";

const NoSystemAccessIcon = () => (
  <span>
    <svg width="339.255" height="219.255" viewBox="0 0 339.255 219.255">
      <defs>
        <clipPath id="clipPath">
          <path
            id="Pipes"
            d="M44.88,136.48h8.56a10.83,10.83,0,0,0,10.82-10.82V7.87H59.7v117.8a6.25,6.25,0,0,1-6.24,6.25H3v4.56H40.3V197.7h4.56v-6.64h257a10.81,10.81,0,0,0,10.82-10.81c0-42.77,0-172.58,0-172.58H308V180.26a6.24,6.24,0,0,1-6.24,6.24H44.88Z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_17416" data-name="Group 17416" transform="translate(-478 -90.745)">
        <g id="CCRO_System_Icon-01" data-name="CCRO System Icon-01" transform="translate(478 106)">
          <rect id="Margin" width="319.73" height="204" transform="translate(0.27)" fill="none" />
          <g id="Icon">
            <g id="Group_14564" data-name="Group 14564" clipPath="url(#clipPath)">
              <g id="Dots">
                <circle
                  id="Ellipse_57800"
                  data-name="Ellipse 57800"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(84.03 154.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57801"
                  data-name="Ellipse 57801"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(84.03 148.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57802"
                  data-name="Ellipse 57802"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.69 151.75)"
                  fill="#969696"
                />
                <circle id="Ellipse_57803" data-name="Ellipse 57803" cx="0.56" cy="0.56" r="0.56" transform="translate(87.1 148.34)" fill="#969696" />
                <circle
                  id="Ellipse_57804"
                  data-name="Ellipse 57804"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.89 146.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57805"
                  data-name="Ellipse 57805"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.89 141.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57806"
                  data-name="Ellipse 57806"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.55 144.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57807"
                  data-name="Ellipse 57807"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(88.96 140.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57808"
                  data-name="Ellipse 57808"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.59 152.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57809"
                  data-name="Ellipse 57809"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.59 146.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57810"
                  data-name="Ellipse 57810"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.25 149.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57811"
                  data-name="Ellipse 57811"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(92.66 146.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57812"
                  data-name="Ellipse 57812"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.62 142.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57813"
                  data-name="Ellipse 57813"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.62 136.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57814"
                  data-name="Ellipse 57814"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.29 139.45)"
                  fill="#969696"
                />
                <circle id="Ellipse_57815" data-name="Ellipse 57815" cx="0.56" cy="0.56" r="0.56" transform="translate(94.7 136.04)" fill="#969696" />
                <circle
                  id="Ellipse_57816"
                  data-name="Ellipse 57816"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(95.53 150.12)"
                  fill="#969696"
                />
                <circle id="Ellipse_57817" data-name="Ellipse 57817" cx="0.56" cy="0.56" r="0.56" transform="translate(95.53 144.5)" fill="#969696" />
                <circle id="Ellipse_57818" data-name="Ellipse 57818" cx="0.56" cy="0.56" r="0.56" transform="translate(97.2 147.51)" fill="#969696" />
                <circle id="Ellipse_57819" data-name="Ellipse 57819" cx="0.56" cy="0.56" r="0.56" transform="translate(98.61 144.1)" fill="#969696" />
                <circle
                  id="Ellipse_57820"
                  data-name="Ellipse 57820"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(97.58 139.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57821"
                  data-name="Ellipse 57821"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(97.58 134.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57822"
                  data-name="Ellipse 57822"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(99.25 137.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57823"
                  data-name="Ellipse 57823"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.66 133.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57824"
                  data-name="Ellipse 57824"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(99.44 132.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57825"
                  data-name="Ellipse 57825"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(99.44 126.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57826"
                  data-name="Ellipse 57826"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.1 129.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57827"
                  data-name="Ellipse 57827"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.51 126.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57828"
                  data-name="Ellipse 57828"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.14 137.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57829"
                  data-name="Ellipse 57829"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.14 131.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57830"
                  data-name="Ellipse 57830"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.8 134.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57831"
                  data-name="Ellipse 57831"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.21 131.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57832"
                  data-name="Ellipse 57832"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.17 127.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57833"
                  data-name="Ellipse 57833"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.17 121.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57834"
                  data-name="Ellipse 57834"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.84 124.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57835"
                  data-name="Ellipse 57835"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.25 121.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57836"
                  data-name="Ellipse 57836"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.08 135.62)"
                  fill="#969696"
                />
                <circle id="Ellipse_57837" data-name="Ellipse 57837" cx="0.56" cy="0.56" r="0.56" transform="translate(109.08 130)" fill="#969696" />
                <circle
                  id="Ellipse_57838"
                  data-name="Ellipse 57838"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.75 133.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57839"
                  data-name="Ellipse 57839"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.16 129.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57840"
                  data-name="Ellipse 57840"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.69 157.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57841"
                  data-name="Ellipse 57841"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.69 151.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57842"
                  data-name="Ellipse 57842"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.36 154.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57843"
                  data-name="Ellipse 57843"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.77 151.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57844"
                  data-name="Ellipse 57844"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.55 149.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57845"
                  data-name="Ellipse 57845"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.55 143.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57846"
                  data-name="Ellipse 57846"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.21 146.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57847"
                  data-name="Ellipse 57847"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.62 143.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57848"
                  data-name="Ellipse 57848"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.25 154.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57849"
                  data-name="Ellipse 57849"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.25 149.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57850"
                  data-name="Ellipse 57850"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.91 152.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57851"
                  data-name="Ellipse 57851"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.32 148.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57852"
                  data-name="Ellipse 57852"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.28 144.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57853"
                  data-name="Ellipse 57853"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.28 139.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57854"
                  data-name="Ellipse 57854"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.95 142.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57855"
                  data-name="Ellipse 57855"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.36 138.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57856"
                  data-name="Ellipse 57856"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.19 153.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57857"
                  data-name="Ellipse 57857"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.19 147.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57858"
                  data-name="Ellipse 57858"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.86 150.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57859"
                  data-name="Ellipse 57859"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.27 147.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57860"
                  data-name="Ellipse 57860"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.85 144.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57861"
                  data-name="Ellipse 57861"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.85 138.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57862"
                  data-name="Ellipse 57862"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.52 141.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57863"
                  data-name="Ellipse 57863"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.93 138.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57864"
                  data-name="Ellipse 57864"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.71 136.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57865"
                  data-name="Ellipse 57865"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.71 130.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57866"
                  data-name="Ellipse 57866"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.38 133.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57867"
                  data-name="Ellipse 57867"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.79 130.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57868"
                  data-name="Ellipse 57868"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.41 141.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57869"
                  data-name="Ellipse 57869"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.41 136.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57870"
                  data-name="Ellipse 57870"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.08 139.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57871"
                  data-name="Ellipse 57871"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.49 135.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57872"
                  data-name="Ellipse 57872"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.45 131.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57873"
                  data-name="Ellipse 57873"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.45 126.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57874"
                  data-name="Ellipse 57874"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.11 129.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57875"
                  data-name="Ellipse 57875"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.52 125.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57876"
                  data-name="Ellipse 57876"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.35 139.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57877"
                  data-name="Ellipse 57877"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.35 134.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57878"
                  data-name="Ellipse 57878"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.02 137.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57879"
                  data-name="Ellipse 57879"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.43 133.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57880"
                  data-name="Ellipse 57880"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.73 122.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57881"
                  data-name="Ellipse 57881"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.73 117.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57882"
                  data-name="Ellipse 57882"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.39 120.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_57883" data-name="Ellipse 57883" cx="0.56" cy="0.56" r="0.56" transform="translate(99.8 116.84)" fill="#969696" />
                <circle
                  id="Ellipse_57884"
                  data-name="Ellipse 57884"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.59 115.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57885"
                  data-name="Ellipse 57885"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.59 109.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57886"
                  data-name="Ellipse 57886"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.25 112.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57887"
                  data-name="Ellipse 57887"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.66 109.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57888"
                  data-name="Ellipse 57888"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.29 120.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57889"
                  data-name="Ellipse 57889"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.29 114.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57890"
                  data-name="Ellipse 57890"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.95 117.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57891"
                  data-name="Ellipse 57891"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.36 114.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57892"
                  data-name="Ellipse 57892"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.32 110.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57893"
                  data-name="Ellipse 57893"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.32 104.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57894"
                  data-name="Ellipse 57894"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.99 107.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57895"
                  data-name="Ellipse 57895"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.4 104.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57896"
                  data-name="Ellipse 57896"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.23 118.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57897"
                  data-name="Ellipse 57897"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.23 112.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_57898" data-name="Ellipse 57898" cx="0.56" cy="0.56" r="0.56" transform="translate(109.89 116)" fill="#969696" />
                <circle
                  id="Ellipse_57899"
                  data-name="Ellipse 57899"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.3 112.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57900"
                  data-name="Ellipse 57900"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.28 108.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57901"
                  data-name="Ellipse 57901"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.28 102.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57902"
                  data-name="Ellipse 57902"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.94 105.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57903"
                  data-name="Ellipse 57903"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.35 102.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57904"
                  data-name="Ellipse 57904"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.14 100.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57905"
                  data-name="Ellipse 57905"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.14 95.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_57906" data-name="Ellipse 57906" cx="0.56" cy="0.56" r="0.56" transform="translate(113.8 98.03)" fill="#969696" />
                <circle
                  id="Ellipse_57907"
                  data-name="Ellipse 57907"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.21 94.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57908"
                  data-name="Ellipse 57908"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.84 106.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57909"
                  data-name="Ellipse 57909"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.84 100.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57910"
                  data-name="Ellipse 57910"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.5 103.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57911"
                  data-name="Ellipse 57911"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.91 100.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57912"
                  data-name="Ellipse 57912"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.87 96.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57913"
                  data-name="Ellipse 57913"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.87 90.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57914"
                  data-name="Ellipse 57914"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.54 93.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57915"
                  data-name="Ellipse 57915"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.95 90.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57916"
                  data-name="Ellipse 57916"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.78 104.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57917"
                  data-name="Ellipse 57917"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.78 98.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57918"
                  data-name="Ellipse 57918"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.45 101.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57919"
                  data-name="Ellipse 57919"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.86 98.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57920"
                  data-name="Ellipse 57920"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.39 125.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57921"
                  data-name="Ellipse 57921"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.39 120.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57922"
                  data-name="Ellipse 57922"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.06 123.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57923"
                  data-name="Ellipse 57923"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.47 119.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57924"
                  data-name="Ellipse 57924"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.25 118.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57925"
                  data-name="Ellipse 57925"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.25 112.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57926"
                  data-name="Ellipse 57926"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.91 115.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57927"
                  data-name="Ellipse 57927"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.32 112.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57928"
                  data-name="Ellipse 57928"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.95 123.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57929"
                  data-name="Ellipse 57929"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.95 117.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57930"
                  data-name="Ellipse 57930"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.61 120.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57931"
                  data-name="Ellipse 57931"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.02 117.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57932"
                  data-name="Ellipse 57932"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.98 113.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57933"
                  data-name="Ellipse 57933"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.98 107.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57934"
                  data-name="Ellipse 57934"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.65 110.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57935"
                  data-name="Ellipse 57935"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.06 107.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57936"
                  data-name="Ellipse 57936"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.89 121.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57937"
                  data-name="Ellipse 57937"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.89 115.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57938"
                  data-name="Ellipse 57938"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.56 118.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57939"
                  data-name="Ellipse 57939"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.97 115.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57940"
                  data-name="Ellipse 57940"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.55 112.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57941"
                  data-name="Ellipse 57941"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.55 106.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57942"
                  data-name="Ellipse 57942"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.22 109.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57943"
                  data-name="Ellipse 57943"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.63 106.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57944"
                  data-name="Ellipse 57944"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.41 104.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57945"
                  data-name="Ellipse 57945"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.41 99.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57946"
                  data-name="Ellipse 57946"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.08 102.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57947"
                  data-name="Ellipse 57947"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.49 98.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57948"
                  data-name="Ellipse 57948"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.11 110.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57949"
                  data-name="Ellipse 57949"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.11 104.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57950"
                  data-name="Ellipse 57950"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.78 107.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57951"
                  data-name="Ellipse 57951"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.19 104.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57952"
                  data-name="Ellipse 57952"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.15 100.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57953"
                  data-name="Ellipse 57953"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.15 94.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57954"
                  data-name="Ellipse 57954"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.81 97.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57955"
                  data-name="Ellipse 57955"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.22 94.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57956"
                  data-name="Ellipse 57956"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.05 108.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57957"
                  data-name="Ellipse 57957"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.05 102.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57958"
                  data-name="Ellipse 57958"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.72 105.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57959"
                  data-name="Ellipse 57959"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.13 102.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57960"
                  data-name="Ellipse 57960"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.04 130.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57961"
                  data-name="Ellipse 57961"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.04 124.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57962"
                  data-name="Ellipse 57962"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.71 127.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_57963" data-name="Ellipse 57963" cx="0.56" cy="0.56" r="0.56" transform="translate(133.12 124)" fill="#969696" />
                <circle id="Ellipse_57964" data-name="Ellipse 57964" cx="0.56" cy="0.56" r="0.56" transform="translate(131.9 122.3)" fill="#969696" />
                <circle
                  id="Ellipse_57965"
                  data-name="Ellipse 57965"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.9 116.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57966"
                  data-name="Ellipse 57966"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.57 119.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57967"
                  data-name="Ellipse 57967"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.98 116.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57968"
                  data-name="Ellipse 57968"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.6 127.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57969"
                  data-name="Ellipse 57969"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.6 122.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57970"
                  data-name="Ellipse 57970"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.27 125.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57971"
                  data-name="Ellipse 57971"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.68 121.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57972"
                  data-name="Ellipse 57972"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.64 117.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57973"
                  data-name="Ellipse 57973"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.64 112.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57974"
                  data-name="Ellipse 57974"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.3 115.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57975"
                  data-name="Ellipse 57975"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.71 111.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57976"
                  data-name="Ellipse 57976"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.54 125.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57977"
                  data-name="Ellipse 57977"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.54 120.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57978"
                  data-name="Ellipse 57978"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.21 123.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57979"
                  data-name="Ellipse 57979"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.62 119.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57980"
                  data-name="Ellipse 57980"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.6 115.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_57981" data-name="Ellipse 57981" cx="0.56" cy="0.56" r="0.56" transform="translate(143.6 109.9)" fill="#969696" />
                <circle
                  id="Ellipse_57982"
                  data-name="Ellipse 57982"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.26 112.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57983"
                  data-name="Ellipse 57983"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.67 109.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57984"
                  data-name="Ellipse 57984"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.45 107.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57985"
                  data-name="Ellipse 57985"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.45 102.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57986"
                  data-name="Ellipse 57986"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.12 105.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57987"
                  data-name="Ellipse 57987"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.53 101.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57988"
                  data-name="Ellipse 57988"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.15 113.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57989"
                  data-name="Ellipse 57989"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.15 107.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57990"
                  data-name="Ellipse 57990"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.82 110.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57991"
                  data-name="Ellipse 57991"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.23 107.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57992"
                  data-name="Ellipse 57992"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.19 103.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57993"
                  data-name="Ellipse 57993"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.19 97.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57994"
                  data-name="Ellipse 57994"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.86 100.61)"
                  fill="#969696"
                />
                <path
                  id="Path_12315"
                  data-name="Path 12315"
                  d="M154.27,97.75a.56.56,0,1,0,1.11,0,.55.55,0,0,0-.48-.54.56.56,0,1,0-.66-.54.55.55,0,0,0,.48.54A.55.55,0,0,0,154.27,97.75Z"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57995"
                  data-name="Ellipse 57995"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.1 111.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57996"
                  data-name="Ellipse 57996"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.1 105.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57997"
                  data-name="Ellipse 57997"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.76 108.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57998"
                  data-name="Ellipse 57998"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.17 105.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_57999"
                  data-name="Ellipse 57999"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.71 132.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58000"
                  data-name="Ellipse 58000"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.71 127.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58001"
                  data-name="Ellipse 58001"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.37 130.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58002"
                  data-name="Ellipse 58002"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.78 126.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58003"
                  data-name="Ellipse 58003"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.56 125.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58004"
                  data-name="Ellipse 58004"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.56 119.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58005"
                  data-name="Ellipse 58005"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.23 122.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58006"
                  data-name="Ellipse 58006"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.64 119.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58007"
                  data-name="Ellipse 58007"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.26 130.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58008"
                  data-name="Ellipse 58008"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.26 125.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58009"
                  data-name="Ellipse 58009"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.93 128.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58010"
                  data-name="Ellipse 58010"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.34 124.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58011"
                  data-name="Ellipse 58011"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.3 120.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58012"
                  data-name="Ellipse 58012"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.3 115.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58013"
                  data-name="Ellipse 58013"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.97 118.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58014"
                  data-name="Ellipse 58014"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.38 114.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58015"
                  data-name="Ellipse 58015"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.21 128.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58016"
                  data-name="Ellipse 58016"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.21 123.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58017"
                  data-name="Ellipse 58017"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.87 126.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58018"
                  data-name="Ellipse 58018"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.28 122.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58019"
                  data-name="Ellipse 58019"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.87 119.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58020"
                  data-name="Ellipse 58020"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.87 114.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58021"
                  data-name="Ellipse 58021"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.54 117.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58022"
                  data-name="Ellipse 58022"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.95 113.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58023"
                  data-name="Ellipse 58023"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.73 112.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58024"
                  data-name="Ellipse 58024"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.73 106.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58025"
                  data-name="Ellipse 58025"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.4 109.42)"
                  fill="#969696"
                />
                <circle id="Ellipse_58026" data-name="Ellipse 58026" cx="0.56" cy="0.56" r="0.56" transform="translate(165.81 106)" fill="#969696" />
                <circle
                  id="Ellipse_58027"
                  data-name="Ellipse 58027"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.43 117.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58028"
                  data-name="Ellipse 58028"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.43 111.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58029"
                  data-name="Ellipse 58029"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.09 114.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58030"
                  data-name="Ellipse 58030"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.5 111.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58031"
                  data-name="Ellipse 58031"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.46 107.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58032"
                  data-name="Ellipse 58032"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.46 101.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58033"
                  data-name="Ellipse 58033"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.13 104.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58034"
                  data-name="Ellipse 58034"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.54 101.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58035"
                  data-name="Ellipse 58035"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.37 115.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58036"
                  data-name="Ellipse 58036"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.37 109.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58037"
                  data-name="Ellipse 58037"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.04 112.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58038"
                  data-name="Ellipse 58038"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.45 109.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58039"
                  data-name="Ellipse 58039"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.52 163.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58040"
                  data-name="Ellipse 58040"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.52 157.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58041"
                  data-name="Ellipse 58041"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.18 160.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58042"
                  data-name="Ellipse 58042"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.59 157.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58043"
                  data-name="Ellipse 58043"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.38 155.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58044"
                  data-name="Ellipse 58044"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.38 150.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58045"
                  data-name="Ellipse 58045"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.04 153.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58046"
                  data-name="Ellipse 58046"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.45 149.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58047"
                  data-name="Ellipse 58047"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.08 161.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58048"
                  data-name="Ellipse 58048"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.08 155.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58049"
                  data-name="Ellipse 58049"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.74 158.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58050"
                  data-name="Ellipse 58050"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.15 155.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58051"
                  data-name="Ellipse 58051"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.11 151.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58052"
                  data-name="Ellipse 58052"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.11 145.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58053"
                  data-name="Ellipse 58053"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.78 148.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58054"
                  data-name="Ellipse 58054"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.19 145.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58055"
                  data-name="Ellipse 58055"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.02 159.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58056"
                  data-name="Ellipse 58056"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.02 153.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58057"
                  data-name="Ellipse 58057"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.68 156.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58058"
                  data-name="Ellipse 58058"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.09 153.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58059"
                  data-name="Ellipse 58059"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.07 149.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58060"
                  data-name="Ellipse 58060"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.07 143.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58061"
                  data-name="Ellipse 58061"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.74 146.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58062"
                  data-name="Ellipse 58062"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.15 142.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58063"
                  data-name="Ellipse 58063"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.93 141.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58064"
                  data-name="Ellipse 58064"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.93 135.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58065"
                  data-name="Ellipse 58065"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.59 138.68)"
                  fill="#969696"
                />
                <circle id="Ellipse_58066" data-name="Ellipse 58066" cx="0.56" cy="0.56" r="0.56" transform="translate(135 135.27)" fill="#969696" />
                <circle
                  id="Ellipse_58067"
                  data-name="Ellipse 58067"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.63 146.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58068"
                  data-name="Ellipse 58068"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.63 141.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58069"
                  data-name="Ellipse 58069"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.29 144.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_58070" data-name="Ellipse 58070" cx="0.56" cy="0.56" r="0.56" transform="translate(138.7 140.7)" fill="#969696" />
                <circle
                  id="Ellipse_58071"
                  data-name="Ellipse 58071"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.66 136.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58072"
                  data-name="Ellipse 58072"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.66 131.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58073"
                  data-name="Ellipse 58073"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.33 134.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58074"
                  data-name="Ellipse 58074"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.74 130.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58075"
                  data-name="Ellipse 58075"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.57 144.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58076"
                  data-name="Ellipse 58076"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.57 139.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58077"
                  data-name="Ellipse 58077"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.24 142.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58078"
                  data-name="Ellipse 58078"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.65 138.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58079"
                  data-name="Ellipse 58079"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.18 166.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58080"
                  data-name="Ellipse 58080"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.18 160.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58081"
                  data-name="Ellipse 58081"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.85 163.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58082"
                  data-name="Ellipse 58082"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.26 160.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58083"
                  data-name="Ellipse 58083"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.04 158.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58084"
                  data-name="Ellipse 58084"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.04 153.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_58085" data-name="Ellipse 58085" cx="0.56" cy="0.56" r="0.56" transform="translate(136.7 156.1)" fill="#969696" />
                <circle
                  id="Ellipse_58086"
                  data-name="Ellipse 58086"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.11 152.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58087"
                  data-name="Ellipse 58087"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.74 164.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58088"
                  data-name="Ellipse 58088"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.74 158.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58089"
                  data-name="Ellipse 58089"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.4 161.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58090"
                  data-name="Ellipse 58090"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.81 158.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58091"
                  data-name="Ellipse 58091"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.77 154.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58092"
                  data-name="Ellipse 58092"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.77 148.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58093"
                  data-name="Ellipse 58093"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.44 151.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58094"
                  data-name="Ellipse 58094"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.85 148.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58095"
                  data-name="Ellipse 58095"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.68 162.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58096"
                  data-name="Ellipse 58096"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.68 156.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58097"
                  data-name="Ellipse 58097"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.35 159.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58098"
                  data-name="Ellipse 58098"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.76 156.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58099"
                  data-name="Ellipse 58099"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.34 153.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58100"
                  data-name="Ellipse 58100"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.34 147.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58101"
                  data-name="Ellipse 58101"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.01 150.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58102"
                  data-name="Ellipse 58102"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.42 147.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58103"
                  data-name="Ellipse 58103"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.2 145.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_58104" data-name="Ellipse 58104" cx="0.56" cy="0.56" r="0.56" transform="translate(149.2 139.9)" fill="#969696" />
                <circle
                  id="Ellipse_58105"
                  data-name="Ellipse 58105"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.87 142.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58106"
                  data-name="Ellipse 58106"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.28 139.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58107"
                  data-name="Ellipse 58107"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.9 150.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58108"
                  data-name="Ellipse 58108"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.9 145.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58109"
                  data-name="Ellipse 58109"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.57 148.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58110"
                  data-name="Ellipse 58110"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.98 144.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58111"
                  data-name="Ellipse 58111"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.94 140.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58112"
                  data-name="Ellipse 58112"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.94 135.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58113"
                  data-name="Ellipse 58113"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.6 138.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58114"
                  data-name="Ellipse 58114"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.01 134.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_58115" data-name="Ellipse 58115" cx="0.56" cy="0.56" r="0.56" transform="translate(158.84 149)" fill="#969696" />
                <circle
                  id="Ellipse_58116"
                  data-name="Ellipse 58116"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.84 143.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58117"
                  data-name="Ellipse 58117"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.51 146.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58118"
                  data-name="Ellipse 58118"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.92 142.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58119"
                  data-name="Ellipse 58119"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.76 169.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58120"
                  data-name="Ellipse 58120"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.76 164.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58121"
                  data-name="Ellipse 58121"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.43 167.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58122"
                  data-name="Ellipse 58122"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.84 163.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58123"
                  data-name="Ellipse 58123"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.62 162.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58124"
                  data-name="Ellipse 58124"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.62 156.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58125"
                  data-name="Ellipse 58125"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.28 159.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58126"
                  data-name="Ellipse 58126"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.69 156.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58127"
                  data-name="Ellipse 58127"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.32 167.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58128"
                  data-name="Ellipse 58128"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.32 161.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58129"
                  data-name="Ellipse 58129"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.98 164.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58130"
                  data-name="Ellipse 58130"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.39 161.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58131"
                  data-name="Ellipse 58131"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.35 157.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58132"
                  data-name="Ellipse 58132"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.35 151.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58133"
                  data-name="Ellipse 58133"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.02 154.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58134"
                  data-name="Ellipse 58134"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.43 151.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58135"
                  data-name="Ellipse 58135"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.26 165.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58136"
                  data-name="Ellipse 58136"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.26 160.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58137"
                  data-name="Ellipse 58137"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.93 163.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58138"
                  data-name="Ellipse 58138"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.34 159.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58139"
                  data-name="Ellipse 58139"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.31 155.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58140"
                  data-name="Ellipse 58140"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.31 149.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58141"
                  data-name="Ellipse 58141"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.98 152.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58142"
                  data-name="Ellipse 58142"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.39 149.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58143"
                  data-name="Ellipse 58143"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.17 147.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58144"
                  data-name="Ellipse 58144"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.17 142.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58145"
                  data-name="Ellipse 58145"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.84 145.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58146"
                  data-name="Ellipse 58146"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.25 141.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58147"
                  data-name="Ellipse 58147"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.87 153.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58148"
                  data-name="Ellipse 58148"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.87 147.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58149"
                  data-name="Ellipse 58149"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.54 150.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58150"
                  data-name="Ellipse 58150"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.95 147.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58151"
                  data-name="Ellipse 58151"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.9 143.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58152"
                  data-name="Ellipse 58152"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.9 137.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58153"
                  data-name="Ellipse 58153"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.57 140.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58154"
                  data-name="Ellipse 58154"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.98 137.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58155"
                  data-name="Ellipse 58155"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.81 151.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58156"
                  data-name="Ellipse 58156"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.81 145.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58157"
                  data-name="Ellipse 58157"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.48 148.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58158"
                  data-name="Ellipse 58158"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.89 145.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58159"
                  data-name="Ellipse 58159"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.42 172.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58160"
                  data-name="Ellipse 58160"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.42 167.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58161"
                  data-name="Ellipse 58161"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.09 170.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58162"
                  data-name="Ellipse 58162"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.5 166.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58163"
                  data-name="Ellipse 58163"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.28 165.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58164"
                  data-name="Ellipse 58164"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.28 159.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58165"
                  data-name="Ellipse 58165"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.95 162.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58166"
                  data-name="Ellipse 58166"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.36 159.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58167"
                  data-name="Ellipse 58167"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.98 170.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58168"
                  data-name="Ellipse 58168"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.98 164.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58169"
                  data-name="Ellipse 58169"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.65 167.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58170"
                  data-name="Ellipse 58170"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.06 164.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58171"
                  data-name="Ellipse 58171"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.02 160.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58172"
                  data-name="Ellipse 58172"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.02 154.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58173"
                  data-name="Ellipse 58173"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.68 157.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58174"
                  data-name="Ellipse 58174"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.09 154.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58175"
                  data-name="Ellipse 58175"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.92 168.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58176"
                  data-name="Ellipse 58176"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.92 162.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58177"
                  data-name="Ellipse 58177"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.59 165.95)"
                  fill="#969696"
                />
                <circle id="Ellipse_58178" data-name="Ellipse 58178" cx="0.56" cy="0.56" r="0.56" transform="translate(182 162.53)" fill="#969696" />
                <circle
                  id="Ellipse_58179"
                  data-name="Ellipse 58179"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.59 159.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58180"
                  data-name="Ellipse 58180"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.59 153.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58181"
                  data-name="Ellipse 58181"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.25 157.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58182"
                  data-name="Ellipse 58182"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.66 153.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58183"
                  data-name="Ellipse 58183"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.44 151.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58184"
                  data-name="Ellipse 58184"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.44 146.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58185"
                  data-name="Ellipse 58185"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.11 149.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58186"
                  data-name="Ellipse 58186"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.52 145.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58187"
                  data-name="Ellipse 58187"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.14 157.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58188"
                  data-name="Ellipse 58188"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.14 151.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58189"
                  data-name="Ellipse 58189"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.81 154.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58190"
                  data-name="Ellipse 58190"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.22 151.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58191"
                  data-name="Ellipse 58191"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.18 147.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58192"
                  data-name="Ellipse 58192"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.18 141.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58193"
                  data-name="Ellipse 58193"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.85 144.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58194"
                  data-name="Ellipse 58194"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.26 141.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58195"
                  data-name="Ellipse 58195"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.09 155.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58196"
                  data-name="Ellipse 58196"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.09 149.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58197"
                  data-name="Ellipse 58197"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.75 152.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58198"
                  data-name="Ellipse 58198"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.16 149.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58199"
                  data-name="Ellipse 58199"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.46 138.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58200"
                  data-name="Ellipse 58200"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.46 132.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58201"
                  data-name="Ellipse 58201"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.13 135.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58202"
                  data-name="Ellipse 58202"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.54 132.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58203"
                  data-name="Ellipse 58203"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.32 130.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58204"
                  data-name="Ellipse 58204"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.32 125.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58205"
                  data-name="Ellipse 58205"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.98 128.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58206"
                  data-name="Ellipse 58206"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.39 124.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58207"
                  data-name="Ellipse 58207"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.02 136.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58208"
                  data-name="Ellipse 58208"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.02 130.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58209"
                  data-name="Ellipse 58209"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.68 133.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58210"
                  data-name="Ellipse 58210"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.09 130.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58211"
                  data-name="Ellipse 58211"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.05 126.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58212"
                  data-name="Ellipse 58212"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.05 120.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58213"
                  data-name="Ellipse 58213"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.72 123.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58214"
                  data-name="Ellipse 58214"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.13 120.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58215"
                  data-name="Ellipse 58215"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.96 134.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58216"
                  data-name="Ellipse 58216"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.96 128.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58217"
                  data-name="Ellipse 58217"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.63 131.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58218"
                  data-name="Ellipse 58218"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.04 128.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58219"
                  data-name="Ellipse 58219"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.01 123.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58220"
                  data-name="Ellipse 58220"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.01 118.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58221"
                  data-name="Ellipse 58221"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.68 121.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58222"
                  data-name="Ellipse 58222"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.09 117.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58223"
                  data-name="Ellipse 58223"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.87 116.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58224"
                  data-name="Ellipse 58224"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.87 110.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58225"
                  data-name="Ellipse 58225"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.54 113.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58226"
                  data-name="Ellipse 58226"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.94 110.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58227"
                  data-name="Ellipse 58227"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.57 121.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58228"
                  data-name="Ellipse 58228"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.57 115.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58229"
                  data-name="Ellipse 58229"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.23 118.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58230"
                  data-name="Ellipse 58230"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.64 115.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58231"
                  data-name="Ellipse 58231"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.6 111.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58232"
                  data-name="Ellipse 58232"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.6 105.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58233"
                  data-name="Ellipse 58233"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.27 108.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58234"
                  data-name="Ellipse 58234"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.68 105.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58235"
                  data-name="Ellipse 58235"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.51 119.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58236"
                  data-name="Ellipse 58236"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.51 114.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58237"
                  data-name="Ellipse 58237"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.18 117.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58238"
                  data-name="Ellipse 58238"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.59 113.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58239"
                  data-name="Ellipse 58239"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.12 141.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58240"
                  data-name="Ellipse 58240"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.12 135.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58241"
                  data-name="Ellipse 58241"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.79 138.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58242"
                  data-name="Ellipse 58242"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.2 135.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58243"
                  data-name="Ellipse 58243"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.98 133.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58244"
                  data-name="Ellipse 58244"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.98 127.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58245"
                  data-name="Ellipse 58245"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.65 130.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58246"
                  data-name="Ellipse 58246"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.06 127.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58247"
                  data-name="Ellipse 58247"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.68 139.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58248"
                  data-name="Ellipse 58248"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.68 133.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58249"
                  data-name="Ellipse 58249"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.35 136.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58250"
                  data-name="Ellipse 58250"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.76 132.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_58251" data-name="Ellipse 58251" cx="0.56" cy="0.56" r="0.56" transform="translate(187.71 129)" fill="#969696" />
                <circle
                  id="Ellipse_58252"
                  data-name="Ellipse 58252"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.71 123.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58253"
                  data-name="Ellipse 58253"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.38 126.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58254"
                  data-name="Ellipse 58254"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.79 122.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58255"
                  data-name="Ellipse 58255"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.62 137.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58256"
                  data-name="Ellipse 58256"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.62 131.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58257"
                  data-name="Ellipse 58257"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.29 134.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58258"
                  data-name="Ellipse 58258"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.7 131.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58259"
                  data-name="Ellipse 58259"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.28 128.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58260"
                  data-name="Ellipse 58260"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.28 122.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58261"
                  data-name="Ellipse 58261"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.95 125.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58262"
                  data-name="Ellipse 58262"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.36 122.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58263"
                  data-name="Ellipse 58263"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.14 120.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58264"
                  data-name="Ellipse 58264"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.14 114.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58265"
                  data-name="Ellipse 58265"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.81 117.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58266"
                  data-name="Ellipse 58266"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.22 114.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58267"
                  data-name="Ellipse 58267"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.84 125.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58268"
                  data-name="Ellipse 58268"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.84 120.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58269"
                  data-name="Ellipse 58269"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.51 123.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58270"
                  data-name="Ellipse 58270"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.92 119.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58271"
                  data-name="Ellipse 58271"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.88 115.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58272"
                  data-name="Ellipse 58272"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.88 110.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58273"
                  data-name="Ellipse 58273"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.54 113.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58274"
                  data-name="Ellipse 58274"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.95 109.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58275"
                  data-name="Ellipse 58275"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.79 123.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58276"
                  data-name="Ellipse 58276"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.79 118.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58277"
                  data-name="Ellipse 58277"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.45 121.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58278"
                  data-name="Ellipse 58278"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.78 145.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58279"
                  data-name="Ellipse 58279"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.78 139.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58280"
                  data-name="Ellipse 58280"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.44 142.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58281"
                  data-name="Ellipse 58281"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.85 139.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58282"
                  data-name="Ellipse 58282"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.63 137.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58283"
                  data-name="Ellipse 58283"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.63 132.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58284"
                  data-name="Ellipse 58284"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.3 135.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58285"
                  data-name="Ellipse 58285"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.71 131.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58286"
                  data-name="Ellipse 58286"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.33 143.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58287"
                  data-name="Ellipse 58287"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.33 137.63)"
                  fill="#969696"
                />
                <circle id="Ellipse_58288" data-name="Ellipse 58288" cx="0.56" cy="0.56" r="0.56" transform="translate(204 140.64)" fill="#969696" />
                <circle
                  id="Ellipse_58289"
                  data-name="Ellipse 58289"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.41 137.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58290"
                  data-name="Ellipse 58290"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.37 133.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58291"
                  data-name="Ellipse 58291"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.37 127.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58292"
                  data-name="Ellipse 58292"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.04 130.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58293"
                  data-name="Ellipse 58293"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.45 127.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58294"
                  data-name="Ellipse 58294"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.28 141.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58295"
                  data-name="Ellipse 58295"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.28 135.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58296"
                  data-name="Ellipse 58296"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.94 138.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58297"
                  data-name="Ellipse 58297"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.35 135.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58298"
                  data-name="Ellipse 58298"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.33 131.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58299"
                  data-name="Ellipse 58299"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.33 125.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58300"
                  data-name="Ellipse 58300"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.99 128.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58301"
                  data-name="Ellipse 58301"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.4 125.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58302"
                  data-name="Ellipse 58302"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.19 123.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58303"
                  data-name="Ellipse 58303"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.19 117.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58304"
                  data-name="Ellipse 58304"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.85 120.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58305"
                  data-name="Ellipse 58305"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.26 117.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58306"
                  data-name="Ellipse 58306"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.89 128.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58307"
                  data-name="Ellipse 58307"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.89 123.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58308"
                  data-name="Ellipse 58308"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.55 126.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58309"
                  data-name="Ellipse 58309"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.96 122.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58310"
                  data-name="Ellipse 58310"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.92 118.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58311"
                  data-name="Ellipse 58311"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.92 113.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58312"
                  data-name="Ellipse 58312"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.59 116.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58313"
                  data-name="Ellipse 58313"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.83 126.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58314"
                  data-name="Ellipse 58314"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.83 121.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58315"
                  data-name="Ellipse 58315"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.49 124.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58316"
                  data-name="Ellipse 58316"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.9 120.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58317"
                  data-name="Ellipse 58317"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.44 148.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58318"
                  data-name="Ellipse 58318"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.44 142.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58319"
                  data-name="Ellipse 58319"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.1 145.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58320"
                  data-name="Ellipse 58320"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.51 142.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58321"
                  data-name="Ellipse 58321"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.3 140.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58322"
                  data-name="Ellipse 58322"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.3 135.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58323"
                  data-name="Ellipse 58323"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.96 138.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58324"
                  data-name="Ellipse 58324"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.37 134.72)"
                  fill="#969696"
                />
                <circle id="Ellipse_58325" data-name="Ellipse 58325" cx="0.56" cy="0.56" r="0.56" transform="translate(219 146.17)" fill="#969696" />
                <circle id="Ellipse_58326" data-name="Ellipse 58326" cx="0.56" cy="0.56" r="0.56" transform="translate(219 140.55)" fill="#969696" />
                <circle
                  id="Ellipse_58327"
                  data-name="Ellipse 58327"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.66 143.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58328"
                  data-name="Ellipse 58328"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.07 140.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58329"
                  data-name="Ellipse 58329"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.03 136.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58330"
                  data-name="Ellipse 58330"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.03 130.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58331"
                  data-name="Ellipse 58331"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.7 133.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58332"
                  data-name="Ellipse 58332"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.11 130.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58333"
                  data-name="Ellipse 58333"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.94 144.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58334"
                  data-name="Ellipse 58334"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.94 138.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_58335" data-name="Ellipse 58335" cx="0.56" cy="0.56" r="0.56" transform="translate(226.6 141.6)" fill="#969696" />
                <circle
                  id="Ellipse_58336"
                  data-name="Ellipse 58336"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.01 138.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58337"
                  data-name="Ellipse 58337"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.6 135.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58338"
                  data-name="Ellipse 58338"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.6 129.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58339"
                  data-name="Ellipse 58339"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.27 132.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58340"
                  data-name="Ellipse 58340"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.68 129.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58341"
                  data-name="Ellipse 58341"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.46 127.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58342"
                  data-name="Ellipse 58342"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.46 121.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58343"
                  data-name="Ellipse 58343"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.13 124.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58344"
                  data-name="Ellipse 58344"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.54 121.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58345"
                  data-name="Ellipse 58345"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.16 132.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58346"
                  data-name="Ellipse 58346"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.16 127.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58347"
                  data-name="Ellipse 58347"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.83 130.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58348"
                  data-name="Ellipse 58348"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.24 126.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58349"
                  data-name="Ellipse 58349"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.2 122.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58350"
                  data-name="Ellipse 58350"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.2 117.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58351"
                  data-name="Ellipse 58351"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.86 120.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58352"
                  data-name="Ellipse 58352"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.27 116.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58353"
                  data-name="Ellipse 58353"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.1 131.03)"
                  fill="#969696"
                />
                <circle id="Ellipse_58354" data-name="Ellipse 58354" cx="0.56" cy="0.56" r="0.56" transform="translate(239.1 125.4)" fill="#969696" />
                <circle
                  id="Ellipse_58355"
                  data-name="Ellipse 58355"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.77 128.42)"
                  fill="#969696"
                />
                <circle id="Ellipse_58356" data-name="Ellipse 58356" cx="0.56" cy="0.56" r="0.56" transform="translate(242.18 125)" fill="#969696" />
                <circle
                  id="Ellipse_58357"
                  data-name="Ellipse 58357"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.25 179.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58358"
                  data-name="Ellipse 58358"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.25 173.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58359"
                  data-name="Ellipse 58359"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.92 176.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58360"
                  data-name="Ellipse 58360"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.33 173.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58361"
                  data-name="Ellipse 58361"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.11 171.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58362"
                  data-name="Ellipse 58362"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.11 165.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58363"
                  data-name="Ellipse 58363"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.77 168.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58364"
                  data-name="Ellipse 58364"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.18 165.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58365"
                  data-name="Ellipse 58365"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.81 176.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58366"
                  data-name="Ellipse 58366"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.81 171.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58367"
                  data-name="Ellipse 58367"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.47 174.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58368"
                  data-name="Ellipse 58368"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.88 170.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58369"
                  data-name="Ellipse 58369"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.84 166.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58370"
                  data-name="Ellipse 58370"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.84 161.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58371"
                  data-name="Ellipse 58371"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.51 164.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58372"
                  data-name="Ellipse 58372"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.92 160.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58373"
                  data-name="Ellipse 58373"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.75 174.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58374"
                  data-name="Ellipse 58374"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.75 169.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58375"
                  data-name="Ellipse 58375"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.42 172.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58376"
                  data-name="Ellipse 58376"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.83 168.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58377"
                  data-name="Ellipse 58377"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.8 164.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58378"
                  data-name="Ellipse 58378"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.8 158.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58379"
                  data-name="Ellipse 58379"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.47 161.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58380"
                  data-name="Ellipse 58380"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.88 158.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58381"
                  data-name="Ellipse 58381"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.66 156.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58382"
                  data-name="Ellipse 58382"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.66 151.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58383"
                  data-name="Ellipse 58383"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.33 154.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58384"
                  data-name="Ellipse 58384"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.74 150.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58385"
                  data-name="Ellipse 58385"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.36 162.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58386"
                  data-name="Ellipse 58386"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.36 156.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58387"
                  data-name="Ellipse 58387"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.03 159.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58388"
                  data-name="Ellipse 58388"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.44 156.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58389"
                  data-name="Ellipse 58389"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.39 152.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58390"
                  data-name="Ellipse 58390"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.39 146.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58391"
                  data-name="Ellipse 58391"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.06 149.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58392"
                  data-name="Ellipse 58392"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.47 146.21)"
                  fill="#969696"
                />
                <circle id="Ellipse_58393" data-name="Ellipse 58393" cx="0.56" cy="0.56" r="0.56" transform="translate(208.3 160.3)" fill="#969696" />
                <circle
                  id="Ellipse_58394"
                  data-name="Ellipse 58394"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.3 154.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58395"
                  data-name="Ellipse 58395"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.97 157.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58396"
                  data-name="Ellipse 58396"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.38 154.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58397"
                  data-name="Ellipse 58397"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.91 181.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58398"
                  data-name="Ellipse 58398"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.91 176.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58399"
                  data-name="Ellipse 58399"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.58 179.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58400"
                  data-name="Ellipse 58400"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.99 175.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58401"
                  data-name="Ellipse 58401"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.77 174.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58402"
                  data-name="Ellipse 58402"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.77 168.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58403"
                  data-name="Ellipse 58403"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.44 171.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58404"
                  data-name="Ellipse 58404"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.85 168.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58405"
                  data-name="Ellipse 58405"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.47 179.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58406"
                  data-name="Ellipse 58406"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.47 174.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58407"
                  data-name="Ellipse 58407"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.14 177.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58408"
                  data-name="Ellipse 58408"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.55 173.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58409"
                  data-name="Ellipse 58409"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.5 169.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58410"
                  data-name="Ellipse 58410"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.5 164.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58411"
                  data-name="Ellipse 58411"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.17 167.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58412"
                  data-name="Ellipse 58412"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.58 163.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58413"
                  data-name="Ellipse 58413"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.41 177.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58414"
                  data-name="Ellipse 58414"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.41 172.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58415"
                  data-name="Ellipse 58415"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.08 175.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58416"
                  data-name="Ellipse 58416"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.49 171.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58417"
                  data-name="Ellipse 58417"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.08 168.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58418"
                  data-name="Ellipse 58418"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.08 163.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58419"
                  data-name="Ellipse 58419"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.74 166.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58420"
                  data-name="Ellipse 58420"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.15 162.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58421"
                  data-name="Ellipse 58421"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.93 161.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58422"
                  data-name="Ellipse 58422"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.93 155.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58423"
                  data-name="Ellipse 58423"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.6 158.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58424"
                  data-name="Ellipse 58424"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.01 155.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58425"
                  data-name="Ellipse 58425"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.63 166.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58426"
                  data-name="Ellipse 58426"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.63 160.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58427"
                  data-name="Ellipse 58427"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.3 163.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58428"
                  data-name="Ellipse 58428"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.71 160.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58429"
                  data-name="Ellipse 58429"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.67 156.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58430"
                  data-name="Ellipse 58430"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.67 150.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58431"
                  data-name="Ellipse 58431"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.34 153.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58432"
                  data-name="Ellipse 58432"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.75 150.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58433"
                  data-name="Ellipse 58433"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.58 164.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58434"
                  data-name="Ellipse 58434"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.58 158.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58435"
                  data-name="Ellipse 58435"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.24 161.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58436"
                  data-name="Ellipse 58436"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.65 158.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58437"
                  data-name="Ellipse 58437"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.5 107.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58438"
                  data-name="Ellipse 58438"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.5 102.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58439"
                  data-name="Ellipse 58439"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.17 105.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58440"
                  data-name="Ellipse 58440"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.58 101.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58441"
                  data-name="Ellipse 58441"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.36 100.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_58442" data-name="Ellipse 58442" cx="0.56" cy="0.56" r="0.56" transform="translate(178.36 94.4)" fill="#969696" />
                <circle
                  id="Ellipse_58443"
                  data-name="Ellipse 58443"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.03 97.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_58444" data-name="Ellipse 58444" cx="0.56" cy="0.56" r="0.56" transform="translate(181.44 94)" fill="#969696" />
                <circle
                  id="Ellipse_58445"
                  data-name="Ellipse 58445"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.06 105.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58446"
                  data-name="Ellipse 58446"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.06 99.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58447"
                  data-name="Ellipse 58447"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.73 102.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58448"
                  data-name="Ellipse 58448"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.14 99.42)"
                  fill="#969696"
                />
                <circle id="Ellipse_58449" data-name="Ellipse 58449" cx="0.56" cy="0.56" r="0.56" transform="translate(184.1 95.44)" fill="#969696" />
                <circle id="Ellipse_58450" data-name="Ellipse 58450" cx="0.56" cy="0.56" r="0.56" transform="translate(184.1 89.81)" fill="#969696" />
                <circle
                  id="Ellipse_58451"
                  data-name="Ellipse 58451"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.76 92.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58452"
                  data-name="Ellipse 58452"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.17 89.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_58453" data-name="Ellipse 58453" cx="0.56" cy="0.56" r="0.56" transform="translate(188 103.5)" fill="#969696" />
                <circle id="Ellipse_58454" data-name="Ellipse 58454" cx="0.56" cy="0.56" r="0.56" transform="translate(188 97.87)" fill="#969696" />
                <circle
                  id="Ellipse_58455"
                  data-name="Ellipse 58455"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.67 100.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58456"
                  data-name="Ellipse 58456"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.08 97.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58457"
                  data-name="Ellipse 58457"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.05 93.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58458"
                  data-name="Ellipse 58458"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.05 87.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58459"
                  data-name="Ellipse 58459"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.72 90.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58460"
                  data-name="Ellipse 58460"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.13 87.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58461"
                  data-name="Ellipse 58461"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.91 85.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_58462" data-name="Ellipse 58462" cx="0.56" cy="0.56" r="0.56" transform="translate(191.91 79.9)" fill="#969696" />
                <circle
                  id="Ellipse_58463"
                  data-name="Ellipse 58463"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.58 82.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_58464" data-name="Ellipse 58464" cx="0.56" cy="0.56" r="0.56" transform="translate(194.99 79.5)" fill="#969696" />
                <circle
                  id="Ellipse_58465"
                  data-name="Ellipse 58465"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.61 90.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58466"
                  data-name="Ellipse 58466"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.61 85.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58467"
                  data-name="Ellipse 58467"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.28 88.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58468"
                  data-name="Ellipse 58468"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.69 84.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58469"
                  data-name="Ellipse 58469"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.65 80.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58470"
                  data-name="Ellipse 58470"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.65 75.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58471"
                  data-name="Ellipse 58471"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.31 78.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58472"
                  data-name="Ellipse 58472"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.72 74.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_58473" data-name="Ellipse 58473" cx="0.56" cy="0.56" r="0.56" transform="translate(201.56 89)" fill="#969696" />
                <circle
                  id="Ellipse_58474"
                  data-name="Ellipse 58474"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.56 83.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58475"
                  data-name="Ellipse 58475"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.22 86.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58476"
                  data-name="Ellipse 58476"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.63 82.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58477"
                  data-name="Ellipse 58477"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.16 110.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58478"
                  data-name="Ellipse 58478"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.16 105.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58479"
                  data-name="Ellipse 58479"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.83 108.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58480"
                  data-name="Ellipse 58480"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.24 104.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58481"
                  data-name="Ellipse 58481"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.02 102.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58482"
                  data-name="Ellipse 58482"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.02 97.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58483"
                  data-name="Ellipse 58483"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.69 100.32)"
                  fill="#969696"
                />
                <circle id="Ellipse_58484" data-name="Ellipse 58484" cx="0.56" cy="0.56" r="0.56" transform="translate(198.1 96.91)" fill="#969696" />
                <circle
                  id="Ellipse_58485"
                  data-name="Ellipse 58485"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.72 108.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58486"
                  data-name="Ellipse 58486"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.72 102.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58487"
                  data-name="Ellipse 58487"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.39 105.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58488"
                  data-name="Ellipse 58488"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.8 102.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58489"
                  data-name="Ellipse 58489"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.76 98.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58490"
                  data-name="Ellipse 58490"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.76 92.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58491"
                  data-name="Ellipse 58491"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.42 95.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58492"
                  data-name="Ellipse 58492"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.83 92.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58493"
                  data-name="Ellipse 58493"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.67 106.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58494"
                  data-name="Ellipse 58494"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.67 100.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58495"
                  data-name="Ellipse 58495"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.33 103.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58496"
                  data-name="Ellipse 58496"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.74 100.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58497"
                  data-name="Ellipse 58497"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.33 97.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58498"
                  data-name="Ellipse 58498"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.33 91.85)"
                  fill="#969696"
                />
                <circle id="Ellipse_58499" data-name="Ellipse 58499" cx="0.56" cy="0.56" r="0.56" transform="translate(209 94.86)" fill="#969696" />
                <circle
                  id="Ellipse_58500"
                  data-name="Ellipse 58500"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.41 91.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58501"
                  data-name="Ellipse 58501"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.19 89.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58502"
                  data-name="Ellipse 58502"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.19 84.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58503"
                  data-name="Ellipse 58503"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.85 87.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58504"
                  data-name="Ellipse 58504"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.26 83.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58505"
                  data-name="Ellipse 58505"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.89 95.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58506"
                  data-name="Ellipse 58506"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.89 89.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58507"
                  data-name="Ellipse 58507"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.55 92.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58508"
                  data-name="Ellipse 58508"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.96 89.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58509"
                  data-name="Ellipse 58509"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.92 85.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58510"
                  data-name="Ellipse 58510"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.92 79.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58511"
                  data-name="Ellipse 58511"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.59 82.55)"
                  fill="#969696"
                />
                <circle id="Ellipse_58512" data-name="Ellipse 58512" cx="0.56" cy="0.56" r="0.56" transform="translate(218 79.14)" fill="#969696" />
                <circle
                  id="Ellipse_58513"
                  data-name="Ellipse 58513"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.83 93.22)"
                  fill="#969696"
                />
                <circle id="Ellipse_58514" data-name="Ellipse 58514" cx="0.56" cy="0.56" r="0.56" transform="translate(218.83 87.6)" fill="#969696" />
                <circle id="Ellipse_58515" data-name="Ellipse 58515" cx="0.56" cy="0.56" r="0.56" transform="translate(220.5 90.61)" fill="#969696" />
                <circle id="Ellipse_58516" data-name="Ellipse 58516" cx="0.56" cy="0.56" r="0.56" transform="translate(221.91 87.2)" fill="#969696" />
                <circle id="Ellipse_58517" data-name="Ellipse 58517" cx="0.56" cy="0.56" r="0.56" transform="translate(189.2 76.24)" fill="#969696" />
                <circle id="Ellipse_58518" data-name="Ellipse 58518" cx="0.56" cy="0.56" r="0.56" transform="translate(189.2 70.62)" fill="#969696" />
                <circle
                  id="Ellipse_58519"
                  data-name="Ellipse 58519"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.87 73.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58520"
                  data-name="Ellipse 58520"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.28 70.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58521"
                  data-name="Ellipse 58521"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.06 68.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58522"
                  data-name="Ellipse 58522"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.06 62.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_58523" data-name="Ellipse 58523" cx="0.56" cy="0.56" r="0.56" transform="translate(192.73 65.9)" fill="#969696" />
                <circle
                  id="Ellipse_58524"
                  data-name="Ellipse 58524"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.14 62.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58525"
                  data-name="Ellipse 58525"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.76 73.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58526"
                  data-name="Ellipse 58526"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.76 68.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58527"
                  data-name="Ellipse 58527"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.43 71.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58528"
                  data-name="Ellipse 58528"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.84 67.92)"
                  fill="#969696"
                />
                <circle id="Ellipse_58529" data-name="Ellipse 58529" cx="0.56" cy="0.56" r="0.56" transform="translate(196.8 63.93)" fill="#969696" />
                <circle id="Ellipse_58530" data-name="Ellipse 58530" cx="0.56" cy="0.56" r="0.56" transform="translate(196.8 58.31)" fill="#969696" />
                <circle
                  id="Ellipse_58531"
                  data-name="Ellipse 58531"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.46 61.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58532"
                  data-name="Ellipse 58532"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.87 57.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_58533" data-name="Ellipse 58533" cx="0.56" cy="0.56" r="0.56" transform="translate(200.7 71.99)" fill="#969696" />
                <circle id="Ellipse_58534" data-name="Ellipse 58534" cx="0.56" cy="0.56" r="0.56" transform="translate(200.7 66.37)" fill="#969696" />
                <circle
                  id="Ellipse_58535"
                  data-name="Ellipse 58535"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.37 69.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58536"
                  data-name="Ellipse 58536"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.78 65.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58537"
                  data-name="Ellipse 58537"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.75 61.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58538"
                  data-name="Ellipse 58538"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.75 56.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58539"
                  data-name="Ellipse 58539"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.42 59.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58540"
                  data-name="Ellipse 58540"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.83 55.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58541"
                  data-name="Ellipse 58541"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.61 54.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58542"
                  data-name="Ellipse 58542"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.61 48.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_58543" data-name="Ellipse 58543" cx="0.56" cy="0.56" r="0.56" transform="translate(206.28 51.4)" fill="#969696" />
                <circle
                  id="Ellipse_58544"
                  data-name="Ellipse 58544"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.69 47.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58545"
                  data-name="Ellipse 58545"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.31 59.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58546"
                  data-name="Ellipse 58546"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.31 53.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58547"
                  data-name="Ellipse 58547"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.98 56.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58548"
                  data-name="Ellipse 58548"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.39 53.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58549"
                  data-name="Ellipse 58549"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.35 49.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58550"
                  data-name="Ellipse 58550"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.35 43.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58551"
                  data-name="Ellipse 58551"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.01 46.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58552"
                  data-name="Ellipse 58552"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.42 43.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58553"
                  data-name="Ellipse 58553"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.25 57.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58554"
                  data-name="Ellipse 58554"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.25 51.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58555"
                  data-name="Ellipse 58555"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.92 54.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58556"
                  data-name="Ellipse 58556"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.33 51.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58557"
                  data-name="Ellipse 58557"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.86 79.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58558"
                  data-name="Ellipse 58558"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.86 73.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58559"
                  data-name="Ellipse 58559"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.53 76.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58560"
                  data-name="Ellipse 58560"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.94 73.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58561"
                  data-name="Ellipse 58561"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.72 71.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58562"
                  data-name="Ellipse 58562"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(207.72 65.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58563"
                  data-name="Ellipse 58563"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.39 68.82)"
                  fill="#969696"
                />
                <circle id="Ellipse_58564" data-name="Ellipse 58564" cx="0.56" cy="0.56" r="0.56" transform="translate(210.8 65.41)" fill="#969696" />
                <circle
                  id="Ellipse_58565"
                  data-name="Ellipse 58565"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.42 76.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58566"
                  data-name="Ellipse 58566"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.42 71.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58567"
                  data-name="Ellipse 58567"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.09 74.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_58568" data-name="Ellipse 58568" cx="0.56" cy="0.56" r="0.56" transform="translate(214.5 70.84)" fill="#969696" />
                <circle
                  id="Ellipse_58569"
                  data-name="Ellipse 58569"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.46 66.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58570"
                  data-name="Ellipse 58570"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.46 61.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58571"
                  data-name="Ellipse 58571"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.12 64.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58572"
                  data-name="Ellipse 58572"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.53 60.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58573"
                  data-name="Ellipse 58573"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.36 74.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58574"
                  data-name="Ellipse 58574"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.36 69.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58575"
                  data-name="Ellipse 58575"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.03 72.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58576"
                  data-name="Ellipse 58576"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.44 68.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58577"
                  data-name="Ellipse 58577"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.03 65.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58578"
                  data-name="Ellipse 58578"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.03 60.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58579"
                  data-name="Ellipse 58579"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.69 63.35)"
                  fill="#969696"
                />
                <circle id="Ellipse_58580" data-name="Ellipse 58580" cx="0.56" cy="0.56" r="0.56" transform="translate(223.1 59.94)" fill="#969696" />
                <circle
                  id="Ellipse_58581"
                  data-name="Ellipse 58581"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.89 58.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58582"
                  data-name="Ellipse 58582"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.89 52.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58583"
                  data-name="Ellipse 58583"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.55 55.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58584"
                  data-name="Ellipse 58584"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.96 52.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58585"
                  data-name="Ellipse 58585"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.59 63.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58586"
                  data-name="Ellipse 58586"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.59 58.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58587"
                  data-name="Ellipse 58587"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.25 61.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58588"
                  data-name="Ellipse 58588"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.66 57.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58589"
                  data-name="Ellipse 58589"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.62 53.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58590"
                  data-name="Ellipse 58590"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.62 48.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58591"
                  data-name="Ellipse 58591"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.29 51.05)"
                  fill="#969696"
                />
                <circle id="Ellipse_58592" data-name="Ellipse 58592" cx="0.56" cy="0.56" r="0.56" transform="translate(230.7 47.64)" fill="#969696" />
                <circle
                  id="Ellipse_58593"
                  data-name="Ellipse 58593"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.53 61.72)"
                  fill="#969696"
                />
                <circle id="Ellipse_58594" data-name="Ellipse 58594" cx="0.56" cy="0.56" r="0.56" transform="translate(231.53 56.1)" fill="#969696" />
                <circle id="Ellipse_58595" data-name="Ellipse 58595" cx="0.56" cy="0.56" r="0.56" transform="translate(233.2 59.11)" fill="#969696" />
                <circle
                  id="Ellipse_58596"
                  data-name="Ellipse 58596"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.61 55.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_58597" data-name="Ellipse 58597" cx="0.56" cy="0.56" r="0.56" transform="translate(222.52 83.4)" fill="#969696" />
                <circle
                  id="Ellipse_58598"
                  data-name="Ellipse 58598"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.52 77.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58599"
                  data-name="Ellipse 58599"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.19 80.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_58600" data-name="Ellipse 58600" cx="0.56" cy="0.56" r="0.56" transform="translate(225.6 77.37)" fill="#969696" />
                <circle
                  id="Ellipse_58601"
                  data-name="Ellipse 58601"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.38 75.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58602"
                  data-name="Ellipse 58602"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.38 70.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58603"
                  data-name="Ellipse 58603"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.04 73.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58604"
                  data-name="Ellipse 58604"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.45 69.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58605"
                  data-name="Ellipse 58605"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.08 81.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58606"
                  data-name="Ellipse 58606"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.08 75.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58607"
                  data-name="Ellipse 58607"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.74 78.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58608"
                  data-name="Ellipse 58608"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.15 75.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58609"
                  data-name="Ellipse 58609"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.11 71.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58610"
                  data-name="Ellipse 58610"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.11 65.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58611"
                  data-name="Ellipse 58611"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.78 68.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58612"
                  data-name="Ellipse 58612"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.19 65.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58613"
                  data-name="Ellipse 58613"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.02 79.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58614"
                  data-name="Ellipse 58614"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.02 73.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58615"
                  data-name="Ellipse 58615"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.69 76.54)"
                  fill="#969696"
                />
                <circle id="Ellipse_58616" data-name="Ellipse 58616" cx="0.56" cy="0.56" r="0.56" transform="translate(237.1 73.13)" fill="#969696" />
                <circle id="Ellipse_58617" data-name="Ellipse 58617" cx="0.56" cy="0.56" r="0.56" transform="translate(236.07 68.9)" fill="#969696" />
                <circle
                  id="Ellipse_58618"
                  data-name="Ellipse 58618"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.07 63.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58619"
                  data-name="Ellipse 58619"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.74 66.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58620"
                  data-name="Ellipse 58620"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.15 62.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58621"
                  data-name="Ellipse 58621"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.93 61.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58622"
                  data-name="Ellipse 58622"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.93 55.55)"
                  fill="#969696"
                />
                <circle id="Ellipse_58623" data-name="Ellipse 58623" cx="0.56" cy="0.56" r="0.56" transform="translate(239.6 58.56)" fill="#969696" />
                <circle
                  id="Ellipse_58624"
                  data-name="Ellipse 58624"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.01 55.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58625"
                  data-name="Ellipse 58625"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.63 66.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58626"
                  data-name="Ellipse 58626"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.63 60.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58627"
                  data-name="Ellipse 58627"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.29 63.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_58628" data-name="Ellipse 58628" cx="0.56" cy="0.56" r="0.56" transform="translate(244.7 60.58)" fill="#969696" />
                <circle
                  id="Ellipse_58629"
                  data-name="Ellipse 58629"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.66 56.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58630"
                  data-name="Ellipse 58630"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.66 50.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58631"
                  data-name="Ellipse 58631"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.33 53.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58632"
                  data-name="Ellipse 58632"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.74 50.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58633"
                  data-name="Ellipse 58633"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.57 64.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58634"
                  data-name="Ellipse 58634"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.57 59.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58635"
                  data-name="Ellipse 58635"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.24 62.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58636"
                  data-name="Ellipse 58636"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.65 58.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58637"
                  data-name="Ellipse 58637"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.18 86.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58638"
                  data-name="Ellipse 58638"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.18 80.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_58639" data-name="Ellipse 58639" cx="0.56" cy="0.56" r="0.56" transform="translate(240.85 83.7)" fill="#969696" />
                <circle
                  id="Ellipse_58640"
                  data-name="Ellipse 58640"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.26 80.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58641"
                  data-name="Ellipse 58641"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.04 78.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58642"
                  data-name="Ellipse 58642"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.04 72.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58643"
                  data-name="Ellipse 58643"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.71 75.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58644"
                  data-name="Ellipse 58644"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.12 72.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58645"
                  data-name="Ellipse 58645"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.74 84.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_58646" data-name="Ellipse 58646" cx="0.56" cy="0.56" r="0.56" transform="translate(244.74 78.4)" fill="#969696" />
                <circle
                  id="Ellipse_58647"
                  data-name="Ellipse 58647"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.41 81.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_58648" data-name="Ellipse 58648" cx="0.56" cy="0.56" r="0.56" transform="translate(247.82 78)" fill="#969696" />
                <circle
                  id="Ellipse_58649"
                  data-name="Ellipse 58649"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.77 74.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58650"
                  data-name="Ellipse 58650"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.77 68.38)"
                  fill="#969696"
                />
                <circle id="Ellipse_58651" data-name="Ellipse 58651" cx="0.56" cy="0.56" r="0.56" transform="translate(248.44 71.4)" fill="#969696" />
                <circle
                  id="Ellipse_58652"
                  data-name="Ellipse 58652"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.85 67.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58653"
                  data-name="Ellipse 58653"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.68 82.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58654"
                  data-name="Ellipse 58654"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.68 76.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58655"
                  data-name="Ellipse 58655"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.35 79.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58656"
                  data-name="Ellipse 58656"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.76 76.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58657"
                  data-name="Ellipse 58657"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.35 73.13)"
                  fill="#969696"
                />
                <circle id="Ellipse_58658" data-name="Ellipse 58658" cx="0.56" cy="0.56" r="0.56" transform="translate(253.35 67.5)" fill="#969696" />
                <circle
                  id="Ellipse_58659"
                  data-name="Ellipse 58659"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.01 70.51)"
                  fill="#969696"
                />
                <circle id="Ellipse_58660" data-name="Ellipse 58660" cx="0.56" cy="0.56" r="0.56" transform="translate(256.42 67.1)" fill="#969696" />
                <circle id="Ellipse_58661" data-name="Ellipse 58661" cx="0.56" cy="0.56" r="0.56" transform="translate(255.2 65.4)" fill="#969696" />
                <circle id="Ellipse_58662" data-name="Ellipse 58662" cx="0.56" cy="0.56" r="0.56" transform="translate(255.2 59.78)" fill="#969696" />
                <circle
                  id="Ellipse_58663"
                  data-name="Ellipse 58663"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.87 62.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58664"
                  data-name="Ellipse 58664"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.28 59.38)"
                  fill="#969696"
                />
                <circle id="Ellipse_58665" data-name="Ellipse 58665" cx="0.56" cy="0.56" r="0.56" transform="translate(258.9 70.83)" fill="#969696" />
                <circle id="Ellipse_58666" data-name="Ellipse 58666" cx="0.56" cy="0.56" r="0.56" transform="translate(258.9 65.21)" fill="#969696" />
                <circle
                  id="Ellipse_58667"
                  data-name="Ellipse 58667"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.57 68.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58668"
                  data-name="Ellipse 58668"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.98 64.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58669"
                  data-name="Ellipse 58669"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.94 60.82)"
                  fill="#969696"
                />
                <circle id="Ellipse_58670" data-name="Ellipse 58670" cx="0.56" cy="0.56" r="0.56" transform="translate(260.94 55.2)" fill="#969696" />
                <circle id="Ellipse_58671" data-name="Ellipse 58671" cx="0.56" cy="0.56" r="0.56" transform="translate(262.6 58.21)" fill="#969696" />
                <circle id="Ellipse_58672" data-name="Ellipse 58672" cx="0.56" cy="0.56" r="0.56" transform="translate(264.01 54.8)" fill="#969696" />
                <circle
                  id="Ellipse_58673"
                  data-name="Ellipse 58673"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.85 68.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58674"
                  data-name="Ellipse 58674"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.85 63.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58675"
                  data-name="Ellipse 58675"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.51 66.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58676"
                  data-name="Ellipse 58676"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.92 62.85)"
                  fill="#969696"
                />
                <path
                  id="Path_12316"
                  data-name="Path 12316"
                  d="M210.11,117.45a.56.56,0,0,0-1.12,0,.57.57,0,0,0,.22.44.56.56,0,1,0,.77.51.54.54,0,0,0-.22-.43A.55.55,0,0,0,210.11,117.45Z"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58677"
                  data-name="Ellipse 58677"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.99 111.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58678"
                  data-name="Ellipse 58678"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.66 114.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58679"
                  data-name="Ellipse 58679"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.07 110.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58680"
                  data-name="Ellipse 58680"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.85 109.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58681"
                  data-name="Ellipse 58681"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.85 103.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58682"
                  data-name="Ellipse 58682"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.52 106.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58683"
                  data-name="Ellipse 58683"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.93 103.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58684"
                  data-name="Ellipse 58684"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.55 114.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58685"
                  data-name="Ellipse 58685"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.55 108.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58686"
                  data-name="Ellipse 58686"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.22 111.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58687"
                  data-name="Ellipse 58687"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.63 108.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58688"
                  data-name="Ellipse 58688"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.59 104.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58689"
                  data-name="Ellipse 58689"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.59 98.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58690"
                  data-name="Ellipse 58690"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.25 101.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58691"
                  data-name="Ellipse 58691"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.66 98.56)"
                  fill="#969696"
                />
                <path
                  id="Path_12317"
                  data-name="Path 12317"
                  d="M221.24,113.73a.59.59,0,0,0,.32.11.56.56,0,1,0,0-1.12.58.58,0,0,0-.19,0,.52.52,0,0,0-.32-.11.56.56,0,0,0-.56.56.57.57,0,0,0,.56.56.58.58,0,0,0,.19,0Z"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58692"
                  data-name="Ellipse 58692"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.49 107.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58693"
                  data-name="Ellipse 58693"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.16 110.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58694"
                  data-name="Ellipse 58694"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.57 106.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58695"
                  data-name="Ellipse 58695"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.54 102.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58696"
                  data-name="Ellipse 58696"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.54 96.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58697"
                  data-name="Ellipse 58697"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.21 99.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58698"
                  data-name="Ellipse 58698"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.62 96.37)"
                  fill="#969696"
                />
                <circle id="Ellipse_58699" data-name="Ellipse 58699" cx="0.56" cy="0.56" r="0.56" transform="translate(224.4 94.67)" fill="#969696" />
                <circle id="Ellipse_58700" data-name="Ellipse 58700" cx="0.56" cy="0.56" r="0.56" transform="translate(224.4 89.05)" fill="#969696" />
                <circle
                  id="Ellipse_58701"
                  data-name="Ellipse 58701"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.07 92.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58702"
                  data-name="Ellipse 58702"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.48 88.65)"
                  fill="#969696"
                />
                <circle id="Ellipse_58703" data-name="Ellipse 58703" cx="0.56" cy="0.56" r="0.56" transform="translate(228.1 100.1)" fill="#969696" />
                <circle id="Ellipse_58704" data-name="Ellipse 58704" cx="0.56" cy="0.56" r="0.56" transform="translate(228.1 94.48)" fill="#969696" />
                <circle
                  id="Ellipse_58705"
                  data-name="Ellipse 58705"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.77 97.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58706"
                  data-name="Ellipse 58706"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.18 94.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58707"
                  data-name="Ellipse 58707"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.14 90.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58708"
                  data-name="Ellipse 58708"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.14 84.46)"
                  fill="#969696"
                />
                <circle id="Ellipse_58709" data-name="Ellipse 58709" cx="0.56" cy="0.56" r="0.56" transform="translate(231.8 87.48)" fill="#969696" />
                <circle
                  id="Ellipse_58710"
                  data-name="Ellipse 58710"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.21 84.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58711"
                  data-name="Ellipse 58711"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.04 98.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58712"
                  data-name="Ellipse 58712"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.04 92.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58713"
                  data-name="Ellipse 58713"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.71 95.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58714"
                  data-name="Ellipse 58714"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.12 92.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58715"
                  data-name="Ellipse 58715"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.65 119.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58716"
                  data-name="Ellipse 58716"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.65 114.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58717"
                  data-name="Ellipse 58717"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.32 117.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58718"
                  data-name="Ellipse 58718"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.73 113.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58719"
                  data-name="Ellipse 58719"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.51 112.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58720"
                  data-name="Ellipse 58720"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.51 106.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58721"
                  data-name="Ellipse 58721"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.18 109.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58722"
                  data-name="Ellipse 58722"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.59 106.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58723"
                  data-name="Ellipse 58723"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.21 117.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58724"
                  data-name="Ellipse 58724"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.21 111.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58725"
                  data-name="Ellipse 58725"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.88 114.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58726"
                  data-name="Ellipse 58726"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.29 111.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58727"
                  data-name="Ellipse 58727"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.25 107.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58728"
                  data-name="Ellipse 58728"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.25 101.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58729"
                  data-name="Ellipse 58729"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.91 104.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58730"
                  data-name="Ellipse 58730"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.32 101.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58731"
                  data-name="Ellipse 58731"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.16 115.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58732"
                  data-name="Ellipse 58732"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.16 109.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58733"
                  data-name="Ellipse 58733"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.82 112.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58734"
                  data-name="Ellipse 58734"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.23 109.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58735"
                  data-name="Ellipse 58735"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.82 106.62)"
                  fill="#969696"
                />
                <circle id="Ellipse_58736" data-name="Ellipse 58736" cx="0.56" cy="0.56" r="0.56" transform="translate(239.82 101)" fill="#969696" />
                <circle
                  id="Ellipse_58737"
                  data-name="Ellipse 58737"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.48 104.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58738"
                  data-name="Ellipse 58738"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.89 100.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_58739" data-name="Ellipse 58739" cx="0.56" cy="0.56" r="0.56" transform="translate(241.68 98.9)" fill="#969696" />
                <circle
                  id="Ellipse_58740"
                  data-name="Ellipse 58740"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.68 93.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58741"
                  data-name="Ellipse 58741"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.34 96.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58742"
                  data-name="Ellipse 58742"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.75 92.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58743"
                  data-name="Ellipse 58743"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.38 104.33)"
                  fill="#969696"
                />
                <circle id="Ellipse_58744" data-name="Ellipse 58744" cx="0.56" cy="0.56" r="0.56" transform="translate(245.38 98.7)" fill="#969696" />
                <circle
                  id="Ellipse_58745"
                  data-name="Ellipse 58745"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.04 101.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_58746" data-name="Ellipse 58746" cx="0.56" cy="0.56" r="0.56" transform="translate(248.45 98.3)" fill="#969696" />
                <circle
                  id="Ellipse_58747"
                  data-name="Ellipse 58747"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.41 94.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58748"
                  data-name="Ellipse 58748"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.41 88.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_58749" data-name="Ellipse 58749" cx="0.56" cy="0.56" r="0.56" transform="translate(249.08 91.7)" fill="#969696" />
                <circle
                  id="Ellipse_58750"
                  data-name="Ellipse 58750"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.49 88.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58751"
                  data-name="Ellipse 58751"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.32 102.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58752"
                  data-name="Ellipse 58752"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.32 96.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58753"
                  data-name="Ellipse 58753"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.99 99.76)"
                  fill="#969696"
                />
                <circle id="Ellipse_58754" data-name="Ellipse 58754" cx="0.56" cy="0.56" r="0.56" transform="translate(254.4 96.35)" fill="#969696" />
                <circle
                  id="Ellipse_58755"
                  data-name="Ellipse 58755"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.25 91.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58756"
                  data-name="Ellipse 58756"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.25 85.58)"
                  fill="#969696"
                />
                <circle id="Ellipse_58757" data-name="Ellipse 58757" cx="0.56" cy="0.56" r="0.56" transform="translate(111.92 88.6)" fill="#969696" />
                <circle
                  id="Ellipse_58758"
                  data-name="Ellipse 58758"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.33 85.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58759"
                  data-name="Ellipse 58759"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.11 83.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58760"
                  data-name="Ellipse 58760"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.11 77.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58761"
                  data-name="Ellipse 58761"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.78 80.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58762"
                  data-name="Ellipse 58762"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.19 77.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58763"
                  data-name="Ellipse 58763"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.81 88.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58764"
                  data-name="Ellipse 58764"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.81 83.29)"
                  fill="#969696"
                />
                <circle id="Ellipse_58765" data-name="Ellipse 58765" cx="0.56" cy="0.56" r="0.56" transform="translate(117.47 86.3)" fill="#969696" />
                <circle
                  id="Ellipse_58766"
                  data-name="Ellipse 58766"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.88 82.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_58767" data-name="Ellipse 58767" cx="0.56" cy="0.56" r="0.56" transform="translate(117.84 78.9)" fill="#969696" />
                <circle
                  id="Ellipse_58768"
                  data-name="Ellipse 58768"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.84 73.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58769"
                  data-name="Ellipse 58769"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.51 76.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58770"
                  data-name="Ellipse 58770"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.92 72.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58771"
                  data-name="Ellipse 58771"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.75 86.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58772"
                  data-name="Ellipse 58772"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.75 81.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58773"
                  data-name="Ellipse 58773"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.42 84.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58774"
                  data-name="Ellipse 58774"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.83 80.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_58775" data-name="Ellipse 58775" cx="0.56" cy="0.56" r="0.56" transform="translate(123.8 76.71)" fill="#969696" />
                <circle id="Ellipse_58776" data-name="Ellipse 58776" cx="0.56" cy="0.56" r="0.56" transform="translate(123.8 71.08)" fill="#969696" />
                <circle id="Ellipse_58777" data-name="Ellipse 58777" cx="0.56" cy="0.56" r="0.56" transform="translate(125.47 74.1)" fill="#969696" />
                <circle
                  id="Ellipse_58778"
                  data-name="Ellipse 58778"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.88 70.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58779"
                  data-name="Ellipse 58779"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.66 68.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58780"
                  data-name="Ellipse 58780"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.66 63.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58781"
                  data-name="Ellipse 58781"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.33 66.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58782"
                  data-name="Ellipse 58782"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.74 62.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58783"
                  data-name="Ellipse 58783"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.36 74.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58784"
                  data-name="Ellipse 58784"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.36 68.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_58785" data-name="Ellipse 58785" cx="0.56" cy="0.56" r="0.56" transform="translate(131.03 71.8)" fill="#969696" />
                <circle
                  id="Ellipse_58786"
                  data-name="Ellipse 58786"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.44 68.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_58787" data-name="Ellipse 58787" cx="0.56" cy="0.56" r="0.56" transform="translate(131.4 64.4)" fill="#969696" />
                <circle id="Ellipse_58788" data-name="Ellipse 58788" cx="0.56" cy="0.56" r="0.56" transform="translate(131.4 58.78)" fill="#969696" />
                <circle
                  id="Ellipse_58789"
                  data-name="Ellipse 58789"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.06 61.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58790"
                  data-name="Ellipse 58790"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.47 58.38)"
                  fill="#969696"
                />
                <circle id="Ellipse_58791" data-name="Ellipse 58791" cx="0.56" cy="0.56" r="0.56" transform="translate(135.3 72.46)" fill="#969696" />
                <circle id="Ellipse_58792" data-name="Ellipse 58792" cx="0.56" cy="0.56" r="0.56" transform="translate(135.3 66.84)" fill="#969696" />
                <circle
                  id="Ellipse_58793"
                  data-name="Ellipse 58793"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.97 69.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58794"
                  data-name="Ellipse 58794"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.38 66.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58795"
                  data-name="Ellipse 58795"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.91 94.12)"
                  fill="#969696"
                />
                <circle id="Ellipse_58796" data-name="Ellipse 58796" cx="0.56" cy="0.56" r="0.56" transform="translate(126.91 88.5)" fill="#969696" />
                <circle
                  id="Ellipse_58797"
                  data-name="Ellipse 58797"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.58 91.51)"
                  fill="#969696"
                />
                <circle id="Ellipse_58798" data-name="Ellipse 58798" cx="0.56" cy="0.56" r="0.56" transform="translate(129.99 88.1)" fill="#969696" />
                <circle id="Ellipse_58799" data-name="Ellipse 58799" cx="0.56" cy="0.56" r="0.56" transform="translate(128.77 86.4)" fill="#969696" />
                <circle
                  id="Ellipse_58800"
                  data-name="Ellipse 58800"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.77 80.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58801"
                  data-name="Ellipse 58801"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.44 83.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58802"
                  data-name="Ellipse 58802"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.85 80.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58803"
                  data-name="Ellipse 58803"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.47 91.83)"
                  fill="#969696"
                />
                <circle id="Ellipse_58804" data-name="Ellipse 58804" cx="0.56" cy="0.56" r="0.56" transform="translate(132.47 86.2)" fill="#969696" />
                <circle
                  id="Ellipse_58805"
                  data-name="Ellipse 58805"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.14 89.22)"
                  fill="#969696"
                />
                <circle id="Ellipse_58806" data-name="Ellipse 58806" cx="0.56" cy="0.56" r="0.56" transform="translate(135.55 85.8)" fill="#969696" />
                <circle
                  id="Ellipse_58807"
                  data-name="Ellipse 58807"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.51 81.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58808"
                  data-name="Ellipse 58808"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.51 76.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_58809" data-name="Ellipse 58809" cx="0.56" cy="0.56" r="0.56" transform="translate(136.17 79.2)" fill="#969696" />
                <circle
                  id="Ellipse_58810"
                  data-name="Ellipse 58810"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.58 75.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58811"
                  data-name="Ellipse 58811"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.41 89.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58812"
                  data-name="Ellipse 58812"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.41 84.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58813"
                  data-name="Ellipse 58813"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.08 87.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58814"
                  data-name="Ellipse 58814"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.49 83.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58815"
                  data-name="Ellipse 58815"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.08 80.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58816"
                  data-name="Ellipse 58816"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.08 75.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58817"
                  data-name="Ellipse 58817"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.74 78.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58818"
                  data-name="Ellipse 58818"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.15 74.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58819"
                  data-name="Ellipse 58819"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.93 73.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58820"
                  data-name="Ellipse 58820"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.93 67.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_58821" data-name="Ellipse 58821" cx="0.56" cy="0.56" r="0.56" transform="translate(144.6 70.6)" fill="#969696" />
                <circle
                  id="Ellipse_58822"
                  data-name="Ellipse 58822"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.01 67.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58823"
                  data-name="Ellipse 58823"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.63 78.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58824"
                  data-name="Ellipse 58824"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.63 73.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_58825" data-name="Ellipse 58825" cx="0.56" cy="0.56" r="0.56" transform="translate(148.3 76.03)" fill="#969696" />
                <circle
                  id="Ellipse_58826"
                  data-name="Ellipse 58826"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.71 72.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58827"
                  data-name="Ellipse 58827"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.67 68.63)"
                  fill="#969696"
                />
                <circle id="Ellipse_58828" data-name="Ellipse 58828" cx="0.56" cy="0.56" r="0.56" transform="translate(148.67 63)" fill="#969696" />
                <circle
                  id="Ellipse_58829"
                  data-name="Ellipse 58829"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.34 66.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_58830" data-name="Ellipse 58830" cx="0.56" cy="0.56" r="0.56" transform="translate(151.75 62.6)" fill="#969696" />
                <circle
                  id="Ellipse_58831"
                  data-name="Ellipse 58831"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.58 76.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58832"
                  data-name="Ellipse 58832"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.58 71.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58833"
                  data-name="Ellipse 58833"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.24 74.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58834"
                  data-name="Ellipse 58834"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.65 70.66)"
                  fill="#969696"
                />
                <circle id="Ellipse_58835" data-name="Ellipse 58835" cx="0.56" cy="0.56" r="0.56" transform="translate(122.95 59.7)" fill="#969696" />
                <circle
                  id="Ellipse_58836"
                  data-name="Ellipse 58836"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.95 54.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58837"
                  data-name="Ellipse 58837"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.62 57.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58838"
                  data-name="Ellipse 58838"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.03 53.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58839"
                  data-name="Ellipse 58839"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.81 51.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58840"
                  data-name="Ellipse 58840"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.81 46.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58841"
                  data-name="Ellipse 58841"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.47 49.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58842"
                  data-name="Ellipse 58842"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.88 45.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58843"
                  data-name="Ellipse 58843"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.51 57.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58844"
                  data-name="Ellipse 58844"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.51 51.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_58845" data-name="Ellipse 58845" cx="0.56" cy="0.56" r="0.56" transform="translate(130.17 54.8)" fill="#969696" />
                <circle
                  id="Ellipse_58846"
                  data-name="Ellipse 58846"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.58 51.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_58847" data-name="Ellipse 58847" cx="0.56" cy="0.56" r="0.56" transform="translate(130.54 47.4)" fill="#969696" />
                <circle
                  id="Ellipse_58848"
                  data-name="Ellipse 58848"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.54 41.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58849"
                  data-name="Ellipse 58849"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.21 44.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58850"
                  data-name="Ellipse 58850"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.62 41.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58851"
                  data-name="Ellipse 58851"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.45 55.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58852"
                  data-name="Ellipse 58852"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.45 49.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58853"
                  data-name="Ellipse 58853"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.12 52.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58854"
                  data-name="Ellipse 58854"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.53 49.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_58855" data-name="Ellipse 58855" cx="0.56" cy="0.56" r="0.56" transform="translate(136.5 45.2)" fill="#969696" />
                <circle id="Ellipse_58856" data-name="Ellipse 58856" cx="0.56" cy="0.56" r="0.56" transform="translate(136.5 39.58)" fill="#969696" />
                <circle
                  id="Ellipse_58857"
                  data-name="Ellipse 58857"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.17 42.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58858"
                  data-name="Ellipse 58858"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.58 39.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58859"
                  data-name="Ellipse 58859"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.36 37.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58860"
                  data-name="Ellipse 58860"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.36 31.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58861"
                  data-name="Ellipse 58861"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.03 34.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58862"
                  data-name="Ellipse 58862"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.44 31.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58863"
                  data-name="Ellipse 58863"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.06 42.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58864"
                  data-name="Ellipse 58864"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.06 37.29)"
                  fill="#969696"
                />
                <circle id="Ellipse_58865" data-name="Ellipse 58865" cx="0.56" cy="0.56" r="0.56" transform="translate(143.73 40.3)" fill="#969696" />
                <circle
                  id="Ellipse_58866"
                  data-name="Ellipse 58866"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.14 36.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_58867" data-name="Ellipse 58867" cx="0.56" cy="0.56" r="0.56" transform="translate(144.09 32.9)" fill="#969696" />
                <circle
                  id="Ellipse_58868"
                  data-name="Ellipse 58868"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.09 27.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58869"
                  data-name="Ellipse 58869"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.76 30.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58870"
                  data-name="Ellipse 58870"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.17 26.87)"
                  fill="#969696"
                />
                <circle id="Ellipse_58871" data-name="Ellipse 58871" cx="0.56" cy="0.56" r="0.56" transform="translate(148 40.96)" fill="#969696" />
                <circle id="Ellipse_58872" data-name="Ellipse 58872" cx="0.56" cy="0.56" r="0.56" transform="translate(148 35.33)" fill="#969696" />
                <circle
                  id="Ellipse_58873"
                  data-name="Ellipse 58873"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.67 38.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58874"
                  data-name="Ellipse 58874"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.08 34.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58875"
                  data-name="Ellipse 58875"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.61 62.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58876"
                  data-name="Ellipse 58876"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.61 56.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58877"
                  data-name="Ellipse 58877"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.28 60.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58878"
                  data-name="Ellipse 58878"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.69 56.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_58879" data-name="Ellipse 58879" cx="0.56" cy="0.56" r="0.56" transform="translate(141.47 54.9)" fill="#969696" />
                <circle
                  id="Ellipse_58880"
                  data-name="Ellipse 58880"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.47 49.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58881"
                  data-name="Ellipse 58881"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.14 52.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58882"
                  data-name="Ellipse 58882"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.55 48.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58883"
                  data-name="Ellipse 58883"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.17 60.32)"
                  fill="#969696"
                />
                <circle id="Ellipse_58884" data-name="Ellipse 58884" cx="0.56" cy="0.56" r="0.56" transform="translate(145.17 54.7)" fill="#969696" />
                <circle
                  id="Ellipse_58885"
                  data-name="Ellipse 58885"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.84 57.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_58886" data-name="Ellipse 58886" cx="0.56" cy="0.56" r="0.56" transform="translate(148.25 54.3)" fill="#969696" />
                <circle id="Ellipse_58887" data-name="Ellipse 58887" cx="0.56" cy="0.56" r="0.56" transform="translate(147.2 50.31)" fill="#969696" />
                <circle id="Ellipse_58888" data-name="Ellipse 58888" cx="0.56" cy="0.56" r="0.56" transform="translate(147.2 44.69)" fill="#969696" />
                <circle id="Ellipse_58889" data-name="Ellipse 58889" cx="0.56" cy="0.56" r="0.56" transform="translate(148.87 47.7)" fill="#969696" />
                <circle
                  id="Ellipse_58890"
                  data-name="Ellipse 58890"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.28 44.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58891"
                  data-name="Ellipse 58891"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.11 58.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58892"
                  data-name="Ellipse 58892"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.11 52.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58893"
                  data-name="Ellipse 58893"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.78 55.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58894"
                  data-name="Ellipse 58894"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.19 52.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58895"
                  data-name="Ellipse 58895"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.78 49.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58896"
                  data-name="Ellipse 58896"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.78 43.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58897"
                  data-name="Ellipse 58897"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.44 46.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58898"
                  data-name="Ellipse 58898"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.85 43.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58899"
                  data-name="Ellipse 58899"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.63 41.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58900"
                  data-name="Ellipse 58900"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.63 36.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_58901" data-name="Ellipse 58901" cx="0.56" cy="0.56" r="0.56" transform="translate(157.3 39.1)" fill="#969696" />
                <circle
                  id="Ellipse_58902"
                  data-name="Ellipse 58902"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.71 35.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58903"
                  data-name="Ellipse 58903"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.33 47.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58904"
                  data-name="Ellipse 58904"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.33 41.51)"
                  fill="#969696"
                />
                <circle id="Ellipse_58905" data-name="Ellipse 58905" cx="0.56" cy="0.56" r="0.56" transform="translate(161 44.53)" fill="#969696" />
                <circle
                  id="Ellipse_58906"
                  data-name="Ellipse 58906"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.41 41.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58907"
                  data-name="Ellipse 58907"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.37 37.12)"
                  fill="#969696"
                />
                <circle id="Ellipse_58908" data-name="Ellipse 58908" cx="0.56" cy="0.56" r="0.56" transform="translate(161.37 31.5)" fill="#969696" />
                <circle
                  id="Ellipse_58909"
                  data-name="Ellipse 58909"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.04 34.51)"
                  fill="#969696"
                />
                <circle id="Ellipse_58910" data-name="Ellipse 58910" cx="0.56" cy="0.56" r="0.56" transform="translate(164.45 31.1)" fill="#969696" />
                <circle
                  id="Ellipse_58911"
                  data-name="Ellipse 58911"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.28 45.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58912"
                  data-name="Ellipse 58912"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.28 39.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58913"
                  data-name="Ellipse 58913"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.94 42.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58914"
                  data-name="Ellipse 58914"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.35 39.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58915"
                  data-name="Ellipse 58915"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.27 66.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58916"
                  data-name="Ellipse 58916"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.27 61.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58917"
                  data-name="Ellipse 58917"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.93 64.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58918"
                  data-name="Ellipse 58918"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.34 60.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58919"
                  data-name="Ellipse 58919"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.12 59.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58920"
                  data-name="Ellipse 58920"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.12 53.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58921"
                  data-name="Ellipse 58921"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.79 56.53)"
                  fill="#969696"
                />
                <circle id="Ellipse_58922" data-name="Ellipse 58922" cx="0.56" cy="0.56" r="0.56" transform="translate(161.2 53.12)" fill="#969696" />
                <circle
                  id="Ellipse_58923"
                  data-name="Ellipse 58923"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.82 64.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58924"
                  data-name="Ellipse 58924"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.82 58.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58925"
                  data-name="Ellipse 58925"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.49 61.96)"
                  fill="#969696"
                />
                <circle id="Ellipse_58926" data-name="Ellipse 58926" cx="0.56" cy="0.56" r="0.56" transform="translate(164.9 58.55)" fill="#969696" />
                <circle
                  id="Ellipse_58927"
                  data-name="Ellipse 58927"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.86 54.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58928"
                  data-name="Ellipse 58928"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.86 48.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58929"
                  data-name="Ellipse 58929"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.53 51.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58930"
                  data-name="Ellipse 58930"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.94 48.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58931"
                  data-name="Ellipse 58931"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.77 62.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58932"
                  data-name="Ellipse 58932"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.77 56.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58933"
                  data-name="Ellipse 58933"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.43 60.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58934"
                  data-name="Ellipse 58934"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.84 56.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58935"
                  data-name="Ellipse 58935"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.82 52.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58936"
                  data-name="Ellipse 58936"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.82 46.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58937"
                  data-name="Ellipse 58937"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.48 49.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58938"
                  data-name="Ellipse 58938"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.89 46.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58939"
                  data-name="Ellipse 58939"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.68 44.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58940"
                  data-name="Ellipse 58940"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.68 39.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58941"
                  data-name="Ellipse 58941"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.34 42.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58942"
                  data-name="Ellipse 58942"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.75 38.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58943"
                  data-name="Ellipse 58943"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.38 50.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58944"
                  data-name="Ellipse 58944"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.38 44.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58945"
                  data-name="Ellipse 58945"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.04 47.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58946"
                  data-name="Ellipse 58946"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.45 44.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58947"
                  data-name="Ellipse 58947"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.41 40.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58948"
                  data-name="Ellipse 58948"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.41 34.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58949"
                  data-name="Ellipse 58949"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.08 37.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58950"
                  data-name="Ellipse 58950"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.49 34.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58951"
                  data-name="Ellipse 58951"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.32 48.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58952"
                  data-name="Ellipse 58952"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.32 42.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58953"
                  data-name="Ellipse 58953"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.98 45.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58954"
                  data-name="Ellipse 58954"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.39 42.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58955"
                  data-name="Ellipse 58955"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.93 69.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58956"
                  data-name="Ellipse 58956"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.93 64.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58957"
                  data-name="Ellipse 58957"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.59 67.17)"
                  fill="#969696"
                />
                <circle id="Ellipse_58958" data-name="Ellipse 58958" cx="0.56" cy="0.56" r="0.56" transform="translate(176 63.75)" fill="#969696" />
                <circle
                  id="Ellipse_58959"
                  data-name="Ellipse 58959"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.79 62.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58960"
                  data-name="Ellipse 58960"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.79 56.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58961"
                  data-name="Ellipse 58961"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.45 59.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58962"
                  data-name="Ellipse 58962"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.86 56.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58963"
                  data-name="Ellipse 58963"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.49 67.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58964"
                  data-name="Ellipse 58964"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.49 61.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58965"
                  data-name="Ellipse 58965"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.15 64.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58966"
                  data-name="Ellipse 58966"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.56 61.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58967"
                  data-name="Ellipse 58967"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.52 57.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58968"
                  data-name="Ellipse 58968"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.52 51.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58969"
                  data-name="Ellipse 58969"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.19 54.86)"
                  fill="#969696"
                />
                <circle id="Ellipse_58970" data-name="Ellipse 58970" cx="0.56" cy="0.56" r="0.56" transform="translate(183.6 51.45)" fill="#969696" />
                <circle
                  id="Ellipse_58971"
                  data-name="Ellipse 58971"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.43 65.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58972"
                  data-name="Ellipse 58972"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.43 59.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_58973" data-name="Ellipse 58973" cx="0.56" cy="0.56" r="0.56" transform="translate(186.1 62.92)" fill="#969696" />
                <circle
                  id="Ellipse_58974"
                  data-name="Ellipse 58974"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.51 59.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58975"
                  data-name="Ellipse 58975"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.09 56.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58976"
                  data-name="Ellipse 58976"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.09 50.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58977"
                  data-name="Ellipse 58977"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.76 53.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58978"
                  data-name="Ellipse 58978"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.17 50.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58979"
                  data-name="Ellipse 58979"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.95 48.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58980"
                  data-name="Ellipse 58980"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.95 43.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58981"
                  data-name="Ellipse 58981"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.62 46.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58982"
                  data-name="Ellipse 58982"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.03 42.84)"
                  fill="#969696"
                />
                <circle id="Ellipse_58983" data-name="Ellipse 58983" cx="0.56" cy="0.56" r="0.56" transform="translate(192.65 54.3)" fill="#969696" />
                <circle
                  id="Ellipse_58984"
                  data-name="Ellipse 58984"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.65 48.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58985"
                  data-name="Ellipse 58985"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.32 51.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58986"
                  data-name="Ellipse 58986"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.73 48.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58987"
                  data-name="Ellipse 58987"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.69 44.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58988"
                  data-name="Ellipse 58988"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.69 38.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58989"
                  data-name="Ellipse 58989"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.35 41.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58990"
                  data-name="Ellipse 58990"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.76 38.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58991"
                  data-name="Ellipse 58991"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.59 52.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58992"
                  data-name="Ellipse 58992"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.59 46.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58993"
                  data-name="Ellipse 58993"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.26 49.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58994"
                  data-name="Ellipse 58994"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.67 46.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58995"
                  data-name="Ellipse 58995"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.74 100.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58996"
                  data-name="Ellipse 58996"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.74 94.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58997"
                  data-name="Ellipse 58997"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.41 97.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_58998"
                  data-name="Ellipse 58998"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.82 94.33)"
                  fill="#969696"
                />
                <circle id="Ellipse_58999" data-name="Ellipse 58999" cx="0.56" cy="0.56" r="0.56" transform="translate(144.6 92.63)" fill="#969696" />
                <circle id="Ellipse_59000" data-name="Ellipse 59000" cx="0.56" cy="0.56" r="0.56" transform="translate(144.6 87.01)" fill="#969696" />
                <circle
                  id="Ellipse_59001"
                  data-name="Ellipse 59001"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.26 90.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59002"
                  data-name="Ellipse 59002"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.67 86.61)"
                  fill="#969696"
                />
                <circle id="Ellipse_59003" data-name="Ellipse 59003" cx="0.56" cy="0.56" r="0.56" transform="translate(148.3 98.06)" fill="#969696" />
                <circle id="Ellipse_59004" data-name="Ellipse 59004" cx="0.56" cy="0.56" r="0.56" transform="translate(148.3 92.44)" fill="#969696" />
                <circle
                  id="Ellipse_59005"
                  data-name="Ellipse 59005"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.96 95.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59006"
                  data-name="Ellipse 59006"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.37 92.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59007"
                  data-name="Ellipse 59007"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.33 88.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59008"
                  data-name="Ellipse 59008"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.33 82.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_59009" data-name="Ellipse 59009" cx="0.56" cy="0.56" r="0.56" transform="translate(152 85.44)" fill="#969696" />
                <circle
                  id="Ellipse_59010"
                  data-name="Ellipse 59010"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.41 82.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59011"
                  data-name="Ellipse 59011"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.24 90.49)"
                  fill="#969696"
                />
                <circle id="Ellipse_59012" data-name="Ellipse 59012" cx="0.56" cy="0.56" r="0.56" transform="translate(155.91 93.5)" fill="#969696" />
                <circle
                  id="Ellipse_59013"
                  data-name="Ellipse 59013"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.32 90.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59014"
                  data-name="Ellipse 59014"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.29 85.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59015"
                  data-name="Ellipse 59015"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.29 80.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59016"
                  data-name="Ellipse 59016"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.96 83.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59017"
                  data-name="Ellipse 59017"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.37 79.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59018"
                  data-name="Ellipse 59018"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.15 78.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59019"
                  data-name="Ellipse 59019"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.15 72.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59020"
                  data-name="Ellipse 59020"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.82 75.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59021"
                  data-name="Ellipse 59021"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.23 72.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59022"
                  data-name="Ellipse 59022"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.85 83.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59023"
                  data-name="Ellipse 59023"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.85 77.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59024"
                  data-name="Ellipse 59024"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.52 80.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59025"
                  data-name="Ellipse 59025"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.93 77.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59026"
                  data-name="Ellipse 59026"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.88 73.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59027"
                  data-name="Ellipse 59027"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.88 67.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59028"
                  data-name="Ellipse 59028"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.55 70.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59029"
                  data-name="Ellipse 59029"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.96 67.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59030"
                  data-name="Ellipse 59030"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.79 81.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59031"
                  data-name="Ellipse 59031"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.79 75.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_59032" data-name="Ellipse 59032" cx="0.56" cy="0.56" r="0.56" transform="translate(169.46 79)" fill="#969696" />
                <circle
                  id="Ellipse_59033"
                  data-name="Ellipse 59033"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.87 75.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59034"
                  data-name="Ellipse 59034"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.4 103.27)"
                  fill="#969696"
                />
                <circle id="Ellipse_59035" data-name="Ellipse 59035" cx="0.56" cy="0.56" r="0.56" transform="translate(159.4 97.65)" fill="#969696" />
                <circle
                  id="Ellipse_59036"
                  data-name="Ellipse 59036"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.07 100.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59037"
                  data-name="Ellipse 59037"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.48 97.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59038"
                  data-name="Ellipse 59038"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.26 95.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59039"
                  data-name="Ellipse 59039"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.26 89.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59040"
                  data-name="Ellipse 59040"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.93 92.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59041"
                  data-name="Ellipse 59041"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.34 89.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59042"
                  data-name="Ellipse 59042"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.96 100.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59043"
                  data-name="Ellipse 59043"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.96 95.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59044"
                  data-name="Ellipse 59044"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.63 98.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59045"
                  data-name="Ellipse 59045"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.04 94.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59046"
                  data-name="Ellipse 59046"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.99 90.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59047"
                  data-name="Ellipse 59047"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.99 85.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59048"
                  data-name="Ellipse 59048"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.66 88.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59049"
                  data-name="Ellipse 59049"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.07 84.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_59050" data-name="Ellipse 59050" cx="0.56" cy="0.56" r="0.56" transform="translate(170.9 99.02)" fill="#969696" />
                <circle id="Ellipse_59051" data-name="Ellipse 59051" cx="0.56" cy="0.56" r="0.56" transform="translate(170.9 93.4)" fill="#969696" />
                <circle
                  id="Ellipse_59052"
                  data-name="Ellipse 59052"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.57 96.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_59053" data-name="Ellipse 59053" cx="0.56" cy="0.56" r="0.56" transform="translate(173.98 93)" fill="#969696" />
                <circle
                  id="Ellipse_59054"
                  data-name="Ellipse 59054"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.57 90.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59055"
                  data-name="Ellipse 59055"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.57 84.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59056"
                  data-name="Ellipse 59056"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.23 87.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59057"
                  data-name="Ellipse 59057"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.64 84.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59058"
                  data-name="Ellipse 59058"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.42 82.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59059"
                  data-name="Ellipse 59059"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.42 76.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59060"
                  data-name="Ellipse 59060"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.09 79.75)"
                  fill="#969696"
                />
                <circle id="Ellipse_59061" data-name="Ellipse 59061" cx="0.56" cy="0.56" r="0.56" transform="translate(178.5 76.34)" fill="#969696" />
                <circle
                  id="Ellipse_59062"
                  data-name="Ellipse 59062"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.12 87.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59063"
                  data-name="Ellipse 59063"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.12 82.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59064"
                  data-name="Ellipse 59064"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.79 85.18)"
                  fill="#969696"
                />
                <circle id="Ellipse_59065" data-name="Ellipse 59065" cx="0.56" cy="0.56" r="0.56" transform="translate(182.2 81.77)" fill="#969696" />
                <circle
                  id="Ellipse_59066"
                  data-name="Ellipse 59066"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.16 77.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59067"
                  data-name="Ellipse 59067"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.16 72.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59068"
                  data-name="Ellipse 59068"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.83 75.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59069"
                  data-name="Ellipse 59069"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.24 71.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59070"
                  data-name="Ellipse 59070"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.07 85.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59071"
                  data-name="Ellipse 59071"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.07 80.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59072"
                  data-name="Ellipse 59072"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.73 83.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59073"
                  data-name="Ellipse 59073"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.14 79.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59074"
                  data-name="Ellipse 59074"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.47 101.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_59075" data-name="Ellipse 59075" cx="0.56" cy="0.56" r="0.56" transform="translate(31.92 97)" fill="#969696" />
                <circle id="Ellipse_59076" data-name="Ellipse 59076" cx="0.56" cy="0.56" r="0.56" transform="translate(33.33 93.59)" fill="#969696" />
                <circle
                  id="Ellipse_59077"
                  data-name="Ellipse 59077"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(33.95 105.04)"
                  fill="#969696"
                />
                <circle id="Ellipse_59078" data-name="Ellipse 59078" cx="0.56" cy="0.56" r="0.56" transform="translate(33.95 99.42)" fill="#969696" />
                <circle
                  id="Ellipse_59079"
                  data-name="Ellipse 59079"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(35.62 102.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_59080" data-name="Ellipse 59080" cx="0.56" cy="0.56" r="0.56" transform="translate(37.03 99.02)" fill="#969696" />
                <circle id="Ellipse_59081" data-name="Ellipse 59081" cx="0.56" cy="0.56" r="0.56" transform="translate(35.98 95.03)" fill="#969696" />
                <circle id="Ellipse_59082" data-name="Ellipse 59082" cx="0.56" cy="0.56" r="0.56" transform="translate(35.98 89.41)" fill="#969696" />
                <circle id="Ellipse_59083" data-name="Ellipse 59083" cx="0.56" cy="0.56" r="0.56" transform="translate(37.65 92.42)" fill="#969696" />
                <circle id="Ellipse_59084" data-name="Ellipse 59084" cx="0.56" cy="0.56" r="0.56" transform="translate(39.06 89)" fill="#969696" />
                <circle
                  id="Ellipse_59085"
                  data-name="Ellipse 59085"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(39.89 103.09)"
                  fill="#969696"
                />
                <circle id="Ellipse_59086" data-name="Ellipse 59086" cx="0.56" cy="0.56" r="0.56" transform="translate(39.89 97.46)" fill="#969696" />
                <circle
                  id="Ellipse_59087"
                  data-name="Ellipse 59087"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.56 100.48)"
                  fill="#969696"
                />
                <circle id="Ellipse_59088" data-name="Ellipse 59088" cx="0.56" cy="0.56" r="0.56" transform="translate(42.97 97.06)" fill="#969696" />
                <circle id="Ellipse_59089" data-name="Ellipse 59089" cx="0.56" cy="0.56" r="0.56" transform="translate(41.94 92.84)" fill="#969696" />
                <circle id="Ellipse_59090" data-name="Ellipse 59090" cx="0.56" cy="0.56" r="0.56" transform="translate(41.94 87.21)" fill="#969696" />
                <circle id="Ellipse_59091" data-name="Ellipse 59091" cx="0.56" cy="0.56" r="0.56" transform="translate(43.61 90.22)" fill="#969696" />
                <circle id="Ellipse_59092" data-name="Ellipse 59092" cx="0.56" cy="0.56" r="0.56" transform="translate(45.02 86.81)" fill="#969696" />
                <circle id="Ellipse_59093" data-name="Ellipse 59093" cx="0.56" cy="0.56" r="0.56" transform="translate(43.8 85.11)" fill="#969696" />
                <circle id="Ellipse_59094" data-name="Ellipse 59094" cx="0.56" cy="0.56" r="0.56" transform="translate(43.8 79.49)" fill="#969696" />
                <circle id="Ellipse_59095" data-name="Ellipse 59095" cx="0.56" cy="0.56" r="0.56" transform="translate(45.47 82.5)" fill="#969696" />
                <circle id="Ellipse_59096" data-name="Ellipse 59096" cx="0.56" cy="0.56" r="0.56" transform="translate(46.88 79.09)" fill="#969696" />
                <circle id="Ellipse_59097" data-name="Ellipse 59097" cx="0.56" cy="0.56" r="0.56" transform="translate(47.5 90.54)" fill="#969696" />
                <circle id="Ellipse_59098" data-name="Ellipse 59098" cx="0.56" cy="0.56" r="0.56" transform="translate(47.5 84.92)" fill="#969696" />
                <circle id="Ellipse_59099" data-name="Ellipse 59099" cx="0.56" cy="0.56" r="0.56" transform="translate(49.17 87.93)" fill="#969696" />
                <circle id="Ellipse_59100" data-name="Ellipse 59100" cx="0.56" cy="0.56" r="0.56" transform="translate(50.58 84.52)" fill="#969696" />
                <circle id="Ellipse_59101" data-name="Ellipse 59101" cx="0.56" cy="0.56" r="0.56" transform="translate(49.54 80.53)" fill="#969696" />
                <circle id="Ellipse_59102" data-name="Ellipse 59102" cx="0.56" cy="0.56" r="0.56" transform="translate(49.54 74.91)" fill="#969696" />
                <circle id="Ellipse_59103" data-name="Ellipse 59103" cx="0.56" cy="0.56" r="0.56" transform="translate(51.2 77.92)" fill="#969696" />
                <circle id="Ellipse_59104" data-name="Ellipse 59104" cx="0.56" cy="0.56" r="0.56" transform="translate(52.61 74.51)" fill="#969696" />
                <circle id="Ellipse_59105" data-name="Ellipse 59105" cx="0.56" cy="0.56" r="0.56" transform="translate(53.44 88.59)" fill="#969696" />
                <circle id="Ellipse_59106" data-name="Ellipse 59106" cx="0.56" cy="0.56" r="0.56" transform="translate(53.44 82.96)" fill="#969696" />
                <circle id="Ellipse_59107" data-name="Ellipse 59107" cx="0.56" cy="0.56" r="0.56" transform="translate(55.11 85.98)" fill="#969696" />
                <circle id="Ellipse_59108" data-name="Ellipse 59108" cx="0.56" cy="0.56" r="0.56" transform="translate(56.52 82.56)" fill="#969696" />
                <circle
                  id="Ellipse_59109"
                  data-name="Ellipse 59109"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.05 110.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59110"
                  data-name="Ellipse 59110"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.05 104.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59111"
                  data-name="Ellipse 59111"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.72 107.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59112"
                  data-name="Ellipse 59112"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(48.13 104.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59113"
                  data-name="Ellipse 59113"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.91 102.53)"
                  fill="#969696"
                />
                <circle id="Ellipse_59114" data-name="Ellipse 59114" cx="0.56" cy="0.56" r="0.56" transform="translate(46.91 96.9)" fill="#969696" />
                <circle id="Ellipse_59115" data-name="Ellipse 59115" cx="0.56" cy="0.56" r="0.56" transform="translate(48.58 99.91)" fill="#969696" />
                <circle id="Ellipse_59116" data-name="Ellipse 59116" cx="0.56" cy="0.56" r="0.56" transform="translate(49.99 96.5)" fill="#969696" />
                <circle
                  id="Ellipse_59117"
                  data-name="Ellipse 59117"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.61 107.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59118"
                  data-name="Ellipse 59118"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.61 102.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59119"
                  data-name="Ellipse 59119"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.28 105.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59120"
                  data-name="Ellipse 59120"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.69 101.93)"
                  fill="#969696"
                />
                <circle id="Ellipse_59121" data-name="Ellipse 59121" cx="0.56" cy="0.56" r="0.56" transform="translate(52.65 97.94)" fill="#969696" />
                <circle id="Ellipse_59122" data-name="Ellipse 59122" cx="0.56" cy="0.56" r="0.56" transform="translate(52.65 92.32)" fill="#969696" />
                <circle id="Ellipse_59123" data-name="Ellipse 59123" cx="0.56" cy="0.56" r="0.56" transform="translate(54.31 95.33)" fill="#969696" />
                <circle id="Ellipse_59124" data-name="Ellipse 59124" cx="0.56" cy="0.56" r="0.56" transform="translate(55.72 91.92)" fill="#969696" />
                <circle id="Ellipse_59125" data-name="Ellipse 59125" cx="0.56" cy="0.56" r="0.56" transform="translate(56.55 106)" fill="#969696" />
                <circle
                  id="Ellipse_59126"
                  data-name="Ellipse 59126"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.55 100.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59127"
                  data-name="Ellipse 59127"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.22 103.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_59128" data-name="Ellipse 59128" cx="0.56" cy="0.56" r="0.56" transform="translate(59.63 99.98)" fill="#969696" />
                <circle id="Ellipse_59129" data-name="Ellipse 59129" cx="0.56" cy="0.56" r="0.56" transform="translate(59.22 97.06)" fill="#969696" />
                <circle id="Ellipse_59130" data-name="Ellipse 59130" cx="0.56" cy="0.56" r="0.56" transform="translate(59.22 91.44)" fill="#969696" />
                <circle id="Ellipse_59131" data-name="Ellipse 59131" cx="0.56" cy="0.56" r="0.56" transform="translate(60.88 94.45)" fill="#969696" />
                <circle id="Ellipse_59132" data-name="Ellipse 59132" cx="0.56" cy="0.56" r="0.56" transform="translate(62.29 91.04)" fill="#969696" />
                <circle id="Ellipse_59133" data-name="Ellipse 59133" cx="0.56" cy="0.56" r="0.56" transform="translate(61.08 89.34)" fill="#969696" />
                <circle id="Ellipse_59134" data-name="Ellipse 59134" cx="0.56" cy="0.56" r="0.56" transform="translate(61.08 83.72)" fill="#969696" />
                <circle id="Ellipse_59135" data-name="Ellipse 59135" cx="0.56" cy="0.56" r="0.56" transform="translate(62.74 86.73)" fill="#969696" />
                <circle id="Ellipse_59136" data-name="Ellipse 59136" cx="0.56" cy="0.56" r="0.56" transform="translate(64.15 83.31)" fill="#969696" />
                <circle id="Ellipse_59137" data-name="Ellipse 59137" cx="0.56" cy="0.56" r="0.56" transform="translate(64.78 94.77)" fill="#969696" />
                <circle id="Ellipse_59138" data-name="Ellipse 59138" cx="0.56" cy="0.56" r="0.56" transform="translate(64.78 89.14)" fill="#969696" />
                <circle id="Ellipse_59139" data-name="Ellipse 59139" cx="0.56" cy="0.56" r="0.56" transform="translate(66.44 92.16)" fill="#969696" />
                <circle id="Ellipse_59140" data-name="Ellipse 59140" cx="0.56" cy="0.56" r="0.56" transform="translate(67.85 88.74)" fill="#969696" />
                <circle id="Ellipse_59141" data-name="Ellipse 59141" cx="0.56" cy="0.56" r="0.56" transform="translate(66.81 84.76)" fill="#969696" />
                <circle id="Ellipse_59142" data-name="Ellipse 59142" cx="0.56" cy="0.56" r="0.56" transform="translate(66.81 79.13)" fill="#969696" />
                <circle id="Ellipse_59143" data-name="Ellipse 59143" cx="0.56" cy="0.56" r="0.56" transform="translate(68.48 82.14)" fill="#969696" />
                <circle id="Ellipse_59144" data-name="Ellipse 59144" cx="0.56" cy="0.56" r="0.56" transform="translate(69.89 78.73)" fill="#969696" />
                <circle id="Ellipse_59145" data-name="Ellipse 59145" cx="0.56" cy="0.56" r="0.56" transform="translate(70.72 92.81)" fill="#969696" />
                <circle id="Ellipse_59146" data-name="Ellipse 59146" cx="0.56" cy="0.56" r="0.56" transform="translate(70.72 87.19)" fill="#969696" />
                <circle id="Ellipse_59147" data-name="Ellipse 59147" cx="0.56" cy="0.56" r="0.56" transform="translate(72.38 90.2)" fill="#969696" />
                <circle id="Ellipse_59148" data-name="Ellipse 59148" cx="0.56" cy="0.56" r="0.56" transform="translate(73.79 86.79)" fill="#969696" />
                <circle id="Ellipse_59149" data-name="Ellipse 59149" cx="0.56" cy="0.56" r="0.56" transform="translate(41.09 75.83)" fill="#969696" />
                <circle id="Ellipse_59150" data-name="Ellipse 59150" cx="0.56" cy="0.56" r="0.56" transform="translate(41.09 70.21)" fill="#969696" />
                <circle id="Ellipse_59151" data-name="Ellipse 59151" cx="0.56" cy="0.56" r="0.56" transform="translate(42.76 73.22)" fill="#969696" />
                <circle id="Ellipse_59152" data-name="Ellipse 59152" cx="0.56" cy="0.56" r="0.56" transform="translate(44.17 69.81)" fill="#969696" />
                <circle id="Ellipse_59153" data-name="Ellipse 59153" cx="0.56" cy="0.56" r="0.56" transform="translate(42.95 68.11)" fill="#969696" />
                <circle id="Ellipse_59154" data-name="Ellipse 59154" cx="0.56" cy="0.56" r="0.56" transform="translate(42.95 62.49)" fill="#969696" />
                <circle id="Ellipse_59155" data-name="Ellipse 59155" cx="0.56" cy="0.56" r="0.56" transform="translate(44.61 65.5)" fill="#969696" />
                <circle id="Ellipse_59156" data-name="Ellipse 59156" cx="0.56" cy="0.56" r="0.56" transform="translate(46.02 62.08)" fill="#969696" />
                <circle id="Ellipse_59157" data-name="Ellipse 59157" cx="0.56" cy="0.56" r="0.56" transform="translate(46.65 73.54)" fill="#969696" />
                <circle id="Ellipse_59158" data-name="Ellipse 59158" cx="0.56" cy="0.56" r="0.56" transform="translate(46.65 67.91)" fill="#969696" />
                <circle id="Ellipse_59159" data-name="Ellipse 59159" cx="0.56" cy="0.56" r="0.56" transform="translate(48.31 70.93)" fill="#969696" />
                <circle id="Ellipse_59160" data-name="Ellipse 59160" cx="0.56" cy="0.56" r="0.56" transform="translate(49.72 67.51)" fill="#969696" />
                <circle id="Ellipse_59161" data-name="Ellipse 59161" cx="0.56" cy="0.56" r="0.56" transform="translate(48.68 63.53)" fill="#969696" />
                <circle id="Ellipse_59162" data-name="Ellipse 59162" cx="0.56" cy="0.56" r="0.56" transform="translate(48.68 57.9)" fill="#969696" />
                <circle id="Ellipse_59163" data-name="Ellipse 59163" cx="0.56" cy="0.56" r="0.56" transform="translate(50.35 60.91)" fill="#969696" />
                <circle id="Ellipse_59164" data-name="Ellipse 59164" cx="0.56" cy="0.56" r="0.56" transform="translate(51.76 57.5)" fill="#969696" />
                <circle id="Ellipse_59165" data-name="Ellipse 59165" cx="0.56" cy="0.56" r="0.56" transform="translate(52.59 71.58)" fill="#969696" />
                <circle id="Ellipse_59166" data-name="Ellipse 59166" cx="0.56" cy="0.56" r="0.56" transform="translate(52.59 65.96)" fill="#969696" />
                <circle id="Ellipse_59167" data-name="Ellipse 59167" cx="0.56" cy="0.56" r="0.56" transform="translate(54.26 68.97)" fill="#969696" />
                <circle id="Ellipse_59168" data-name="Ellipse 59168" cx="0.56" cy="0.56" r="0.56" transform="translate(55.67 65.56)" fill="#969696" />
                <circle id="Ellipse_59169" data-name="Ellipse 59169" cx="0.56" cy="0.56" r="0.56" transform="translate(54.64 61.33)" fill="#969696" />
                <circle id="Ellipse_59170" data-name="Ellipse 59170" cx="0.56" cy="0.56" r="0.56" transform="translate(54.64 55.71)" fill="#969696" />
                <circle id="Ellipse_59171" data-name="Ellipse 59171" cx="0.56" cy="0.56" r="0.56" transform="translate(56.31 58.72)" fill="#969696" />
                <circle id="Ellipse_59172" data-name="Ellipse 59172" cx="0.56" cy="0.56" r="0.56" transform="translate(57.72 55.31)" fill="#969696" />
                <circle id="Ellipse_59173" data-name="Ellipse 59173" cx="0.56" cy="0.56" r="0.56" transform="translate(56.5 53.61)" fill="#969696" />
                <circle id="Ellipse_59174" data-name="Ellipse 59174" cx="0.56" cy="0.56" r="0.56" transform="translate(56.5 47.99)" fill="#969696" />
                <circle id="Ellipse_59175" data-name="Ellipse 59175" cx="0.56" cy="0.56" r="0.56" transform="translate(58.17 51)" fill="#969696" />
                <circle id="Ellipse_59176" data-name="Ellipse 59176" cx="0.56" cy="0.56" r="0.56" transform="translate(59.58 47.58)" fill="#969696" />
                <circle id="Ellipse_59177" data-name="Ellipse 59177" cx="0.56" cy="0.56" r="0.56" transform="translate(60.2 59.04)" fill="#969696" />
                <circle id="Ellipse_59178" data-name="Ellipse 59178" cx="0.56" cy="0.56" r="0.56" transform="translate(60.2 53.42)" fill="#969696" />
                <circle id="Ellipse_59179" data-name="Ellipse 59179" cx="0.56" cy="0.56" r="0.56" transform="translate(61.87 56.43)" fill="#969696" />
                <circle id="Ellipse_59180" data-name="Ellipse 59180" cx="0.56" cy="0.56" r="0.56" transform="translate(63.28 53.01)" fill="#969696" />
                <circle id="Ellipse_59181" data-name="Ellipse 59181" cx="0.56" cy="0.56" r="0.56" transform="translate(62.23 49.03)" fill="#969696" />
                <circle id="Ellipse_59182" data-name="Ellipse 59182" cx="0.56" cy="0.56" r="0.56" transform="translate(62.23 43.4)" fill="#969696" />
                <circle id="Ellipse_59183" data-name="Ellipse 59183" cx="0.56" cy="0.56" r="0.56" transform="translate(63.9 46.41)" fill="#969696" />
                <circle id="Ellipse_59184" data-name="Ellipse 59184" cx="0.56" cy="0.56" r="0.56" transform="translate(65.31 43)" fill="#969696" />
                <circle id="Ellipse_59185" data-name="Ellipse 59185" cx="0.56" cy="0.56" r="0.56" transform="translate(66.14 57.09)" fill="#969696" />
                <circle id="Ellipse_59186" data-name="Ellipse 59186" cx="0.56" cy="0.56" r="0.56" transform="translate(66.14 51.46)" fill="#969696" />
                <circle id="Ellipse_59187" data-name="Ellipse 59187" cx="0.56" cy="0.56" r="0.56" transform="translate(67.81 54.47)" fill="#969696" />
                <circle id="Ellipse_59188" data-name="Ellipse 59188" cx="0.56" cy="0.56" r="0.56" transform="translate(69.22 51.06)" fill="#969696" />
                <circle id="Ellipse_59189" data-name="Ellipse 59189" cx="0.56" cy="0.56" r="0.56" transform="translate(57.75 78.75)" fill="#969696" />
                <circle id="Ellipse_59190" data-name="Ellipse 59190" cx="0.56" cy="0.56" r="0.56" transform="translate(57.75 73.12)" fill="#969696" />
                <circle id="Ellipse_59191" data-name="Ellipse 59191" cx="0.56" cy="0.56" r="0.56" transform="translate(59.42 76.13)" fill="#969696" />
                <circle id="Ellipse_59192" data-name="Ellipse 59192" cx="0.56" cy="0.56" r="0.56" transform="translate(60.83 72.72)" fill="#969696" />
                <circle id="Ellipse_59193" data-name="Ellipse 59193" cx="0.56" cy="0.56" r="0.56" transform="translate(59.61 71.02)" fill="#969696" />
                <circle id="Ellipse_59194" data-name="Ellipse 59194" cx="0.56" cy="0.56" r="0.56" transform="translate(59.61 65.4)" fill="#969696" />
                <circle id="Ellipse_59195" data-name="Ellipse 59195" cx="0.56" cy="0.56" r="0.56" transform="translate(61.28 68.41)" fill="#969696" />
                <circle id="Ellipse_59196" data-name="Ellipse 59196" cx="0.56" cy="0.56" r="0.56" transform="translate(62.69 65)" fill="#969696" />
                <circle id="Ellipse_59197" data-name="Ellipse 59197" cx="0.56" cy="0.56" r="0.56" transform="translate(63.31 76.45)" fill="#969696" />
                <circle id="Ellipse_59198" data-name="Ellipse 59198" cx="0.56" cy="0.56" r="0.56" transform="translate(63.31 70.83)" fill="#969696" />
                <circle id="Ellipse_59199" data-name="Ellipse 59199" cx="0.56" cy="0.56" r="0.56" transform="translate(64.98 73.84)" fill="#969696" />
                <circle id="Ellipse_59200" data-name="Ellipse 59200" cx="0.56" cy="0.56" r="0.56" transform="translate(66.39 70.43)" fill="#969696" />
                <circle id="Ellipse_59201" data-name="Ellipse 59201" cx="0.56" cy="0.56" r="0.56" transform="translate(65.35 66.44)" fill="#969696" />
                <circle id="Ellipse_59202" data-name="Ellipse 59202" cx="0.56" cy="0.56" r="0.56" transform="translate(65.35 60.82)" fill="#969696" />
                <circle id="Ellipse_59203" data-name="Ellipse 59203" cx="0.56" cy="0.56" r="0.56" transform="translate(67.01 63.83)" fill="#969696" />
                <circle id="Ellipse_59204" data-name="Ellipse 59204" cx="0.56" cy="0.56" r="0.56" transform="translate(68.42 60.42)" fill="#969696" />
                <circle id="Ellipse_59205" data-name="Ellipse 59205" cx="0.56" cy="0.56" r="0.56" transform="translate(69.25 74.5)" fill="#969696" />
                <circle id="Ellipse_59206" data-name="Ellipse 59206" cx="0.56" cy="0.56" r="0.56" transform="translate(69.25 68.88)" fill="#969696" />
                <circle id="Ellipse_59207" data-name="Ellipse 59207" cx="0.56" cy="0.56" r="0.56" transform="translate(70.92 71.89)" fill="#969696" />
                <circle id="Ellipse_59208" data-name="Ellipse 59208" cx="0.56" cy="0.56" r="0.56" transform="translate(72.33 68.47)" fill="#969696" />
                <circle id="Ellipse_59209" data-name="Ellipse 59209" cx="0.56" cy="0.56" r="0.56" transform="translate(71.92 65.56)" fill="#969696" />
                <circle id="Ellipse_59210" data-name="Ellipse 59210" cx="0.56" cy="0.56" r="0.56" transform="translate(71.92 59.93)" fill="#969696" />
                <circle id="Ellipse_59211" data-name="Ellipse 59211" cx="0.56" cy="0.56" r="0.56" transform="translate(73.58 62.95)" fill="#969696" />
                <circle id="Ellipse_59212" data-name="Ellipse 59212" cx="0.56" cy="0.56" r="0.56" transform="translate(74.99 59.53)" fill="#969696" />
                <circle id="Ellipse_59213" data-name="Ellipse 59213" cx="0.56" cy="0.56" r="0.56" transform="translate(73.77 57.84)" fill="#969696" />
                <circle id="Ellipse_59214" data-name="Ellipse 59214" cx="0.56" cy="0.56" r="0.56" transform="translate(73.77 52.21)" fill="#969696" />
                <circle id="Ellipse_59215" data-name="Ellipse 59215" cx="0.56" cy="0.56" r="0.56" transform="translate(75.44 55.22)" fill="#969696" />
                <circle id="Ellipse_59216" data-name="Ellipse 59216" cx="0.56" cy="0.56" r="0.56" transform="translate(76.85 51.81)" fill="#969696" />
                <circle id="Ellipse_59217" data-name="Ellipse 59217" cx="0.56" cy="0.56" r="0.56" transform="translate(77.47 63.27)" fill="#969696" />
                <circle id="Ellipse_59218" data-name="Ellipse 59218" cx="0.56" cy="0.56" r="0.56" transform="translate(77.47 57.64)" fill="#969696" />
                <circle id="Ellipse_59219" data-name="Ellipse 59219" cx="0.56" cy="0.56" r="0.56" transform="translate(79.14 60.65)" fill="#969696" />
                <circle id="Ellipse_59220" data-name="Ellipse 59220" cx="0.56" cy="0.56" r="0.56" transform="translate(80.55 57.24)" fill="#969696" />
                <circle id="Ellipse_59221" data-name="Ellipse 59221" cx="0.56" cy="0.56" r="0.56" transform="translate(79.51 53.25)" fill="#969696" />
                <circle id="Ellipse_59222" data-name="Ellipse 59222" cx="0.56" cy="0.56" r="0.56" transform="translate(79.51 47.63)" fill="#969696" />
                <circle id="Ellipse_59223" data-name="Ellipse 59223" cx="0.56" cy="0.56" r="0.56" transform="translate(81.18 50.64)" fill="#969696" />
                <circle id="Ellipse_59224" data-name="Ellipse 59224" cx="0.56" cy="0.56" r="0.56" transform="translate(82.59 47.23)" fill="#969696" />
                <circle id="Ellipse_59225" data-name="Ellipse 59225" cx="0.56" cy="0.56" r="0.56" transform="translate(83.42 61.31)" fill="#969696" />
                <circle id="Ellipse_59226" data-name="Ellipse 59226" cx="0.56" cy="0.56" r="0.56" transform="translate(83.42 55.69)" fill="#969696" />
                <circle id="Ellipse_59227" data-name="Ellipse 59227" cx="0.56" cy="0.56" r="0.56" transform="translate(85.08 58.7)" fill="#969696" />
                <circle id="Ellipse_59228" data-name="Ellipse 59228" cx="0.56" cy="0.56" r="0.56" transform="translate(86.49 55.29)" fill="#969696" />
                <circle id="Ellipse_59229" data-name="Ellipse 59229" cx="0.56" cy="0.56" r="0.56" transform="translate(74.41 82.99)" fill="#969696" />
                <circle id="Ellipse_59230" data-name="Ellipse 59230" cx="0.56" cy="0.56" r="0.56" transform="translate(74.41 77.37)" fill="#969696" />
                <circle id="Ellipse_59231" data-name="Ellipse 59231" cx="0.56" cy="0.56" r="0.56" transform="translate(76.07 80.38)" fill="#969696" />
                <circle id="Ellipse_59232" data-name="Ellipse 59232" cx="0.56" cy="0.56" r="0.56" transform="translate(77.48 76.97)" fill="#969696" />
                <circle id="Ellipse_59233" data-name="Ellipse 59233" cx="0.56" cy="0.56" r="0.56" transform="translate(76.27 75.27)" fill="#969696" />
                <circle id="Ellipse_59234" data-name="Ellipse 59234" cx="0.56" cy="0.56" r="0.56" transform="translate(76.27 69.65)" fill="#969696" />
                <circle id="Ellipse_59235" data-name="Ellipse 59235" cx="0.56" cy="0.56" r="0.56" transform="translate(77.93 72.66)" fill="#969696" />
                <circle id="Ellipse_59236" data-name="Ellipse 59236" cx="0.56" cy="0.56" r="0.56" transform="translate(79.34 69.24)" fill="#969696" />
                <circle id="Ellipse_59237" data-name="Ellipse 59237" cx="0.56" cy="0.56" r="0.56" transform="translate(79.97 80.7)" fill="#969696" />
                <circle id="Ellipse_59238" data-name="Ellipse 59238" cx="0.56" cy="0.56" r="0.56" transform="translate(79.97 75.07)" fill="#969696" />
                <circle id="Ellipse_59239" data-name="Ellipse 59239" cx="0.56" cy="0.56" r="0.56" transform="translate(81.63 78.09)" fill="#969696" />
                <circle id="Ellipse_59240" data-name="Ellipse 59240" cx="0.56" cy="0.56" r="0.56" transform="translate(83.04 74.67)" fill="#969696" />
                <circle id="Ellipse_59241" data-name="Ellipse 59241" cx="0.56" cy="0.56" r="0.56" transform="translate(82 70.69)" fill="#969696" />
                <circle id="Ellipse_59242" data-name="Ellipse 59242" cx="0.56" cy="0.56" r="0.56" transform="translate(82 65.06)" fill="#969696" />
                <circle id="Ellipse_59243" data-name="Ellipse 59243" cx="0.56" cy="0.56" r="0.56" transform="translate(83.67 68.07)" fill="#969696" />
                <circle id="Ellipse_59244" data-name="Ellipse 59244" cx="0.56" cy="0.56" r="0.56" transform="translate(85.08 64.66)" fill="#969696" />
                <circle id="Ellipse_59245" data-name="Ellipse 59245" cx="0.56" cy="0.56" r="0.56" transform="translate(85.91 78.75)" fill="#969696" />
                <circle id="Ellipse_59246" data-name="Ellipse 59246" cx="0.56" cy="0.56" r="0.56" transform="translate(85.91 73.12)" fill="#969696" />
                <circle id="Ellipse_59247" data-name="Ellipse 59247" cx="0.56" cy="0.56" r="0.56" transform="translate(87.57 76.13)" fill="#969696" />
                <circle id="Ellipse_59248" data-name="Ellipse 59248" cx="0.56" cy="0.56" r="0.56" transform="translate(88.98 72.72)" fill="#969696" />
                <circle id="Ellipse_59249" data-name="Ellipse 59249" cx="0.56" cy="0.56" r="0.56" transform="translate(87.96 68.49)" fill="#969696" />
                <circle id="Ellipse_59250" data-name="Ellipse 59250" cx="0.56" cy="0.56" r="0.56" transform="translate(87.96 62.87)" fill="#969696" />
                <circle id="Ellipse_59251" data-name="Ellipse 59251" cx="0.56" cy="0.56" r="0.56" transform="translate(89.62 65.88)" fill="#969696" />
                <circle id="Ellipse_59252" data-name="Ellipse 59252" cx="0.56" cy="0.56" r="0.56" transform="translate(91.03 62.47)" fill="#969696" />
                <circle id="Ellipse_59253" data-name="Ellipse 59253" cx="0.56" cy="0.56" r="0.56" transform="translate(89.82 60.77)" fill="#969696" />
                <circle id="Ellipse_59254" data-name="Ellipse 59254" cx="0.56" cy="0.56" r="0.56" transform="translate(89.82 55.15)" fill="#969696" />
                <circle id="Ellipse_59255" data-name="Ellipse 59255" cx="0.56" cy="0.56" r="0.56" transform="translate(91.48 58.16)" fill="#969696" />
                <circle id="Ellipse_59256" data-name="Ellipse 59256" cx="0.56" cy="0.56" r="0.56" transform="translate(92.89 54.74)" fill="#969696" />
                <circle id="Ellipse_59257" data-name="Ellipse 59257" cx="0.56" cy="0.56" r="0.56" transform="translate(93.52 66.2)" fill="#969696" />
                <circle id="Ellipse_59258" data-name="Ellipse 59258" cx="0.56" cy="0.56" r="0.56" transform="translate(93.52 60.58)" fill="#969696" />
                <circle id="Ellipse_59259" data-name="Ellipse 59259" cx="0.56" cy="0.56" r="0.56" transform="translate(95.18 63.59)" fill="#969696" />
                <circle id="Ellipse_59260" data-name="Ellipse 59260" cx="0.56" cy="0.56" r="0.56" transform="translate(96.59 60.17)" fill="#969696" />
                <circle id="Ellipse_59261" data-name="Ellipse 59261" cx="0.56" cy="0.56" r="0.56" transform="translate(95.55 56.19)" fill="#969696" />
                <circle id="Ellipse_59262" data-name="Ellipse 59262" cx="0.56" cy="0.56" r="0.56" transform="translate(95.55 50.56)" fill="#969696" />
                <circle id="Ellipse_59263" data-name="Ellipse 59263" cx="0.56" cy="0.56" r="0.56" transform="translate(97.22 53.57)" fill="#969696" />
                <path
                  id="Path_12318"
                  data-name="Path 12318"
                  d="M99,50.19a.51.51,0,0,0,.14-.36.56.56,0,1,0-.56.56.76.76,0,0,0,.16,0,.57.57,0,0,0-.14.36.56.56,0,1,0,.56-.56.76.76,0,0,0-.16,0Z"
                  fill="#969696"
                />
                <circle id="Ellipse_59264" data-name="Ellipse 59264" cx="0.56" cy="0.56" r="0.56" transform="translate(99.46 64.25)" fill="#969696" />
                <circle id="Ellipse_59265" data-name="Ellipse 59265" cx="0.56" cy="0.56" r="0.56" transform="translate(99.46 58.62)" fill="#969696" />
                <circle
                  id="Ellipse_59266"
                  data-name="Ellipse 59266"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.13 61.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59267"
                  data-name="Ellipse 59267"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.54 58.22)"
                  fill="#969696"
                />
                <circle id="Ellipse_59268" data-name="Ellipse 59268" cx="0.56" cy="0.56" r="0.56" transform="translate(91.07 85.91)" fill="#969696" />
                <circle id="Ellipse_59269" data-name="Ellipse 59269" cx="0.56" cy="0.56" r="0.56" transform="translate(91.07 80.28)" fill="#969696" />
                <circle id="Ellipse_59270" data-name="Ellipse 59270" cx="0.56" cy="0.56" r="0.56" transform="translate(92.74 83.29)" fill="#969696" />
                <circle id="Ellipse_59271" data-name="Ellipse 59271" cx="0.56" cy="0.56" r="0.56" transform="translate(94.15 79.88)" fill="#969696" />
                <circle id="Ellipse_59272" data-name="Ellipse 59272" cx="0.56" cy="0.56" r="0.56" transform="translate(92.93 78.18)" fill="#969696" />
                <circle id="Ellipse_59273" data-name="Ellipse 59273" cx="0.56" cy="0.56" r="0.56" transform="translate(92.93 72.56)" fill="#969696" />
                <circle id="Ellipse_59274" data-name="Ellipse 59274" cx="0.56" cy="0.56" r="0.56" transform="translate(94.59 75.57)" fill="#969696" />
                <circle id="Ellipse_59275" data-name="Ellipse 59275" cx="0.56" cy="0.56" r="0.56" transform="translate(96 72.16)" fill="#969696" />
                <circle id="Ellipse_59276" data-name="Ellipse 59276" cx="0.56" cy="0.56" r="0.56" transform="translate(96.63 83.61)" fill="#969696" />
                <circle id="Ellipse_59277" data-name="Ellipse 59277" cx="0.56" cy="0.56" r="0.56" transform="translate(96.63 77.99)" fill="#969696" />
                <circle id="Ellipse_59278" data-name="Ellipse 59278" cx="0.56" cy="0.56" r="0.56" transform="translate(98.29 81)" fill="#969696" />
                <circle id="Ellipse_59279" data-name="Ellipse 59279" cx="0.56" cy="0.56" r="0.56" transform="translate(99.7 77.59)" fill="#969696" />
                <circle id="Ellipse_59280" data-name="Ellipse 59280" cx="0.56" cy="0.56" r="0.56" transform="translate(98.66 73.6)" fill="#969696" />
                <circle id="Ellipse_59281" data-name="Ellipse 59281" cx="0.56" cy="0.56" r="0.56" transform="translate(98.66 67.98)" fill="#969696" />
                <circle
                  id="Ellipse_59282"
                  data-name="Ellipse 59282"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.33 70.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59283"
                  data-name="Ellipse 59283"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.74 67.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59284"
                  data-name="Ellipse 59284"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.57 81.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59285"
                  data-name="Ellipse 59285"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.57 76.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59286"
                  data-name="Ellipse 59286"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.24 79.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59287"
                  data-name="Ellipse 59287"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.65 75.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59288"
                  data-name="Ellipse 59288"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.23 72.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59289"
                  data-name="Ellipse 59289"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.23 67.09)"
                  fill="#969696"
                />
                <circle id="Ellipse_59290" data-name="Ellipse 59290" cx="0.56" cy="0.56" r="0.56" transform="translate(106.9 70.11)" fill="#969696" />
                <circle
                  id="Ellipse_59291"
                  data-name="Ellipse 59291"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.31 66.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_59292" data-name="Ellipse 59292" cx="0.56" cy="0.56" r="0.56" transform="translate(107.09 65)" fill="#969696" />
                <circle
                  id="Ellipse_59293"
                  data-name="Ellipse 59293"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.09 59.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59294"
                  data-name="Ellipse 59294"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.76 62.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59295"
                  data-name="Ellipse 59295"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.17 58.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59296"
                  data-name="Ellipse 59296"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.79 70.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_59297" data-name="Ellipse 59297" cx="0.56" cy="0.56" r="0.56" transform="translate(110.79 64.8)" fill="#969696" />
                <circle
                  id="Ellipse_59298"
                  data-name="Ellipse 59298"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.46 67.81)"
                  fill="#969696"
                />
                <circle id="Ellipse_59299" data-name="Ellipse 59299" cx="0.56" cy="0.56" r="0.56" transform="translate(113.87 64.4)" fill="#969696" />
                <circle
                  id="Ellipse_59300"
                  data-name="Ellipse 59300"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.83 60.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59301"
                  data-name="Ellipse 59301"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.83 54.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_59302" data-name="Ellipse 59302" cx="0.56" cy="0.56" r="0.56" transform="translate(114.49 57.8)" fill="#969696" />
                <circle id="Ellipse_59303" data-name="Ellipse 59303" cx="0.56" cy="0.56" r="0.56" transform="translate(115.9 54.39)" fill="#969696" />
                <circle
                  id="Ellipse_59304"
                  data-name="Ellipse 59304"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.73 68.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59305"
                  data-name="Ellipse 59305"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.73 62.85)"
                  fill="#969696"
                />
                <circle id="Ellipse_59306" data-name="Ellipse 59306" cx="0.56" cy="0.56" r="0.56" transform="translate(118.4 65.86)" fill="#969696" />
                <circle
                  id="Ellipse_59307"
                  data-name="Ellipse 59307"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.81 62.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59308"
                  data-name="Ellipse 59308"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(60.88 116.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59309"
                  data-name="Ellipse 59309"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(60.88 110.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59310"
                  data-name="Ellipse 59310"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.55 113.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59311"
                  data-name="Ellipse 59311"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(63.96 110.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59312"
                  data-name="Ellipse 59312"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.74 108.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59313"
                  data-name="Ellipse 59313"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.74 103.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59314"
                  data-name="Ellipse 59314"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(64.41 106.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59315"
                  data-name="Ellipse 59315"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.82 102.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59316"
                  data-name="Ellipse 59316"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(66.44 114.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59317"
                  data-name="Ellipse 59317"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(66.44 108.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59318"
                  data-name="Ellipse 59318"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.11 111.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59319"
                  data-name="Ellipse 59319"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.52 108.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59320"
                  data-name="Ellipse 59320"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.47 104.18)"
                  fill="#969696"
                />
                <circle id="Ellipse_59321" data-name="Ellipse 59321" cx="0.56" cy="0.56" r="0.56" transform="translate(68.47 98.56)" fill="#969696" />
                <circle
                  id="Ellipse_59322"
                  data-name="Ellipse 59322"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(70.14 101.57)"
                  fill="#969696"
                />
                <circle id="Ellipse_59323" data-name="Ellipse 59323" cx="0.56" cy="0.56" r="0.56" transform="translate(71.55 98.16)" fill="#969696" />
                <circle
                  id="Ellipse_59324"
                  data-name="Ellipse 59324"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.38 112.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59325"
                  data-name="Ellipse 59325"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.38 106.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59326"
                  data-name="Ellipse 59326"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(74.05 109.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59327"
                  data-name="Ellipse 59327"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.46 106.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59328"
                  data-name="Ellipse 59328"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(74.43 101.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_59329" data-name="Ellipse 59329" cx="0.56" cy="0.56" r="0.56" transform="translate(74.43 96.36)" fill="#969696" />
                <circle id="Ellipse_59330" data-name="Ellipse 59330" cx="0.56" cy="0.56" r="0.56" transform="translate(76.1 99.37)" fill="#969696" />
                <circle id="Ellipse_59331" data-name="Ellipse 59331" cx="0.56" cy="0.56" r="0.56" transform="translate(77.51 95.96)" fill="#969696" />
                <circle id="Ellipse_59332" data-name="Ellipse 59332" cx="0.56" cy="0.56" r="0.56" transform="translate(76.29 94.26)" fill="#969696" />
                <circle id="Ellipse_59333" data-name="Ellipse 59333" cx="0.56" cy="0.56" r="0.56" transform="translate(76.29 88.64)" fill="#969696" />
                <circle id="Ellipse_59334" data-name="Ellipse 59334" cx="0.56" cy="0.56" r="0.56" transform="translate(77.96 91.65)" fill="#969696" />
                <circle id="Ellipse_59335" data-name="Ellipse 59335" cx="0.56" cy="0.56" r="0.56" transform="translate(79.37 88.24)" fill="#969696" />
                <circle id="Ellipse_59336" data-name="Ellipse 59336" cx="0.56" cy="0.56" r="0.56" transform="translate(79.99 99.69)" fill="#969696" />
                <circle id="Ellipse_59337" data-name="Ellipse 59337" cx="0.56" cy="0.56" r="0.56" transform="translate(79.99 94.07)" fill="#969696" />
                <circle id="Ellipse_59338" data-name="Ellipse 59338" cx="0.56" cy="0.56" r="0.56" transform="translate(81.66 97.08)" fill="#969696" />
                <circle id="Ellipse_59339" data-name="Ellipse 59339" cx="0.56" cy="0.56" r="0.56" transform="translate(83.07 93.67)" fill="#969696" />
                <circle id="Ellipse_59340" data-name="Ellipse 59340" cx="0.56" cy="0.56" r="0.56" transform="translate(82.03 89.68)" fill="#969696" />
                <circle id="Ellipse_59341" data-name="Ellipse 59341" cx="0.56" cy="0.56" r="0.56" transform="translate(82.03 84.06)" fill="#969696" />
                <circle id="Ellipse_59342" data-name="Ellipse 59342" cx="0.56" cy="0.56" r="0.56" transform="translate(83.69 87.07)" fill="#969696" />
                <circle id="Ellipse_59343" data-name="Ellipse 59343" cx="0.56" cy="0.56" r="0.56" transform="translate(85.1 83.66)" fill="#969696" />
                <circle id="Ellipse_59344" data-name="Ellipse 59344" cx="0.56" cy="0.56" r="0.56" transform="translate(85.93 97.74)" fill="#969696" />
                <circle id="Ellipse_59345" data-name="Ellipse 59345" cx="0.56" cy="0.56" r="0.56" transform="translate(85.93 92.11)" fill="#969696" />
                <circle id="Ellipse_59346" data-name="Ellipse 59346" cx="0.56" cy="0.56" r="0.56" transform="translate(87.6 95.13)" fill="#969696" />
                <circle id="Ellipse_59347" data-name="Ellipse 59347" cx="0.56" cy="0.56" r="0.56" transform="translate(89.01 91.71)" fill="#969696" />
                <circle id="Ellipse_59348" data-name="Ellipse 59348" cx="0.56" cy="0.56" r="0.56" transform="translate(77.54 119.4)" fill="#969696" />
                <circle
                  id="Ellipse_59349"
                  data-name="Ellipse 59349"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(77.54 113.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59350"
                  data-name="Ellipse 59350"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(79.21 116.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59351"
                  data-name="Ellipse 59351"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(80.62 113.37)"
                  fill="#969696"
                />
                <circle id="Ellipse_59352" data-name="Ellipse 59352" cx="0.56" cy="0.56" r="0.56" transform="translate(79.4 111.68)" fill="#969696" />
                <circle id="Ellipse_59353" data-name="Ellipse 59353" cx="0.56" cy="0.56" r="0.56" transform="translate(79.4 106.05)" fill="#969696" />
                <circle
                  id="Ellipse_59354"
                  data-name="Ellipse 59354"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.07 109.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59355"
                  data-name="Ellipse 59355"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.48 105.65)"
                  fill="#969696"
                />
                <circle id="Ellipse_59356" data-name="Ellipse 59356" cx="0.56" cy="0.56" r="0.56" transform="translate(83.1 117.11)" fill="#969696" />
                <circle id="Ellipse_59357" data-name="Ellipse 59357" cx="0.56" cy="0.56" r="0.56" transform="translate(83.1 111.48)" fill="#969696" />
                <circle
                  id="Ellipse_59358"
                  data-name="Ellipse 59358"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(84.77 114.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59359"
                  data-name="Ellipse 59359"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(86.18 111.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59360"
                  data-name="Ellipse 59360"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.14 107.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59361"
                  data-name="Ellipse 59361"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.14 101.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_59362" data-name="Ellipse 59362" cx="0.56" cy="0.56" r="0.56" transform="translate(86.8 104.48)" fill="#969696" />
                <circle
                  id="Ellipse_59363"
                  data-name="Ellipse 59363"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(88.21 101.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59364"
                  data-name="Ellipse 59364"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.04 115.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59365"
                  data-name="Ellipse 59365"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.04 109.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59366"
                  data-name="Ellipse 59366"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.71 112.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59367"
                  data-name="Ellipse 59367"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(92.12 109.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59368"
                  data-name="Ellipse 59368"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.71 106.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59369"
                  data-name="Ellipse 59369"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.71 100.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_59370" data-name="Ellipse 59370" cx="0.56" cy="0.56" r="0.56" transform="translate(93.37 103.6)" fill="#969696" />
                <circle
                  id="Ellipse_59371"
                  data-name="Ellipse 59371"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(94.78 100.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_59372" data-name="Ellipse 59372" cx="0.56" cy="0.56" r="0.56" transform="translate(93.57 98.49)" fill="#969696" />
                <circle id="Ellipse_59373" data-name="Ellipse 59373" cx="0.56" cy="0.56" r="0.56" transform="translate(93.57 92.87)" fill="#969696" />
                <circle id="Ellipse_59374" data-name="Ellipse 59374" cx="0.56" cy="0.56" r="0.56" transform="translate(95.23 95.88)" fill="#969696" />
                <circle id="Ellipse_59375" data-name="Ellipse 59375" cx="0.56" cy="0.56" r="0.56" transform="translate(96.64 92.46)" fill="#969696" />
                <circle
                  id="Ellipse_59376"
                  data-name="Ellipse 59376"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(97.26 103.92)"
                  fill="#969696"
                />
                <circle id="Ellipse_59377" data-name="Ellipse 59377" cx="0.56" cy="0.56" r="0.56" transform="translate(97.26 98.3)" fill="#969696" />
                <circle
                  id="Ellipse_59378"
                  data-name="Ellipse 59378"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.93 101.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59379"
                  data-name="Ellipse 59379"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.34 97.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_59380" data-name="Ellipse 59380" cx="0.56" cy="0.56" r="0.56" transform="translate(99.3 93.91)" fill="#969696" />
                <circle id="Ellipse_59381" data-name="Ellipse 59381" cx="0.56" cy="0.56" r="0.56" transform="translate(99.3 88.28)" fill="#969696" />
                <circle
                  id="Ellipse_59382"
                  data-name="Ellipse 59382"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.97 91.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59383"
                  data-name="Ellipse 59383"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.38 87.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59384"
                  data-name="Ellipse 59384"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.21 101.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59385"
                  data-name="Ellipse 59385"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.21 96.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59386"
                  data-name="Ellipse 59386"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.87 99.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59387"
                  data-name="Ellipse 59387"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.28 95.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_59388" data-name="Ellipse 59388" cx="0.56" cy="0.56" r="0.56" transform="translate(54.06 44.37)" fill="#969696" />
                <circle id="Ellipse_59389" data-name="Ellipse 59389" cx="0.56" cy="0.56" r="0.56" transform="translate(54.06 38.74)" fill="#969696" />
                <circle id="Ellipse_59390" data-name="Ellipse 59390" cx="0.56" cy="0.56" r="0.56" transform="translate(55.73 41.76)" fill="#969696" />
                <circle id="Ellipse_59391" data-name="Ellipse 59391" cx="0.56" cy="0.56" r="0.56" transform="translate(57.14 38.34)" fill="#969696" />
                <circle id="Ellipse_59392" data-name="Ellipse 59392" cx="0.56" cy="0.56" r="0.56" transform="translate(55.92 36.64)" fill="#969696" />
                <circle id="Ellipse_59393" data-name="Ellipse 59393" cx="0.56" cy="0.56" r="0.56" transform="translate(55.92 31.02)" fill="#969696" />
                <circle id="Ellipse_59394" data-name="Ellipse 59394" cx="0.56" cy="0.56" r="0.56" transform="translate(57.59 34.03)" fill="#969696" />
                <circle id="Ellipse_59395" data-name="Ellipse 59395" cx="0.56" cy="0.56" r="0.56" transform="translate(59 30.62)" fill="#969696" />
                <circle id="Ellipse_59396" data-name="Ellipse 59396" cx="0.56" cy="0.56" r="0.56" transform="translate(59.62 42.07)" fill="#969696" />
                <circle id="Ellipse_59397" data-name="Ellipse 59397" cx="0.56" cy="0.56" r="0.56" transform="translate(59.62 36.45)" fill="#969696" />
                <circle id="Ellipse_59398" data-name="Ellipse 59398" cx="0.56" cy="0.56" r="0.56" transform="translate(61.29 39.46)" fill="#969696" />
                <circle id="Ellipse_59399" data-name="Ellipse 59399" cx="0.56" cy="0.56" r="0.56" transform="translate(62.7 36.05)" fill="#969696" />
                <circle id="Ellipse_59400" data-name="Ellipse 59400" cx="0.56" cy="0.56" r="0.56" transform="translate(61.66 32.06)" fill="#969696" />
                <circle id="Ellipse_59401" data-name="Ellipse 59401" cx="0.56" cy="0.56" r="0.56" transform="translate(61.66 26.44)" fill="#969696" />
                <circle id="Ellipse_59402" data-name="Ellipse 59402" cx="0.56" cy="0.56" r="0.56" transform="translate(63.32 29.45)" fill="#969696" />
                <circle id="Ellipse_59403" data-name="Ellipse 59403" cx="0.56" cy="0.56" r="0.56" transform="translate(64.73 26.04)" fill="#969696" />
                <circle id="Ellipse_59404" data-name="Ellipse 59404" cx="0.56" cy="0.56" r="0.56" transform="translate(65.56 40.12)" fill="#969696" />
                <circle id="Ellipse_59405" data-name="Ellipse 59405" cx="0.56" cy="0.56" r="0.56" transform="translate(65.56 34.5)" fill="#969696" />
                <circle id="Ellipse_59406" data-name="Ellipse 59406" cx="0.56" cy="0.56" r="0.56" transform="translate(67.23 37.51)" fill="#969696" />
                <circle id="Ellipse_59407" data-name="Ellipse 59407" cx="0.56" cy="0.56" r="0.56" transform="translate(68.64 34.1)" fill="#969696" />
                <circle id="Ellipse_59408" data-name="Ellipse 59408" cx="0.56" cy="0.56" r="0.56" transform="translate(67.61 29.87)" fill="#969696" />
                <circle id="Ellipse_59409" data-name="Ellipse 59409" cx="0.56" cy="0.56" r="0.56" transform="translate(67.61 24.24)" fill="#969696" />
                <circle id="Ellipse_59410" data-name="Ellipse 59410" cx="0.56" cy="0.56" r="0.56" transform="translate(69.28 27.26)" fill="#969696" />
                <circle id="Ellipse_59411" data-name="Ellipse 59411" cx="0.56" cy="0.56" r="0.56" transform="translate(70.69 23.84)" fill="#969696" />
                <circle id="Ellipse_59412" data-name="Ellipse 59412" cx="0.56" cy="0.56" r="0.56" transform="translate(69.47 22.14)" fill="#969696" />
                <circle id="Ellipse_59413" data-name="Ellipse 59413" cx="0.56" cy="0.56" r="0.56" transform="translate(69.47 16.52)" fill="#969696" />
                <circle id="Ellipse_59414" data-name="Ellipse 59414" cx="0.56" cy="0.56" r="0.56" transform="translate(71.14 19.53)" fill="#969696" />
                <circle id="Ellipse_59415" data-name="Ellipse 59415" cx="0.56" cy="0.56" r="0.56" transform="translate(72.55 16.12)" fill="#969696" />
                <circle id="Ellipse_59416" data-name="Ellipse 59416" cx="0.56" cy="0.56" r="0.56" transform="translate(73.17 27.57)" fill="#969696" />
                <circle id="Ellipse_59417" data-name="Ellipse 59417" cx="0.56" cy="0.56" r="0.56" transform="translate(73.17 21.95)" fill="#969696" />
                <circle id="Ellipse_59418" data-name="Ellipse 59418" cx="0.56" cy="0.56" r="0.56" transform="translate(74.84 24.96)" fill="#969696" />
                <circle id="Ellipse_59419" data-name="Ellipse 59419" cx="0.56" cy="0.56" r="0.56" transform="translate(76.25 21.55)" fill="#969696" />
                <circle id="Ellipse_59420" data-name="Ellipse 59420" cx="0.56" cy="0.56" r="0.56" transform="translate(75.21 17.56)" fill="#969696" />
                <circle id="Ellipse_59421" data-name="Ellipse 59421" cx="0.56" cy="0.56" r="0.56" transform="translate(75.21 11.94)" fill="#969696" />
                <circle id="Ellipse_59422" data-name="Ellipse 59422" cx="0.56" cy="0.56" r="0.56" transform="translate(76.87 14.95)" fill="#969696" />
                <circle id="Ellipse_59423" data-name="Ellipse 59423" cx="0.56" cy="0.56" r="0.56" transform="translate(78.28 11.54)" fill="#969696" />
                <circle id="Ellipse_59424" data-name="Ellipse 59424" cx="0.56" cy="0.56" r="0.56" transform="translate(79.11 25.62)" fill="#969696" />
                <circle id="Ellipse_59425" data-name="Ellipse 59425" cx="0.56" cy="0.56" r="0.56" transform="translate(79.11 20)" fill="#969696" />
                <circle id="Ellipse_59426" data-name="Ellipse 59426" cx="0.56" cy="0.56" r="0.56" transform="translate(80.78 23.01)" fill="#969696" />
                <circle id="Ellipse_59427" data-name="Ellipse 59427" cx="0.56" cy="0.56" r="0.56" transform="translate(82.19 19.6)" fill="#969696" />
                <circle id="Ellipse_59428" data-name="Ellipse 59428" cx="0.56" cy="0.56" r="0.56" transform="translate(70.72 47.28)" fill="#969696" />
                <circle id="Ellipse_59429" data-name="Ellipse 59429" cx="0.56" cy="0.56" r="0.56" transform="translate(70.72 41.66)" fill="#969696" />
                <circle id="Ellipse_59430" data-name="Ellipse 59430" cx="0.56" cy="0.56" r="0.56" transform="translate(72.39 44.67)" fill="#969696" />
                <circle id="Ellipse_59431" data-name="Ellipse 59431" cx="0.56" cy="0.56" r="0.56" transform="translate(73.8 41.26)" fill="#969696" />
                <circle id="Ellipse_59432" data-name="Ellipse 59432" cx="0.56" cy="0.56" r="0.56" transform="translate(72.58 39.56)" fill="#969696" />
                <circle id="Ellipse_59433" data-name="Ellipse 59433" cx="0.56" cy="0.56" r="0.56" transform="translate(72.58 33.93)" fill="#969696" />
                <circle id="Ellipse_59434" data-name="Ellipse 59434" cx="0.56" cy="0.56" r="0.56" transform="translate(74.25 36.95)" fill="#969696" />
                <circle id="Ellipse_59435" data-name="Ellipse 59435" cx="0.56" cy="0.56" r="0.56" transform="translate(75.66 33.53)" fill="#969696" />
                <circle id="Ellipse_59436" data-name="Ellipse 59436" cx="0.56" cy="0.56" r="0.56" transform="translate(76.28 44.99)" fill="#969696" />
                <circle id="Ellipse_59437" data-name="Ellipse 59437" cx="0.56" cy="0.56" r="0.56" transform="translate(76.28 39.36)" fill="#969696" />
                <circle id="Ellipse_59438" data-name="Ellipse 59438" cx="0.56" cy="0.56" r="0.56" transform="translate(77.95 42.38)" fill="#969696" />
                <circle id="Ellipse_59439" data-name="Ellipse 59439" cx="0.56" cy="0.56" r="0.56" transform="translate(79.36 38.96)" fill="#969696" />
                <circle id="Ellipse_59440" data-name="Ellipse 59440" cx="0.56" cy="0.56" r="0.56" transform="translate(78.32 34.98)" fill="#969696" />
                <circle id="Ellipse_59441" data-name="Ellipse 59441" cx="0.56" cy="0.56" r="0.56" transform="translate(78.32 29.35)" fill="#969696" />
                <circle id="Ellipse_59442" data-name="Ellipse 59442" cx="0.56" cy="0.56" r="0.56" transform="translate(79.98 32.36)" fill="#969696" />
                <circle id="Ellipse_59443" data-name="Ellipse 59443" cx="0.56" cy="0.56" r="0.56" transform="translate(81.39 28.95)" fill="#969696" />
                <circle id="Ellipse_59444" data-name="Ellipse 59444" cx="0.56" cy="0.56" r="0.56" transform="translate(82.22 43.03)" fill="#969696" />
                <circle id="Ellipse_59445" data-name="Ellipse 59445" cx="0.56" cy="0.56" r="0.56" transform="translate(82.22 37.41)" fill="#969696" />
                <circle id="Ellipse_59446" data-name="Ellipse 59446" cx="0.56" cy="0.56" r="0.56" transform="translate(83.89 40.42)" fill="#969696" />
                <circle id="Ellipse_59447" data-name="Ellipse 59447" cx="0.56" cy="0.56" r="0.56" transform="translate(85.3 37.01)" fill="#969696" />
                <circle id="Ellipse_59448" data-name="Ellipse 59448" cx="0.56" cy="0.56" r="0.56" transform="translate(84.89 34.09)" fill="#969696" />
                <circle id="Ellipse_59449" data-name="Ellipse 59449" cx="0.56" cy="0.56" r="0.56" transform="translate(84.89 28.47)" fill="#969696" />
                <circle id="Ellipse_59450" data-name="Ellipse 59450" cx="0.56" cy="0.56" r="0.56" transform="translate(86.55 31.48)" fill="#969696" />
                <circle id="Ellipse_59451" data-name="Ellipse 59451" cx="0.56" cy="0.56" r="0.56" transform="translate(87.96 28.07)" fill="#969696" />
                <circle id="Ellipse_59452" data-name="Ellipse 59452" cx="0.56" cy="0.56" r="0.56" transform="translate(86.75 26.37)" fill="#969696" />
                <circle id="Ellipse_59453" data-name="Ellipse 59453" cx="0.56" cy="0.56" r="0.56" transform="translate(86.75 20.75)" fill="#969696" />
                <circle id="Ellipse_59454" data-name="Ellipse 59454" cx="0.56" cy="0.56" r="0.56" transform="translate(88.41 23.76)" fill="#969696" />
                <circle id="Ellipse_59455" data-name="Ellipse 59455" cx="0.56" cy="0.56" r="0.56" transform="translate(89.82 20.35)" fill="#969696" />
                <circle id="Ellipse_59456" data-name="Ellipse 59456" cx="0.56" cy="0.56" r="0.56" transform="translate(90.45 31.8)" fill="#969696" />
                <circle id="Ellipse_59457" data-name="Ellipse 59457" cx="0.56" cy="0.56" r="0.56" transform="translate(90.45 26.18)" fill="#969696" />
                <circle id="Ellipse_59458" data-name="Ellipse 59458" cx="0.56" cy="0.56" r="0.56" transform="translate(92.11 29.19)" fill="#969696" />
                <circle id="Ellipse_59459" data-name="Ellipse 59459" cx="0.56" cy="0.56" r="0.56" transform="translate(93.52 25.78)" fill="#969696" />
                <circle id="Ellipse_59460" data-name="Ellipse 59460" cx="0.56" cy="0.56" r="0.56" transform="translate(92.48 21.79)" fill="#969696" />
                <circle id="Ellipse_59461" data-name="Ellipse 59461" cx="0.56" cy="0.56" r="0.56" transform="translate(92.48 16.16)" fill="#969696" />
                <circle id="Ellipse_59462" data-name="Ellipse 59462" cx="0.56" cy="0.56" r="0.56" transform="translate(94.15 19.18)" fill="#969696" />
                <circle id="Ellipse_59463" data-name="Ellipse 59463" cx="0.56" cy="0.56" r="0.56" transform="translate(95.56 15.76)" fill="#969696" />
                <circle id="Ellipse_59464" data-name="Ellipse 59464" cx="0.56" cy="0.56" r="0.56" transform="translate(96.39 29.85)" fill="#969696" />
                <circle id="Ellipse_59465" data-name="Ellipse 59465" cx="0.56" cy="0.56" r="0.56" transform="translate(96.39 24.22)" fill="#969696" />
                <circle id="Ellipse_59466" data-name="Ellipse 59466" cx="0.56" cy="0.56" r="0.56" transform="translate(98.06 27.24)" fill="#969696" />
                <circle id="Ellipse_59467" data-name="Ellipse 59467" cx="0.56" cy="0.56" r="0.56" transform="translate(99.47 23.82)" fill="#969696" />
                <circle id="Ellipse_59468" data-name="Ellipse 59468" cx="0.56" cy="0.56" r="0.56" transform="translate(66.76 12.86)" fill="#969696" />
                <circle id="Ellipse_59469" data-name="Ellipse 59469" cx="0.56" cy="0.56" r="0.56" transform="translate(66.76 7.24)" fill="#969696" />
                <circle id="Ellipse_59470" data-name="Ellipse 59470" cx="0.56" cy="0.56" r="0.56" transform="translate(68.43 10.25)" fill="#969696" />
                <circle id="Ellipse_59471" data-name="Ellipse 59471" cx="0.56" cy="0.56" r="0.56" transform="translate(69.84 6.84)" fill="#969696" />
                <circle id="Ellipse_59472" data-name="Ellipse 59472" cx="0.56" cy="0.56" r="0.56" transform="translate(68.62 5.14)" fill="#969696" />
                <circle id="Ellipse_59473" data-name="Ellipse 59473" cx="0.56" cy="0.56" r="0.56" transform="translate(68.62 -0.48)" fill="#969696" />
                <circle id="Ellipse_59474" data-name="Ellipse 59474" cx="0.56" cy="0.56" r="0.56" transform="translate(70.29 2.53)" fill="#969696" />
                <circle id="Ellipse_59475" data-name="Ellipse 59475" cx="0.56" cy="0.56" r="0.56" transform="translate(71.7 -0.88)" fill="#969696" />
                <circle id="Ellipse_59476" data-name="Ellipse 59476" cx="0.56" cy="0.56" r="0.56" transform="translate(72.32 10.57)" fill="#969696" />
                <circle id="Ellipse_59477" data-name="Ellipse 59477" cx="0.56" cy="0.56" r="0.56" transform="translate(72.32 4.95)" fill="#969696" />
                <circle id="Ellipse_59478" data-name="Ellipse 59478" cx="0.56" cy="0.56" r="0.56" transform="translate(73.99 7.96)" fill="#969696" />
                <circle id="Ellipse_59479" data-name="Ellipse 59479" cx="0.56" cy="0.56" r="0.56" transform="translate(75.4 4.55)" fill="#969696" />
                <circle id="Ellipse_59480" data-name="Ellipse 59480" cx="0.56" cy="0.56" r="0.56" transform="translate(74.35 0.56)" fill="#969696" />
                <circle id="Ellipse_59481" data-name="Ellipse 59481" cx="0.56" cy="0.56" r="0.56" transform="translate(78.26 8.62)" fill="#969696" />
                <circle id="Ellipse_59482" data-name="Ellipse 59482" cx="0.56" cy="0.56" r="0.56" transform="translate(78.26 2.99)" fill="#969696" />
                <circle id="Ellipse_59483" data-name="Ellipse 59483" cx="0.56" cy="0.56" r="0.56" transform="translate(79.93 6.01)" fill="#969696" />
                <circle id="Ellipse_59484" data-name="Ellipse 59484" cx="0.56" cy="0.56" r="0.56" transform="translate(81.34 2.59)" fill="#969696" />
                <circle id="Ellipse_59485" data-name="Ellipse 59485" cx="0.56" cy="0.56" r="0.56" transform="translate(83.42 15.78)" fill="#969696" />
                <circle id="Ellipse_59486" data-name="Ellipse 59486" cx="0.56" cy="0.56" r="0.56" transform="translate(83.42 10.15)" fill="#969696" />
                <circle id="Ellipse_59487" data-name="Ellipse 59487" cx="0.56" cy="0.56" r="0.56" transform="translate(85.09 13.17)" fill="#969696" />
                <circle id="Ellipse_59488" data-name="Ellipse 59488" cx="0.56" cy="0.56" r="0.56" transform="translate(86.5 9.75)" fill="#969696" />
                <circle id="Ellipse_59489" data-name="Ellipse 59489" cx="0.56" cy="0.56" r="0.56" transform="translate(85.28 8.05)" fill="#969696" />
                <circle id="Ellipse_59490" data-name="Ellipse 59490" cx="0.56" cy="0.56" r="0.56" transform="translate(85.28 2.43)" fill="#969696" />
                <circle id="Ellipse_59491" data-name="Ellipse 59491" cx="0.56" cy="0.56" r="0.56" transform="translate(86.95 5.44)" fill="#969696" />
                <circle id="Ellipse_59492" data-name="Ellipse 59492" cx="0.56" cy="0.56" r="0.56" transform="translate(88.36 2.03)" fill="#969696" />
                <circle id="Ellipse_59493" data-name="Ellipse 59493" cx="0.56" cy="0.56" r="0.56" transform="translate(88.98 13.48)" fill="#969696" />
                <circle id="Ellipse_59494" data-name="Ellipse 59494" cx="0.56" cy="0.56" r="0.56" transform="translate(88.98 7.86)" fill="#969696" />
                <circle id="Ellipse_59495" data-name="Ellipse 59495" cx="0.56" cy="0.56" r="0.56" transform="translate(90.65 10.87)" fill="#969696" />
                <circle id="Ellipse_59496" data-name="Ellipse 59496" cx="0.56" cy="0.56" r="0.56" transform="translate(92.06 7.46)" fill="#969696" />
                <circle id="Ellipse_59497" data-name="Ellipse 59497" cx="0.56" cy="0.56" r="0.56" transform="translate(91.02 3.47)" fill="#969696" />
                <circle id="Ellipse_59498" data-name="Ellipse 59498" cx="0.56" cy="0.56" r="0.56" transform="translate(92.68 0.86)" fill="#969696" />
                <circle id="Ellipse_59499" data-name="Ellipse 59499" cx="0.56" cy="0.56" r="0.56" transform="translate(94.92 11.53)" fill="#969696" />
                <circle id="Ellipse_59500" data-name="Ellipse 59500" cx="0.56" cy="0.56" r="0.56" transform="translate(94.92 5.91)" fill="#969696" />
                <circle id="Ellipse_59501" data-name="Ellipse 59501" cx="0.56" cy="0.56" r="0.56" transform="translate(96.59 8.92)" fill="#969696" />
                <circle id="Ellipse_59502" data-name="Ellipse 59502" cx="0.56" cy="0.56" r="0.56" transform="translate(98 5.51)" fill="#969696" />
                <circle id="Ellipse_59503" data-name="Ellipse 59503" cx="0.56" cy="0.56" r="0.56" transform="translate(97.59 2.59)" fill="#969696" />
                <circle id="Ellipse_59504" data-name="Ellipse 59504" cx="0.56" cy="0.56" r="0.56" transform="translate(99.25 -0.02)" fill="#969696" />
                <circle id="Ellipse_59505" data-name="Ellipse 59505" cx="0.56" cy="0.56" r="0.56" transform="translate(103.15 0.3)" fill="#969696" />
                <circle
                  id="Ellipse_59506"
                  data-name="Ellipse 59506"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.08 20.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_59507" data-name="Ellipse 59507" cx="0.56" cy="0.56" r="0.56" transform="translate(100.08 14.4)" fill="#969696" />
                <circle
                  id="Ellipse_59508"
                  data-name="Ellipse 59508"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.74 17.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_59509" data-name="Ellipse 59509" cx="0.56" cy="0.56" r="0.56" transform="translate(103.15 14)" fill="#969696" />
                <circle id="Ellipse_59510" data-name="Ellipse 59510" cx="0.56" cy="0.56" r="0.56" transform="translate(101.94 12.3)" fill="#969696" />
                <circle id="Ellipse_59511" data-name="Ellipse 59511" cx="0.56" cy="0.56" r="0.56" transform="translate(101.94 6.68)" fill="#969696" />
                <circle id="Ellipse_59512" data-name="Ellipse 59512" cx="0.56" cy="0.56" r="0.56" transform="translate(103.6 9.69)" fill="#969696" />
                <circle id="Ellipse_59513" data-name="Ellipse 59513" cx="0.56" cy="0.56" r="0.56" transform="translate(105.01 6.28)" fill="#969696" />
                <circle
                  id="Ellipse_59514"
                  data-name="Ellipse 59514"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.64 17.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59515"
                  data-name="Ellipse 59515"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.64 12.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_59516" data-name="Ellipse 59516" cx="0.56" cy="0.56" r="0.56" transform="translate(107.3 15.12)" fill="#969696" />
                <circle
                  id="Ellipse_59517"
                  data-name="Ellipse 59517"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.71 11.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_59518" data-name="Ellipse 59518" cx="0.56" cy="0.56" r="0.56" transform="translate(107.67 7.72)" fill="#969696" />
                <circle id="Ellipse_59519" data-name="Ellipse 59519" cx="0.56" cy="0.56" r="0.56" transform="translate(107.67 2.09)" fill="#969696" />
                <circle id="Ellipse_59520" data-name="Ellipse 59520" cx="0.56" cy="0.56" r="0.56" transform="translate(109.34 5.11)" fill="#969696" />
                <circle id="Ellipse_59521" data-name="Ellipse 59521" cx="0.56" cy="0.56" r="0.56" transform="translate(110.75 1.69)" fill="#969696" />
                <circle
                  id="Ellipse_59522"
                  data-name="Ellipse 59522"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.58 15.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59523"
                  data-name="Ellipse 59523"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.58 10.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59524"
                  data-name="Ellipse 59524"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.25 13.17)"
                  fill="#969696"
                />
                <circle id="Ellipse_59525" data-name="Ellipse 59525" cx="0.56" cy="0.56" r="0.56" transform="translate(114.66 9.75)" fill="#969696" />
                <circle id="Ellipse_59526" data-name="Ellipse 59526" cx="0.56" cy="0.56" r="0.56" transform="translate(113.63 5.52)" fill="#969696" />
                <circle id="Ellipse_59527" data-name="Ellipse 59527" cx="0.56" cy="0.56" r="0.56" transform="translate(113.63 -0.1)" fill="#969696" />
                <circle id="Ellipse_59528" data-name="Ellipse 59528" cx="0.56" cy="0.56" r="0.56" transform="translate(115.3 2.91)" fill="#969696" />
                <circle id="Ellipse_59529" data-name="Ellipse 59529" cx="0.56" cy="0.56" r="0.56" transform="translate(116.71 -0.5)" fill="#969696" />
                <circle id="Ellipse_59530" data-name="Ellipse 59530" cx="0.56" cy="0.56" r="0.56" transform="translate(119.19 3.23)" fill="#969696" />
                <circle id="Ellipse_59531" data-name="Ellipse 59531" cx="0.56" cy="0.56" r="0.56" transform="translate(120.85 0.62)" fill="#969696" />
                <circle id="Ellipse_59532" data-name="Ellipse 59532" cx="0.56" cy="0.56" r="0.56" transform="translate(125.13 1.28)" fill="#969696" />
                <circle
                  id="Ellipse_59533"
                  data-name="Ellipse 59533"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.51 27.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59534"
                  data-name="Ellipse 59534"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.74 22.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59535"
                  data-name="Ellipse 59535"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.74 17.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59536"
                  data-name="Ellipse 59536"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.41 20.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59537"
                  data-name="Ellipse 59537"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.82 16.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_59538" data-name="Ellipse 59538" cx="0.56" cy="0.56" r="0.56" transform="translate(118.6 15.21)" fill="#969696" />
                <circle id="Ellipse_59539" data-name="Ellipse 59539" cx="0.56" cy="0.56" r="0.56" transform="translate(118.6 9.59)" fill="#969696" />
                <circle id="Ellipse_59540" data-name="Ellipse 59540" cx="0.56" cy="0.56" r="0.56" transform="translate(120.26 12.6)" fill="#969696" />
                <circle id="Ellipse_59541" data-name="Ellipse 59541" cx="0.56" cy="0.56" r="0.56" transform="translate(121.67 9.19)" fill="#969696" />
                <circle id="Ellipse_59542" data-name="Ellipse 59542" cx="0.56" cy="0.56" r="0.56" transform="translate(122.3 20.64)" fill="#969696" />
                <circle id="Ellipse_59543" data-name="Ellipse 59543" cx="0.56" cy="0.56" r="0.56" transform="translate(122.3 15.02)" fill="#969696" />
                <circle
                  id="Ellipse_59544"
                  data-name="Ellipse 59544"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.96 18.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59545"
                  data-name="Ellipse 59545"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.37 14.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59546"
                  data-name="Ellipse 59546"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.33 10.63)"
                  fill="#969696"
                />
                <circle id="Ellipse_59547" data-name="Ellipse 59547" cx="0.56" cy="0.56" r="0.56" transform="translate(124.33 5.01)" fill="#969696" />
                <circle id="Ellipse_59548" data-name="Ellipse 59548" cx="0.56" cy="0.56" r="0.56" transform="translate(126 8.02)" fill="#969696" />
                <circle id="Ellipse_59549" data-name="Ellipse 59549" cx="0.56" cy="0.56" r="0.56" transform="translate(127.41 4.61)" fill="#969696" />
                <circle
                  id="Ellipse_59550"
                  data-name="Ellipse 59550"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.24 18.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59551"
                  data-name="Ellipse 59551"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.24 13.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59552"
                  data-name="Ellipse 59552"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.91 16.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59553"
                  data-name="Ellipse 59553"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.32 12.67)"
                  fill="#969696"
                />
                <circle id="Ellipse_59554" data-name="Ellipse 59554" cx="0.56" cy="0.56" r="0.56" transform="translate(130.9 9.75)" fill="#969696" />
                <circle id="Ellipse_59555" data-name="Ellipse 59555" cx="0.56" cy="0.56" r="0.56" transform="translate(130.9 4.13)" fill="#969696" />
                <circle id="Ellipse_59556" data-name="Ellipse 59556" cx="0.56" cy="0.56" r="0.56" transform="translate(132.57 7.14)" fill="#969696" />
                <circle id="Ellipse_59557" data-name="Ellipse 59557" cx="0.56" cy="0.56" r="0.56" transform="translate(133.98 3.73)" fill="#969696" />
                <circle id="Ellipse_59558" data-name="Ellipse 59558" cx="0.56" cy="0.56" r="0.56" transform="translate(132.76 2.03)" fill="#969696" />
                <circle
                  id="Ellipse_59559"
                  data-name="Ellipse 59559"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.43 -0.58)"
                  fill="#969696"
                />
                <circle id="Ellipse_59560" data-name="Ellipse 59560" cx="0.56" cy="0.56" r="0.56" transform="translate(136.46 7.46)" fill="#969696" />
                <circle id="Ellipse_59561" data-name="Ellipse 59561" cx="0.56" cy="0.56" r="0.56" transform="translate(136.46 1.83)" fill="#969696" />
                <circle id="Ellipse_59562" data-name="Ellipse 59562" cx="0.56" cy="0.56" r="0.56" transform="translate(138.13 4.85)" fill="#969696" />
                <circle id="Ellipse_59563" data-name="Ellipse 59563" cx="0.56" cy="0.56" r="0.56" transform="translate(139.54 1.43)" fill="#969696" />
                <circle id="Ellipse_59564" data-name="Ellipse 59564" cx="0.56" cy="0.56" r="0.56" transform="translate(142.41 5.5)" fill="#969696" />
                <circle
                  id="Ellipse_59565"
                  data-name="Ellipse 59565"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.41 -0.12)"
                  fill="#969696"
                />
                <circle id="Ellipse_59566" data-name="Ellipse 59566" cx="0.56" cy="0.56" r="0.56" transform="translate(144.07 2.89)" fill="#969696" />
                <circle
                  id="Ellipse_59567"
                  data-name="Ellipse 59567"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.48 -0.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_59568" data-name="Ellipse 59568" cx="0.56" cy="0.56" r="0.56" transform="translate(86.55 53.52)" fill="#969696" />
                <circle id="Ellipse_59569" data-name="Ellipse 59569" cx="0.56" cy="0.56" r="0.56" transform="translate(86.55 47.89)" fill="#969696" />
                <circle id="Ellipse_59570" data-name="Ellipse 59570" cx="0.56" cy="0.56" r="0.56" transform="translate(88.22 50.91)" fill="#969696" />
                <circle id="Ellipse_59571" data-name="Ellipse 59571" cx="0.56" cy="0.56" r="0.56" transform="translate(89.63 47.49)" fill="#969696" />
                <circle id="Ellipse_59572" data-name="Ellipse 59572" cx="0.56" cy="0.56" r="0.56" transform="translate(88.41 45.79)" fill="#969696" />
                <circle id="Ellipse_59573" data-name="Ellipse 59573" cx="0.56" cy="0.56" r="0.56" transform="translate(88.41 40.17)" fill="#969696" />
                <circle id="Ellipse_59574" data-name="Ellipse 59574" cx="0.56" cy="0.56" r="0.56" transform="translate(90.08 43.18)" fill="#969696" />
                <circle id="Ellipse_59575" data-name="Ellipse 59575" cx="0.56" cy="0.56" r="0.56" transform="translate(91.49 39.77)" fill="#969696" />
                <circle id="Ellipse_59576" data-name="Ellipse 59576" cx="0.56" cy="0.56" r="0.56" transform="translate(92.11 51.22)" fill="#969696" />
                <circle id="Ellipse_59577" data-name="Ellipse 59577" cx="0.56" cy="0.56" r="0.56" transform="translate(92.11 45.6)" fill="#969696" />
                <circle id="Ellipse_59578" data-name="Ellipse 59578" cx="0.56" cy="0.56" r="0.56" transform="translate(93.78 48.61)" fill="#969696" />
                <circle id="Ellipse_59579" data-name="Ellipse 59579" cx="0.56" cy="0.56" r="0.56" transform="translate(95.19 45.2)" fill="#969696" />
                <circle id="Ellipse_59580" data-name="Ellipse 59580" cx="0.56" cy="0.56" r="0.56" transform="translate(94.15 41.21)" fill="#969696" />
                <circle id="Ellipse_59581" data-name="Ellipse 59581" cx="0.56" cy="0.56" r="0.56" transform="translate(94.15 35.59)" fill="#969696" />
                <circle id="Ellipse_59582" data-name="Ellipse 59582" cx="0.56" cy="0.56" r="0.56" transform="translate(95.81 38.6)" fill="#969696" />
                <circle id="Ellipse_59583" data-name="Ellipse 59583" cx="0.56" cy="0.56" r="0.56" transform="translate(97.22 35.19)" fill="#969696" />
                <circle id="Ellipse_59584" data-name="Ellipse 59584" cx="0.56" cy="0.56" r="0.56" transform="translate(98.05 43.65)" fill="#969696" />
                <circle id="Ellipse_59585" data-name="Ellipse 59585" cx="0.56" cy="0.56" r="0.56" transform="translate(99.72 46.66)" fill="#969696" />
                <circle
                  id="Ellipse_59586"
                  data-name="Ellipse 59586"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.13 43.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_59587" data-name="Ellipse 59587" cx="0.56" cy="0.56" r="0.56" transform="translate(100.1 39.02)" fill="#969696" />
                <circle id="Ellipse_59588" data-name="Ellipse 59588" cx="0.56" cy="0.56" r="0.56" transform="translate(100.1 33.39)" fill="#969696" />
                <circle
                  id="Ellipse_59589"
                  data-name="Ellipse 59589"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.77 36.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59590"
                  data-name="Ellipse 59590"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.18 32.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59591"
                  data-name="Ellipse 59591"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.96 31.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59592"
                  data-name="Ellipse 59592"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.96 25.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59593"
                  data-name="Ellipse 59593"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.63 28.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59594"
                  data-name="Ellipse 59594"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.04 25.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59595"
                  data-name="Ellipse 59595"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.66 36.72)"
                  fill="#969696"
                />
                <circle id="Ellipse_59596" data-name="Ellipse 59596" cx="0.56" cy="0.56" r="0.56" transform="translate(105.66 31.1)" fill="#969696" />
                <circle
                  id="Ellipse_59597"
                  data-name="Ellipse 59597"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.33 34.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_59598" data-name="Ellipse 59598" cx="0.56" cy="0.56" r="0.56" transform="translate(108.74 30.7)" fill="#969696" />
                <circle id="Ellipse_59599" data-name="Ellipse 59599" cx="0.56" cy="0.56" r="0.56" transform="translate(107.7 26.71)" fill="#969696" />
                <circle id="Ellipse_59600" data-name="Ellipse 59600" cx="0.56" cy="0.56" r="0.56" transform="translate(107.7 21.09)" fill="#969696" />
                <circle id="Ellipse_59601" data-name="Ellipse 59601" cx="0.56" cy="0.56" r="0.56" transform="translate(109.36 24.1)" fill="#969696" />
                <circle
                  id="Ellipse_59602"
                  data-name="Ellipse 59602"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.77 20.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_59603" data-name="Ellipse 59603" cx="0.56" cy="0.56" r="0.56" transform="translate(111.6 34.77)" fill="#969696" />
                <circle id="Ellipse_59604" data-name="Ellipse 59604" cx="0.56" cy="0.56" r="0.56" transform="translate(111.6 29.15)" fill="#969696" />
                <circle
                  id="Ellipse_59605"
                  data-name="Ellipse 59605"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.27 32.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59606"
                  data-name="Ellipse 59606"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.68 28.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59607"
                  data-name="Ellipse 59607"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.21 56.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59608"
                  data-name="Ellipse 59608"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.21 50.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59609"
                  data-name="Ellipse 59609"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.88 53.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59610"
                  data-name="Ellipse 59610"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.29 50.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59611"
                  data-name="Ellipse 59611"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.07 48.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59612"
                  data-name="Ellipse 59612"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.07 43.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_59613" data-name="Ellipse 59613" cx="0.56" cy="0.56" r="0.56" transform="translate(106.74 46.1)" fill="#969696" />
                <circle
                  id="Ellipse_59614"
                  data-name="Ellipse 59614"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.15 42.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59615"
                  data-name="Ellipse 59615"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.77 54.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59616"
                  data-name="Ellipse 59616"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.77 48.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59617"
                  data-name="Ellipse 59617"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.44 51.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59618"
                  data-name="Ellipse 59618"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.85 48.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59619"
                  data-name="Ellipse 59619"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.81 44.13)"
                  fill="#969696"
                />
                <circle id="Ellipse_59620" data-name="Ellipse 59620" cx="0.56" cy="0.56" r="0.56" transform="translate(110.81 38.5)" fill="#969696" />
                <circle
                  id="Ellipse_59621"
                  data-name="Ellipse 59621"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.47 41.51)"
                  fill="#969696"
                />
                <circle id="Ellipse_59622" data-name="Ellipse 59622" cx="0.56" cy="0.56" r="0.56" transform="translate(113.88 38.1)" fill="#969696" />
                <circle
                  id="Ellipse_59623"
                  data-name="Ellipse 59623"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.71 52.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59624"
                  data-name="Ellipse 59624"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.71 46.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59625"
                  data-name="Ellipse 59625"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.38 49.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59626"
                  data-name="Ellipse 59626"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.79 46.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59627"
                  data-name="Ellipse 59627"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.38 43.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59628"
                  data-name="Ellipse 59628"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.38 37.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59629"
                  data-name="Ellipse 59629"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.04 40.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59630"
                  data-name="Ellipse 59630"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.45 37.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59631"
                  data-name="Ellipse 59631"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.24 35.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_59632" data-name="Ellipse 59632" cx="0.56" cy="0.56" r="0.56" transform="translate(119.24 29.9)" fill="#969696" />
                <circle id="Ellipse_59633" data-name="Ellipse 59633" cx="0.56" cy="0.56" r="0.56" transform="translate(120.9 32.91)" fill="#969696" />
                <circle id="Ellipse_59634" data-name="Ellipse 59634" cx="0.56" cy="0.56" r="0.56" transform="translate(122.31 29.5)" fill="#969696" />
                <circle
                  id="Ellipse_59635"
                  data-name="Ellipse 59635"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.94 40.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59636"
                  data-name="Ellipse 59636"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.94 35.33)"
                  fill="#969696"
                />
                <circle id="Ellipse_59637" data-name="Ellipse 59637" cx="0.56" cy="0.56" r="0.56" transform="translate(124.6 38.34)" fill="#969696" />
                <circle
                  id="Ellipse_59638"
                  data-name="Ellipse 59638"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.01 34.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59639"
                  data-name="Ellipse 59639"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.97 30.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59640"
                  data-name="Ellipse 59640"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.97 25.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59641"
                  data-name="Ellipse 59641"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.64 28.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59642"
                  data-name="Ellipse 59642"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.05 24.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_59643" data-name="Ellipse 59643" cx="0.56" cy="0.56" r="0.56" transform="translate(128.88 39)" fill="#969696" />
                <circle
                  id="Ellipse_59644"
                  data-name="Ellipse 59644"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.88 33.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59645"
                  data-name="Ellipse 59645"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.54 36.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59646"
                  data-name="Ellipse 59646"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.95 32.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59647"
                  data-name="Ellipse 59647"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.55 26.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59648"
                  data-name="Ellipse 59648"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.55 21.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59649"
                  data-name="Ellipse 59649"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.21 24.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59650"
                  data-name="Ellipse 59650"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.62 20.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59651"
                  data-name="Ellipse 59651"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.41 18.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59652"
                  data-name="Ellipse 59652"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.41 13.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59653"
                  data-name="Ellipse 59653"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.07 16.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59654"
                  data-name="Ellipse 59654"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.48 12.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59655"
                  data-name="Ellipse 59655"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.11 24.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59656"
                  data-name="Ellipse 59656"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.11 18.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_59657" data-name="Ellipse 59657" cx="0.56" cy="0.56" r="0.56" transform="translate(142.77 21.8)" fill="#969696" />
                <circle
                  id="Ellipse_59658"
                  data-name="Ellipse 59658"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.18 18.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_59659" data-name="Ellipse 59659" cx="0.56" cy="0.56" r="0.56" transform="translate(143.14 14.4)" fill="#969696" />
                <circle id="Ellipse_59660" data-name="Ellipse 59660" cx="0.56" cy="0.56" r="0.56" transform="translate(143.14 8.78)" fill="#969696" />
                <circle
                  id="Ellipse_59661"
                  data-name="Ellipse 59661"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.81 11.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_59662" data-name="Ellipse 59662" cx="0.56" cy="0.56" r="0.56" transform="translate(146.22 8.38)" fill="#969696" />
                <circle
                  id="Ellipse_59663"
                  data-name="Ellipse 59663"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.05 22.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59664"
                  data-name="Ellipse 59664"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.05 16.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59665"
                  data-name="Ellipse 59665"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.71 19.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59666"
                  data-name="Ellipse 59666"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.12 16.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_59667" data-name="Ellipse 59667" cx="0.56" cy="0.56" r="0.56" transform="translate(149.1 12.21)" fill="#969696" />
                <circle id="Ellipse_59668" data-name="Ellipse 59668" cx="0.56" cy="0.56" r="0.56" transform="translate(149.1 6.58)" fill="#969696" />
                <circle id="Ellipse_59669" data-name="Ellipse 59669" cx="0.56" cy="0.56" r="0.56" transform="translate(150.77 9.59)" fill="#969696" />
                <circle id="Ellipse_59670" data-name="Ellipse 59670" cx="0.56" cy="0.56" r="0.56" transform="translate(152.18 6.18)" fill="#969696" />
                <circle id="Ellipse_59671" data-name="Ellipse 59671" cx="0.56" cy="0.56" r="0.56" transform="translate(150.96 4.48)" fill="#969696" />
                <circle id="Ellipse_59672" data-name="Ellipse 59672" cx="0.56" cy="0.56" r="0.56" transform="translate(152.62 1.87)" fill="#969696" />
                <circle id="Ellipse_59673" data-name="Ellipse 59673" cx="0.56" cy="0.56" r="0.56" transform="translate(154.66 9.91)" fill="#969696" />
                <circle id="Ellipse_59674" data-name="Ellipse 59674" cx="0.56" cy="0.56" r="0.56" transform="translate(154.66 4.29)" fill="#969696" />
                <circle id="Ellipse_59675" data-name="Ellipse 59675" cx="0.56" cy="0.56" r="0.56" transform="translate(156.32 7.3)" fill="#969696" />
                <circle id="Ellipse_59676" data-name="Ellipse 59676" cx="0.56" cy="0.56" r="0.56" transform="translate(157.73 3.89)" fill="#969696" />
                <circle id="Ellipse_59677" data-name="Ellipse 59677" cx="0.56" cy="0.56" r="0.56" transform="translate(156.69 -0.1)" fill="#969696" />
                <circle id="Ellipse_59678" data-name="Ellipse 59678" cx="0.56" cy="0.56" r="0.56" transform="translate(160.6 7.96)" fill="#969696" />
                <circle id="Ellipse_59679" data-name="Ellipse 59679" cx="0.56" cy="0.56" r="0.56" transform="translate(160.6 2.34)" fill="#969696" />
                <circle id="Ellipse_59680" data-name="Ellipse 59680" cx="0.56" cy="0.56" r="0.56" transform="translate(162.27 5.35)" fill="#969696" />
                <circle id="Ellipse_59681" data-name="Ellipse 59681" cx="0.56" cy="0.56" r="0.56" transform="translate(163.68 1.93)" fill="#969696" />
                <circle
                  id="Ellipse_59682"
                  data-name="Ellipse 59682"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.21 29.62)"
                  fill="#969696"
                />
                <circle id="Ellipse_59683" data-name="Ellipse 59683" cx="0.56" cy="0.56" r="0.56" transform="translate(152.21 24)" fill="#969696" />
                <circle
                  id="Ellipse_59684"
                  data-name="Ellipse 59684"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.88 27.01)"
                  fill="#969696"
                />
                <circle id="Ellipse_59685" data-name="Ellipse 59685" cx="0.56" cy="0.56" r="0.56" transform="translate(155.29 23.6)" fill="#969696" />
                <circle id="Ellipse_59686" data-name="Ellipse 59686" cx="0.56" cy="0.56" r="0.56" transform="translate(154.07 21.9)" fill="#969696" />
                <circle
                  id="Ellipse_59687"
                  data-name="Ellipse 59687"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.07 16.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59688"
                  data-name="Ellipse 59688"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.73 19.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59689"
                  data-name="Ellipse 59689"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.14 15.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59690"
                  data-name="Ellipse 59690"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.77 27.33)"
                  fill="#969696"
                />
                <circle id="Ellipse_59691" data-name="Ellipse 59691" cx="0.56" cy="0.56" r="0.56" transform="translate(157.77 21.7)" fill="#969696" />
                <circle
                  id="Ellipse_59692"
                  data-name="Ellipse 59692"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.43 24.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_59693" data-name="Ellipse 59693" cx="0.56" cy="0.56" r="0.56" transform="translate(160.84 21.3)" fill="#969696" />
                <circle id="Ellipse_59694" data-name="Ellipse 59694" cx="0.56" cy="0.56" r="0.56" transform="translate(159.8 17.31)" fill="#969696" />
                <circle id="Ellipse_59695" data-name="Ellipse 59695" cx="0.56" cy="0.56" r="0.56" transform="translate(159.8 11.69)" fill="#969696" />
                <circle id="Ellipse_59696" data-name="Ellipse 59696" cx="0.56" cy="0.56" r="0.56" transform="translate(161.47 14.7)" fill="#969696" />
                <circle
                  id="Ellipse_59697"
                  data-name="Ellipse 59697"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.88 11.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59698"
                  data-name="Ellipse 59698"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.71 25.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59699"
                  data-name="Ellipse 59699"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.71 19.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59700"
                  data-name="Ellipse 59700"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.38 22.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59701"
                  data-name="Ellipse 59701"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.79 19.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59702"
                  data-name="Ellipse 59702"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.37 16.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59703"
                  data-name="Ellipse 59703"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.37 10.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59704"
                  data-name="Ellipse 59704"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.04 13.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59705"
                  data-name="Ellipse 59705"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.45 10.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_59706" data-name="Ellipse 59706" cx="0.56" cy="0.56" r="0.56" transform="translate(168.23 8.71)" fill="#969696" />
                <circle id="Ellipse_59707" data-name="Ellipse 59707" cx="0.56" cy="0.56" r="0.56" transform="translate(168.23 3.09)" fill="#969696" />
                <circle id="Ellipse_59708" data-name="Ellipse 59708" cx="0.56" cy="0.56" r="0.56" transform="translate(169.9 6.1)" fill="#969696" />
                <circle id="Ellipse_59709" data-name="Ellipse 59709" cx="0.56" cy="0.56" r="0.56" transform="translate(171.31 2.69)" fill="#969696" />
                <circle
                  id="Ellipse_59710"
                  data-name="Ellipse 59710"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.93 14.14)"
                  fill="#969696"
                />
                <circle id="Ellipse_59711" data-name="Ellipse 59711" cx="0.56" cy="0.56" r="0.56" transform="translate(171.93 8.52)" fill="#969696" />
                <circle id="Ellipse_59712" data-name="Ellipse 59712" cx="0.56" cy="0.56" r="0.56" transform="translate(173.6 11.53)" fill="#969696" />
                <circle id="Ellipse_59713" data-name="Ellipse 59713" cx="0.56" cy="0.56" r="0.56" transform="translate(175.01 8.11)" fill="#969696" />
                <circle id="Ellipse_59714" data-name="Ellipse 59714" cx="0.56" cy="0.56" r="0.56" transform="translate(173.97 4.13)" fill="#969696" />
                <circle id="Ellipse_59715" data-name="Ellipse 59715" cx="0.56" cy="0.56" r="0.56" transform="translate(175.63 1.51)" fill="#969696" />
                <circle
                  id="Ellipse_59716"
                  data-name="Ellipse 59716"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.87 12.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_59717" data-name="Ellipse 59717" cx="0.56" cy="0.56" r="0.56" transform="translate(177.87 6.56)" fill="#969696" />
                <circle id="Ellipse_59718" data-name="Ellipse 59718" cx="0.56" cy="0.56" r="0.56" transform="translate(179.54 9.57)" fill="#969696" />
                <circle id="Ellipse_59719" data-name="Ellipse 59719" cx="0.56" cy="0.56" r="0.56" transform="translate(180.95 6.16)" fill="#969696" />
                <circle id="Ellipse_59720" data-name="Ellipse 59720" cx="0.56" cy="0.56" r="0.56" transform="translate(181.56 2.36)" fill="#969696" />
                <circle
                  id="Ellipse_59721"
                  data-name="Ellipse 59721"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.23 -0.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_59722" data-name="Ellipse 59722" cx="0.56" cy="0.56" r="0.56" transform="translate(187.12 0.07)" fill="#969696" />
                <circle id="Ellipse_59723" data-name="Ellipse 59723" cx="0.56" cy="0.56" r="0.56" transform="translate(198.23 5.28)" fill="#969696" />
                <circle
                  id="Ellipse_59724"
                  data-name="Ellipse 59724"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.23 -0.35)"
                  fill="#969696"
                />
                <circle id="Ellipse_59725" data-name="Ellipse 59725" cx="0.56" cy="0.56" r="0.56" transform="translate(199.89 2.66)" fill="#969696" />
                <circle id="Ellipse_59726" data-name="Ellipse 59726" cx="0.56" cy="0.56" r="0.56" transform="translate(201.3 -0.75)" fill="#969696" />
                <circle id="Ellipse_59727" data-name="Ellipse 59727" cx="0.56" cy="0.56" r="0.56" transform="translate(203.78 2.98)" fill="#969696" />
                <circle id="Ellipse_59728" data-name="Ellipse 59728" cx="0.56" cy="0.56" r="0.56" transform="translate(205.45 0.37)" fill="#969696" />
                <circle id="Ellipse_59729" data-name="Ellipse 59729" cx="0.56" cy="0.56" r="0.56" transform="translate(209.73 1.03)" fill="#969696" />
                <circle
                  id="Ellipse_59730"
                  data-name="Ellipse 59730"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.04 35.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59731"
                  data-name="Ellipse 59731"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.04 30.23)"
                  fill="#969696"
                />
                <circle id="Ellipse_59732" data-name="Ellipse 59732" cx="0.56" cy="0.56" r="0.56" transform="translate(169.7 33.24)" fill="#969696" />
                <circle
                  id="Ellipse_59733"
                  data-name="Ellipse 59733"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.11 29.83)"
                  fill="#969696"
                />
                <circle id="Ellipse_59734" data-name="Ellipse 59734" cx="0.56" cy="0.56" r="0.56" transform="translate(169.9 28.13)" fill="#969696" />
                <circle id="Ellipse_59735" data-name="Ellipse 59735" cx="0.56" cy="0.56" r="0.56" transform="translate(169.9 22.51)" fill="#969696" />
                <circle
                  id="Ellipse_59736"
                  data-name="Ellipse 59736"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.56 25.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59737"
                  data-name="Ellipse 59737"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.97 22.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_59738" data-name="Ellipse 59738" cx="0.56" cy="0.56" r="0.56" transform="translate(173.6 33.56)" fill="#969696" />
                <circle id="Ellipse_59739" data-name="Ellipse 59739" cx="0.56" cy="0.56" r="0.56" transform="translate(173.6 27.94)" fill="#969696" />
                <circle
                  id="Ellipse_59740"
                  data-name="Ellipse 59740"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.26 30.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59741"
                  data-name="Ellipse 59741"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.67 27.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59742"
                  data-name="Ellipse 59742"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.63 23.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59743"
                  data-name="Ellipse 59743"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.63 17.93)"
                  fill="#969696"
                />
                <circle id="Ellipse_59744" data-name="Ellipse 59744" cx="0.56" cy="0.56" r="0.56" transform="translate(177.3 20.94)" fill="#969696" />
                <circle
                  id="Ellipse_59745"
                  data-name="Ellipse 59745"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.71 17.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59746"
                  data-name="Ellipse 59746"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.54 31.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59747"
                  data-name="Ellipse 59747"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.54 25.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_59748" data-name="Ellipse 59748" cx="0.56" cy="0.56" r="0.56" transform="translate(181.2 29)" fill="#969696" />
                <circle
                  id="Ellipse_59749"
                  data-name="Ellipse 59749"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.61 25.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59750"
                  data-name="Ellipse 59750"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.59 21.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59751"
                  data-name="Ellipse 59751"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.59 15.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59752"
                  data-name="Ellipse 59752"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.25 18.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59753"
                  data-name="Ellipse 59753"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.66 15.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59754"
                  data-name="Ellipse 59754"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.45 13.63)"
                  fill="#969696"
                />
                <circle id="Ellipse_59755" data-name="Ellipse 59755" cx="0.56" cy="0.56" r="0.56" transform="translate(183.45 8.01)" fill="#969696" />
                <circle
                  id="Ellipse_59756"
                  data-name="Ellipse 59756"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.11 11.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_59757" data-name="Ellipse 59757" cx="0.56" cy="0.56" r="0.56" transform="translate(186.52 7.61)" fill="#969696" />
                <circle
                  id="Ellipse_59758"
                  data-name="Ellipse 59758"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.15 19.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59759"
                  data-name="Ellipse 59759"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.15 13.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59760"
                  data-name="Ellipse 59760"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.81 16.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59761"
                  data-name="Ellipse 59761"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.22 13.04)"
                  fill="#969696"
                />
                <circle id="Ellipse_59762" data-name="Ellipse 59762" cx="0.56" cy="0.56" r="0.56" transform="translate(189.18 9.05)" fill="#969696" />
                <circle id="Ellipse_59763" data-name="Ellipse 59763" cx="0.56" cy="0.56" r="0.56" transform="translate(189.18 3.43)" fill="#969696" />
                <circle id="Ellipse_59764" data-name="Ellipse 59764" cx="0.56" cy="0.56" r="0.56" transform="translate(190.85 6.44)" fill="#969696" />
                <circle id="Ellipse_59765" data-name="Ellipse 59765" cx="0.56" cy="0.56" r="0.56" transform="translate(192.26 3.03)" fill="#969696" />
                <circle
                  id="Ellipse_59766"
                  data-name="Ellipse 59766"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.09 17.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59767"
                  data-name="Ellipse 59767"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.09 11.49)"
                  fill="#969696"
                />
                <circle id="Ellipse_59768" data-name="Ellipse 59768" cx="0.56" cy="0.56" r="0.56" transform="translate(194.76 14.5)" fill="#969696" />
                <circle
                  id="Ellipse_59769"
                  data-name="Ellipse 59769"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.17 11.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_59770" data-name="Ellipse 59770" cx="0.56" cy="0.56" r="0.56" transform="translate(184.7 38.77)" fill="#969696" />
                <circle id="Ellipse_59771" data-name="Ellipse 59771" cx="0.56" cy="0.56" r="0.56" transform="translate(184.7 33.15)" fill="#969696" />
                <circle
                  id="Ellipse_59772"
                  data-name="Ellipse 59772"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.37 36.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59773"
                  data-name="Ellipse 59773"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.77 32.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59774"
                  data-name="Ellipse 59774"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.56 31.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59775"
                  data-name="Ellipse 59775"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(186.56 25.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59776"
                  data-name="Ellipse 59776"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.22 28.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59777"
                  data-name="Ellipse 59777"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.63 25.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59778"
                  data-name="Ellipse 59778"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.26 36.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59779"
                  data-name="Ellipse 59779"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.26 30.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59780"
                  data-name="Ellipse 59780"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.92 33.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59781"
                  data-name="Ellipse 59781"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.33 30.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59782"
                  data-name="Ellipse 59782"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.29 26.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59783"
                  data-name="Ellipse 59783"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.29 20.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59784"
                  data-name="Ellipse 59784"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.96 23.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59785"
                  data-name="Ellipse 59785"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.37 20.44)"
                  fill="#969696"
                />
                <circle id="Ellipse_59786" data-name="Ellipse 59786" cx="0.56" cy="0.56" r="0.56" transform="translate(196.2 34.52)" fill="#969696" />
                <circle id="Ellipse_59787" data-name="Ellipse 59787" cx="0.56" cy="0.56" r="0.56" transform="translate(196.2 28.9)" fill="#969696" />
                <circle
                  id="Ellipse_59788"
                  data-name="Ellipse 59788"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.87 31.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_59789" data-name="Ellipse 59789" cx="0.56" cy="0.56" r="0.56" transform="translate(199.28 28.5)" fill="#969696" />
                <circle
                  id="Ellipse_59790"
                  data-name="Ellipse 59790"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.86 25.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59791"
                  data-name="Ellipse 59791"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.86 19.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59792"
                  data-name="Ellipse 59792"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.53 22.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59793"
                  data-name="Ellipse 59793"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.94 19.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59794"
                  data-name="Ellipse 59794"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.72 17.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59795"
                  data-name="Ellipse 59795"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(200.72 12.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59796"
                  data-name="Ellipse 59796"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.39 15.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_59797" data-name="Ellipse 59797" cx="0.56" cy="0.56" r="0.56" transform="translate(203.8 11.84)" fill="#969696" />
                <circle
                  id="Ellipse_59798"
                  data-name="Ellipse 59798"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.42 23.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59799"
                  data-name="Ellipse 59799"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.42 17.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59800"
                  data-name="Ellipse 59800"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.09 20.68)"
                  fill="#969696"
                />
                <circle id="Ellipse_59801" data-name="Ellipse 59801" cx="0.56" cy="0.56" r="0.56" transform="translate(207.5 17.26)" fill="#969696" />
                <circle
                  id="Ellipse_59802"
                  data-name="Ellipse 59802"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.46 13.28)"
                  fill="#969696"
                />
                <circle id="Ellipse_59803" data-name="Ellipse 59803" cx="0.56" cy="0.56" r="0.56" transform="translate(206.46 7.65)" fill="#969696" />
                <circle
                  id="Ellipse_59804"
                  data-name="Ellipse 59804"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.12 10.67)"
                  fill="#969696"
                />
                <circle id="Ellipse_59805" data-name="Ellipse 59805" cx="0.56" cy="0.56" r="0.56" transform="translate(209.53 7.25)" fill="#969696" />
                <circle
                  id="Ellipse_59806"
                  data-name="Ellipse 59806"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.36 21.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59807"
                  data-name="Ellipse 59807"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.36 15.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59808"
                  data-name="Ellipse 59808"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.03 18.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59809"
                  data-name="Ellipse 59809"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.44 15.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59810"
                  data-name="Ellipse 59810"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.35 43.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59811"
                  data-name="Ellipse 59811"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.35 37.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59812"
                  data-name="Ellipse 59812"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.02 40.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59813"
                  data-name="Ellipse 59813"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.43 37.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59814"
                  data-name="Ellipse 59814"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.21 35.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59815"
                  data-name="Ellipse 59815"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.21 29.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59816"
                  data-name="Ellipse 59816"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.88 32.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59817"
                  data-name="Ellipse 59817"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.29 29.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59818"
                  data-name="Ellipse 59818"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.91 40.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59819"
                  data-name="Ellipse 59819"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.91 35.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59820"
                  data-name="Ellipse 59820"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.58 38.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59821"
                  data-name="Ellipse 59821"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.99 34.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59822"
                  data-name="Ellipse 59822"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.95 30.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59823"
                  data-name="Ellipse 59823"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.95 25.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59824"
                  data-name="Ellipse 59824"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.61 28.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59825"
                  data-name="Ellipse 59825"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.02 24.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59826"
                  data-name="Ellipse 59826"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.86 38.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59827"
                  data-name="Ellipse 59827"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.86 33.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59828"
                  data-name="Ellipse 59828"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.52 36.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59829"
                  data-name="Ellipse 59829"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.93 32.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59830"
                  data-name="Ellipse 59830"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.91 28.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59831"
                  data-name="Ellipse 59831"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.91 22.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59832"
                  data-name="Ellipse 59832"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.57 25.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59833"
                  data-name="Ellipse 59833"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.98 22.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59834"
                  data-name="Ellipse 59834"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.76 20.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59835"
                  data-name="Ellipse 59835"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.76 15.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59836"
                  data-name="Ellipse 59836"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.43 18.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59837"
                  data-name="Ellipse 59837"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.84 14.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59838"
                  data-name="Ellipse 59838"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.46 26.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59839"
                  data-name="Ellipse 59839"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.46 20.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59840"
                  data-name="Ellipse 59840"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.13 23.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59841"
                  data-name="Ellipse 59841"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.54 20.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_59842" data-name="Ellipse 59842" cx="0.56" cy="0.56" r="0.56" transform="translate(222.5 16.26)" fill="#969696" />
                <circle id="Ellipse_59843" data-name="Ellipse 59843" cx="0.56" cy="0.56" r="0.56" transform="translate(222.5 10.63)" fill="#969696" />
                <circle
                  id="Ellipse_59844"
                  data-name="Ellipse 59844"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.17 13.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59845"
                  data-name="Ellipse 59845"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.58 10.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59846"
                  data-name="Ellipse 59846"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.41 24.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59847"
                  data-name="Ellipse 59847"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.41 18.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59848"
                  data-name="Ellipse 59848"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.07 21.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59849"
                  data-name="Ellipse 59849"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.48 18.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59850"
                  data-name="Ellipse 59850"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.02 45.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59851"
                  data-name="Ellipse 59851"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.02 40.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59852"
                  data-name="Ellipse 59852"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.68 43.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59853"
                  data-name="Ellipse 59853"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.09 39.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59854"
                  data-name="Ellipse 59854"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.88 38.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59855"
                  data-name="Ellipse 59855"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.88 32.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59856"
                  data-name="Ellipse 59856"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.54 35.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59857"
                  data-name="Ellipse 59857"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.95 32.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59858"
                  data-name="Ellipse 59858"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.57 43.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59859"
                  data-name="Ellipse 59859"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.57 38.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59860"
                  data-name="Ellipse 59860"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.24 41.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59861"
                  data-name="Ellipse 59861"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.65 37.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59862"
                  data-name="Ellipse 59862"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.61 33.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59863"
                  data-name="Ellipse 59863"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.61 28.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59864"
                  data-name="Ellipse 59864"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.28 31.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59865"
                  data-name="Ellipse 59865"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.69 27.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59866"
                  data-name="Ellipse 59866"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.52 41.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59867"
                  data-name="Ellipse 59867"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.52 36.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59868"
                  data-name="Ellipse 59868"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.18 39.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59869"
                  data-name="Ellipse 59869"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.59 35.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59870"
                  data-name="Ellipse 59870"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.18 32.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59871"
                  data-name="Ellipse 59871"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.18 27.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59872"
                  data-name="Ellipse 59872"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.85 30.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59873"
                  data-name="Ellipse 59873"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.26 26.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59874"
                  data-name="Ellipse 59874"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.04 25.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59875"
                  data-name="Ellipse 59875"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.04 19.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59876"
                  data-name="Ellipse 59876"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.71 22.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59877"
                  data-name="Ellipse 59877"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.12 19.04)"
                  fill="#969696"
                />
                <circle id="Ellipse_59878" data-name="Ellipse 59878" cx="0.56" cy="0.56" r="0.56" transform="translate(237.74 30.5)" fill="#969696" />
                <circle
                  id="Ellipse_59879"
                  data-name="Ellipse 59879"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.74 24.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59880"
                  data-name="Ellipse 59880"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.41 27.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59881"
                  data-name="Ellipse 59881"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.82 24.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59882"
                  data-name="Ellipse 59882"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.77 20.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59883"
                  data-name="Ellipse 59883"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.77 14.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59884"
                  data-name="Ellipse 59884"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.44 17.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59885"
                  data-name="Ellipse 59885"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.85 14.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59886"
                  data-name="Ellipse 59886"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.68 28.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59887"
                  data-name="Ellipse 59887"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.68 22.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59888"
                  data-name="Ellipse 59888"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.35 25.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59889"
                  data-name="Ellipse 59889"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.76 22.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59890"
                  data-name="Ellipse 59890"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.05 11.56)"
                  fill="#969696"
                />
                <circle id="Ellipse_59891" data-name="Ellipse 59891" cx="0.56" cy="0.56" r="0.56" transform="translate(214.05 5.94)" fill="#969696" />
                <circle id="Ellipse_59892" data-name="Ellipse 59892" cx="0.56" cy="0.56" r="0.56" transform="translate(215.72 8.95)" fill="#969696" />
                <circle id="Ellipse_59893" data-name="Ellipse 59893" cx="0.56" cy="0.56" r="0.56" transform="translate(217.13 5.54)" fill="#969696" />
                <circle id="Ellipse_59894" data-name="Ellipse 59894" cx="0.56" cy="0.56" r="0.56" transform="translate(215.91 3.84)" fill="#969696" />
                <circle id="Ellipse_59895" data-name="Ellipse 59895" cx="0.56" cy="0.56" r="0.56" transform="translate(217.58 1.23)" fill="#969696" />
                <circle id="Ellipse_59896" data-name="Ellipse 59896" cx="0.56" cy="0.56" r="0.56" transform="translate(219.61 9.27)" fill="#969696" />
                <circle id="Ellipse_59897" data-name="Ellipse 59897" cx="0.56" cy="0.56" r="0.56" transform="translate(219.61 3.64)" fill="#969696" />
                <circle id="Ellipse_59898" data-name="Ellipse 59898" cx="0.56" cy="0.56" r="0.56" transform="translate(221.28 6.66)" fill="#969696" />
                <circle id="Ellipse_59899" data-name="Ellipse 59899" cx="0.56" cy="0.56" r="0.56" transform="translate(222.69 3.24)" fill="#969696" />
                <circle
                  id="Ellipse_59900"
                  data-name="Ellipse 59900"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.65 -0.74)"
                  fill="#969696"
                />
                <circle id="Ellipse_59901" data-name="Ellipse 59901" cx="0.56" cy="0.56" r="0.56" transform="translate(225.55 7.31)" fill="#969696" />
                <circle id="Ellipse_59902" data-name="Ellipse 59902" cx="0.56" cy="0.56" r="0.56" transform="translate(225.55 1.69)" fill="#969696" />
                <circle id="Ellipse_59903" data-name="Ellipse 59903" cx="0.56" cy="0.56" r="0.56" transform="translate(227.22 4.7)" fill="#969696" />
                <circle id="Ellipse_59904" data-name="Ellipse 59904" cx="0.56" cy="0.56" r="0.56" transform="translate(228.63 1.29)" fill="#969696" />
                <circle
                  id="Ellipse_59905"
                  data-name="Ellipse 59905"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.72 14.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_59906" data-name="Ellipse 59906" cx="0.56" cy="0.56" r="0.56" transform="translate(230.72 8.85)" fill="#969696" />
                <circle
                  id="Ellipse_59907"
                  data-name="Ellipse 59907"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.38 11.86)"
                  fill="#969696"
                />
                <circle id="Ellipse_59908" data-name="Ellipse 59908" cx="0.56" cy="0.56" r="0.56" transform="translate(233.79 8.45)" fill="#969696" />
                <circle id="Ellipse_59909" data-name="Ellipse 59909" cx="0.56" cy="0.56" r="0.56" transform="translate(232.57 6.75)" fill="#969696" />
                <circle id="Ellipse_59910" data-name="Ellipse 59910" cx="0.56" cy="0.56" r="0.56" transform="translate(232.57 1.13)" fill="#969696" />
                <circle id="Ellipse_59911" data-name="Ellipse 59911" cx="0.56" cy="0.56" r="0.56" transform="translate(234.24 4.14)" fill="#969696" />
                <circle id="Ellipse_59912" data-name="Ellipse 59912" cx="0.56" cy="0.56" r="0.56" transform="translate(235.65 0.73)" fill="#969696" />
                <circle
                  id="Ellipse_59913"
                  data-name="Ellipse 59913"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.27 12.18)"
                  fill="#969696"
                />
                <circle id="Ellipse_59914" data-name="Ellipse 59914" cx="0.56" cy="0.56" r="0.56" transform="translate(236.27 6.56)" fill="#969696" />
                <circle id="Ellipse_59915" data-name="Ellipse 59915" cx="0.56" cy="0.56" r="0.56" transform="translate(237.94 9.57)" fill="#969696" />
                <circle id="Ellipse_59916" data-name="Ellipse 59916" cx="0.56" cy="0.56" r="0.56" transform="translate(239.35 6.16)" fill="#969696" />
                <circle id="Ellipse_59917" data-name="Ellipse 59917" cx="0.56" cy="0.56" r="0.56" transform="translate(238.31 2.17)" fill="#969696" />
                <circle
                  id="Ellipse_59918"
                  data-name="Ellipse 59918"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.98 -0.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59919"
                  data-name="Ellipse 59919"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.22 10.23)"
                  fill="#969696"
                />
                <circle id="Ellipse_59920" data-name="Ellipse 59920" cx="0.56" cy="0.56" r="0.56" transform="translate(242.22 4.6)" fill="#969696" />
                <circle id="Ellipse_59921" data-name="Ellipse 59921" cx="0.56" cy="0.56" r="0.56" transform="translate(243.88 7.62)" fill="#969696" />
                <circle id="Ellipse_59922" data-name="Ellipse 59922" cx="0.56" cy="0.56" r="0.56" transform="translate(245.29 4.2)" fill="#969696" />
                <circle id="Ellipse_59923" data-name="Ellipse 59923" cx="0.56" cy="0.56" r="0.56" transform="translate(244.88 1.29)" fill="#969696" />
                <circle
                  id="Ellipse_59924"
                  data-name="Ellipse 59924"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.44 -1.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59925"
                  data-name="Ellipse 59925"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.37 18.72)"
                  fill="#969696"
                />
                <circle id="Ellipse_59926" data-name="Ellipse 59926" cx="0.56" cy="0.56" r="0.56" transform="translate(247.37 13.1)" fill="#969696" />
                <circle
                  id="Ellipse_59927"
                  data-name="Ellipse 59927"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.04 16.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_59928" data-name="Ellipse 59928" cx="0.56" cy="0.56" r="0.56" transform="translate(250.45 12.7)" fill="#969696" />
                <circle id="Ellipse_59929" data-name="Ellipse 59929" cx="0.56" cy="0.56" r="0.56" transform="translate(249.23 11)" fill="#969696" />
                <circle id="Ellipse_59930" data-name="Ellipse 59930" cx="0.56" cy="0.56" r="0.56" transform="translate(249.23 5.37)" fill="#969696" />
                <circle id="Ellipse_59931" data-name="Ellipse 59931" cx="0.56" cy="0.56" r="0.56" transform="translate(250.9 8.39)" fill="#969696" />
                <circle id="Ellipse_59932" data-name="Ellipse 59932" cx="0.56" cy="0.56" r="0.56" transform="translate(252.31 4.97)" fill="#969696" />
                <circle
                  id="Ellipse_59933"
                  data-name="Ellipse 59933"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.93 16.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_59934" data-name="Ellipse 59934" cx="0.56" cy="0.56" r="0.56" transform="translate(252.93 10.8)" fill="#969696" />
                <circle id="Ellipse_59935" data-name="Ellipse 59935" cx="0.56" cy="0.56" r="0.56" transform="translate(254.6 13.82)" fill="#969696" />
                <circle id="Ellipse_59936" data-name="Ellipse 59936" cx="0.56" cy="0.56" r="0.56" transform="translate(256.01 10.4)" fill="#969696" />
                <circle id="Ellipse_59937" data-name="Ellipse 59937" cx="0.56" cy="0.56" r="0.56" transform="translate(254.96 6.42)" fill="#969696" />
                <circle id="Ellipse_59938" data-name="Ellipse 59938" cx="0.56" cy="0.56" r="0.56" transform="translate(254.96 0.79)" fill="#969696" />
                <circle id="Ellipse_59939" data-name="Ellipse 59939" cx="0.56" cy="0.56" r="0.56" transform="translate(256.63 3.8)" fill="#969696" />
                <circle id="Ellipse_59940" data-name="Ellipse 59940" cx="0.56" cy="0.56" r="0.56" transform="translate(258.04 0.39)" fill="#969696" />
                <circle
                  id="Ellipse_59941"
                  data-name="Ellipse 59941"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.87 14.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_59942" data-name="Ellipse 59942" cx="0.56" cy="0.56" r="0.56" transform="translate(258.87 8.85)" fill="#969696" />
                <circle
                  id="Ellipse_59943"
                  data-name="Ellipse 59943"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.54 11.86)"
                  fill="#969696"
                />
                <circle id="Ellipse_59944" data-name="Ellipse 59944" cx="0.56" cy="0.56" r="0.56" transform="translate(261.95 8.45)" fill="#969696" />
                <circle id="Ellipse_59945" data-name="Ellipse 59945" cx="0.56" cy="0.56" r="0.56" transform="translate(260.92 4.22)" fill="#969696" />
                <circle id="Ellipse_59946" data-name="Ellipse 59946" cx="0.56" cy="0.56" r="0.56" transform="translate(262.59 1.61)" fill="#969696" />
                <circle id="Ellipse_59947" data-name="Ellipse 59947" cx="0.56" cy="0.56" r="0.56" transform="translate(266.48 1.93)" fill="#969696" />
                <circle
                  id="Ellipse_59948"
                  data-name="Ellipse 59948"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.15 -0.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59949"
                  data-name="Ellipse 59949"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.42 -0.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59950"
                  data-name="Ellipse 59950"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.03 21.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59951"
                  data-name="Ellipse 59951"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.03 16.01)"
                  fill="#969696"
                />
                <circle id="Ellipse_59952" data-name="Ellipse 59952" cx="0.56" cy="0.56" r="0.56" transform="translate(265.7 19.02)" fill="#969696" />
                <circle
                  id="Ellipse_59953"
                  data-name="Ellipse 59953"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.11 15.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59954"
                  data-name="Ellipse 59954"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.89 13.91)"
                  fill="#969696"
                />
                <circle id="Ellipse_59955" data-name="Ellipse 59955" cx="0.56" cy="0.56" r="0.56" transform="translate(265.89 8.29)" fill="#969696" />
                <circle id="Ellipse_59956" data-name="Ellipse 59956" cx="0.56" cy="0.56" r="0.56" transform="translate(267.56 11.3)" fill="#969696" />
                <circle id="Ellipse_59957" data-name="Ellipse 59957" cx="0.56" cy="0.56" r="0.56" transform="translate(268.97 7.89)" fill="#969696" />
                <circle
                  id="Ellipse_59958"
                  data-name="Ellipse 59958"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.59 19.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59959"
                  data-name="Ellipse 59959"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.59 13.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59960"
                  data-name="Ellipse 59960"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.26 16.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59961"
                  data-name="Ellipse 59961"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.67 13.32)"
                  fill="#969696"
                />
                <circle id="Ellipse_59962" data-name="Ellipse 59962" cx="0.56" cy="0.56" r="0.56" transform="translate(271.63 9.33)" fill="#969696" />
                <circle id="Ellipse_59963" data-name="Ellipse 59963" cx="0.56" cy="0.56" r="0.56" transform="translate(271.63 3.71)" fill="#969696" />
                <circle id="Ellipse_59964" data-name="Ellipse 59964" cx="0.56" cy="0.56" r="0.56" transform="translate(273.29 6.72)" fill="#969696" />
                <circle id="Ellipse_59965" data-name="Ellipse 59965" cx="0.56" cy="0.56" r="0.56" transform="translate(274.7 3.3)" fill="#969696" />
                <circle
                  id="Ellipse_59966"
                  data-name="Ellipse 59966"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.53 17.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59967"
                  data-name="Ellipse 59967"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.53 11.76)"
                  fill="#969696"
                />
                <circle id="Ellipse_59968" data-name="Ellipse 59968" cx="0.56" cy="0.56" r="0.56" transform="translate(277.2 14.78)" fill="#969696" />
                <circle
                  id="Ellipse_59969"
                  data-name="Ellipse 59969"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.61 11.36)"
                  fill="#969696"
                />
                <circle id="Ellipse_59970" data-name="Ellipse 59970" cx="0.56" cy="0.56" r="0.56" transform="translate(278.2 8.45)" fill="#969696" />
                <circle id="Ellipse_59971" data-name="Ellipse 59971" cx="0.56" cy="0.56" r="0.56" transform="translate(278.2 2.82)" fill="#969696" />
                <circle id="Ellipse_59972" data-name="Ellipse 59972" cx="0.56" cy="0.56" r="0.56" transform="translate(279.86 5.84)" fill="#969696" />
                <circle id="Ellipse_59973" data-name="Ellipse 59973" cx="0.56" cy="0.56" r="0.56" transform="translate(281.27 2.42)" fill="#969696" />
                <circle id="Ellipse_59974" data-name="Ellipse 59974" cx="0.56" cy="0.56" r="0.56" transform="translate(280.06 0.72)" fill="#969696" />
                <circle id="Ellipse_59975" data-name="Ellipse 59975" cx="0.56" cy="0.56" r="0.56" transform="translate(283.76 6.15)" fill="#969696" />
                <circle id="Ellipse_59976" data-name="Ellipse 59976" cx="0.56" cy="0.56" r="0.56" transform="translate(283.76 0.53)" fill="#969696" />
                <circle id="Ellipse_59977" data-name="Ellipse 59977" cx="0.56" cy="0.56" r="0.56" transform="translate(285.42 3.54)" fill="#969696" />
                <circle id="Ellipse_59978" data-name="Ellipse 59978" cx="0.56" cy="0.56" r="0.56" transform="translate(286.83 0.13)" fill="#969696" />
                <circle id="Ellipse_59979" data-name="Ellipse 59979" cx="0.56" cy="0.56" r="0.56" transform="translate(289.7 4.2)" fill="#969696" />
                <circle id="Ellipse_59980" data-name="Ellipse 59980" cx="0.56" cy="0.56" r="0.56" transform="translate(291.36 1.59)" fill="#969696" />
                <circle
                  id="Ellipse_59981"
                  data-name="Ellipse 59981"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.84 52.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59982"
                  data-name="Ellipse 59982"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.84 46.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_59983" data-name="Ellipse 59983" cx="0.56" cy="0.56" r="0.56" transform="translate(235.51 49.6)" fill="#969696" />
                <circle
                  id="Ellipse_59984"
                  data-name="Ellipse 59984"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.92 46.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_59985" data-name="Ellipse 59985" cx="0.56" cy="0.56" r="0.56" transform="translate(235.7 44.49)" fill="#969696" />
                <circle id="Ellipse_59986" data-name="Ellipse 59986" cx="0.56" cy="0.56" r="0.56" transform="translate(235.7 38.87)" fill="#969696" />
                <circle
                  id="Ellipse_59987"
                  data-name="Ellipse 59987"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.37 41.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59988"
                  data-name="Ellipse 59988"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.78 38.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_59989" data-name="Ellipse 59989" cx="0.56" cy="0.56" r="0.56" transform="translate(239.4 49.92)" fill="#969696" />
                <circle id="Ellipse_59990" data-name="Ellipse 59990" cx="0.56" cy="0.56" r="0.56" transform="translate(239.4 44.3)" fill="#969696" />
                <circle
                  id="Ellipse_59991"
                  data-name="Ellipse 59991"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.07 47.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_59992" data-name="Ellipse 59992" cx="0.56" cy="0.56" r="0.56" transform="translate(242.48 43.9)" fill="#969696" />
                <circle
                  id="Ellipse_59993"
                  data-name="Ellipse 59993"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.44 39.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59994"
                  data-name="Ellipse 59994"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.44 34.28)"
                  fill="#969696"
                />
                <circle id="Ellipse_59995" data-name="Ellipse 59995" cx="0.56" cy="0.56" r="0.56" transform="translate(243.1 37.3)" fill="#969696" />
                <circle
                  id="Ellipse_59996"
                  data-name="Ellipse 59996"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.51 33.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59997"
                  data-name="Ellipse 59997"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.35 47.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59998"
                  data-name="Ellipse 59998"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.35 42.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_59999"
                  data-name="Ellipse 59999"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.01 45.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60000"
                  data-name="Ellipse 60000"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.42 41.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_60001" data-name="Ellipse 60001" cx="0.56" cy="0.56" r="0.56" transform="translate(247.4 37.71)" fill="#969696" />
                <circle id="Ellipse_60002" data-name="Ellipse 60002" cx="0.56" cy="0.56" r="0.56" transform="translate(247.4 32.09)" fill="#969696" />
                <circle id="Ellipse_60003" data-name="Ellipse 60003" cx="0.56" cy="0.56" r="0.56" transform="translate(249.06 35.1)" fill="#969696" />
                <circle
                  id="Ellipse_60004"
                  data-name="Ellipse 60004"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.47 31.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60005"
                  data-name="Ellipse 60005"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.25 29.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60006"
                  data-name="Ellipse 60006"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.25 24.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60007"
                  data-name="Ellipse 60007"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.92 27.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60008"
                  data-name="Ellipse 60008"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.33 23.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60009"
                  data-name="Ellipse 60009"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.95 35.42)"
                  fill="#969696"
                />
                <circle id="Ellipse_60010" data-name="Ellipse 60010" cx="0.56" cy="0.56" r="0.56" transform="translate(252.95 29.8)" fill="#969696" />
                <circle
                  id="Ellipse_60011"
                  data-name="Ellipse 60011"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.62 32.81)"
                  fill="#969696"
                />
                <circle id="Ellipse_60012" data-name="Ellipse 60012" cx="0.56" cy="0.56" r="0.56" transform="translate(256.03 29.4)" fill="#969696" />
                <circle
                  id="Ellipse_60013"
                  data-name="Ellipse 60013"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.99 25.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60014"
                  data-name="Ellipse 60014"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.99 19.78)"
                  fill="#969696"
                />
                <circle id="Ellipse_60015" data-name="Ellipse 60015" cx="0.56" cy="0.56" r="0.56" transform="translate(256.66 22.8)" fill="#969696" />
                <circle
                  id="Ellipse_60016"
                  data-name="Ellipse 60016"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.07 19.38)"
                  fill="#969696"
                />
                <circle id="Ellipse_60017" data-name="Ellipse 60017" cx="0.56" cy="0.56" r="0.56" transform="translate(258.9 33.47)" fill="#969696" />
                <circle id="Ellipse_60018" data-name="Ellipse 60018" cx="0.56" cy="0.56" r="0.56" transform="translate(258.9 27.84)" fill="#969696" />
                <circle
                  id="Ellipse_60019"
                  data-name="Ellipse 60019"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.56 30.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60020"
                  data-name="Ellipse 60020"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.97 27.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60021"
                  data-name="Ellipse 60021"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.51 55.13)"
                  fill="#969696"
                />
                <circle id="Ellipse_60022" data-name="Ellipse 60022" cx="0.56" cy="0.56" r="0.56" transform="translate(250.51 49.5)" fill="#969696" />
                <circle
                  id="Ellipse_60023"
                  data-name="Ellipse 60023"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.17 52.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_60024" data-name="Ellipse 60024" cx="0.56" cy="0.56" r="0.56" transform="translate(253.58 49.1)" fill="#969696" />
                <circle
                  id="Ellipse_60025"
                  data-name="Ellipse 60025"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.36 47.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60026"
                  data-name="Ellipse 60026"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.36 41.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60027"
                  data-name="Ellipse 60027"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.03 44.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60028"
                  data-name="Ellipse 60028"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.44 41.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60029"
                  data-name="Ellipse 60029"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.06 52.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60030"
                  data-name="Ellipse 60030"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.06 47.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60031"
                  data-name="Ellipse 60031"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.73 50.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60032"
                  data-name="Ellipse 60032"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.14 46.81)"
                  fill="#969696"
                />
                <circle id="Ellipse_60033" data-name="Ellipse 60033" cx="0.56" cy="0.56" r="0.56" transform="translate(258.1 42.82)" fill="#969696" />
                <circle id="Ellipse_60034" data-name="Ellipse 60034" cx="0.56" cy="0.56" r="0.56" transform="translate(258.1 37.2)" fill="#969696" />
                <circle
                  id="Ellipse_60035"
                  data-name="Ellipse 60035"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.77 40.21)"
                  fill="#969696"
                />
                <circle id="Ellipse_60036" data-name="Ellipse 60036" cx="0.56" cy="0.56" r="0.56" transform="translate(261.18 36.8)" fill="#969696" />
                <circle
                  id="Ellipse_60037"
                  data-name="Ellipse 60037"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.01 50.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60038"
                  data-name="Ellipse 60038"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.01 45.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60039"
                  data-name="Ellipse 60039"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.67 48.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60040"
                  data-name="Ellipse 60040"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.08 44.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60041"
                  data-name="Ellipse 60041"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.67 41.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60042"
                  data-name="Ellipse 60042"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.67 36.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60043"
                  data-name="Ellipse 60043"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.34 39.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60044"
                  data-name="Ellipse 60044"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.75 35.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60045"
                  data-name="Ellipse 60045"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.53 34.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60046"
                  data-name="Ellipse 60046"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.53 28.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_60047" data-name="Ellipse 60047" cx="0.56" cy="0.56" r="0.56" transform="translate(268.2 31.61)" fill="#969696" />
                <circle
                  id="Ellipse_60048"
                  data-name="Ellipse 60048"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.61 28.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60049"
                  data-name="Ellipse 60049"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.23 39.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60050"
                  data-name="Ellipse 60050"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.23 34.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_60051" data-name="Ellipse 60051" cx="0.56" cy="0.56" r="0.56" transform="translate(271.9 37.04)" fill="#969696" />
                <circle id="Ellipse_60052" data-name="Ellipse 60052" cx="0.56" cy="0.56" r="0.56" transform="translate(273.3 33.62)" fill="#969696" />
                <circle
                  id="Ellipse_60053"
                  data-name="Ellipse 60053"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.26 29.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60054"
                  data-name="Ellipse 60054"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.26 24.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60055"
                  data-name="Ellipse 60055"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.93 27.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60056"
                  data-name="Ellipse 60056"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.34 23.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60057"
                  data-name="Ellipse 60057"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.17 37.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60058"
                  data-name="Ellipse 60058"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.17 32.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60059"
                  data-name="Ellipse 60059"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.84 35.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60060"
                  data-name="Ellipse 60060"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.25 31.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60061"
                  data-name="Ellipse 60061"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.62 154.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60062"
                  data-name="Ellipse 60062"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.62 149.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60063"
                  data-name="Ellipse 60063"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.29 152.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60064"
                  data-name="Ellipse 60064"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.7 148.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60065"
                  data-name="Ellipse 60065"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.48 147.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60066"
                  data-name="Ellipse 60066"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.48 141.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60067"
                  data-name="Ellipse 60067"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.14 144.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60068"
                  data-name="Ellipse 60068"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.55 141.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60069"
                  data-name="Ellipse 60069"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.18 152.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60070"
                  data-name="Ellipse 60070"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.18 146.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_60071" data-name="Ellipse 60071" cx="0.56" cy="0.56" r="0.56" transform="translate(235.84 150)" fill="#969696" />
                <circle
                  id="Ellipse_60072"
                  data-name="Ellipse 60072"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.25 146.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60073"
                  data-name="Ellipse 60073"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.21 142.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60074"
                  data-name="Ellipse 60074"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.21 136.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60075"
                  data-name="Ellipse 60075"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.88 139.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60076"
                  data-name="Ellipse 60076"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.29 136.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60077"
                  data-name="Ellipse 60077"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.12 150.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60078"
                  data-name="Ellipse 60078"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.12 145.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60079"
                  data-name="Ellipse 60079"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.79 148.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60080"
                  data-name="Ellipse 60080"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.2 144.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60081"
                  data-name="Ellipse 60081"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.17 140.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60082"
                  data-name="Ellipse 60082"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.17 134.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60083"
                  data-name="Ellipse 60083"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.84 137.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60084"
                  data-name="Ellipse 60084"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.25 134.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60085"
                  data-name="Ellipse 60085"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.03 132.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60086"
                  data-name="Ellipse 60086"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.03 127.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60087"
                  data-name="Ellipse 60087"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.7 130.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60088"
                  data-name="Ellipse 60088"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.11 126.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60089"
                  data-name="Ellipse 60089"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.73 138.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60090"
                  data-name="Ellipse 60090"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.73 132.49)"
                  fill="#969696"
                />
                <circle id="Ellipse_60091" data-name="Ellipse 60091" cx="0.56" cy="0.56" r="0.56" transform="translate(249.4 135.5)" fill="#969696" />
                <circle
                  id="Ellipse_60092"
                  data-name="Ellipse 60092"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.81 132.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60093"
                  data-name="Ellipse 60093"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.76 128.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60094"
                  data-name="Ellipse 60094"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.76 122.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60095"
                  data-name="Ellipse 60095"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.43 125.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60096"
                  data-name="Ellipse 60096"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.84 122.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60097"
                  data-name="Ellipse 60097"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.67 136.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60098"
                  data-name="Ellipse 60098"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.67 130.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60099"
                  data-name="Ellipse 60099"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.34 133.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60100"
                  data-name="Ellipse 60100"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.75 130.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60101"
                  data-name="Ellipse 60101"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.28 157.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60102"
                  data-name="Ellipse 60102"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.28 152.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60103"
                  data-name="Ellipse 60103"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.95 155.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60104"
                  data-name="Ellipse 60104"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.36 151.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60105"
                  data-name="Ellipse 60105"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.14 150.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60106"
                  data-name="Ellipse 60106"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.14 144.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60107"
                  data-name="Ellipse 60107"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.81 147.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60108"
                  data-name="Ellipse 60108"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.22 144.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60109"
                  data-name="Ellipse 60109"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.84 155.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60110"
                  data-name="Ellipse 60110"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.84 149.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60111"
                  data-name="Ellipse 60111"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.51 152.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60112"
                  data-name="Ellipse 60112"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.92 149.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60113"
                  data-name="Ellipse 60113"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.87 145.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60114"
                  data-name="Ellipse 60114"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.87 139.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60115"
                  data-name="Ellipse 60115"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.54 142.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60116"
                  data-name="Ellipse 60116"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.95 139.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60117"
                  data-name="Ellipse 60117"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.78 153.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60118"
                  data-name="Ellipse 60118"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.78 147.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60119"
                  data-name="Ellipse 60119"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.45 150.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60120"
                  data-name="Ellipse 60120"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.86 147.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60121"
                  data-name="Ellipse 60121"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.45 144.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60122"
                  data-name="Ellipse 60122"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.45 139.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60123"
                  data-name="Ellipse 60123"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.11 142.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60124"
                  data-name="Ellipse 60124"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.52 138.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60125"
                  data-name="Ellipse 60125"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.3 136.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60126"
                  data-name="Ellipse 60126"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.3 131.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60127"
                  data-name="Ellipse 60127"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.97 134.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60128"
                  data-name="Ellipse 60128"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.38 130.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_60129" data-name="Ellipse 60129" cx="0.56" cy="0.56" r="0.56" transform="translate(265 142.34)" fill="#969696" />
                <circle id="Ellipse_60130" data-name="Ellipse 60130" cx="0.56" cy="0.56" r="0.56" transform="translate(265 136.72)" fill="#969696" />
                <circle
                  id="Ellipse_60131"
                  data-name="Ellipse 60131"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.67 139.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60132"
                  data-name="Ellipse 60132"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.08 136.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60133"
                  data-name="Ellipse 60133"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.04 132.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60134"
                  data-name="Ellipse 60134"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.04 126.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60135"
                  data-name="Ellipse 60135"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.71 129.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60136"
                  data-name="Ellipse 60136"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.12 126.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60137"
                  data-name="Ellipse 60137"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.95 140.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60138"
                  data-name="Ellipse 60138"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.95 134.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60139"
                  data-name="Ellipse 60139"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.61 137.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60140"
                  data-name="Ellipse 60140"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.02 134.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60141"
                  data-name="Ellipse 60141"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.32 123.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60142"
                  data-name="Ellipse 60142"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.32 117.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60143"
                  data-name="Ellipse 60143"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.98 120.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60144"
                  data-name="Ellipse 60144"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.39 117.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60145"
                  data-name="Ellipse 60145"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.18 115.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60146"
                  data-name="Ellipse 60146"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.18 110.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60147"
                  data-name="Ellipse 60147"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.84 113.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60148"
                  data-name="Ellipse 60148"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.25 109.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60149"
                  data-name="Ellipse 60149"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.88 121.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60150"
                  data-name="Ellipse 60150"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.88 115.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60151"
                  data-name="Ellipse 60151"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.54 118.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60152"
                  data-name="Ellipse 60152"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.95 115.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60153"
                  data-name="Ellipse 60153"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.91 111.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60154"
                  data-name="Ellipse 60154"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.91 105.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60155"
                  data-name="Ellipse 60155"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.58 108.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60156"
                  data-name="Ellipse 60156"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.99 105.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60157"
                  data-name="Ellipse 60157"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.82 119.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60158"
                  data-name="Ellipse 60158"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.82 113.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60159"
                  data-name="Ellipse 60159"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.49 116.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60160"
                  data-name="Ellipse 60160"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.9 113.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60161"
                  data-name="Ellipse 60161"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.87 108.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60162"
                  data-name="Ellipse 60162"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.87 103.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60163"
                  data-name="Ellipse 60163"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.54 106.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60164"
                  data-name="Ellipse 60164"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.95 102.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60165"
                  data-name="Ellipse 60165"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.73 101.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60166"
                  data-name="Ellipse 60166"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.73 95.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60167"
                  data-name="Ellipse 60167"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.39 98.57)"
                  fill="#969696"
                />
                <circle id="Ellipse_60168" data-name="Ellipse 60168" cx="0.56" cy="0.56" r="0.56" transform="translate(259.8 95.16)" fill="#969696" />
                <circle
                  id="Ellipse_60169"
                  data-name="Ellipse 60169"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.43 106.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60170"
                  data-name="Ellipse 60170"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.43 100.99)"
                  fill="#969696"
                />
                <circle id="Ellipse_60171" data-name="Ellipse 60171" cx="0.56" cy="0.56" r="0.56" transform="translate(262.09 104)" fill="#969696" />
                <circle
                  id="Ellipse_60172"
                  data-name="Ellipse 60172"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.5 100.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_60173" data-name="Ellipse 60173" cx="0.56" cy="0.56" r="0.56" transform="translate(262.46 96.6)" fill="#969696" />
                <circle
                  id="Ellipse_60174"
                  data-name="Ellipse 60174"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.46 90.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60175"
                  data-name="Ellipse 60175"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.13 93.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60176"
                  data-name="Ellipse 60176"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.54 90.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60177"
                  data-name="Ellipse 60177"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.37 104.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60178"
                  data-name="Ellipse 60178"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.37 99.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60179"
                  data-name="Ellipse 60179"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.04 102.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60180"
                  data-name="Ellipse 60180"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.45 98.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60181"
                  data-name="Ellipse 60181"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.98 126.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60182"
                  data-name="Ellipse 60182"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.98 120.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60183"
                  data-name="Ellipse 60183"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.65 123.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60184"
                  data-name="Ellipse 60184"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.06 120.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60185"
                  data-name="Ellipse 60185"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.84 118.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60186"
                  data-name="Ellipse 60186"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(259.84 112.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60187"
                  data-name="Ellipse 60187"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.51 115.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60188"
                  data-name="Ellipse 60188"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.92 112.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60189"
                  data-name="Ellipse 60189"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.54 124.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60190"
                  data-name="Ellipse 60190"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.54 118.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60191"
                  data-name="Ellipse 60191"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.2 121.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_60192" data-name="Ellipse 60192" cx="0.56" cy="0.56" r="0.56" transform="translate(266.61 118)" fill="#969696" />
                <circle
                  id="Ellipse_60193"
                  data-name="Ellipse 60193"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.57 114.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60194"
                  data-name="Ellipse 60194"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.57 108.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60195"
                  data-name="Ellipse 60195"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.24 111.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60196"
                  data-name="Ellipse 60196"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.65 107.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60197"
                  data-name="Ellipse 60197"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.48 122.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60198"
                  data-name="Ellipse 60198"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.48 116.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60199"
                  data-name="Ellipse 60199"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.15 119.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60200"
                  data-name="Ellipse 60200"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.56 116.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60201"
                  data-name="Ellipse 60201"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.14 113.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60202"
                  data-name="Ellipse 60202"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.14 107.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60203"
                  data-name="Ellipse 60203"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.81 110.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60204"
                  data-name="Ellipse 60204"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.22 107.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_60205" data-name="Ellipse 60205" cx="0.56" cy="0.56" r="0.56" transform="translate(274 105.41)" fill="#969696" />
                <circle id="Ellipse_60206" data-name="Ellipse 60206" cx="0.56" cy="0.56" r="0.56" transform="translate(274 99.78)" fill="#969696" />
                <circle
                  id="Ellipse_60207"
                  data-name="Ellipse 60207"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.67 102.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60208"
                  data-name="Ellipse 60208"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.08 99.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60209"
                  data-name="Ellipse 60209"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.7 110.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60210"
                  data-name="Ellipse 60210"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.7 105.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60211"
                  data-name="Ellipse 60211"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.37 108.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60212"
                  data-name="Ellipse 60212"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.78 104.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60213"
                  data-name="Ellipse 60213"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.74 100.82)"
                  fill="#969696"
                />
                <circle id="Ellipse_60214" data-name="Ellipse 60214" cx="0.56" cy="0.56" r="0.56" transform="translate(279.74 95.2)" fill="#969696" />
                <circle id="Ellipse_60215" data-name="Ellipse 60215" cx="0.56" cy="0.56" r="0.56" transform="translate(281.4 98.21)" fill="#969696" />
                <circle id="Ellipse_60216" data-name="Ellipse 60216" cx="0.56" cy="0.56" r="0.56" transform="translate(282.81 94.8)" fill="#969696" />
                <circle
                  id="Ellipse_60217"
                  data-name="Ellipse 60217"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.65 108.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60218"
                  data-name="Ellipse 60218"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.65 103.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60219"
                  data-name="Ellipse 60219"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.31 106.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60220"
                  data-name="Ellipse 60220"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.72 102.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60221"
                  data-name="Ellipse 60221"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.64 130.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60222"
                  data-name="Ellipse 60222"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.64 124.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60223"
                  data-name="Ellipse 60223"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.3 127.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60224"
                  data-name="Ellipse 60224"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.71 124.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60225"
                  data-name="Ellipse 60225"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.49 122.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60226"
                  data-name="Ellipse 60226"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.49 117.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60227"
                  data-name="Ellipse 60227"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.16 120.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60228"
                  data-name="Ellipse 60228"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.57 116.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60229"
                  data-name="Ellipse 60229"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.19 128.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60230"
                  data-name="Ellipse 60230"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.19 122.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60231"
                  data-name="Ellipse 60231"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.86 125.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60232"
                  data-name="Ellipse 60232"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.27 122.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60233"
                  data-name="Ellipse 60233"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.23 118.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60234"
                  data-name="Ellipse 60234"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.23 112.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60235"
                  data-name="Ellipse 60235"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.9 115.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60236"
                  data-name="Ellipse 60236"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.31 112.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60237"
                  data-name="Ellipse 60237"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.14 126.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60238"
                  data-name="Ellipse 60238"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.14 120.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60239"
                  data-name="Ellipse 60239"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.8 123.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60240"
                  data-name="Ellipse 60240"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.21 120.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60241"
                  data-name="Ellipse 60241"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.19 116.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60242"
                  data-name="Ellipse 60242"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.19 110.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60243"
                  data-name="Ellipse 60243"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.85 113.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60244"
                  data-name="Ellipse 60244"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.26 110.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60245"
                  data-name="Ellipse 60245"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.05 108.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60246"
                  data-name="Ellipse 60246"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.05 102.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60247"
                  data-name="Ellipse 60247"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.71 105.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60248"
                  data-name="Ellipse 60248"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.12 102.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60249"
                  data-name="Ellipse 60249"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.75 113.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60250"
                  data-name="Ellipse 60250"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.75 108.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60251"
                  data-name="Ellipse 60251"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.41 111.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60252"
                  data-name="Ellipse 60252"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.82 107.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60253"
                  data-name="Ellipse 60253"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.78 103.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60254"
                  data-name="Ellipse 60254"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.78 98.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60255"
                  data-name="Ellipse 60255"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.45 101.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60256"
                  data-name="Ellipse 60256"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.86 97.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60257"
                  data-name="Ellipse 60257"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.69 111.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60258"
                  data-name="Ellipse 60258"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.69 106.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60259"
                  data-name="Ellipse 60259"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.35 109.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60260"
                  data-name="Ellipse 60260"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.76 105.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60261"
                  data-name="Ellipse 60261"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.3 133.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60262"
                  data-name="Ellipse 60262"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.3 127.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60263"
                  data-name="Ellipse 60263"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.96 130.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60264"
                  data-name="Ellipse 60264"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.82 137.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60265"
                  data-name="Ellipse 60265"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.48 134.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60266"
                  data-name="Ellipse 60266"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.73 135.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_60267" data-name="Ellipse 60267" cx="0.56" cy="0.56" r="0.56" transform="translate(288.4 133.1)" fill="#969696" />
                <circle
                  id="Ellipse_60268"
                  data-name="Ellipse 60268"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.18 141.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60269"
                  data-name="Ellipse 60269"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.85 139.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60270"
                  data-name="Ellipse 60270"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.19 156.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60271"
                  data-name="Ellipse 60271"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.86 153.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60272"
                  data-name="Ellipse 60272"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.27 140.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60273"
                  data-name="Ellipse 60273"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.94 137.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60274"
                  data-name="Ellipse 60274"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.53 160.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60275"
                  data-name="Ellipse 60275"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.2 158.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60276"
                  data-name="Ellipse 60276"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.99 162.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60277"
                  data-name="Ellipse 60277"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.66 159.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60278"
                  data-name="Ellipse 60278"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.49 144.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60279"
                  data-name="Ellipse 60279"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.15 142.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60280"
                  data-name="Ellipse 60280"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.93 150.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60281"
                  data-name="Ellipse 60281"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.59 148.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60282"
                  data-name="Ellipse 60282"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.14 152.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60283"
                  data-name="Ellipse 60283"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.81 149.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60284"
                  data-name="Ellipse 60284"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.81 142.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60285"
                  data-name="Ellipse 60285"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.47 139.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60286"
                  data-name="Ellipse 60286"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.99 169.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60287"
                  data-name="Ellipse 60287"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.66 167.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60288"
                  data-name="Ellipse 60288"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(284.73 168.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60289"
                  data-name="Ellipse 60289"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.4 165.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60290"
                  data-name="Ellipse 60290"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.55 166.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60291"
                  data-name="Ellipse 60291"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.21 163.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60292"
                  data-name="Ellipse 60292"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.56 166.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60293"
                  data-name="Ellipse 60293"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.23 164.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60294"
                  data-name="Ellipse 60294"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.02 173.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60295"
                  data-name="Ellipse 60295"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.69 170.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60296"
                  data-name="Ellipse 60296"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.95 179.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60297"
                  data-name="Ellipse 60297"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.62 176.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60298"
                  data-name="Ellipse 60298"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.08 186.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60299"
                  data-name="Ellipse 60299"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.74 183.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60300"
                  data-name="Ellipse 60300"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.51 189.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60301"
                  data-name="Ellipse 60301"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(284.17 186.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60302"
                  data-name="Ellipse 60302"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.56 176.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60303"
                  data-name="Ellipse 60303"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.23 173.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60304"
                  data-name="Ellipse 60304"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.21 176.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60305"
                  data-name="Ellipse 60305"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.88 173.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60306"
                  data-name="Ellipse 60306"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.37 127.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60307"
                  data-name="Ellipse 60307"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.16 125.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60308"
                  data-name="Ellipse 60308"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.16 120.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60309"
                  data-name="Ellipse 60309"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.82 123.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60310"
                  data-name="Ellipse 60310"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.23 119.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60311"
                  data-name="Ellipse 60311"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.86 131.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60312"
                  data-name="Ellipse 60312"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.86 125.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60313"
                  data-name="Ellipse 60313"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.52 128.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60314"
                  data-name="Ellipse 60314"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.93 125.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60315"
                  data-name="Ellipse 60315"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.89 121.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60316"
                  data-name="Ellipse 60316"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.89 115.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60317"
                  data-name="Ellipse 60317"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.56 118.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60318"
                  data-name="Ellipse 60318"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.97 115.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60319"
                  data-name="Ellipse 60319"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.8 129.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60320"
                  data-name="Ellipse 60320"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.8 123.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60321"
                  data-name="Ellipse 60321"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(304.46 126.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60322"
                  data-name="Ellipse 60322"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.87 123.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60323"
                  data-name="Ellipse 60323"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.46 120.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60324"
                  data-name="Ellipse 60324"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.46 114.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60325"
                  data-name="Ellipse 60325"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.13 117.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60326"
                  data-name="Ellipse 60326"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.54 114.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60327"
                  data-name="Ellipse 60327"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.32 112.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60328"
                  data-name="Ellipse 60328"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.32 106.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60329"
                  data-name="Ellipse 60329"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.99 109.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60330"
                  data-name="Ellipse 60330"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.4 106.54)"
                  fill="#969696"
                />
                <circle id="Ellipse_60331" data-name="Ellipse 60331" cx="0.56" cy="0.56" r="0.56" transform="translate(311.02 118)" fill="#969696" />
                <circle
                  id="Ellipse_60332"
                  data-name="Ellipse 60332"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.02 112.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60333"
                  data-name="Ellipse 60333"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.69 115.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60334"
                  data-name="Ellipse 60334"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.1 111.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60335"
                  data-name="Ellipse 60335"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.06 107.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60336"
                  data-name="Ellipse 60336"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.06 102.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60337"
                  data-name="Ellipse 60337"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.72 105.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60338"
                  data-name="Ellipse 60338"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.13 101.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60339"
                  data-name="Ellipse 60339"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.11 164.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60340"
                  data-name="Ellipse 60340"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.11 158.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60341"
                  data-name="Ellipse 60341"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.78 161.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60342"
                  data-name="Ellipse 60342"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.19 158.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60343"
                  data-name="Ellipse 60343"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.97 156.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60344"
                  data-name="Ellipse 60344"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.97 150.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60345"
                  data-name="Ellipse 60345"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.63 153.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60346"
                  data-name="Ellipse 60346"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.04 150.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60347"
                  data-name="Ellipse 60347"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.67 161.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60348"
                  data-name="Ellipse 60348"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.67 156.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60349"
                  data-name="Ellipse 60349"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.33 159.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60350"
                  data-name="Ellipse 60350"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.74 155.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60351"
                  data-name="Ellipse 60351"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.7 151.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60352"
                  data-name="Ellipse 60352"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.7 146.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60353"
                  data-name="Ellipse 60353"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.37 149.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60354"
                  data-name="Ellipse 60354"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.78 145.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60355"
                  data-name="Ellipse 60355"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.61 159.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60356"
                  data-name="Ellipse 60356"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.61 154.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60357"
                  data-name="Ellipse 60357"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.28 157.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60358"
                  data-name="Ellipse 60358"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.69 153.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60359"
                  data-name="Ellipse 60359"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.66 149.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60360"
                  data-name="Ellipse 60360"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.66 143.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60361"
                  data-name="Ellipse 60361"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.33 146.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60362"
                  data-name="Ellipse 60362"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.74 143.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60363"
                  data-name="Ellipse 60363"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.52 141.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60364"
                  data-name="Ellipse 60364"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.52 136.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60365"
                  data-name="Ellipse 60365"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.19 139.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60366"
                  data-name="Ellipse 60366"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.6 135.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60367"
                  data-name="Ellipse 60367"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.22 147.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60368"
                  data-name="Ellipse 60368"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.22 141.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60369"
                  data-name="Ellipse 60369"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.88 144.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60370"
                  data-name="Ellipse 60370"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.29 141.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60371"
                  data-name="Ellipse 60371"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.25 137.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60372"
                  data-name="Ellipse 60372"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.25 131.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60373"
                  data-name="Ellipse 60373"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.92 134.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60374"
                  data-name="Ellipse 60374"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.33 131.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60375"
                  data-name="Ellipse 60375"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.16 145.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60376"
                  data-name="Ellipse 60376"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.16 139.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60377"
                  data-name="Ellipse 60377"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.83 142.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60378"
                  data-name="Ellipse 60378"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.24 139.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60379"
                  data-name="Ellipse 60379"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.77 166.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60380"
                  data-name="Ellipse 60380"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.77 161.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60381"
                  data-name="Ellipse 60381"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.44 164.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60382"
                  data-name="Ellipse 60382"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.85 160.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60383"
                  data-name="Ellipse 60383"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.63 159.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60384"
                  data-name="Ellipse 60384"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.63 153.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60385"
                  data-name="Ellipse 60385"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.3 156.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60386"
                  data-name="Ellipse 60386"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.71 153.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60387"
                  data-name="Ellipse 60387"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.33 164.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60388"
                  data-name="Ellipse 60388"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.33 159.05)"
                  fill="#969696"
                />
                <circle id="Ellipse_60389" data-name="Ellipse 60389" cx="0.56" cy="0.56" r="0.56" transform="translate(285 162.07)" fill="#969696" />
                <circle
                  id="Ellipse_60390"
                  data-name="Ellipse 60390"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.41 158.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60391"
                  data-name="Ellipse 60391"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.36 154.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60392"
                  data-name="Ellipse 60392"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.36 149.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60393"
                  data-name="Ellipse 60393"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.03 152.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60394"
                  data-name="Ellipse 60394"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.44 148.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60395"
                  data-name="Ellipse 60395"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.27 162.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60396"
                  data-name="Ellipse 60396"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.27 157.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60397"
                  data-name="Ellipse 60397"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.94 160.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60398"
                  data-name="Ellipse 60398"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.35 156.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60399"
                  data-name="Ellipse 60399"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.94 153.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60400"
                  data-name="Ellipse 60400"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.94 148.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60401"
                  data-name="Ellipse 60401"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.6 151.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60402"
                  data-name="Ellipse 60402"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.01 147.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60403"
                  data-name="Ellipse 60403"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.79 146.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60404"
                  data-name="Ellipse 60404"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.79 140.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60405"
                  data-name="Ellipse 60405"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.46 143.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60406"
                  data-name="Ellipse 60406"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.87 140.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60407"
                  data-name="Ellipse 60407"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.49 151.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60408"
                  data-name="Ellipse 60408"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.49 145.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60409"
                  data-name="Ellipse 60409"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.16 148.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60410"
                  data-name="Ellipse 60410"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.57 145.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60411"
                  data-name="Ellipse 60411"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.53 141.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60412"
                  data-name="Ellipse 60412"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.53 135.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60413"
                  data-name="Ellipse 60413"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.19 138.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60414"
                  data-name="Ellipse 60414"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.6 135.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60415"
                  data-name="Ellipse 60415"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.63 131.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60416"
                  data-name="Ellipse 60416"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.63 126.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60417"
                  data-name="Ellipse 60417"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.3 129.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60418"
                  data-name="Ellipse 60418"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.71 125.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60419"
                  data-name="Ellipse 60419"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.44 137.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60420"
                  data-name="Ellipse 60420"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.14 128.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60421"
                  data-name="Ellipse 60421"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.14 122.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60422"
                  data-name="Ellipse 60422"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.81 125.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60423"
                  data-name="Ellipse 60423"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.22 122.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60424"
                  data-name="Ellipse 60424"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.95 134.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60425"
                  data-name="Ellipse 60425"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.31 138.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60426"
                  data-name="Ellipse 60426"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.31 132.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60427"
                  data-name="Ellipse 60427"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.98 135.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60428"
                  data-name="Ellipse 60428"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.39 132.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60429"
                  data-name="Ellipse 60429"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.12 144.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60430"
                  data-name="Ellipse 60430"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.44 149.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60431"
                  data-name="Ellipse 60431"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.44 143.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60432"
                  data-name="Ellipse 60432"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.1 146.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60433"
                  data-name="Ellipse 60433"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.51 143.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60434"
                  data-name="Ellipse 60434"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.13 201.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60435"
                  data-name="Ellipse 60435"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.21 201.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60436"
                  data-name="Ellipse 60436"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.09 199.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60437"
                  data-name="Ellipse 60437"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.76 202.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60438"
                  data-name="Ellipse 60438"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.17 199.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60439"
                  data-name="Ellipse 60439"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.95 197.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60440"
                  data-name="Ellipse 60440"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.95 191.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60441"
                  data-name="Ellipse 60441"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(220.62 194.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60442"
                  data-name="Ellipse 60442"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.03 191.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60443"
                  data-name="Ellipse 60443"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.65 202.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60444"
                  data-name="Ellipse 60444"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.65 197.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60445"
                  data-name="Ellipse 60445"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.32 200.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60446"
                  data-name="Ellipse 60446"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.73 196.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60447"
                  data-name="Ellipse 60447"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.68 192.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60448"
                  data-name="Ellipse 60448"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.68 187.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60449"
                  data-name="Ellipse 60449"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.35 190.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60450"
                  data-name="Ellipse 60450"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.76 186.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60451"
                  data-name="Ellipse 60451"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.59 200.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60452"
                  data-name="Ellipse 60452"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.59 195.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60453"
                  data-name="Ellipse 60453"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.26 198.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60454"
                  data-name="Ellipse 60454"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.67 194.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60455"
                  data-name="Ellipse 60455"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.37 203.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60456"
                  data-name="Ellipse 60456"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.44 203.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60457"
                  data-name="Ellipse 60457"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.22 201.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60458"
                  data-name="Ellipse 60458"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.22 196.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60459"
                  data-name="Ellipse 60459"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.89 199.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60460"
                  data-name="Ellipse 60460"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.3 195.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60461"
                  data-name="Ellipse 60461"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.92 201.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_60462" data-name="Ellipse 60462" cx="0.56" cy="0.56" r="0.56" transform="translate(243 201.07)" fill="#969696" />
                <circle
                  id="Ellipse_60463"
                  data-name="Ellipse 60463"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.96 197.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60464"
                  data-name="Ellipse 60464"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.96 191.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60465"
                  data-name="Ellipse 60465"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.63 194.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60466"
                  data-name="Ellipse 60466"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.03 191.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60467"
                  data-name="Ellipse 60467"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.87 199.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60468"
                  data-name="Ellipse 60468"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.53 202.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60469"
                  data-name="Ellipse 60469"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.94 199.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60470"
                  data-name="Ellipse 60470"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.24 188.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60471"
                  data-name="Ellipse 60471"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.24 182.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60472"
                  data-name="Ellipse 60472"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.9 185.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60473"
                  data-name="Ellipse 60473"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.31 182.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60474"
                  data-name="Ellipse 60474"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.1 180.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60475"
                  data-name="Ellipse 60475"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(218.1 174.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60476"
                  data-name="Ellipse 60476"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.76 177.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60477"
                  data-name="Ellipse 60477"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.17 174.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60478"
                  data-name="Ellipse 60478"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.8 185.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60479"
                  data-name="Ellipse 60479"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(221.8 180.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60480"
                  data-name="Ellipse 60480"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.46 183.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60481"
                  data-name="Ellipse 60481"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(224.87 179.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60482"
                  data-name="Ellipse 60482"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.83 175.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60483"
                  data-name="Ellipse 60483"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.83 170.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60484"
                  data-name="Ellipse 60484"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(225.5 173.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60485"
                  data-name="Ellipse 60485"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.91 169.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60486"
                  data-name="Ellipse 60486"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.74 183.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60487"
                  data-name="Ellipse 60487"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.74 178.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60488"
                  data-name="Ellipse 60488"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.41 181.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60489"
                  data-name="Ellipse 60489"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(230.82 177.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60490"
                  data-name="Ellipse 60490"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.79 173.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60491"
                  data-name="Ellipse 60491"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.79 168.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60492"
                  data-name="Ellipse 60492"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.46 171.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60493"
                  data-name="Ellipse 60493"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.87 167.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60494"
                  data-name="Ellipse 60494"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.65 165.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60495"
                  data-name="Ellipse 60495"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.65 160.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60496"
                  data-name="Ellipse 60496"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.31 163.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60497"
                  data-name="Ellipse 60497"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.72 159.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60498"
                  data-name="Ellipse 60498"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.35 171.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60499"
                  data-name="Ellipse 60499"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.35 165.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60500"
                  data-name="Ellipse 60500"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.01 168.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60501"
                  data-name="Ellipse 60501"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.42 165.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60502"
                  data-name="Ellipse 60502"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.38 161.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60503"
                  data-name="Ellipse 60503"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.38 155.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60504"
                  data-name="Ellipse 60504"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(239.05 158.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60505"
                  data-name="Ellipse 60505"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.46 155.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60506"
                  data-name="Ellipse 60506"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.29 169.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60507"
                  data-name="Ellipse 60507"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.29 163.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60508"
                  data-name="Ellipse 60508"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.96 166.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60509"
                  data-name="Ellipse 60509"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.37 163.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60510"
                  data-name="Ellipse 60510"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.9 191.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60511"
                  data-name="Ellipse 60511"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.9 185.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60512"
                  data-name="Ellipse 60512"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.57 188.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60513"
                  data-name="Ellipse 60513"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.98 185.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60514"
                  data-name="Ellipse 60514"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.76 183.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60515"
                  data-name="Ellipse 60515"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.76 177.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60516"
                  data-name="Ellipse 60516"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.42 180.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60517"
                  data-name="Ellipse 60517"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.83 177.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60518"
                  data-name="Ellipse 60518"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.46 188.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60519"
                  data-name="Ellipse 60519"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.46 183.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60520"
                  data-name="Ellipse 60520"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.12 186.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60521"
                  data-name="Ellipse 60521"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(241.53 182.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60522"
                  data-name="Ellipse 60522"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.49 178.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60523"
                  data-name="Ellipse 60523"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(240.49 173.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60524"
                  data-name="Ellipse 60524"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.16 176.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60525"
                  data-name="Ellipse 60525"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.57 172.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60526"
                  data-name="Ellipse 60526"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.4 186.83)"
                  fill="#969696"
                />
                <circle id="Ellipse_60527" data-name="Ellipse 60527" cx="0.56" cy="0.56" r="0.56" transform="translate(244.4 181.2)" fill="#969696" />
                <circle
                  id="Ellipse_60528"
                  data-name="Ellipse 60528"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.07 184.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60529"
                  data-name="Ellipse 60529"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.48 180.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60530"
                  data-name="Ellipse 60530"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.06 177.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60531"
                  data-name="Ellipse 60531"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.06 172.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60532"
                  data-name="Ellipse 60532"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.73 175.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60533"
                  data-name="Ellipse 60533"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.14 171.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60534"
                  data-name="Ellipse 60534"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.92 170.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60535"
                  data-name="Ellipse 60535"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.92 164.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60536"
                  data-name="Ellipse 60536"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.59 167.55)"
                  fill="#969696"
                />
                <circle id="Ellipse_60537" data-name="Ellipse 60537" cx="0.56" cy="0.56" r="0.56" transform="translate(252 164.14)" fill="#969696" />
                <circle
                  id="Ellipse_60538"
                  data-name="Ellipse 60538"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.62 175.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60539"
                  data-name="Ellipse 60539"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.62 169.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60540"
                  data-name="Ellipse 60540"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.29 172.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60541"
                  data-name="Ellipse 60541"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.7 169.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60542"
                  data-name="Ellipse 60542"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.66 165.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60543"
                  data-name="Ellipse 60543"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.66 159.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60544"
                  data-name="Ellipse 60544"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.32 162.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60545"
                  data-name="Ellipse 60545"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.73 159.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60546"
                  data-name="Ellipse 60546"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.57 173.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60547"
                  data-name="Ellipse 60547"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.57 168.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60548"
                  data-name="Ellipse 60548"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.23 171.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60549"
                  data-name="Ellipse 60549"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.64 167.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60550"
                  data-name="Ellipse 60550"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.56 195.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60551"
                  data-name="Ellipse 60551"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(249.56 189.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60552"
                  data-name="Ellipse 60552"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.22 192.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60553"
                  data-name="Ellipse 60553"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(252.63 189.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60554"
                  data-name="Ellipse 60554"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.41 187.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60555"
                  data-name="Ellipse 60555"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.41 181.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60556"
                  data-name="Ellipse 60556"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.08 184.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60557"
                  data-name="Ellipse 60557"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.49 181.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60558"
                  data-name="Ellipse 60558"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.11 193.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60559"
                  data-name="Ellipse 60559"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.11 187.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60560"
                  data-name="Ellipse 60560"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.78 190.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_60561" data-name="Ellipse 60561" cx="0.56" cy="0.56" r="0.56" transform="translate(258.19 187)" fill="#969696" />
                <circle
                  id="Ellipse_60562"
                  data-name="Ellipse 60562"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.15 183.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60563"
                  data-name="Ellipse 60563"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.15 177.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60564"
                  data-name="Ellipse 60564"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.82 180.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60565"
                  data-name="Ellipse 60565"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.23 176.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60566"
                  data-name="Ellipse 60566"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.06 191.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60567"
                  data-name="Ellipse 60567"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.06 185.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60568"
                  data-name="Ellipse 60568"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.72 188.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60569"
                  data-name="Ellipse 60569"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.13 185.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60570"
                  data-name="Ellipse 60570"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.11 180.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60571"
                  data-name="Ellipse 60571"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.11 175.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60572"
                  data-name="Ellipse 60572"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.77 178.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60573"
                  data-name="Ellipse 60573"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.18 174.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60574"
                  data-name="Ellipse 60574"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.97 173.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60575"
                  data-name="Ellipse 60575"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.97 167.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60576"
                  data-name="Ellipse 60576"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.63 170.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60577"
                  data-name="Ellipse 60577"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.04 167.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60578"
                  data-name="Ellipse 60578"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.66 178.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60579"
                  data-name="Ellipse 60579"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.66 172.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60580"
                  data-name="Ellipse 60580"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.33 175.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60581"
                  data-name="Ellipse 60581"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.74 172.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60582"
                  data-name="Ellipse 60582"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.7 168.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60583"
                  data-name="Ellipse 60583"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.7 162.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60584"
                  data-name="Ellipse 60584"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.37 165.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60585"
                  data-name="Ellipse 60585"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.78 162.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60586"
                  data-name="Ellipse 60586"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.61 176.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60587"
                  data-name="Ellipse 60587"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.61 170.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60588"
                  data-name="Ellipse 60588"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.27 173.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60589"
                  data-name="Ellipse 60589"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.68 170.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60590"
                  data-name="Ellipse 60590"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.22 198.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60591"
                  data-name="Ellipse 60591"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.22 192.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60592"
                  data-name="Ellipse 60592"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.88 195.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60593"
                  data-name="Ellipse 60593"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.29 192.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60594"
                  data-name="Ellipse 60594"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.08 190.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60595"
                  data-name="Ellipse 60595"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.08 184.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60596"
                  data-name="Ellipse 60596"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.74 187.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60597"
                  data-name="Ellipse 60597"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.15 184.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60598"
                  data-name="Ellipse 60598"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.78 195.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60599"
                  data-name="Ellipse 60599"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.78 190.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60600"
                  data-name="Ellipse 60600"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.44 193.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60601"
                  data-name="Ellipse 60601"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.85 189.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60602"
                  data-name="Ellipse 60602"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.81 185.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60603"
                  data-name="Ellipse 60603"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.81 180.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60604"
                  data-name="Ellipse 60604"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.48 183.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60605"
                  data-name="Ellipse 60605"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.89 179.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60606"
                  data-name="Ellipse 60606"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.72 193.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60607"
                  data-name="Ellipse 60607"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.72 188.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60608"
                  data-name="Ellipse 60608"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.38 191.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60609"
                  data-name="Ellipse 60609"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.79 187.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60610"
                  data-name="Ellipse 60610"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.38 185.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60611"
                  data-name="Ellipse 60611"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.38 179.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60612"
                  data-name="Ellipse 60612"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.05 182.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60613"
                  data-name="Ellipse 60613"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.46 179.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60614"
                  data-name="Ellipse 60614"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.24 177.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60615"
                  data-name="Ellipse 60615"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.24 171.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60616"
                  data-name="Ellipse 60616"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.91 174.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60617"
                  data-name="Ellipse 60617"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.32 171.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60618"
                  data-name="Ellipse 60618"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.94 182.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60619"
                  data-name="Ellipse 60619"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.94 177.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60620"
                  data-name="Ellipse 60620"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.61 180.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60621"
                  data-name="Ellipse 60621"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.02 176.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60622"
                  data-name="Ellipse 60622"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.97 172.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60623"
                  data-name="Ellipse 60623"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.97 167.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60624"
                  data-name="Ellipse 60624"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.64 170.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60625"
                  data-name="Ellipse 60625"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.05 166.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60626"
                  data-name="Ellipse 60626"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.88 180.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60627"
                  data-name="Ellipse 60627"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.88 175.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60628"
                  data-name="Ellipse 60628"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.55 178.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60629"
                  data-name="Ellipse 60629"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.96 174.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60630"
                  data-name="Ellipse 60630"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(251.44 200.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60631"
                  data-name="Ellipse 60631"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(253.1 203.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60632"
                  data-name="Ellipse 60632"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.51 200.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60633"
                  data-name="Ellipse 60633"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.17 202.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60634"
                  data-name="Ellipse 60634"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.17 196.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60635"
                  data-name="Ellipse 60635"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.84 199.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60636"
                  data-name="Ellipse 60636"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.25 195.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60637"
                  data-name="Ellipse 60637"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.45 200.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60638"
                  data-name="Ellipse 60638"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.11 203.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60639"
                  data-name="Ellipse 60639"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.52 200.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60640"
                  data-name="Ellipse 60640"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.53 203.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60641"
                  data-name="Ellipse 60641"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.61 203.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60642"
                  data-name="Ellipse 60642"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(137.09 198.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60643"
                  data-name="Ellipse 60643"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.75 201.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60644"
                  data-name="Ellipse 60644"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.16 198.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60645"
                  data-name="Ellipse 60645"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.94 196.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60646"
                  data-name="Ellipse 60646"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.94 191.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60647"
                  data-name="Ellipse 60647"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.61 194.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60648"
                  data-name="Ellipse 60648"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.02 190.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60649"
                  data-name="Ellipse 60649"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.64 202.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60650"
                  data-name="Ellipse 60650"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.64 196.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60651"
                  data-name="Ellipse 60651"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.31 199.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60652"
                  data-name="Ellipse 60652"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.72 196.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60653"
                  data-name="Ellipse 60653"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.68 192.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60654"
                  data-name="Ellipse 60654"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.68 186.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60655"
                  data-name="Ellipse 60655"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.35 189.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60656"
                  data-name="Ellipse 60656"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.76 186.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60657"
                  data-name="Ellipse 60657"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.59 200.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60658"
                  data-name="Ellipse 60658"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.59 194.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60659"
                  data-name="Ellipse 60659"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.25 197.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60660"
                  data-name="Ellipse 60660"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.66 194.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60661"
                  data-name="Ellipse 60661"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.64 190.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60662"
                  data-name="Ellipse 60662"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.64 184.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60663"
                  data-name="Ellipse 60663"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.3 187.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60664"
                  data-name="Ellipse 60664"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.71 184.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60665"
                  data-name="Ellipse 60665"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.5 182.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60666"
                  data-name="Ellipse 60666"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.5 176.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60667"
                  data-name="Ellipse 60667"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.16 179.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60668"
                  data-name="Ellipse 60668"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.57 176.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60669"
                  data-name="Ellipse 60669"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.2 187.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60670"
                  data-name="Ellipse 60670"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.2 182.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60671"
                  data-name="Ellipse 60671"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.86 185.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60672"
                  data-name="Ellipse 60672"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.27 181.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60673"
                  data-name="Ellipse 60673"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.23 177.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60674"
                  data-name="Ellipse 60674"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.23 172.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60675"
                  data-name="Ellipse 60675"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.9 175.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60676"
                  data-name="Ellipse 60676"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.31 171.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60677"
                  data-name="Ellipse 60677"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.14 185.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60678"
                  data-name="Ellipse 60678"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.14 180.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60679"
                  data-name="Ellipse 60679"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.8 183.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60680"
                  data-name="Ellipse 60680"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.21 179.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60681"
                  data-name="Ellipse 60681"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.75 201.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60682"
                  data-name="Ellipse 60682"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.82 201.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60683"
                  data-name="Ellipse 60683"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.61 199.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60684"
                  data-name="Ellipse 60684"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.61 194.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60685"
                  data-name="Ellipse 60685"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.27 197.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60686"
                  data-name="Ellipse 60686"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.68 193.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60687"
                  data-name="Ellipse 60687"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.31 199.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60688"
                  data-name="Ellipse 60688"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.97 202.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60689"
                  data-name="Ellipse 60689"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.38 199.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60690"
                  data-name="Ellipse 60690"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.34 195.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60691"
                  data-name="Ellipse 60691"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.34 189.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60692"
                  data-name="Ellipse 60692"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.01 192.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60693"
                  data-name="Ellipse 60693"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.42 189.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60694"
                  data-name="Ellipse 60694"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.25 203.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60695"
                  data-name="Ellipse 60695"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.25 197.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60696"
                  data-name="Ellipse 60696"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.92 200.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60697"
                  data-name="Ellipse 60697"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.33 197.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60698"
                  data-name="Ellipse 60698"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.91 194.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60699"
                  data-name="Ellipse 60699"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.91 188.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60700"
                  data-name="Ellipse 60700"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.58 191.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60701"
                  data-name="Ellipse 60701"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.99 188.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60702"
                  data-name="Ellipse 60702"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.77 186.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60703"
                  data-name="Ellipse 60703"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.77 180.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60704"
                  data-name="Ellipse 60704"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(171.44 183.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60705"
                  data-name="Ellipse 60705"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.85 180.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60706"
                  data-name="Ellipse 60706"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.47 191.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60707"
                  data-name="Ellipse 60707"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.47 186.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60708"
                  data-name="Ellipse 60708"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.14 189.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60709"
                  data-name="Ellipse 60709"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.55 185.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60710"
                  data-name="Ellipse 60710"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.51 181.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60711"
                  data-name="Ellipse 60711"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.51 176.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60712"
                  data-name="Ellipse 60712"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.17 179.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60713"
                  data-name="Ellipse 60713"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.58 175.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60714"
                  data-name="Ellipse 60714"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.41 190.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60715"
                  data-name="Ellipse 60715"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.41 184.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60716"
                  data-name="Ellipse 60716"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.08 187.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60717"
                  data-name="Ellipse 60717"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(182.49 183.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60718"
                  data-name="Ellipse 60718"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.26 203.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60719"
                  data-name="Ellipse 60719"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(172.26 198.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60720"
                  data-name="Ellipse 60720"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(173.93 201.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60721"
                  data-name="Ellipse 60721"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.34 197.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60722"
                  data-name="Ellipse 60722"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.96 203.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60723"
                  data-name="Ellipse 60723"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.04 203.37)"
                  fill="#969696"
                />
                <circle id="Ellipse_60724" data-name="Ellipse 60724" cx="0.56" cy="0.56" r="0.56" transform="translate(178 199.39)" fill="#969696" />
                <circle id="Ellipse_60725" data-name="Ellipse 60725" cx="0.56" cy="0.56" r="0.56" transform="translate(178 193.76)" fill="#969696" />
                <circle
                  id="Ellipse_60726"
                  data-name="Ellipse 60726"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.66 196.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60727"
                  data-name="Ellipse 60727"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.07 193.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60728"
                  data-name="Ellipse 60728"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.9 201.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60729"
                  data-name="Ellipse 60729"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.98 201.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60730"
                  data-name="Ellipse 60730"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.95 197.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60731"
                  data-name="Ellipse 60731"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(183.95 191.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60732"
                  data-name="Ellipse 60732"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.62 194.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60733"
                  data-name="Ellipse 60733"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.03 191.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60734"
                  data-name="Ellipse 60734"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.81 189.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60735"
                  data-name="Ellipse 60735"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.81 183.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60736"
                  data-name="Ellipse 60736"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.48 186.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60737"
                  data-name="Ellipse 60737"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.89 183.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60738"
                  data-name="Ellipse 60738"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.51 194.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60739"
                  data-name="Ellipse 60739"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.51 189.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60740"
                  data-name="Ellipse 60740"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.18 192.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60741"
                  data-name="Ellipse 60741"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.59 188.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60742"
                  data-name="Ellipse 60742"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.55 184.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60743"
                  data-name="Ellipse 60743"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.55 179.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60744"
                  data-name="Ellipse 60744"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.21 182.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60745"
                  data-name="Ellipse 60745"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.62 178.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60746"
                  data-name="Ellipse 60746"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.46 192.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60747"
                  data-name="Ellipse 60747"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(195.46 187.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60748"
                  data-name="Ellipse 60748"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.12 190.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60749"
                  data-name="Ellipse 60749"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(198.53 186.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60750"
                  data-name="Ellipse 60750"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.92 201.26)"
                  fill="#969696"
                />
                <circle id="Ellipse_60751" data-name="Ellipse 60751" cx="0.56" cy="0.56" r="0.56" transform="translate(192 200.86)" fill="#969696" />
                <circle
                  id="Ellipse_60752"
                  data-name="Ellipse 60752"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.66 202.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60753"
                  data-name="Ellipse 60753"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(194.66 196.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60754"
                  data-name="Ellipse 60754"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(196.32 199.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60755"
                  data-name="Ellipse 60755"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(197.73 196.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60756"
                  data-name="Ellipse 60756"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.23 201.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60757"
                  data-name="Ellipse 60757"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(201.23 195.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60758"
                  data-name="Ellipse 60758"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(202.9 198.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60759"
                  data-name="Ellipse 60759"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.31 195.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60760"
                  data-name="Ellipse 60760"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.09 193.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60761"
                  data-name="Ellipse 60761"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.09 188.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60762"
                  data-name="Ellipse 60762"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.75 191.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60763"
                  data-name="Ellipse 60763"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.16 187.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60764"
                  data-name="Ellipse 60764"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.79 199.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60765"
                  data-name="Ellipse 60765"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(206.79 193.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60766"
                  data-name="Ellipse 60766"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.45 196.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60767"
                  data-name="Ellipse 60767"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.86 193.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60768"
                  data-name="Ellipse 60768"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.82 189.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60769"
                  data-name="Ellipse 60769"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(208.82 183.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60770"
                  data-name="Ellipse 60770"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.49 186.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60771"
                  data-name="Ellipse 60771"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(211.9 183.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60772"
                  data-name="Ellipse 60772"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.73 197.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60773"
                  data-name="Ellipse 60773"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(212.73 191.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60774"
                  data-name="Ellipse 60774"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.4 194.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60775"
                  data-name="Ellipse 60775"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.81 191.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60776"
                  data-name="Ellipse 60776"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.75 200.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60777"
                  data-name="Ellipse 60777"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.41 203.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60778"
                  data-name="Ellipse 60778"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.82 200.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60779"
                  data-name="Ellipse 60779"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(71.71 198.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60780"
                  data-name="Ellipse 60780"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.37 201.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60781"
                  data-name="Ellipse 60781"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(74.78 198.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60782"
                  data-name="Ellipse 60782"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.56 196.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60783"
                  data-name="Ellipse 60783"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.56 190.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60784"
                  data-name="Ellipse 60784"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.23 193.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60785"
                  data-name="Ellipse 60785"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(76.64 190.34)"
                  fill="#969696"
                />
                <circle id="Ellipse_60786" data-name="Ellipse 60786" cx="0.56" cy="0.56" r="0.56" transform="translate(77.26 201.8)" fill="#969696" />
                <circle
                  id="Ellipse_60787"
                  data-name="Ellipse 60787"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(77.26 196.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60788"
                  data-name="Ellipse 60788"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.93 199.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60789"
                  data-name="Ellipse 60789"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(80.34 195.77)"
                  fill="#969696"
                />
                <circle id="Ellipse_60790" data-name="Ellipse 60790" cx="0.56" cy="0.56" r="0.56" transform="translate(79.3 191.78)" fill="#969696" />
                <circle id="Ellipse_60791" data-name="Ellipse 60791" cx="0.56" cy="0.56" r="0.56" transform="translate(79.3 186.16)" fill="#969696" />
                <circle
                  id="Ellipse_60792"
                  data-name="Ellipse 60792"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(80.97 189.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60793"
                  data-name="Ellipse 60793"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.38 185.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60794"
                  data-name="Ellipse 60794"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(83.21 199.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60795"
                  data-name="Ellipse 60795"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(83.21 194.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60796"
                  data-name="Ellipse 60796"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(84.87 197.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60797"
                  data-name="Ellipse 60797"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(86.28 193.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60798"
                  data-name="Ellipse 60798"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.41 203.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60799"
                  data-name="Ellipse 60799"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.49 203.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60800"
                  data-name="Ellipse 60800"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(88.98 202.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60801"
                  data-name="Ellipse 60801"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(92.06 202.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60802"
                  data-name="Ellipse 60802"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.84 200.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60803"
                  data-name="Ellipse 60803"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.84 194.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60804"
                  data-name="Ellipse 60804"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(92.51 197.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60805"
                  data-name="Ellipse 60805"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.92 194.57)"
                  fill="#969696"
                />
                <circle id="Ellipse_60806" data-name="Ellipse 60806" cx="0.56" cy="0.56" r="0.56" transform="translate(94.54 200.4)" fill="#969696" />
                <circle id="Ellipse_60807" data-name="Ellipse 60807" cx="0.56" cy="0.56" r="0.56" transform="translate(96.2 203.41)" fill="#969696" />
                <circle id="Ellipse_60808" data-name="Ellipse 60808" cx="0.56" cy="0.56" r="0.56" transform="translate(97.61 200)" fill="#969696" />
                <circle
                  id="Ellipse_60809"
                  data-name="Ellipse 60809"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.57 196.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60810"
                  data-name="Ellipse 60810"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.57 190.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_60811" data-name="Ellipse 60811" cx="0.56" cy="0.56" r="0.56" transform="translate(98.24 193.4)" fill="#969696" />
                <circle
                  id="Ellipse_60812"
                  data-name="Ellipse 60812"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(99.65 189.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60813"
                  data-name="Ellipse 60813"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.48 198.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60814"
                  data-name="Ellipse 60814"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.15 201.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60815"
                  data-name="Ellipse 60815"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.56 198.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60816"
                  data-name="Ellipse 60816"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(70.85 187.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60817"
                  data-name="Ellipse 60817"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(70.85 181.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60818"
                  data-name="Ellipse 60818"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.52 184.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60819"
                  data-name="Ellipse 60819"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.93 181.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60820"
                  data-name="Ellipse 60820"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.71 179.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60821"
                  data-name="Ellipse 60821"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.71 173.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60822"
                  data-name="Ellipse 60822"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(74.38 176.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60823"
                  data-name="Ellipse 60823"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.79 173.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60824"
                  data-name="Ellipse 60824"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(76.41 184.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60825"
                  data-name="Ellipse 60825"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(76.41 179.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60826"
                  data-name="Ellipse 60826"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.08 182.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60827"
                  data-name="Ellipse 60827"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(79.49 178.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60828"
                  data-name="Ellipse 60828"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.45 174.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60829"
                  data-name="Ellipse 60829"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.45 169.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60830"
                  data-name="Ellipse 60830"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(80.11 172.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60831"
                  data-name="Ellipse 60831"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.52 168.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60832"
                  data-name="Ellipse 60832"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.35 182.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60833"
                  data-name="Ellipse 60833"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.35 177.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60834"
                  data-name="Ellipse 60834"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(84.02 180.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60835"
                  data-name="Ellipse 60835"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.43 176.82)"
                  fill="#969696"
                />
                <circle id="Ellipse_60836" data-name="Ellipse 60836" cx="0.56" cy="0.56" r="0.56" transform="translate(84.4 172.59)" fill="#969696" />
                <circle id="Ellipse_60837" data-name="Ellipse 60837" cx="0.56" cy="0.56" r="0.56" transform="translate(84.4 166.96)" fill="#969696" />
                <circle
                  id="Ellipse_60838"
                  data-name="Ellipse 60838"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(86.07 169.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60839"
                  data-name="Ellipse 60839"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.48 166.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60840"
                  data-name="Ellipse 60840"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(86.26 164.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60841"
                  data-name="Ellipse 60841"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(86.26 159.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60842"
                  data-name="Ellipse 60842"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.93 162.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60843"
                  data-name="Ellipse 60843"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.34 158.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60844"
                  data-name="Ellipse 60844"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.96 170.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60845"
                  data-name="Ellipse 60845"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.96 164.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60846"
                  data-name="Ellipse 60846"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.63 167.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60847"
                  data-name="Ellipse 60847"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.04 164.27)"
                  fill="#969696"
                />
                <circle id="Ellipse_60848" data-name="Ellipse 60848" cx="0.56" cy="0.56" r="0.56" transform="translate(92 160.28)" fill="#969696" />
                <circle id="Ellipse_60849" data-name="Ellipse 60849" cx="0.56" cy="0.56" r="0.56" transform="translate(92 154.66)" fill="#969696" />
                <circle
                  id="Ellipse_60850"
                  data-name="Ellipse 60850"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.66 157.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60851"
                  data-name="Ellipse 60851"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(95.07 154.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60852"
                  data-name="Ellipse 60852"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(95.91 168.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60853"
                  data-name="Ellipse 60853"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(95.91 162.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60854"
                  data-name="Ellipse 60854"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(97.57 165.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60855"
                  data-name="Ellipse 60855"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.98 162.32)"
                  fill="#969696"
                />
                <path
                  id="Path_12319"
                  data-name="Path 12319"
                  d="M88.63,190.56a2.46,2.46,0,0,0-1.49,1,.57.57,0,0,0,.56.56.56.56,0,0,0,.56-.56.54.54,0,0,0-.18-.41.55.55,0,0,0,.55-.59Z"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60856"
                  data-name="Ellipse 60856"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.52 184.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60857"
                  data-name="Ellipse 60857"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.18 187.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60858"
                  data-name="Ellipse 60858"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.59 183.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60859"
                  data-name="Ellipse 60859"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.37 182.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60860"
                  data-name="Ellipse 60860"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.37 176.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60861"
                  data-name="Ellipse 60861"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(91.04 179.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60862"
                  data-name="Ellipse 60862"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(92.45 176.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60863"
                  data-name="Ellipse 60863"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.07 187.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60864"
                  data-name="Ellipse 60864"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.07 182.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_60865" data-name="Ellipse 60865" cx="0.56" cy="0.56" r="0.56" transform="translate(94.74 185.1)" fill="#969696" />
                <circle
                  id="Ellipse_60866"
                  data-name="Ellipse 60866"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.15 181.68)"
                  fill="#969696"
                />
                <circle id="Ellipse_60867" data-name="Ellipse 60867" cx="0.56" cy="0.56" r="0.56" transform="translate(95.11 177.7)" fill="#969696" />
                <circle
                  id="Ellipse_60868"
                  data-name="Ellipse 60868"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(95.11 172.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60869"
                  data-name="Ellipse 60869"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.77 175.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60870"
                  data-name="Ellipse 60870"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.18 171.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60871"
                  data-name="Ellipse 60871"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(99.02 185.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60872"
                  data-name="Ellipse 60872"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(99.02 180.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60873"
                  data-name="Ellipse 60873"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.68 183.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60874"
                  data-name="Ellipse 60874"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.09 179.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60875"
                  data-name="Ellipse 60875"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.68 176.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60876"
                  data-name="Ellipse 60876"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.68 171.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60877"
                  data-name="Ellipse 60877"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.35 174.2)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60878"
                  data-name="Ellipse 60878"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.76 170.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60879"
                  data-name="Ellipse 60879"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.54 169.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60880"
                  data-name="Ellipse 60880"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.54 163.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60881"
                  data-name="Ellipse 60881"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.2 166.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60882"
                  data-name="Ellipse 60882"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.61 163.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60883"
                  data-name="Ellipse 60883"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.24 174.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60884"
                  data-name="Ellipse 60884"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.24 168.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60885"
                  data-name="Ellipse 60885"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.9 171.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60886"
                  data-name="Ellipse 60886"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.31 168.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60887"
                  data-name="Ellipse 60887"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.27 164.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60888"
                  data-name="Ellipse 60888"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.27 158.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60889"
                  data-name="Ellipse 60889"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.94 161.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60890"
                  data-name="Ellipse 60890"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.35 158.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60891"
                  data-name="Ellipse 60891"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.18 172.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60892"
                  data-name="Ellipse 60892"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.18 166.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60893"
                  data-name="Ellipse 60893"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.85 169.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60894"
                  data-name="Ellipse 60894"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.26 166.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60895"
                  data-name="Ellipse 60895"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.17 194.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60896"
                  data-name="Ellipse 60896"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.17 188.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60897"
                  data-name="Ellipse 60897"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.84 191.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60898"
                  data-name="Ellipse 60898"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.25 188.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60899"
                  data-name="Ellipse 60899"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.03 186.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60900"
                  data-name="Ellipse 60900"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.03 180.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60901"
                  data-name="Ellipse 60901"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.7 183.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60902"
                  data-name="Ellipse 60902"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.11 180.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60903"
                  data-name="Ellipse 60903"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.73 191.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60904"
                  data-name="Ellipse 60904"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.73 186.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60905"
                  data-name="Ellipse 60905"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.39 189.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60906"
                  data-name="Ellipse 60906"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.8 185.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60907"
                  data-name="Ellipse 60907"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.76 181.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60908"
                  data-name="Ellipse 60908"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.76 176.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60909"
                  data-name="Ellipse 60909"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.43 179.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60910"
                  data-name="Ellipse 60910"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.84 175.92)"
                  fill="#969696"
                />
                <circle id="Ellipse_60911" data-name="Ellipse 60911" cx="0.56" cy="0.56" r="0.56" transform="translate(115.67 190)" fill="#969696" />
                <circle
                  id="Ellipse_60912"
                  data-name="Ellipse 60912"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.67 184.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60913"
                  data-name="Ellipse 60913"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.34 187.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60914"
                  data-name="Ellipse 60914"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.75 183.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60915"
                  data-name="Ellipse 60915"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.72 179.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60916"
                  data-name="Ellipse 60916"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.72 174.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60917"
                  data-name="Ellipse 60917"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.39 177.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60918"
                  data-name="Ellipse 60918"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.8 173.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60919"
                  data-name="Ellipse 60919"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.58 172.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60920"
                  data-name="Ellipse 60920"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.58 166.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60921"
                  data-name="Ellipse 60921"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.25 169.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_60922" data-name="Ellipse 60922" cx="0.56" cy="0.56" r="0.56" transform="translate(122.66 166)" fill="#969696" />
                <circle
                  id="Ellipse_60923"
                  data-name="Ellipse 60923"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.28 177.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60924"
                  data-name="Ellipse 60924"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.28 171.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60925"
                  data-name="Ellipse 60925"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.95 174.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60926"
                  data-name="Ellipse 60926"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.36 171.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60927"
                  data-name="Ellipse 60927"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.32 167.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60928"
                  data-name="Ellipse 60928"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.32 161.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60929"
                  data-name="Ellipse 60929"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.98 164.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60930"
                  data-name="Ellipse 60930"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.39 161.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60931"
                  data-name="Ellipse 60931"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.22 175.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60932"
                  data-name="Ellipse 60932"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.22 169.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60933"
                  data-name="Ellipse 60933"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.89 172.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60934"
                  data-name="Ellipse 60934"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.3 169.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60935"
                  data-name="Ellipse 60935"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.83 197.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60936"
                  data-name="Ellipse 60936"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.83 191.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60937"
                  data-name="Ellipse 60937"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.5 194.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60938"
                  data-name="Ellipse 60938"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.91 191.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60939"
                  data-name="Ellipse 60939"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.69 189.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60940"
                  data-name="Ellipse 60940"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.69 183.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60941"
                  data-name="Ellipse 60941"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.36 186.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60942"
                  data-name="Ellipse 60942"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.77 183.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60943"
                  data-name="Ellipse 60943"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.39 194.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60944"
                  data-name="Ellipse 60944"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.39 189.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60945"
                  data-name="Ellipse 60945"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.06 192.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60946"
                  data-name="Ellipse 60946"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.47 188.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60947"
                  data-name="Ellipse 60947"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.43 184.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60948"
                  data-name="Ellipse 60948"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.43 179.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60949"
                  data-name="Ellipse 60949"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.09 182.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60950"
                  data-name="Ellipse 60950"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.5 178.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60951"
                  data-name="Ellipse 60951"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.33 192.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60952"
                  data-name="Ellipse 60952"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.33 187.29)"
                  fill="#969696"
                />
                <circle id="Ellipse_60953" data-name="Ellipse 60953" cx="0.56" cy="0.56" r="0.56" transform="translate(134 190.3)" fill="#969696" />
                <circle
                  id="Ellipse_60954"
                  data-name="Ellipse 60954"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.41 186.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_60955" data-name="Ellipse 60955" cx="0.56" cy="0.56" r="0.56" transform="translate(135 183.97)" fill="#969696" />
                <circle id="Ellipse_60956" data-name="Ellipse 60956" cx="0.56" cy="0.56" r="0.56" transform="translate(135 178.35)" fill="#969696" />
                <circle
                  id="Ellipse_60957"
                  data-name="Ellipse 60957"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.66 181.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60958"
                  data-name="Ellipse 60958"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.07 177.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60959"
                  data-name="Ellipse 60959"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.85 176.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60960"
                  data-name="Ellipse 60960"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.85 170.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60961"
                  data-name="Ellipse 60961"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.52 173.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60962"
                  data-name="Ellipse 60962"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.93 170.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60963"
                  data-name="Ellipse 60963"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.55 181.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60964"
                  data-name="Ellipse 60964"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.55 176.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60965"
                  data-name="Ellipse 60965"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.22 179.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60966"
                  data-name="Ellipse 60966"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.63 175.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60967"
                  data-name="Ellipse 60967"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.59 171.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60968"
                  data-name="Ellipse 60968"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.59 166.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60969"
                  data-name="Ellipse 60969"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.26 169.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60970"
                  data-name="Ellipse 60970"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.67 165.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60971"
                  data-name="Ellipse 60971"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.5 179.73)"
                  fill="#969696"
                />
                <circle id="Ellipse_60972" data-name="Ellipse 60972" cx="0.56" cy="0.56" r="0.56" transform="translate(146.5 174.1)" fill="#969696" />
                <circle
                  id="Ellipse_60973"
                  data-name="Ellipse 60973"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.16 177.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60974"
                  data-name="Ellipse 60974"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.57 173.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60975"
                  data-name="Ellipse 60975"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.05 199.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60976"
                  data-name="Ellipse 60976"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.72 202.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60977"
                  data-name="Ellipse 60977"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(109.13 199.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60978"
                  data-name="Ellipse 60978"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.79 200.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60979"
                  data-name="Ellipse 60979"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.79 195.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60980"
                  data-name="Ellipse 60980"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.45 198.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60981"
                  data-name="Ellipse 60981"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.86 194.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60982"
                  data-name="Ellipse 60982"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.7 203.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60983"
                  data-name="Ellipse 60983"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.77 202.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60984"
                  data-name="Ellipse 60984"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.4 203.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60985"
                  data-name="Ellipse 60985"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.06 199.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60986"
                  data-name="Ellipse 60986"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.73 202.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60987"
                  data-name="Ellipse 60987"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.14 199.14)"
                  fill="#969696"
                />
                <circle id="Ellipse_60988" data-name="Ellipse 60988" cx="0.56" cy="0.56" r="0.56" transform="translate(31.5 150.44)" fill="#969696" />
                <circle
                  id="Ellipse_60989"
                  data-name="Ellipse 60989"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.91 147.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60990"
                  data-name="Ellipse 60990"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.11 156.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60991"
                  data-name="Ellipse 60991"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.94 170.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60992"
                  data-name="Ellipse 60992"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.94 164.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60993"
                  data-name="Ellipse 60993"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.61 167.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60994"
                  data-name="Ellipse 60994"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(36.02 164.45)"
                  fill="#969696"
                />
                <circle id="Ellipse_60995" data-name="Ellipse 60995" cx="0.56" cy="0.56" r="0.56" transform="translate(35.6 161.53)" fill="#969696" />
                <circle id="Ellipse_60996" data-name="Ellipse 60996" cx="0.56" cy="0.56" r="0.56" transform="translate(35.6 155.91)" fill="#969696" />
                <circle
                  id="Ellipse_60997"
                  data-name="Ellipse 60997"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.27 158.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60998"
                  data-name="Ellipse 60998"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(38.68 155.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_60999"
                  data-name="Ellipse 60999"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.46 153.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61000"
                  data-name="Ellipse 61000"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.46 148.18)"
                  fill="#969696"
                />
                <circle id="Ellipse_61001" data-name="Ellipse 61001" cx="0.56" cy="0.56" r="0.56" transform="translate(39.13 151.2)" fill="#969696" />
                <circle
                  id="Ellipse_61002"
                  data-name="Ellipse 61002"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.54 147.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61003"
                  data-name="Ellipse 61003"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.16 159.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61004"
                  data-name="Ellipse 61004"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.16 153.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61005"
                  data-name="Ellipse 61005"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.83 156.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61006"
                  data-name="Ellipse 61006"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.24 153.21)"
                  fill="#969696"
                />
                <circle id="Ellipse_61007" data-name="Ellipse 61007" cx="0.56" cy="0.56" r="0.56" transform="translate(43.2 149.22)" fill="#969696" />
                <circle id="Ellipse_61008" data-name="Ellipse 61008" cx="0.56" cy="0.56" r="0.56" transform="translate(43.2 143.6)" fill="#969696" />
                <circle
                  id="Ellipse_61009"
                  data-name="Ellipse 61009"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.86 146.61)"
                  fill="#969696"
                />
                <circle id="Ellipse_61010" data-name="Ellipse 61010" cx="0.56" cy="0.56" r="0.56" transform="translate(46.27 143.2)" fill="#969696" />
                <circle id="Ellipse_61011" data-name="Ellipse 61011" cx="0.56" cy="0.56" r="0.56" transform="translate(47.1 157.28)" fill="#969696" />
                <circle id="Ellipse_61012" data-name="Ellipse 61012" cx="0.56" cy="0.56" r="0.56" transform="translate(47.1 151.66)" fill="#969696" />
                <circle
                  id="Ellipse_61013"
                  data-name="Ellipse 61013"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(48.77 154.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61014"
                  data-name="Ellipse 61014"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.18 151.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61015"
                  data-name="Ellipse 61015"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.05 130.03)"
                  fill="#969696"
                />
                <circle id="Ellipse_61016" data-name="Ellipse 61016" cx="0.56" cy="0.56" r="0.56" transform="translate(31.03 125.8)" fill="#969696" />
                <circle
                  id="Ellipse_61017"
                  data-name="Ellipse 61017"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.03 120.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61018"
                  data-name="Ellipse 61018"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.69 123.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_61019" data-name="Ellipse 61019" cx="0.56" cy="0.56" r="0.56" transform="translate(34.1 119.78)" fill="#969696" />
                <circle
                  id="Ellipse_61020"
                  data-name="Ellipse 61020"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.89 118.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61021"
                  data-name="Ellipse 61021"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.89 112.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61022"
                  data-name="Ellipse 61022"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.55 115.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61023"
                  data-name="Ellipse 61023"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(35.96 112.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61024"
                  data-name="Ellipse 61024"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(36.59 123.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61025"
                  data-name="Ellipse 61025"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(36.59 117.88)"
                  fill="#969696"
                />
                <circle id="Ellipse_61026" data-name="Ellipse 61026" cx="0.56" cy="0.56" r="0.56" transform="translate(38.25 120.9)" fill="#969696" />
                <circle
                  id="Ellipse_61027"
                  data-name="Ellipse 61027"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(39.66 117.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61028"
                  data-name="Ellipse 61028"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(38.62 113.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61029"
                  data-name="Ellipse 61029"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(38.62 107.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61030"
                  data-name="Ellipse 61030"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.29 110.88)"
                  fill="#969696"
                />
                <circle id="Ellipse_61031" data-name="Ellipse 61031" cx="0.56" cy="0.56" r="0.56" transform="translate(41.7 107.47)" fill="#969696" />
                <circle
                  id="Ellipse_61032"
                  data-name="Ellipse 61032"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.53 121.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61033"
                  data-name="Ellipse 61033"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.53 115.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61034"
                  data-name="Ellipse 61034"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.19 118.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_61035" data-name="Ellipse 61035" cx="0.56" cy="0.56" r="0.56" transform="translate(45.6 115.53)" fill="#969696" />
                <circle
                  id="Ellipse_61036"
                  data-name="Ellipse 61036"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.14 143.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61037"
                  data-name="Ellipse 61037"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.14 137.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_61038" data-name="Ellipse 61038" cx="0.56" cy="0.56" r="0.56" transform="translate(35.8 140.6)" fill="#969696" />
                <circle
                  id="Ellipse_61039"
                  data-name="Ellipse 61039"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.21 137.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_61040" data-name="Ellipse 61040" cx="0.56" cy="0.56" r="0.56" transform="translate(36 135.49)" fill="#969696" />
                <circle id="Ellipse_61041" data-name="Ellipse 61041" cx="0.56" cy="0.56" r="0.56" transform="translate(36 129.87)" fill="#969696" />
                <circle
                  id="Ellipse_61042"
                  data-name="Ellipse 61042"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.66 132.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61043"
                  data-name="Ellipse 61043"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(39.07 129.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_61044" data-name="Ellipse 61044" cx="0.56" cy="0.56" r="0.56" transform="translate(39.7 140.92)" fill="#969696" />
                <circle id="Ellipse_61045" data-name="Ellipse 61045" cx="0.56" cy="0.56" r="0.56" transform="translate(39.7 135.3)" fill="#969696" />
                <circle
                  id="Ellipse_61046"
                  data-name="Ellipse 61046"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.36 138.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_61047" data-name="Ellipse 61047" cx="0.56" cy="0.56" r="0.56" transform="translate(42.77 134.9)" fill="#969696" />
                <circle
                  id="Ellipse_61048"
                  data-name="Ellipse 61048"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.73 130.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61049"
                  data-name="Ellipse 61049"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.73 125.28)"
                  fill="#969696"
                />
                <circle id="Ellipse_61050" data-name="Ellipse 61050" cx="0.56" cy="0.56" r="0.56" transform="translate(43.4 128.3)" fill="#969696" />
                <circle
                  id="Ellipse_61051"
                  data-name="Ellipse 61051"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.81 124.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61052"
                  data-name="Ellipse 61052"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.64 138.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61053"
                  data-name="Ellipse 61053"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.64 133.34)"
                  fill="#969696"
                />
                <circle id="Ellipse_61054" data-name="Ellipse 61054" cx="0.56" cy="0.56" r="0.56" transform="translate(47.3 136.36)" fill="#969696" />
                <circle
                  id="Ellipse_61055"
                  data-name="Ellipse 61055"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(48.71 132.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_61056" data-name="Ellipse 61056" cx="0.56" cy="0.56" r="0.56" transform="translate(48.3 130.03)" fill="#969696" />
                <circle id="Ellipse_61057" data-name="Ellipse 61057" cx="0.56" cy="0.56" r="0.56" transform="translate(48.3 124.4)" fill="#969696" />
                <circle
                  id="Ellipse_61058"
                  data-name="Ellipse 61058"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(49.97 127.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_61059" data-name="Ellipse 61059" cx="0.56" cy="0.56" r="0.56" transform="translate(51.38 124)" fill="#969696" />
                <circle id="Ellipse_61060" data-name="Ellipse 61060" cx="0.56" cy="0.56" r="0.56" transform="translate(50.16 122.3)" fill="#969696" />
                <circle
                  id="Ellipse_61061"
                  data-name="Ellipse 61061"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.16 116.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61062"
                  data-name="Ellipse 61062"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(51.83 119.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61063"
                  data-name="Ellipse 61063"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.24 116.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61064"
                  data-name="Ellipse 61064"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.86 127.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61065"
                  data-name="Ellipse 61065"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.86 122.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61066"
                  data-name="Ellipse 61066"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.53 125.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61067"
                  data-name="Ellipse 61067"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.94 121.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_61068" data-name="Ellipse 61068" cx="0.56" cy="0.56" r="0.56" transform="translate(55.9 117.72)" fill="#969696" />
                <circle id="Ellipse_61069" data-name="Ellipse 61069" cx="0.56" cy="0.56" r="0.56" transform="translate(55.9 112.1)" fill="#969696" />
                <circle
                  id="Ellipse_61070"
                  data-name="Ellipse 61070"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(57.56 115.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_61071" data-name="Ellipse 61071" cx="0.56" cy="0.56" r="0.56" transform="translate(58.97 111.7)" fill="#969696" />
                <circle id="Ellipse_61072" data-name="Ellipse 61072" cx="0.56" cy="0.56" r="0.56" transform="translate(59.8 125.78)" fill="#969696" />
                <circle id="Ellipse_61073" data-name="Ellipse 61073" cx="0.56" cy="0.56" r="0.56" transform="translate(59.8 120.16)" fill="#969696" />
                <circle
                  id="Ellipse_61074"
                  data-name="Ellipse 61074"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.47 123.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61075"
                  data-name="Ellipse 61075"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.88 119.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61076"
                  data-name="Ellipse 61076"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.79 147.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61077"
                  data-name="Ellipse 61077"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.79 141.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61078"
                  data-name="Ellipse 61078"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.46 144.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61079"
                  data-name="Ellipse 61079"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.87 141.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61080"
                  data-name="Ellipse 61080"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.65 139.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61081"
                  data-name="Ellipse 61081"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.65 134.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61082"
                  data-name="Ellipse 61082"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(54.32 137.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61083"
                  data-name="Ellipse 61083"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.73 133.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61084"
                  data-name="Ellipse 61084"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.35 145.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61085"
                  data-name="Ellipse 61085"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.35 139.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61086"
                  data-name="Ellipse 61086"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.02 142.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61087"
                  data-name="Ellipse 61087"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(59.43 139.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61088"
                  data-name="Ellipse 61088"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.39 135.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61089"
                  data-name="Ellipse 61089"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.39 129.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61090"
                  data-name="Ellipse 61090"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(60.05 132.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61091"
                  data-name="Ellipse 61091"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.46 129.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61092"
                  data-name="Ellipse 61092"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.29 143.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61093"
                  data-name="Ellipse 61093"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.29 137.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_61094" data-name="Ellipse 61094" cx="0.56" cy="0.56" r="0.56" transform="translate(63.96 140.6)" fill="#969696" />
                <circle
                  id="Ellipse_61095"
                  data-name="Ellipse 61095"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.37 137.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61096"
                  data-name="Ellipse 61096"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(64.34 132.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61097"
                  data-name="Ellipse 61097"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(64.34 127.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61098"
                  data-name="Ellipse 61098"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(66.01 130.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61099"
                  data-name="Ellipse 61099"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.42 126.94)"
                  fill="#969696"
                />
                <circle id="Ellipse_61100" data-name="Ellipse 61100" cx="0.56" cy="0.56" r="0.56" transform="translate(66.2 125.24)" fill="#969696" />
                <circle id="Ellipse_61101" data-name="Ellipse 61101" cx="0.56" cy="0.56" r="0.56" transform="translate(66.2 119.61)" fill="#969696" />
                <circle
                  id="Ellipse_61102"
                  data-name="Ellipse 61102"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.87 122.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61103"
                  data-name="Ellipse 61103"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.28 119.21)"
                  fill="#969696"
                />
                <circle id="Ellipse_61104" data-name="Ellipse 61104" cx="0.56" cy="0.56" r="0.56" transform="translate(69.9 130.67)" fill="#969696" />
                <circle id="Ellipse_61105" data-name="Ellipse 61105" cx="0.56" cy="0.56" r="0.56" transform="translate(69.9 125.04)" fill="#969696" />
                <circle
                  id="Ellipse_61106"
                  data-name="Ellipse 61106"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(71.57 128.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61107"
                  data-name="Ellipse 61107"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.98 124.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61108"
                  data-name="Ellipse 61108"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(71.94 120.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61109"
                  data-name="Ellipse 61109"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(71.94 115.03)"
                  fill="#969696"
                />
                <circle id="Ellipse_61110" data-name="Ellipse 61110" cx="0.56" cy="0.56" r="0.56" transform="translate(73.6 118.04)" fill="#969696" />
                <circle
                  id="Ellipse_61111"
                  data-name="Ellipse 61111"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.01 114.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61112"
                  data-name="Ellipse 61112"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.85 128.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61113"
                  data-name="Ellipse 61113"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.85 123.09)"
                  fill="#969696"
                />
                <circle id="Ellipse_61114" data-name="Ellipse 61114" cx="0.56" cy="0.56" r="0.56" transform="translate(77.51 126.1)" fill="#969696" />
                <circle
                  id="Ellipse_61115"
                  data-name="Ellipse 61115"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.92 122.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61116"
                  data-name="Ellipse 61116"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.45 150.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61117"
                  data-name="Ellipse 61117"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.45 144.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61118"
                  data-name="Ellipse 61118"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.12 147.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61119"
                  data-name="Ellipse 61119"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(70.53 144.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61120"
                  data-name="Ellipse 61120"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.31 142.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61121"
                  data-name="Ellipse 61121"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.31 137.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61122"
                  data-name="Ellipse 61122"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(70.98 140.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61123"
                  data-name="Ellipse 61123"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.39 136.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61124"
                  data-name="Ellipse 61124"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.01 148.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61125"
                  data-name="Ellipse 61125"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.01 142.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61126"
                  data-name="Ellipse 61126"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(74.68 145.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61127"
                  data-name="Ellipse 61127"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(76.09 142.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61128"
                  data-name="Ellipse 61128"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.05 138.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61129"
                  data-name="Ellipse 61129"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.05 132.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61130"
                  data-name="Ellipse 61130"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(76.71 135.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61131"
                  data-name="Ellipse 61131"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.12 132.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61132"
                  data-name="Ellipse 61132"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.96 146.13)"
                  fill="#969696"
                />
                <circle id="Ellipse_61133" data-name="Ellipse 61133" cx="0.56" cy="0.56" r="0.56" transform="translate(78.96 140.5)" fill="#969696" />
                <circle
                  id="Ellipse_61134"
                  data-name="Ellipse 61134"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(80.62 143.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_61135" data-name="Ellipse 61135" cx="0.56" cy="0.56" r="0.56" transform="translate(82.03 140.1)" fill="#969696" />
                <circle
                  id="Ellipse_61136"
                  data-name="Ellipse 61136"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.62 137.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61137"
                  data-name="Ellipse 61137"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.62 131.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61138"
                  data-name="Ellipse 61138"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(83.29 134.57)"
                  fill="#969696"
                />
                <circle id="Ellipse_61139" data-name="Ellipse 61139" cx="0.56" cy="0.56" r="0.56" transform="translate(84.7 131.16)" fill="#969696" />
                <circle
                  id="Ellipse_61140"
                  data-name="Ellipse 61140"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(83.48 129.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61141"
                  data-name="Ellipse 61141"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(83.48 123.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61142"
                  data-name="Ellipse 61142"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(85.14 126.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61143"
                  data-name="Ellipse 61143"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(86.55 123.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61144"
                  data-name="Ellipse 61144"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.18 134.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61145"
                  data-name="Ellipse 61145"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.18 129.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61146"
                  data-name="Ellipse 61146"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(88.84 132.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61147"
                  data-name="Ellipse 61147"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.25 128.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61148"
                  data-name="Ellipse 61148"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.21 124.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61149"
                  data-name="Ellipse 61149"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(89.21 119.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61150"
                  data-name="Ellipse 61150"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.88 122.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61151"
                  data-name="Ellipse 61151"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(92.29 118.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61152"
                  data-name="Ellipse 61152"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.12 132.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61153"
                  data-name="Ellipse 61153"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.12 127.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61154"
                  data-name="Ellipse 61154"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(94.79 130.33)"
                  fill="#969696"
                />
                <circle id="Ellipse_61155" data-name="Ellipse 61155" cx="0.56" cy="0.56" r="0.56" transform="translate(96.2 126.92)" fill="#969696" />
                <circle
                  id="Ellipse_61156"
                  data-name="Ellipse 61156"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.27 180.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61157"
                  data-name="Ellipse 61157"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.27 175.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61158"
                  data-name="Ellipse 61158"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(38.93 178.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61159"
                  data-name="Ellipse 61159"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.34 174.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61160"
                  data-name="Ellipse 61160"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(39.12 173.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61161"
                  data-name="Ellipse 61161"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(39.12 167.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61162"
                  data-name="Ellipse 61162"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.79 170.62)"
                  fill="#969696"
                />
                <circle id="Ellipse_61163" data-name="Ellipse 61163" cx="0.56" cy="0.56" r="0.56" transform="translate(42.2 167.21)" fill="#969696" />
                <circle
                  id="Ellipse_61164"
                  data-name="Ellipse 61164"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.82 178.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61165"
                  data-name="Ellipse 61165"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.82 173.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61166"
                  data-name="Ellipse 61166"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.49 176.05)"
                  fill="#969696"
                />
                <circle id="Ellipse_61167" data-name="Ellipse 61167" cx="0.56" cy="0.56" r="0.56" transform="translate(45.9 172.64)" fill="#969696" />
                <circle
                  id="Ellipse_61168"
                  data-name="Ellipse 61168"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.86 168.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61169"
                  data-name="Ellipse 61169"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.86 163.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61170"
                  data-name="Ellipse 61170"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.53 166.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61171"
                  data-name="Ellipse 61171"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(47.94 162.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61172"
                  data-name="Ellipse 61172"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(48.77 176.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61173"
                  data-name="Ellipse 61173"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(48.77 171.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_61174" data-name="Ellipse 61174" cx="0.56" cy="0.56" r="0.56" transform="translate(50.43 174.1)" fill="#969696" />
                <circle
                  id="Ellipse_61175"
                  data-name="Ellipse 61175"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(51.84 170.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61176"
                  data-name="Ellipse 61176"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.82 166.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61177"
                  data-name="Ellipse 61177"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.82 160.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61178"
                  data-name="Ellipse 61178"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.48 163.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61179"
                  data-name="Ellipse 61179"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.89 160.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61180"
                  data-name="Ellipse 61180"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.68 158.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61181"
                  data-name="Ellipse 61181"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.68 153.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61182"
                  data-name="Ellipse 61182"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(54.34 156.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61183"
                  data-name="Ellipse 61183"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.75 152.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61184"
                  data-name="Ellipse 61184"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.38 164.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61185"
                  data-name="Ellipse 61185"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.38 158.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61186"
                  data-name="Ellipse 61186"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.04 161.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61187"
                  data-name="Ellipse 61187"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(59.45 158.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61188"
                  data-name="Ellipse 61188"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.41 154.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61189"
                  data-name="Ellipse 61189"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.41 148.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61190"
                  data-name="Ellipse 61190"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(60.08 151.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61191"
                  data-name="Ellipse 61191"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.49 148.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61192"
                  data-name="Ellipse 61192"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.32 162.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61193"
                  data-name="Ellipse 61193"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.32 156.58)"
                  fill="#969696"
                />
                <circle id="Ellipse_61194" data-name="Ellipse 61194" cx="0.56" cy="0.56" r="0.56" transform="translate(63.98 159.6)" fill="#969696" />
                <circle
                  id="Ellipse_61195"
                  data-name="Ellipse 61195"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.39 156.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61196"
                  data-name="Ellipse 61196"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.93 183.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61197"
                  data-name="Ellipse 61197"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.93 178.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61198"
                  data-name="Ellipse 61198"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.59 181.26)"
                  fill="#969696"
                />
                <circle id="Ellipse_61199" data-name="Ellipse 61199" cx="0.56" cy="0.56" r="0.56" transform="translate(57 177.84)" fill="#969696" />
                <circle
                  id="Ellipse_61200"
                  data-name="Ellipse 61200"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.79 176.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61201"
                  data-name="Ellipse 61201"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.79 170.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61202"
                  data-name="Ellipse 61202"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(57.45 173.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61203"
                  data-name="Ellipse 61203"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(58.86 170.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61204"
                  data-name="Ellipse 61204"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(59.49 181.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61205"
                  data-name="Ellipse 61205"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(59.49 175.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61206"
                  data-name="Ellipse 61206"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.15 178.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61207"
                  data-name="Ellipse 61207"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(62.56 175.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61208"
                  data-name="Ellipse 61208"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.52 171.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61209"
                  data-name="Ellipse 61209"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.52 165.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61210"
                  data-name="Ellipse 61210"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(63.19 168.95)"
                  fill="#969696"
                />
                <circle id="Ellipse_61211" data-name="Ellipse 61211" cx="0.56" cy="0.56" r="0.56" transform="translate(64.6 165.54)" fill="#969696" />
                <circle
                  id="Ellipse_61212"
                  data-name="Ellipse 61212"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.43 179.62)"
                  fill="#969696"
                />
                <circle id="Ellipse_61213" data-name="Ellipse 61213" cx="0.56" cy="0.56" r="0.56" transform="translate(65.43 174)" fill="#969696" />
                <circle id="Ellipse_61214" data-name="Ellipse 61214" cx="0.56" cy="0.56" r="0.56" transform="translate(67.1 177.01)" fill="#969696" />
                <circle id="Ellipse_61215" data-name="Ellipse 61215" cx="0.56" cy="0.56" r="0.56" transform="translate(68.51 173.6)" fill="#969696" />
                <circle
                  id="Ellipse_61216"
                  data-name="Ellipse 61216"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.09 170.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61217"
                  data-name="Ellipse 61217"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.09 165.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61218"
                  data-name="Ellipse 61218"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.76 168.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61219"
                  data-name="Ellipse 61219"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(71.17 164.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61220"
                  data-name="Ellipse 61220"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.95 162.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61221"
                  data-name="Ellipse 61221"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.95 157.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61222"
                  data-name="Ellipse 61222"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(71.62 160.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61223"
                  data-name="Ellipse 61223"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.03 156.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61224"
                  data-name="Ellipse 61224"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.65 168.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61225"
                  data-name="Ellipse 61225"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(73.65 162.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61226"
                  data-name="Ellipse 61226"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.32 165.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61227"
                  data-name="Ellipse 61227"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(76.73 162.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61228"
                  data-name="Ellipse 61228"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.69 158.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61229"
                  data-name="Ellipse 61229"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.69 152.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61230"
                  data-name="Ellipse 61230"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(77.35 155.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61231"
                  data-name="Ellipse 61231"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.76 152.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61232"
                  data-name="Ellipse 61232"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(79.59 166.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61233"
                  data-name="Ellipse 61233"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(79.59 160.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61234"
                  data-name="Ellipse 61234"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.26 163.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61235"
                  data-name="Ellipse 61235"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.67 160.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61236"
                  data-name="Ellipse 61236"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.14 185.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61237"
                  data-name="Ellipse 61237"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.76 179.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61238"
                  data-name="Ellipse 61238"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(33.17 175.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61239"
                  data-name="Ellipse 61239"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.01 189.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61240"
                  data-name="Ellipse 61240"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.01 184.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61241"
                  data-name="Ellipse 61241"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(35.67 187.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61242"
                  data-name="Ellipse 61242"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.08 183.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61243"
                  data-name="Ellipse 61243"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(33.63 203.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61244"
                  data-name="Ellipse 61244"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.59 199.22)"
                  fill="#969696"
                />
                <circle id="Ellipse_61245" data-name="Ellipse 61245" cx="0.56" cy="0.56" r="0.56" transform="translate(32.59 193.6)" fill="#969696" />
                <circle
                  id="Ellipse_61246"
                  data-name="Ellipse 61246"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.26 196.61)"
                  fill="#969696"
                />
                <circle id="Ellipse_61247" data-name="Ellipse 61247" cx="0.56" cy="0.56" r="0.56" transform="translate(35.67 193.2)" fill="#969696" />
                <circle id="Ellipse_61248" data-name="Ellipse 61248" cx="0.56" cy="0.56" r="0.56" transform="translate(36.5 201.66)" fill="#969696" />
                <circle
                  id="Ellipse_61249"
                  data-name="Ellipse 61249"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(39.57 201.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61250"
                  data-name="Ellipse 61250"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(38.55 197.03)"
                  fill="#969696"
                />
                <circle id="Ellipse_61251" data-name="Ellipse 61251" cx="0.56" cy="0.56" r="0.56" transform="translate(38.55 191.4)" fill="#969696" />
                <circle
                  id="Ellipse_61252"
                  data-name="Ellipse 61252"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.21 194.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_61253" data-name="Ellipse 61253" cx="0.56" cy="0.56" r="0.56" transform="translate(41.62 191)" fill="#969696" />
                <circle id="Ellipse_61254" data-name="Ellipse 61254" cx="0.56" cy="0.56" r="0.56" transform="translate(40.41 189.3)" fill="#969696" />
                <circle
                  id="Ellipse_61255"
                  data-name="Ellipse 61255"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.41 183.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61256"
                  data-name="Ellipse 61256"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.07 186.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61257"
                  data-name="Ellipse 61257"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(43.48 183.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61258"
                  data-name="Ellipse 61258"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.11 194.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61259"
                  data-name="Ellipse 61259"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(44.11 189.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61260"
                  data-name="Ellipse 61260"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.77 192.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61261"
                  data-name="Ellipse 61261"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(47.18 188.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61262"
                  data-name="Ellipse 61262"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.14 184.72)"
                  fill="#969696"
                />
                <circle id="Ellipse_61263" data-name="Ellipse 61263" cx="0.56" cy="0.56" r="0.56" transform="translate(46.14 179.1)" fill="#969696" />
                <circle
                  id="Ellipse_61264"
                  data-name="Ellipse 61264"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(47.81 182.11)"
                  fill="#969696"
                />
                <circle id="Ellipse_61265" data-name="Ellipse 61265" cx="0.56" cy="0.56" r="0.56" transform="translate(49.22 178.7)" fill="#969696" />
                <circle
                  id="Ellipse_61266"
                  data-name="Ellipse 61266"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.05 192.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61267"
                  data-name="Ellipse 61267"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.05 187.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61268"
                  data-name="Ellipse 61268"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(51.71 190.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61269"
                  data-name="Ellipse 61269"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.12 186.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61270"
                  data-name="Ellipse 61270"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(43.52 201.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61271"
                  data-name="Ellipse 61271"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.59 200.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61272"
                  data-name="Ellipse 61272"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(49.25 202.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61273"
                  data-name="Ellipse 61273"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(49.25 196.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61274"
                  data-name="Ellipse 61274"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(50.92 199.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61275"
                  data-name="Ellipse 61275"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.33 196.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61276"
                  data-name="Ellipse 61276"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.82 201.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61277"
                  data-name="Ellipse 61277"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.82 195.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61278"
                  data-name="Ellipse 61278"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(57.49 198.64)"
                  fill="#969696"
                />
                <circle id="Ellipse_61279" data-name="Ellipse 61279" cx="0.56" cy="0.56" r="0.56" transform="translate(58.9 195.23)" fill="#969696" />
                <circle
                  id="Ellipse_61280"
                  data-name="Ellipse 61280"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(57.68 193.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61281"
                  data-name="Ellipse 61281"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(57.68 187.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61282"
                  data-name="Ellipse 61282"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(59.35 190.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61283"
                  data-name="Ellipse 61283"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(60.76 187.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61284"
                  data-name="Ellipse 61284"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.38 198.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61285"
                  data-name="Ellipse 61285"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(61.38 193.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61286"
                  data-name="Ellipse 61286"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(63.05 196.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61287"
                  data-name="Ellipse 61287"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(64.46 192.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61288"
                  data-name="Ellipse 61288"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(63.42 188.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61289"
                  data-name="Ellipse 61289"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(63.42 183.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61290"
                  data-name="Ellipse 61290"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.08 186.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61291"
                  data-name="Ellipse 61291"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(66.49 182.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61292"
                  data-name="Ellipse 61292"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.32 197.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61293"
                  data-name="Ellipse 61293"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.32 191.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61294"
                  data-name="Ellipse 61294"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.99 194.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_61295" data-name="Ellipse 61295" cx="0.56" cy="0.56" r="0.56" transform="translate(70.4 190.98)" fill="#969696" />
                <circle
                  id="Ellipse_61296"
                  data-name="Ellipse 61296"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.09 200.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61297"
                  data-name="Ellipse 61297"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.96 199.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61298"
                  data-name="Ellipse 61298"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.63 202.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61299"
                  data-name="Ellipse 61299"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.04 198.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61300"
                  data-name="Ellipse 61300"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.13 177.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61301"
                  data-name="Ellipse 61301"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.99 181.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61302"
                  data-name="Ellipse 61302"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.99 176.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61303"
                  data-name="Ellipse 61303"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.66 179.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61304"
                  data-name="Ellipse 61304"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.07 175.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61305"
                  data-name="Ellipse 61305"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.02 173.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61306"
                  data-name="Ellipse 61306"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.89 177.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61307"
                  data-name="Ellipse 61307"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.89 172.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61308"
                  data-name="Ellipse 61308"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.55 175.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61309"
                  data-name="Ellipse 61309"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.96 171.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61310"
                  data-name="Ellipse 61310"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.51 182.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61311"
                  data-name="Ellipse 61311"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.38 186.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61312"
                  data-name="Ellipse 61312"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.38 180.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61313"
                  data-name="Ellipse 61313"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.05 183.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61314"
                  data-name="Ellipse 61314"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.46 180.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61315"
                  data-name="Ellipse 61315"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.25 184.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61316"
                  data-name="Ellipse 61316"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.12 188.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61317"
                  data-name="Ellipse 61317"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.12 182.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61318"
                  data-name="Ellipse 61318"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.78 185.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61319"
                  data-name="Ellipse 61319"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.19 182.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61320"
                  data-name="Ellipse 61320"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.66 169.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61321"
                  data-name="Ellipse 61321"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.52 173.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61322"
                  data-name="Ellipse 61322"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.52 168.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61323"
                  data-name="Ellipse 61323"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.19 171.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61324"
                  data-name="Ellipse 61324"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(165.6 167.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61325"
                  data-name="Ellipse 61325"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.61 168.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61326"
                  data-name="Ellipse 61326"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.48 172.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61327"
                  data-name="Ellipse 61327"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.48 167.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61328"
                  data-name="Ellipse 61328"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(138.14 170.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61329"
                  data-name="Ellipse 61329"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.55 166.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61330"
                  data-name="Ellipse 61330"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.84 159.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61331"
                  data-name="Ellipse 61331"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.71 163.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61332"
                  data-name="Ellipse 61332"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.71 157.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61333"
                  data-name="Ellipse 61333"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.38 160.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61334"
                  data-name="Ellipse 61334"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.79 157.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61335"
                  data-name="Ellipse 61335"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.42 156.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61336"
                  data-name="Ellipse 61336"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.29 160.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61337"
                  data-name="Ellipse 61337"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.29 155.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61338"
                  data-name="Ellipse 61338"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.95 158.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61339"
                  data-name="Ellipse 61339"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.36 154.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61340"
                  data-name="Ellipse 61340"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.11 171.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61341"
                  data-name="Ellipse 61341"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.98 175.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61342"
                  data-name="Ellipse 61342"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.98 170.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61343"
                  data-name="Ellipse 61343"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.64 173.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61344"
                  data-name="Ellipse 61344"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.05 169.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61345"
                  data-name="Ellipse 61345"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.56 192.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61346"
                  data-name="Ellipse 61346"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.43 196.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61347"
                  data-name="Ellipse 61347"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.43 191.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61348"
                  data-name="Ellipse 61348"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.1 194.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61349"
                  data-name="Ellipse 61349"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.51 190.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61350"
                  data-name="Ellipse 61350"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.35 196.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61351"
                  data-name="Ellipse 61351"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.22 200.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61352"
                  data-name="Ellipse 61352"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.22 194.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61353"
                  data-name="Ellipse 61353"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.89 197.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61354"
                  data-name="Ellipse 61354"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.3 194.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61355"
                  data-name="Ellipse 61355"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.44 193.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61356"
                  data-name="Ellipse 61356"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.31 197.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61357"
                  data-name="Ellipse 61357"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.31 192.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61358"
                  data-name="Ellipse 61358"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.98 195.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61359"
                  data-name="Ellipse 61359"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.39 191.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61360"
                  data-name="Ellipse 61360"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(84.28 192.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61361"
                  data-name="Ellipse 61361"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(87.14 196.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61362"
                  data-name="Ellipse 61362"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(88.81 193.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61363"
                  data-name="Ellipse 61363"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.22 190.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61364"
                  data-name="Ellipse 61364"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(98.12 187.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61365"
                  data-name="Ellipse 61365"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.98 192.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61366"
                  data-name="Ellipse 61366"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.98 186.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61367"
                  data-name="Ellipse 61367"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.65 189.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61368"
                  data-name="Ellipse 61368"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.06 186.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61369"
                  data-name="Ellipse 61369"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(97.55 160.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61370"
                  data-name="Ellipse 61370"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.41 165.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61371"
                  data-name="Ellipse 61371"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.41 159.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61372"
                  data-name="Ellipse 61372"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.08 162.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61373"
                  data-name="Ellipse 61373"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.49 158.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61374"
                  data-name="Ellipse 61374"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(64.42 154.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61375"
                  data-name="Ellipse 61375"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.28 158.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61376"
                  data-name="Ellipse 61376"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.28 152.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61377"
                  data-name="Ellipse 61377"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(68.95 155.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61378"
                  data-name="Ellipse 61378"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(70.36 152.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61379"
                  data-name="Ellipse 61379"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(42.52 146.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61380"
                  data-name="Ellipse 61380"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.38 150.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61381"
                  data-name="Ellipse 61381"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(45.38 144.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61382"
                  data-name="Ellipse 61382"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(47.05 147.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61383"
                  data-name="Ellipse 61383"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(48.46 144.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61384"
                  data-name="Ellipse 61384"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(49.27 169.33)"
                  fill="#969696"
                />
                <circle id="Ellipse_61385" data-name="Ellipse 61385" cx="0.56" cy="0.56" r="0.56" transform="translate(52.14 173.4)" fill="#969696" />
                <circle
                  id="Ellipse_61386"
                  data-name="Ellipse 61386"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(52.14 167.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61387"
                  data-name="Ellipse 61387"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.81 170.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61388"
                  data-name="Ellipse 61388"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(55.22 167.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61389"
                  data-name="Ellipse 61389"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(37.31 162.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61390"
                  data-name="Ellipse 61390"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.17 166.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61391"
                  data-name="Ellipse 61391"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(40.17 161.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61392"
                  data-name="Ellipse 61392"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(41.84 164.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61393"
                  data-name="Ellipse 61393"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(43.25 160.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61394"
                  data-name="Ellipse 61394"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.46 146.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61395"
                  data-name="Ellipse 61395"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.32 150.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61396"
                  data-name="Ellipse 61396"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(34.32 145.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61397"
                  data-name="Ellipse 61397"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(35.99 148.08)"
                  fill="#969696"
                />
                <circle id="Ellipse_61398" data-name="Ellipse 61398" cx="0.56" cy="0.56" r="0.56" transform="translate(37.4 144.67)" fill="#969696" />
                <circle
                  id="Ellipse_61399"
                  data-name="Ellipse 61399"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(63.12 135.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61400"
                  data-name="Ellipse 61400"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.99 139.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61401"
                  data-name="Ellipse 61401"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.99 134.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61402"
                  data-name="Ellipse 61402"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(67.66 137.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61403"
                  data-name="Ellipse 61403"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(69.07 133.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61404"
                  data-name="Ellipse 61404"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(43.59 113.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61405"
                  data-name="Ellipse 61405"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.45 117.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61406"
                  data-name="Ellipse 61406"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(46.45 111.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_61407" data-name="Ellipse 61407" cx="0.56" cy="0.56" r="0.56" transform="translate(48.12 114.7)" fill="#969696" />
                <circle
                  id="Ellipse_61408"
                  data-name="Ellipse 61408"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(49.53 111.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61409"
                  data-name="Ellipse 61409"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(30.97 109.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61410"
                  data-name="Ellipse 61410"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(33.83 113.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61411"
                  data-name="Ellipse 61411"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(33.83 107.86)"
                  fill="#969696"
                />
                <circle id="Ellipse_61412" data-name="Ellipse 61412" cx="0.56" cy="0.56" r="0.56" transform="translate(35.5 110.88)" fill="#969696" />
                <circle
                  id="Ellipse_61413"
                  data-name="Ellipse 61413"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(36.91 107.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61414"
                  data-name="Ellipse 61414"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(72.65 104.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61415"
                  data-name="Ellipse 61415"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.51 108.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61416"
                  data-name="Ellipse 61416"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(75.51 103.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61417"
                  data-name="Ellipse 61417"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(77.18 106.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61418"
                  data-name="Ellipse 61418"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(78.59 102.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61419"
                  data-name="Ellipse 61419"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(90.72 116.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61420"
                  data-name="Ellipse 61420"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.59 120.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61421"
                  data-name="Ellipse 61421"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(93.59 114.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61422"
                  data-name="Ellipse 61422"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(95.25 117.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61423"
                  data-name="Ellipse 61423"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(96.66 114.46)"
                  fill="#969696"
                />
                <circle id="Ellipse_61424" data-name="Ellipse 61424" cx="0.56" cy="0.56" r="0.56" transform="translate(78.25 120.9)" fill="#969696" />
                <circle
                  id="Ellipse_61425"
                  data-name="Ellipse 61425"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.12 124.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61426"
                  data-name="Ellipse 61426"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(81.12 119.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61427"
                  data-name="Ellipse 61427"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(82.79 122.35)"
                  fill="#969696"
                />
                <circle id="Ellipse_61428" data-name="Ellipse 61428" cx="0.56" cy="0.56" r="0.56" transform="translate(84.2 118.94)" fill="#969696" />
                <circle
                  id="Ellipse_61429"
                  data-name="Ellipse 61429"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(28.35 133.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61430"
                  data-name="Ellipse 61430"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.22 137.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61431"
                  data-name="Ellipse 61431"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(31.22 132.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61432"
                  data-name="Ellipse 61432"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(32.89 135.14)"
                  fill="#969696"
                />
                <circle id="Ellipse_61433" data-name="Ellipse 61433" cx="0.56" cy="0.56" r="0.56" transform="translate(34.3 131.73)" fill="#969696" />
                <circle
                  id="Ellipse_61434"
                  data-name="Ellipse 61434"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.64 85.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61435"
                  data-name="Ellipse 61435"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.51 89.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61436"
                  data-name="Ellipse 61436"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.51 84.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61437"
                  data-name="Ellipse 61437"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.17 87.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61438"
                  data-name="Ellipse 61438"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.58 83.87)"
                  fill="#969696"
                />
                <circle id="Ellipse_61439" data-name="Ellipse 61439" cx="0.56" cy="0.56" r="0.56" transform="translate(87.21 90.13)" fill="#969696" />
                <circle id="Ellipse_61440" data-name="Ellipse 61440" cx="0.56" cy="0.56" r="0.56" transform="translate(90.07 94.21)" fill="#969696" />
                <circle id="Ellipse_61441" data-name="Ellipse 61441" cx="0.56" cy="0.56" r="0.56" transform="translate(90.07 88.58)" fill="#969696" />
                <circle id="Ellipse_61442" data-name="Ellipse 61442" cx="0.56" cy="0.56" r="0.56" transform="translate(91.74 91.59)" fill="#969696" />
                <circle id="Ellipse_61443" data-name="Ellipse 61443" cx="0.56" cy="0.56" r="0.56" transform="translate(93.15 88.18)" fill="#969696" />
                <circle
                  id="Ellipse_61444"
                  data-name="Ellipse 61444"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.65 73.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61445"
                  data-name="Ellipse 61445"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.52 77.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61446"
                  data-name="Ellipse 61446"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.52 71.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61447"
                  data-name="Ellipse 61447"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.18 74.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61448"
                  data-name="Ellipse 61448"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(113.59 71.56)"
                  fill="#969696"
                />
                <circle id="Ellipse_61449" data-name="Ellipse 61449" cx="0.56" cy="0.56" r="0.56" transform="translate(104.31 94.6)" fill="#969696" />
                <circle
                  id="Ellipse_61450"
                  data-name="Ellipse 61450"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.18 98.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61451"
                  data-name="Ellipse 61451"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(107.18 93.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61452"
                  data-name="Ellipse 61452"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.85 96.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61453"
                  data-name="Ellipse 61453"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(110.26 92.65)"
                  fill="#969696"
                />
                <circle id="Ellipse_61454" data-name="Ellipse 61454" cx="0.56" cy="0.56" r="0.56" transform="translate(33.97 68.39)" fill="#969696" />
                <circle id="Ellipse_61455" data-name="Ellipse 61455" cx="0.56" cy="0.56" r="0.56" transform="translate(36.84 72.46)" fill="#969696" />
                <circle id="Ellipse_61456" data-name="Ellipse 61456" cx="0.56" cy="0.56" r="0.56" transform="translate(36.84 66.84)" fill="#969696" />
                <circle id="Ellipse_61457" data-name="Ellipse 61457" cx="0.56" cy="0.56" r="0.56" transform="translate(38.5 69.85)" fill="#969696" />
                <circle id="Ellipse_61458" data-name="Ellipse 61458" cx="0.56" cy="0.56" r="0.56" transform="translate(39.91 66.44)" fill="#969696" />
                <circle id="Ellipse_61459" data-name="Ellipse 61459" cx="0.56" cy="0.56" r="0.56" transform="translate(59.12 80.68)" fill="#969696" />
                <circle id="Ellipse_61460" data-name="Ellipse 61460" cx="0.56" cy="0.56" r="0.56" transform="translate(61.99 84.75)" fill="#969696" />
                <circle id="Ellipse_61461" data-name="Ellipse 61461" cx="0.56" cy="0.56" r="0.56" transform="translate(61.99 79.13)" fill="#969696" />
                <circle id="Ellipse_61462" data-name="Ellipse 61462" cx="0.56" cy="0.56" r="0.56" transform="translate(63.66 82.14)" fill="#969696" />
                <circle id="Ellipse_61463" data-name="Ellipse 61463" cx="0.56" cy="0.56" r="0.56" transform="translate(65.07 78.73)" fill="#969696" />
                <circle id="Ellipse_61464" data-name="Ellipse 61464" cx="0.56" cy="0.56" r="0.56" transform="translate(61.32 98.67)" fill="#969696" />
                <circle
                  id="Ellipse_61465"
                  data-name="Ellipse 61465"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(64.19 102.74)"
                  fill="#969696"
                />
                <circle id="Ellipse_61466" data-name="Ellipse 61466" cx="0.56" cy="0.56" r="0.56" transform="translate(64.19 97.12)" fill="#969696" />
                <circle
                  id="Ellipse_61467"
                  data-name="Ellipse 61467"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(65.85 100.13)"
                  fill="#969696"
                />
                <circle id="Ellipse_61468" data-name="Ellipse 61468" cx="0.56" cy="0.56" r="0.56" transform="translate(67.26 96.72)" fill="#969696" />
                <circle
                  id="Ellipse_61469"
                  data-name="Ellipse 61469"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(53.27 109.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61470"
                  data-name="Ellipse 61470"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.14 114.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61471"
                  data-name="Ellipse 61471"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(56.14 108.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61472"
                  data-name="Ellipse 61472"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(57.81 111.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61473"
                  data-name="Ellipse 61473"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(59.22 108.03)"
                  fill="#969696"
                />
                <circle id="Ellipse_61474" data-name="Ellipse 61474" cx="0.56" cy="0.56" r="0.56" transform="translate(40.51 59.84)" fill="#969696" />
                <circle id="Ellipse_61475" data-name="Ellipse 61475" cx="0.56" cy="0.56" r="0.56" transform="translate(43.38 63.91)" fill="#969696" />
                <circle id="Ellipse_61476" data-name="Ellipse 61476" cx="0.56" cy="0.56" r="0.56" transform="translate(43.38 58.29)" fill="#969696" />
                <circle id="Ellipse_61477" data-name="Ellipse 61477" cx="0.56" cy="0.56" r="0.56" transform="translate(45.04 61.3)" fill="#969696" />
                <circle id="Ellipse_61478" data-name="Ellipse 61478" cx="0.56" cy="0.56" r="0.56" transform="translate(46.45 57.89)" fill="#969696" />
                <circle id="Ellipse_61479" data-name="Ellipse 61479" cx="0.56" cy="0.56" r="0.56" transform="translate(47.35 36.4)" fill="#969696" />
                <circle id="Ellipse_61480" data-name="Ellipse 61480" cx="0.56" cy="0.56" r="0.56" transform="translate(50.21 40.47)" fill="#969696" />
                <circle id="Ellipse_61481" data-name="Ellipse 61481" cx="0.56" cy="0.56" r="0.56" transform="translate(50.21 34.84)" fill="#969696" />
                <circle id="Ellipse_61482" data-name="Ellipse 61482" cx="0.56" cy="0.56" r="0.56" transform="translate(51.88 37.86)" fill="#969696" />
                <circle id="Ellipse_61483" data-name="Ellipse 61483" cx="0.56" cy="0.56" r="0.56" transform="translate(53.29 34.44)" fill="#969696" />
                <circle id="Ellipse_61484" data-name="Ellipse 61484" cx="0.56" cy="0.56" r="0.56" transform="translate(33.56 40.95)" fill="#969696" />
                <circle id="Ellipse_61485" data-name="Ellipse 61485" cx="0.56" cy="0.56" r="0.56" transform="translate(36.43 45.02)" fill="#969696" />
                <circle id="Ellipse_61486" data-name="Ellipse 61486" cx="0.56" cy="0.56" r="0.56" transform="translate(36.43 39.39)" fill="#969696" />
                <circle id="Ellipse_61487" data-name="Ellipse 61487" cx="0.56" cy="0.56" r="0.56" transform="translate(38.1 42.41)" fill="#969696" />
                <circle id="Ellipse_61488" data-name="Ellipse 61488" cx="0.56" cy="0.56" r="0.56" transform="translate(39.51 38.99)" fill="#969696" />
                <circle id="Ellipse_61489" data-name="Ellipse 61489" cx="0.56" cy="0.56" r="0.56" transform="translate(45.62 7.99)" fill="#969696" />
                <circle id="Ellipse_61490" data-name="Ellipse 61490" cx="0.56" cy="0.56" r="0.56" transform="translate(48.49 12.06)" fill="#969696" />
                <circle id="Ellipse_61491" data-name="Ellipse 61491" cx="0.56" cy="0.56" r="0.56" transform="translate(48.49 6.43)" fill="#969696" />
                <circle id="Ellipse_61492" data-name="Ellipse 61492" cx="0.56" cy="0.56" r="0.56" transform="translate(50.15 9.45)" fill="#969696" />
                <circle id="Ellipse_61493" data-name="Ellipse 61493" cx="0.56" cy="0.56" r="0.56" transform="translate(51.56 6.03)" fill="#969696" />
                <circle id="Ellipse_61494" data-name="Ellipse 61494" cx="0.56" cy="0.56" r="0.56" transform="translate(59.79 3.84)" fill="#969696" />
                <circle id="Ellipse_61495" data-name="Ellipse 61495" cx="0.56" cy="0.56" r="0.56" transform="translate(62.65 7.91)" fill="#969696" />
                <circle id="Ellipse_61496" data-name="Ellipse 61496" cx="0.56" cy="0.56" r="0.56" transform="translate(62.65 2.28)" fill="#969696" />
                <circle id="Ellipse_61497" data-name="Ellipse 61497" cx="0.56" cy="0.56" r="0.56" transform="translate(64.32 5.3)" fill="#969696" />
                <circle id="Ellipse_61498" data-name="Ellipse 61498" cx="0.56" cy="0.56" r="0.56" transform="translate(65.73 1.88)" fill="#969696" />
                <circle id="Ellipse_61499" data-name="Ellipse 61499" cx="0.56" cy="0.56" r="0.56" transform="translate(55.62 25.01)" fill="#969696" />
                <circle id="Ellipse_61500" data-name="Ellipse 61500" cx="0.56" cy="0.56" r="0.56" transform="translate(58.49 29.08)" fill="#969696" />
                <circle id="Ellipse_61501" data-name="Ellipse 61501" cx="0.56" cy="0.56" r="0.56" transform="translate(58.49 23.46)" fill="#969696" />
                <circle id="Ellipse_61502" data-name="Ellipse 61502" cx="0.56" cy="0.56" r="0.56" transform="translate(60.16 26.47)" fill="#969696" />
                <circle id="Ellipse_61503" data-name="Ellipse 61503" cx="0.56" cy="0.56" r="0.56" transform="translate(61.57 23.06)" fill="#969696" />
                <circle id="Ellipse_61504" data-name="Ellipse 61504" cx="0.56" cy="0.56" r="0.56" transform="translate(41.71 0.91)" fill="#969696" />
                <circle id="Ellipse_61505" data-name="Ellipse 61505" cx="0.56" cy="0.56" r="0.56" transform="translate(44.58 4.98)" fill="#969696" />
                <circle id="Ellipse_61506" data-name="Ellipse 61506" cx="0.56" cy="0.56" r="0.56" transform="translate(44.58 -0.65)" fill="#969696" />
                <circle id="Ellipse_61507" data-name="Ellipse 61507" cx="0.56" cy="0.56" r="0.56" transform="translate(46.25 2.36)" fill="#969696" />
                <circle id="Ellipse_61508" data-name="Ellipse 61508" cx="0.56" cy="0.56" r="0.56" transform="translate(47.66 -1.05)" fill="#969696" />
                <circle
                  id="Ellipse_61509"
                  data-name="Ellipse 61509"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(108.38 19.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61510"
                  data-name="Ellipse 61510"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.25 23.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61511"
                  data-name="Ellipse 61511"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(111.25 17.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61512"
                  data-name="Ellipse 61512"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.92 20.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61513"
                  data-name="Ellipse 61513"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.33 17.27)"
                  fill="#969696"
                />
                <circle id="Ellipse_61514" data-name="Ellipse 61514" cx="0.56" cy="0.56" r="0.56" transform="translate(125.89 22.4)" fill="#969696" />
                <circle
                  id="Ellipse_61515"
                  data-name="Ellipse 61515"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.75 26.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61516"
                  data-name="Ellipse 61516"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(128.75 20.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61517"
                  data-name="Ellipse 61517"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.42 23.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61518"
                  data-name="Ellipse 61518"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.83 20.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61519"
                  data-name="Ellipse 61519"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.86 24.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61520"
                  data-name="Ellipse 61520"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.53 27.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61521"
                  data-name="Ellipse 61521"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.94 23.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61522"
                  data-name="Ellipse 61522"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.91 18.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61523"
                  data-name="Ellipse 61523"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.26 14.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61524"
                  data-name="Ellipse 61524"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(134.92 17.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61525"
                  data-name="Ellipse 61525"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.33 14.41)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61526"
                  data-name="Ellipse 61526"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(101.14 23.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61527"
                  data-name="Ellipse 61527"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.49 19.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61528"
                  data-name="Ellipse 61528"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(104.15 22.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61529"
                  data-name="Ellipse 61529"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(105.56 19.29)"
                  fill="#969696"
                />
                <circle id="Ellipse_61530" data-name="Ellipse 61530" cx="0.56" cy="0.56" r="0.56" transform="translate(81.44 26.77)" fill="#969696" />
                <circle id="Ellipse_61531" data-name="Ellipse 61531" cx="0.56" cy="0.56" r="0.56" transform="translate(82.79 22.97)" fill="#969696" />
                <circle id="Ellipse_61532" data-name="Ellipse 61532" cx="0.56" cy="0.56" r="0.56" transform="translate(84.45 25.98)" fill="#969696" />
                <circle id="Ellipse_61533" data-name="Ellipse 61533" cx="0.56" cy="0.56" r="0.56" transform="translate(85.86 22.57)" fill="#969696" />
                <circle
                  id="Ellipse_61534"
                  data-name="Ellipse 61534"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.47 30.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_61535" data-name="Ellipse 61535" cx="0.56" cy="0.56" r="0.56" transform="translate(130.82 26.8)" fill="#969696" />
                <circle
                  id="Ellipse_61536"
                  data-name="Ellipse 61536"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.48 29.81)"
                  fill="#969696"
                />
                <circle id="Ellipse_61537" data-name="Ellipse 61537" cx="0.56" cy="0.56" r="0.56" transform="translate(133.89 26.4)" fill="#969696" />
                <circle
                  id="Ellipse_61538"
                  data-name="Ellipse 61538"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(132.48 38.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61539"
                  data-name="Ellipse 61539"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(133.83 34.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61540"
                  data-name="Ellipse 61540"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(135.49 37.85)"
                  fill="#969696"
                />
                <circle id="Ellipse_61541" data-name="Ellipse 61541" cx="0.56" cy="0.56" r="0.56" transform="translate(136.9 34.43)" fill="#969696" />
                <circle
                  id="Ellipse_61542"
                  data-name="Ellipse 61542"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.56 53.14)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61543"
                  data-name="Ellipse 61543"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.91 49.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61544"
                  data-name="Ellipse 61544"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.57 52.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61545"
                  data-name="Ellipse 61545"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.98 48.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61546"
                  data-name="Ellipse 61546"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.62 70.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61547"
                  data-name="Ellipse 61547"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.97 66.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61548"
                  data-name="Ellipse 61548"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.63 69.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61549"
                  data-name="Ellipse 61549"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.04 66.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61550"
                  data-name="Ellipse 61550"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(154.29 33.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61551"
                  data-name="Ellipse 61551"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.64 30.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61552"
                  data-name="Ellipse 61552"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(157.31 33.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61553"
                  data-name="Ellipse 61553"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.72 29.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61554"
                  data-name="Ellipse 61554"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(117.09 60.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61555"
                  data-name="Ellipse 61555"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(118.44 56.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61556"
                  data-name="Ellipse 61556"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.11 59.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61557"
                  data-name="Ellipse 61557"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(121.52 55.92)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61558"
                  data-name="Ellipse 61558"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.05 42.79)"
                  fill="#969696"
                />
                <circle id="Ellipse_61559" data-name="Ellipse 61559" cx="0.56" cy="0.56" r="0.56" transform="translate(151.4 39)" fill="#969696" />
                <circle
                  id="Ellipse_61560"
                  data-name="Ellipse 61560"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.07 42.01)"
                  fill="#969696"
                />
                <circle id="Ellipse_61561" data-name="Ellipse 61561" cx="0.56" cy="0.56" r="0.56" transform="translate(154.48 38.6)" fill="#969696" />
                <circle
                  id="Ellipse_61562"
                  data-name="Ellipse 61562"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(119.21 47.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61563"
                  data-name="Ellipse 61563"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(120.56 43.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61564"
                  data-name="Ellipse 61564"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(122.22 46.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61565"
                  data-name="Ellipse 61565"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.63 42.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61566"
                  data-name="Ellipse 61566"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(102.11 65.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61567"
                  data-name="Ellipse 61567"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.46 61.39)"
                  fill="#969696"
                />
                <circle id="Ellipse_61568" data-name="Ellipse 61568" cx="0.56" cy="0.56" r="0.56" transform="translate(105.13 64.4)" fill="#969696" />
                <circle
                  id="Ellipse_61569"
                  data-name="Ellipse 61569"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(106.54 60.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61570"
                  data-name="Ellipse 61570"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.68 66.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61571"
                  data-name="Ellipse 61571"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.03 62.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61572"
                  data-name="Ellipse 61572"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(144.69 65.38)"
                  fill="#969696"
                />
                <circle id="Ellipse_61573" data-name="Ellipse 61573" cx="0.56" cy="0.56" r="0.56" transform="translate(146.1 61.97)" fill="#969696" />
                <circle
                  id="Ellipse_61574"
                  data-name="Ellipse 61574"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(147.54 31.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61575"
                  data-name="Ellipse 61575"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.89 28.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61576"
                  data-name="Ellipse 61576"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(150.55 31.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61577"
                  data-name="Ellipse 61577"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.96 27.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61578"
                  data-name="Ellipse 61578"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(152.34 68.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61579"
                  data-name="Ellipse 61579"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(153.69 64.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61580"
                  data-name="Ellipse 61580"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(167.88 70.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61581"
                  data-name="Ellipse 61581"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(169.55 73.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61582"
                  data-name="Ellipse 61582"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(170.96 70.58)"
                  fill="#969696"
                />
                <circle id="Ellipse_61583" data-name="Ellipse 61583" cx="0.56" cy="0.56" r="0.56" transform="translate(172.9 72.95)" fill="#969696" />
                <circle
                  id="Ellipse_61584"
                  data-name="Ellipse 61584"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.82 60.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_61585" data-name="Ellipse 61585" cx="0.56" cy="0.56" r="0.56" transform="translate(133.49 63.9)" fill="#969696" />
                <circle id="Ellipse_61586" data-name="Ellipse 61586" cx="0.56" cy="0.56" r="0.56" transform="translate(134.9 60.49)" fill="#969696" />
                <circle
                  id="Ellipse_61587"
                  data-name="Ellipse 61587"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(136.84 62.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61588"
                  data-name="Ellipse 61588"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.48 49.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61589"
                  data-name="Ellipse 61589"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.15 52.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61590"
                  data-name="Ellipse 61590"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.56 48.66)"
                  fill="#969696"
                />
                <circle id="Ellipse_61591" data-name="Ellipse 61591" cx="0.56" cy="0.56" r="0.56" transform="translate(161.5 51.03)" fill="#969696" />
                <circle
                  id="Ellipse_61592"
                  data-name="Ellipse 61592"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.68 86.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61593"
                  data-name="Ellipse 61593"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.35 89.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61594"
                  data-name="Ellipse 61594"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.76 85.62)"
                  fill="#969696"
                />
                <circle id="Ellipse_61595" data-name="Ellipse 61595" cx="0.56" cy="0.56" r="0.56" transform="translate(163.7 87.99)" fill="#969696" />
                <circle
                  id="Ellipse_61596"
                  data-name="Ellipse 61596"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.44 90.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_61597" data-name="Ellipse 61597" cx="0.56" cy="0.56" r="0.56" transform="translate(177.11 93.7)" fill="#969696" />
                <circle
                  id="Ellipse_61598"
                  data-name="Ellipse 61598"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(178.52 90.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61599"
                  data-name="Ellipse 61599"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.46 92.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61600"
                  data-name="Ellipse 61600"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(188.71 107.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61601"
                  data-name="Ellipse 61601"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.38 110.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61602"
                  data-name="Ellipse 61602"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(191.79 106.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61603"
                  data-name="Ellipse 61603"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(193.73 109.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61604"
                  data-name="Ellipse 61604"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.38 135.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61605"
                  data-name="Ellipse 61605"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(148.05 138.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61606"
                  data-name="Ellipse 61606"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(149.46 134.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61607"
                  data-name="Ellipse 61607"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(151.4 137.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_61608" data-name="Ellipse 61608" cx="0.56" cy="0.56" r="0.56" transform="translate(187.5 159.7)" fill="#969696" />
                <circle
                  id="Ellipse_61609"
                  data-name="Ellipse 61609"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(189.17 162.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61610"
                  data-name="Ellipse 61610"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(190.58 159.3)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61611"
                  data-name="Ellipse 61611"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(192.52 161.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61612"
                  data-name="Ellipse 61612"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(229.99 136.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61613"
                  data-name="Ellipse 61613"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(231.66 139.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61614"
                  data-name="Ellipse 61614"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.07 136.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61615"
                  data-name="Ellipse 61615"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.01 138.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_61616" data-name="Ellipse 61616" cx="0.56" cy="0.56" r="0.56" transform="translate(240.73 88.6)" fill="#969696" />
                <circle
                  id="Ellipse_61617"
                  data-name="Ellipse 61617"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.39 91.61)"
                  fill="#969696"
                />
                <circle id="Ellipse_61618" data-name="Ellipse 61618" cx="0.56" cy="0.56" r="0.56" transform="translate(243.8 88.2)" fill="#969696" />
                <circle
                  id="Ellipse_61619"
                  data-name="Ellipse 61619"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(245.75 90.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61620"
                  data-name="Ellipse 61620"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.78 59.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61621"
                  data-name="Ellipse 61621"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.44 62.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61622"
                  data-name="Ellipse 61622"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.85 59.46)"
                  fill="#969696"
                />
                <circle id="Ellipse_61623" data-name="Ellipse 61623" cx="0.56" cy="0.56" r="0.56" transform="translate(285.8 61.83)" fill="#969696" />
                <circle
                  id="Ellipse_61624"
                  data-name="Ellipse 61624"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.79 94.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61625"
                  data-name="Ellipse 61625"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.46 97.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61626"
                  data-name="Ellipse 61626"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.87 94.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61627"
                  data-name="Ellipse 61627"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.81 96.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61628"
                  data-name="Ellipse 61628"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.42 30.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61629"
                  data-name="Ellipse 61629"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.09 33.54)"
                  fill="#969696"
                />
                <circle id="Ellipse_61630" data-name="Ellipse 61630" cx="0.56" cy="0.56" r="0.56" transform="translate(303.5 30.13)" fill="#969696" />
                <circle id="Ellipse_61631" data-name="Ellipse 61631" cx="0.56" cy="0.56" r="0.56" transform="translate(305.44 32.5)" fill="#969696" />
                <circle
                  id="Ellipse_61632"
                  data-name="Ellipse 61632"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.25 -0.07)"
                  fill="#969696"
                />
                <circle id="Ellipse_61633" data-name="Ellipse 61633" cx="0.56" cy="0.56" r="0.56" transform="translate(311.91 2.94)" fill="#969696" />
                <circle
                  id="Ellipse_61634"
                  data-name="Ellipse 61634"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.32 -0.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_61635" data-name="Ellipse 61635" cx="0.56" cy="0.56" r="0.56" transform="translate(315.27 1.9)" fill="#969696" />
                <circle
                  id="Ellipse_61636"
                  data-name="Ellipse 61636"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.33 22.96)"
                  fill="#969696"
                />
                <circle id="Ellipse_61637" data-name="Ellipse 61637" cx="0.56" cy="0.56" r="0.56" transform="translate(266 25.98)" fill="#969696" />
                <circle
                  id="Ellipse_61638"
                  data-name="Ellipse 61638"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.41 22.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61639"
                  data-name="Ellipse 61639"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.35 24.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61640"
                  data-name="Ellipse 61640"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.55 22.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61641"
                  data-name="Ellipse 61641"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.22 25.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61642"
                  data-name="Ellipse 61642"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.63 22.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61643"
                  data-name="Ellipse 61643"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.57 24.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61644"
                  data-name="Ellipse 61644"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.08 14.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61645"
                  data-name="Ellipse 61645"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(234.74 17.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61646"
                  data-name="Ellipse 61646"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(236.15 14.46)"
                  fill="#969696"
                />
                <circle id="Ellipse_61647" data-name="Ellipse 61647" cx="0.56" cy="0.56" r="0.56" transform="translate(238.1 16.83)" fill="#969696" />
                <circle id="Ellipse_61648" data-name="Ellipse 61648" cx="0.56" cy="0.56" r="0.56" transform="translate(198.07 7.46)" fill="#969696" />
                <circle
                  id="Ellipse_61649"
                  data-name="Ellipse 61649"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(199.74 10.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_61650" data-name="Ellipse 61650" cx="0.56" cy="0.56" r="0.56" transform="translate(201.15 7.06)" fill="#969696" />
                <circle id="Ellipse_61651" data-name="Ellipse 61651" cx="0.56" cy="0.56" r="0.56" transform="translate(203.09 9.43)" fill="#969696" />
                <circle id="Ellipse_61652" data-name="Ellipse 61652" cx="0.56" cy="0.56" r="0.56" transform="translate(207.84 2.49)" fill="#969696" />
                <circle id="Ellipse_61653" data-name="Ellipse 61653" cx="0.56" cy="0.56" r="0.56" transform="translate(209.51 5.5)" fill="#969696" />
                <circle id="Ellipse_61654" data-name="Ellipse 61654" cx="0.56" cy="0.56" r="0.56" transform="translate(210.92 2.09)" fill="#969696" />
                <circle id="Ellipse_61655" data-name="Ellipse 61655" cx="0.56" cy="0.56" r="0.56" transform="translate(212.86 4.46)" fill="#969696" />
                <circle
                  id="Ellipse_61656"
                  data-name="Ellipse 61656"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(168.27 -0.97)"
                  fill="#969696"
                />
                <circle id="Ellipse_61657" data-name="Ellipse 61657" cx="0.56" cy="0.56" r="0.56" transform="translate(169.94 2.04)" fill="#969696" />
                <circle id="Ellipse_61658" data-name="Ellipse 61658" cx="0.56" cy="0.56" r="0.56" transform="translate(173.29 1)" fill="#969696" />
                <circle id="Ellipse_61659" data-name="Ellipse 61659" cx="0.56" cy="0.56" r="0.56" transform="translate(81.04 14.97)" fill="#969696" />
                <circle id="Ellipse_61660" data-name="Ellipse 61660" cx="0.56" cy="0.56" r="0.56" transform="translate(82.71 17.98)" fill="#969696" />
                <circle id="Ellipse_61661" data-name="Ellipse 61661" cx="0.56" cy="0.56" r="0.56" transform="translate(84.12 14.57)" fill="#969696" />
                <circle id="Ellipse_61662" data-name="Ellipse 61662" cx="0.56" cy="0.56" r="0.56" transform="translate(86.06 16.94)" fill="#969696" />
                <circle
                  id="Ellipse_61663"
                  data-name="Ellipse 61663"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(155.36 67.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61664"
                  data-name="Ellipse 61664"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(156.77 64.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61665"
                  data-name="Ellipse 61665"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.93 200.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61666"
                  data-name="Ellipse 61666"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.59 203.29)"
                  fill="#969696"
                />
                <circle id="Ellipse_61667" data-name="Ellipse 61667" cx="0.56" cy="0.56" r="0.56" transform="translate(285 199.88)" fill="#969696" />
                <circle
                  id="Ellipse_61668"
                  data-name="Ellipse 61668"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.79 198.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61669"
                  data-name="Ellipse 61669"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.79 192.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61670"
                  data-name="Ellipse 61670"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.45 195.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61671"
                  data-name="Ellipse 61671"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.86 192.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61672"
                  data-name="Ellipse 61672"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.49 203.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61673"
                  data-name="Ellipse 61673"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.49 197.98)"
                  fill="#969696"
                />
                <circle id="Ellipse_61674" data-name="Ellipse 61674" cx="0.56" cy="0.56" r="0.56" transform="translate(289.15 201)" fill="#969696" />
                <circle
                  id="Ellipse_61675"
                  data-name="Ellipse 61675"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.56 197.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61676"
                  data-name="Ellipse 61676"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.52 193.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61677"
                  data-name="Ellipse 61677"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.52 187.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61678"
                  data-name="Ellipse 61678"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.19 190.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61679"
                  data-name="Ellipse 61679"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.6 187.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61680"
                  data-name="Ellipse 61680"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.43 201.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61681"
                  data-name="Ellipse 61681"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.43 196.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61682"
                  data-name="Ellipse 61682"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.09 199.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61683"
                  data-name="Ellipse 61683"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.5 195.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61684"
                  data-name="Ellipse 61684"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.48 191.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61685"
                  data-name="Ellipse 61685"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.48 185.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61686"
                  data-name="Ellipse 61686"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.14 188.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61687"
                  data-name="Ellipse 61687"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.55 185.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61688"
                  data-name="Ellipse 61688"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.34 183.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61689"
                  data-name="Ellipse 61689"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.34 178.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61690"
                  data-name="Ellipse 61690"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.87 192.74)"
                  fill="#969696"
                />
                <circle id="Ellipse_61691" data-name="Ellipse 61691" cx="0.56" cy="0.56" r="0.56" transform="translate(300 194.32)" fill="#969696" />
                <circle
                  id="Ellipse_61692"
                  data-name="Ellipse 61692"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.67 186.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61693"
                  data-name="Ellipse 61693"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.8 187.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61694"
                  data-name="Ellipse 61694"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.8 194.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61695"
                  data-name="Ellipse 61695"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.92 196.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61696"
                  data-name="Ellipse 61696"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.85 196.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61697"
                  data-name="Ellipse 61697"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.98 198.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61698"
                  data-name="Ellipse 61698"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.97 198.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61699"
                  data-name="Ellipse 61699"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.09 199.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61700"
                  data-name="Ellipse 61700"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(204.6 201.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61701"
                  data-name="Ellipse 61701"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.73 203.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61702"
                  data-name="Ellipse 61702"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.96 179.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61703"
                  data-name="Ellipse 61703"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(187.09 181.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61704"
                  data-name="Ellipse 61704"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(203.9 182.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61705"
                  data-name="Ellipse 61705"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(205.03 184.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61706"
                  data-name="Ellipse 61706"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.73 176.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61707"
                  data-name="Ellipse 61707"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(215.86 178.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61708"
                  data-name="Ellipse 61708"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.92 169.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61709"
                  data-name="Ellipse 61709"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(219.05 170.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61710"
                  data-name="Ellipse 61710"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.95 173.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61711"
                  data-name="Ellipse 61711"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(235.08 175.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61712"
                  data-name="Ellipse 61712"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(248.99 159.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61713"
                  data-name="Ellipse 61713"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(250.11 161.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61714"
                  data-name="Ellipse 61714"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(232.76 154.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61715"
                  data-name="Ellipse 61715"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(233.89 156.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61716"
                  data-name="Ellipse 61716"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.46 140.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61717"
                  data-name="Ellipse 61717"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.59 142.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61718"
                  data-name="Ellipse 61718"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(255.45 155.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61719"
                  data-name="Ellipse 61719"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.58 157.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61720"
                  data-name="Ellipse 61720"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.87 166.36)"
                  fill="#969696"
                />
                <circle id="Ellipse_61721" data-name="Ellipse 61721" cx="0.56" cy="0.56" r="0.56" transform="translate(224 167.95)" fill="#969696" />
                <circle
                  id="Ellipse_61722"
                  data-name="Ellipse 61722"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(246.04 166.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61723"
                  data-name="Ellipse 61723"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(247.16 168.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61724"
                  data-name="Ellipse 61724"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.28 159.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61725"
                  data-name="Ellipse 61725"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(244.4 160.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61726"
                  data-name="Ellipse 61726"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(242.52 152.66)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61727"
                  data-name="Ellipse 61727"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(243.64 154.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61728"
                  data-name="Ellipse 61728"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(264.4 145.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61729"
                  data-name="Ellipse 61729"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(265.53 146.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61730"
                  data-name="Ellipse 61730"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(222.82 146.67)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61731"
                  data-name="Ellipse 61731"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(223.95 148.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61732"
                  data-name="Ellipse 61732"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.21 126.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61733"
                  data-name="Ellipse 61733"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.34 128.03)"
                  fill="#969696"
                />
                <circle id="Ellipse_61734" data-name="Ellipse 61734" cx="0.56" cy="0.56" r="0.56" transform="translate(253.6 124.5)" fill="#969696" />
                <circle
                  id="Ellipse_61735"
                  data-name="Ellipse 61735"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.73 126.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61736"
                  data-name="Ellipse 61736"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(226.96 123.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61737"
                  data-name="Ellipse 61737"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.09 125.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61738"
                  data-name="Ellipse 61738"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(237.66 132.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61739"
                  data-name="Ellipse 61739"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(238.79 134.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61740"
                  data-name="Ellipse 61740"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(227.34 102.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61741"
                  data-name="Ellipse 61741"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(228.47 103.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61742"
                  data-name="Ellipse 61742"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(213.69 130.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61743"
                  data-name="Ellipse 61743"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(214.82 132.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61744"
                  data-name="Ellipse 61744"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(209.12 147.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61745"
                  data-name="Ellipse 61745"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(210.25 149.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61746"
                  data-name="Ellipse 61746"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(216.45 149.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61747"
                  data-name="Ellipse 61747"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(217.57 151.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61748"
                  data-name="Ellipse 61748"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(184.34 141.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61749"
                  data-name="Ellipse 61749"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(185.46 143.4)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61750"
                  data-name="Ellipse 61750"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(179.34 123.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61751"
                  data-name="Ellipse 61751"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.47 124.8)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61752"
                  data-name="Ellipse 61752"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(176.63 141.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61753"
                  data-name="Ellipse 61753"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(177.76 142.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61754"
                  data-name="Ellipse 61754"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(159.08 131.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61755"
                  data-name="Ellipse 61755"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.2 133.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61756"
                  data-name="Ellipse 61756"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(180.24 147.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61757"
                  data-name="Ellipse 61757"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(181.37 149.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61758"
                  data-name="Ellipse 61758"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(164.88 120.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61759"
                  data-name="Ellipse 61759"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(166.01 121.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61760"
                  data-name="Ellipse 61760"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.93 107.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61761"
                  data-name="Ellipse 61761"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.06 109.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61762"
                  data-name="Ellipse 61762"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(162.45 127.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61763"
                  data-name="Ellipse 61763"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(163.58 129.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61764"
                  data-name="Ellipse 61764"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.76 133.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61765"
                  data-name="Ellipse 61765"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(143.89 135.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61766"
                  data-name="Ellipse 61766"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(160.31 138.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61767"
                  data-name="Ellipse 61767"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(161.44 139.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61768"
                  data-name="Ellipse 61768"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(174.2 104.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61769"
                  data-name="Ellipse 61769"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(175.33 106.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61770"
                  data-name="Ellipse 61770"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(145.52 82.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61771"
                  data-name="Ellipse 61771"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(146.65 83.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61772"
                  data-name="Ellipse 61772"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(158.55 67.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_61773" data-name="Ellipse 61773" cx="0.56" cy="0.56" r="0.56" transform="translate(159.68 69)" fill="#969696" />
                <circle
                  id="Ellipse_61774"
                  data-name="Ellipse 61774"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(129.58 77.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61775"
                  data-name="Ellipse 61775"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.71 78.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61776"
                  data-name="Ellipse 61776"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.63 89.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61777"
                  data-name="Ellipse 61777"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.76 91.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61778"
                  data-name="Ellipse 61778"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(123.44 94.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61779"
                  data-name="Ellipse 61779"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(124.57 95.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61780"
                  data-name="Ellipse 61780"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(130.58 94.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61781"
                  data-name="Ellipse 61781"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(131.71 95.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61782"
                  data-name="Ellipse 61782"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(141.62 90.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61783"
                  data-name="Ellipse 61783"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(142.74 92.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61784"
                  data-name="Ellipse 61784"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.19 69.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61785"
                  data-name="Ellipse 61785"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.32 71.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61786"
                  data-name="Ellipse 61786"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(125.82 58.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_61787" data-name="Ellipse 61787" cx="0.56" cy="0.56" r="0.56" transform="translate(126.95 60.1)" fill="#969696" />
                <circle
                  id="Ellipse_61788"
                  data-name="Ellipse 61788"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.29 45.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61789"
                  data-name="Ellipse 61789"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.41 46.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61790"
                  data-name="Ellipse 61790"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(126.63 41.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61791"
                  data-name="Ellipse 61791"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(127.76 43.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61792"
                  data-name="Ellipse 61792"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(115.45 31.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61793"
                  data-name="Ellipse 61793"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(116.58 33.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61794"
                  data-name="Ellipse 61794"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(112.93 23.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61795"
                  data-name="Ellipse 61795"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(114.06 25.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61796"
                  data-name="Ellipse 61796"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(139.33 26.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61797"
                  data-name="Ellipse 61797"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(140.46 28.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61798"
                  data-name="Ellipse 61798"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(103.65 37.92)"
                  fill="#969696"
                />
                <circle id="Ellipse_61799" data-name="Ellipse 61799" cx="0.56" cy="0.56" r="0.56" transform="translate(104.78 39.5)" fill="#969696" />
                <circle id="Ellipse_61800" data-name="Ellipse 61800" cx="0.56" cy="0.56" r="0.56" transform="translate(88.91 35.02)" fill="#969696" />
                <circle id="Ellipse_61801" data-name="Ellipse 61801" cx="0.56" cy="0.56" r="0.56" transform="translate(90.03 36.6)" fill="#969696" />
                <circle id="Ellipse_61802" data-name="Ellipse 61802" cx="0.56" cy="0.56" r="0.56" transform="translate(96.9 17.7)" fill="#969696" />
                <circle id="Ellipse_61803" data-name="Ellipse 61803" cx="0.56" cy="0.56" r="0.56" transform="translate(98.03 19.29)" fill="#969696" />
                <circle id="Ellipse_61804" data-name="Ellipse 61804" cx="0.56" cy="0.56" r="0.56" transform="translate(115.4 5.66)" fill="#969696" />
                <circle id="Ellipse_61805" data-name="Ellipse 61805" cx="0.56" cy="0.56" r="0.56" transform="translate(116.53 7.25)" fill="#969696" />
                <circle id="Ellipse_61806" data-name="Ellipse 61806" cx="0.56" cy="0.56" r="0.56" transform="translate(102.56 2.76)" fill="#969696" />
                <circle id="Ellipse_61807" data-name="Ellipse 61807" cx="0.56" cy="0.56" r="0.56" transform="translate(103.69 4.35)" fill="#969696" />
                <circle id="Ellipse_61808" data-name="Ellipse 61808" cx="0.56" cy="0.56" r="0.56" transform="translate(86.13 -0.31)" fill="#969696" />
                <circle id="Ellipse_61809" data-name="Ellipse 61809" cx="0.56" cy="0.56" r="0.56" transform="translate(118.59 5.47)" fill="#969696" />
                <circle id="Ellipse_61810" data-name="Ellipse 61810" cx="0.56" cy="0.56" r="0.56" transform="translate(119.72 7.06)" fill="#969696" />
                <circle id="Ellipse_61811" data-name="Ellipse 61811" cx="0.56" cy="0.56" r="0.56" transform="translate(99.61 8.76)" fill="#969696" />
                <circle
                  id="Ellipse_61812"
                  data-name="Ellipse 61812"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(100.74 10.34)"
                  fill="#969696"
                />
                <circle id="Ellipse_61813" data-name="Ellipse 61813" cx="0.56" cy="0.56" r="0.56" transform="translate(128.72 0.81)" fill="#969696" />
                <circle id="Ellipse_61814" data-name="Ellipse 61814" cx="0.56" cy="0.56" r="0.56" transform="translate(129.85 2.4)" fill="#969696" />
                <circle id="Ellipse_61815" data-name="Ellipse 61815" cx="0.56" cy="0.56" r="0.56" transform="translate(82.02 4.9)" fill="#969696" />
                <circle id="Ellipse_61816" data-name="Ellipse 61816" cx="0.56" cy="0.56" r="0.56" transform="translate(83.15 6.49)" fill="#969696" />
                <circle id="Ellipse_61817" data-name="Ellipse 61817" cx="0.56" cy="0.56" r="0.56" transform="translate(62.94 10.28)" fill="#969696" />
                <circle id="Ellipse_61818" data-name="Ellipse 61818" cx="0.56" cy="0.56" r="0.56" transform="translate(64.07 11.87)" fill="#969696" />
                <circle id="Ellipse_61819" data-name="Ellipse 61819" cx="0.56" cy="0.56" r="0.56" transform="translate(53.57 5.38)" fill="#969696" />
                <circle id="Ellipse_61820" data-name="Ellipse 61820" cx="0.56" cy="0.56" r="0.56" transform="translate(54.7 6.97)" fill="#969696" />
                <circle id="Ellipse_61821" data-name="Ellipse 61821" cx="0.56" cy="0.56" r="0.56" transform="translate(36.59 1.29)" fill="#969696" />
                <circle id="Ellipse_61822" data-name="Ellipse 61822" cx="0.56" cy="0.56" r="0.56" transform="translate(37.72 2.87)" fill="#969696" />
                <circle id="Ellipse_61823" data-name="Ellipse 61823" cx="0.56" cy="0.56" r="0.56" transform="translate(32.97 9.04)" fill="#969696" />
                <circle id="Ellipse_61824" data-name="Ellipse 61824" cx="0.56" cy="0.56" r="0.56" transform="translate(34.1 10.63)" fill="#969696" />
                <circle id="Ellipse_61825" data-name="Ellipse 61825" cx="0.56" cy="0.56" r="0.56" transform="translate(48.95 14.85)" fill="#969696" />
                <circle id="Ellipse_61826" data-name="Ellipse 61826" cx="0.56" cy="0.56" r="0.56" transform="translate(50.07 16.43)" fill="#969696" />
                <circle id="Ellipse_61827" data-name="Ellipse 61827" cx="0.56" cy="0.56" r="0.56" transform="translate(37.67 20.46)" fill="#969696" />
                <circle id="Ellipse_61828" data-name="Ellipse 61828" cx="0.56" cy="0.56" r="0.56" transform="translate(38.8 22.05)" fill="#969696" />
                <circle id="Ellipse_61829" data-name="Ellipse 61829" cx="0.56" cy="0.56" r="0.56" transform="translate(64.46 19.46)" fill="#969696" />
                <circle id="Ellipse_61830" data-name="Ellipse 61830" cx="0.56" cy="0.56" r="0.56" transform="translate(65.58 21.05)" fill="#969696" />
                <circle id="Ellipse_61831" data-name="Ellipse 61831" cx="0.56" cy="0.56" r="0.56" transform="translate(31.49 16.56)" fill="#969696" />
                <circle id="Ellipse_61832" data-name="Ellipse 61832" cx="0.56" cy="0.56" r="0.56" transform="translate(32.62 18.14)" fill="#969696" />
                <circle id="Ellipse_61833" data-name="Ellipse 61833" cx="0.56" cy="0.56" r="0.56" transform="translate(36.44 26.22)" fill="#969696" />
                <circle id="Ellipse_61834" data-name="Ellipse 61834" cx="0.56" cy="0.56" r="0.56" transform="translate(37.56 27.8)" fill="#969696" />
                <circle id="Ellipse_61835" data-name="Ellipse 61835" cx="0.56" cy="0.56" r="0.56" transform="translate(33.87 33.87)" fill="#969696" />
                <circle id="Ellipse_61836" data-name="Ellipse 61836" cx="0.56" cy="0.56" r="0.56" transform="translate(34.99 35.46)" fill="#969696" />
                <circle id="Ellipse_61837" data-name="Ellipse 61837" cx="0.56" cy="0.56" r="0.56" transform="translate(50.99 44.1)" fill="#969696" />
                <circle id="Ellipse_61838" data-name="Ellipse 61838" cx="0.56" cy="0.56" r="0.56" transform="translate(52.12 45.69)" fill="#969696" />
                <circle id="Ellipse_61839" data-name="Ellipse 61839" cx="0.56" cy="0.56" r="0.56" transform="translate(75.35 48.15)" fill="#969696" />
                <circle id="Ellipse_61840" data-name="Ellipse 61840" cx="0.56" cy="0.56" r="0.56" transform="translate(76.48 49.73)" fill="#969696" />
                <circle id="Ellipse_61841" data-name="Ellipse 61841" cx="0.56" cy="0.56" r="0.56" transform="translate(66.74 45.15)" fill="#969696" />
                <circle id="Ellipse_61842" data-name="Ellipse 61842" cx="0.56" cy="0.56" r="0.56" transform="translate(67.87 46.73)" fill="#969696" />
                <circle id="Ellipse_61843" data-name="Ellipse 61843" cx="0.56" cy="0.56" r="0.56" transform="translate(57.18 61.28)" fill="#969696" />
                <circle id="Ellipse_61844" data-name="Ellipse 61844" cx="0.56" cy="0.56" r="0.56" transform="translate(58.3 62.86)" fill="#969696" />
                <circle id="Ellipse_61845" data-name="Ellipse 61845" cx="0.56" cy="0.56" r="0.56" transform="translate(55.08 74.69)" fill="#969696" />
                <circle id="Ellipse_61846" data-name="Ellipse 61846" cx="0.56" cy="0.56" r="0.56" transform="translate(56.21 76.28)" fill="#969696" />
                <circle id="Ellipse_61847" data-name="Ellipse 61847" cx="0.56" cy="0.56" r="0.56" transform="translate(70.02 54.24)" fill="#969696" />
                <circle id="Ellipse_61848" data-name="Ellipse 61848" cx="0.56" cy="0.56" r="0.56" transform="translate(71.15 55.82)" fill="#969696" />
                <circle id="Ellipse_61849" data-name="Ellipse 61849" cx="0.56" cy="0.56" r="0.56" transform="translate(41.24 80.78)" fill="#969696" />
                <circle id="Ellipse_61850" data-name="Ellipse 61850" cx="0.56" cy="0.56" r="0.56" transform="translate(42.37 82.37)" fill="#969696" />
                <circle id="Ellipse_61851" data-name="Ellipse 61851" cx="0.56" cy="0.56" r="0.56" transform="translate(36.82 74.83)" fill="#969696" />
                <circle id="Ellipse_61852" data-name="Ellipse 61852" cx="0.56" cy="0.56" r="0.56" transform="translate(37.94 76.42)" fill="#969696" />
                <circle id="Ellipse_61853" data-name="Ellipse 61853" cx="0.56" cy="0.56" r="0.56" transform="translate(59.03 85.63)" fill="#969696" />
                <circle id="Ellipse_61854" data-name="Ellipse 61854" cx="0.56" cy="0.56" r="0.56" transform="translate(60.16 87.22)" fill="#969696" />
                <circle id="Ellipse_61855" data-name="Ellipse 61855" cx="0.56" cy="0.56" r="0.56" transform="translate(46.95 92.86)" fill="#969696" />
                <circle id="Ellipse_61856" data-name="Ellipse 61856" cx="0.56" cy="0.56" r="0.56" transform="translate(48.08 94.45)" fill="#969696" />
                <circle id="Ellipse_61857" data-name="Ellipse 61857" cx="0.56" cy="0.56" r="0.56" transform="translate(299 181.07)" fill="#969696" />
                <circle
                  id="Ellipse_61858"
                  data-name="Ellipse 61858"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.41 177.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61859"
                  data-name="Ellipse 61859"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.04 189.11)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61860"
                  data-name="Ellipse 61860"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.04 183.48)"
                  fill="#969696"
                />
                <circle id="Ellipse_61861" data-name="Ellipse 61861" cx="0.56" cy="0.56" r="0.56" transform="translate(302.7 186.5)" fill="#969696" />
                <circle
                  id="Ellipse_61862"
                  data-name="Ellipse 61862"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(304.11 183.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61863"
                  data-name="Ellipse 61863"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.07 179.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61864"
                  data-name="Ellipse 61864"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.07 173.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61865"
                  data-name="Ellipse 61865"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(304.74 176.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61866"
                  data-name="Ellipse 61866"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.15 173.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61867"
                  data-name="Ellipse 61867"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.98 187.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61868"
                  data-name="Ellipse 61868"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.98 181.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61869"
                  data-name="Ellipse 61869"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.65 184.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61870"
                  data-name="Ellipse 61870"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.06 181.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61871"
                  data-name="Ellipse 61871"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.59 203.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61872"
                  data-name="Ellipse 61872"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.66 202.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61873"
                  data-name="Ellipse 61873"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.45 201.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61874"
                  data-name="Ellipse 61874"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.45 195.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61875"
                  data-name="Ellipse 61875"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.11 198.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61876"
                  data-name="Ellipse 61876"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.52 195.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61877"
                  data-name="Ellipse 61877"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(304.15 200.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61878"
                  data-name="Ellipse 61878"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.81 203.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61879"
                  data-name="Ellipse 61879"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.22 200.5)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61880"
                  data-name="Ellipse 61880"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.18 196.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61881"
                  data-name="Ellipse 61881"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.18 190.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61882"
                  data-name="Ellipse 61882"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.85 193.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61883"
                  data-name="Ellipse 61883"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.26 190.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61884"
                  data-name="Ellipse 61884"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.09 198.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61885"
                  data-name="Ellipse 61885"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.76 201.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61886"
                  data-name="Ellipse 61886"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.17 198.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61887"
                  data-name="Ellipse 61887"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.75 195.63)"
                  fill="#969696"
                />
                <circle id="Ellipse_61888" data-name="Ellipse 61888" cx="0.56" cy="0.56" r="0.56" transform="translate(312.75 190)" fill="#969696" />
                <circle
                  id="Ellipse_61889"
                  data-name="Ellipse 61889"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.42 193.02)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61890"
                  data-name="Ellipse 61890"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.83 189.6)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61891"
                  data-name="Ellipse 61891"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.61 187.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61892"
                  data-name="Ellipse 61892"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.61 182.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61893"
                  data-name="Ellipse 61893"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.28 185.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61894"
                  data-name="Ellipse 61894"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.45 168.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61895"
                  data-name="Ellipse 61895"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.63 168.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61896"
                  data-name="Ellipse 61896"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.29 171.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61897"
                  data-name="Ellipse 61897"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.7 168.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61898"
                  data-name="Ellipse 61898"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.48 166.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61899"
                  data-name="Ellipse 61899"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.48 161.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61900"
                  data-name="Ellipse 61900"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.15 164.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61901"
                  data-name="Ellipse 61901"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.56 160.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61902"
                  data-name="Ellipse 61902"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.18 172.1)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61903"
                  data-name="Ellipse 61903"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.18 166.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61904"
                  data-name="Ellipse 61904"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.85 169.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61905"
                  data-name="Ellipse 61905"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.26 166.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61906"
                  data-name="Ellipse 61906"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.22 162.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61907"
                  data-name="Ellipse 61907"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.22 156.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61908"
                  data-name="Ellipse 61908"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.89 159.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61909"
                  data-name="Ellipse 61909"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.3 156.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61910"
                  data-name="Ellipse 61910"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.13 170.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61911"
                  data-name="Ellipse 61911"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.13 164.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61912"
                  data-name="Ellipse 61912"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.79 167.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61913"
                  data-name="Ellipse 61913"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.2 164.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61914"
                  data-name="Ellipse 61914"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.18 159.9)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61915"
                  data-name="Ellipse 61915"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.18 154.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61916"
                  data-name="Ellipse 61916"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.84 157.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61917"
                  data-name="Ellipse 61917"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.25 153.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61918"
                  data-name="Ellipse 61918"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.04 152.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61919"
                  data-name="Ellipse 61919"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.04 146.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61920"
                  data-name="Ellipse 61920"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.7 149.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61921"
                  data-name="Ellipse 61921"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.11 146.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61922"
                  data-name="Ellipse 61922"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.74 157.61)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61923"
                  data-name="Ellipse 61923"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.74 151.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61924"
                  data-name="Ellipse 61924"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.4 154.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61925"
                  data-name="Ellipse 61925"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.77 147.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61926"
                  data-name="Ellipse 61926"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.77 141.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61927"
                  data-name="Ellipse 61927"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.29 177.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61928"
                  data-name="Ellipse 61928"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.29 171.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61929"
                  data-name="Ellipse 61929"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.95 174.7)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61930"
                  data-name="Ellipse 61930"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.36 171.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61931"
                  data-name="Ellipse 61931"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.15 169.59)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61932"
                  data-name="Ellipse 61932"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.15 163.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61933"
                  data-name="Ellipse 61933"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.81 166.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61934"
                  data-name="Ellipse 61934"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.22 163.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61935"
                  data-name="Ellipse 61935"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.27 201.71)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61936"
                  data-name="Ellipse 61936"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.73 90.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61937"
                  data-name="Ellipse 61937"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(254.73 84.52)"
                  fill="#969696"
                />
                <circle id="Ellipse_61938" data-name="Ellipse 61938" cx="0.56" cy="0.56" r="0.56" transform="translate(256.4 87.54)" fill="#969696" />
                <circle
                  id="Ellipse_61939"
                  data-name="Ellipse 61939"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(257.81 84.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61940"
                  data-name="Ellipse 61940"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(256.59 82.43)"
                  fill="#969696"
                />
                <circle id="Ellipse_61941" data-name="Ellipse 61941" cx="0.56" cy="0.56" r="0.56" transform="translate(256.59 76.8)" fill="#969696" />
                <circle
                  id="Ellipse_61942"
                  data-name="Ellipse 61942"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(258.26 79.81)"
                  fill="#969696"
                />
                <circle id="Ellipse_61943" data-name="Ellipse 61943" cx="0.56" cy="0.56" r="0.56" transform="translate(259.67 76.4)" fill="#969696" />
                <circle
                  id="Ellipse_61944"
                  data-name="Ellipse 61944"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.29 87.86)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61945"
                  data-name="Ellipse 61945"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(260.29 82.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61946"
                  data-name="Ellipse 61946"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(261.96 85.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61947"
                  data-name="Ellipse 61947"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.37 81.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61948"
                  data-name="Ellipse 61948"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.33 77.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61949"
                  data-name="Ellipse 61949"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(262.33 72.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61950"
                  data-name="Ellipse 61950"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(263.99 75.23)"
                  fill="#969696"
                />
                <circle id="Ellipse_61951" data-name="Ellipse 61951" cx="0.56" cy="0.56" r="0.56" transform="translate(265.4 71.82)" fill="#969696" />
                <circle id="Ellipse_61952" data-name="Ellipse 61952" cx="0.56" cy="0.56" r="0.56" transform="translate(266.23 85.9)" fill="#969696" />
                <circle
                  id="Ellipse_61953"
                  data-name="Ellipse 61953"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(266.23 80.28)"
                  fill="#969696"
                />
                <circle id="Ellipse_61954" data-name="Ellipse 61954" cx="0.56" cy="0.56" r="0.56" transform="translate(267.9 83.29)" fill="#969696" />
                <circle
                  id="Ellipse_61955"
                  data-name="Ellipse 61955"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.31 79.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61956"
                  data-name="Ellipse 61956"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.28 75.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61957"
                  data-name="Ellipse 61957"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(268.28 70.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61958"
                  data-name="Ellipse 61958"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.95 73.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61959"
                  data-name="Ellipse 61959"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.36 69.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61960"
                  data-name="Ellipse 61960"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.14 67.93)"
                  fill="#969696"
                />
                <circle id="Ellipse_61961" data-name="Ellipse 61961" cx="0.56" cy="0.56" r="0.56" transform="translate(270.14 62.3)" fill="#969696" />
                <circle
                  id="Ellipse_61962"
                  data-name="Ellipse 61962"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.81 65.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_61963" data-name="Ellipse 61963" cx="0.56" cy="0.56" r="0.56" transform="translate(273.22 61.9)" fill="#969696" />
                <circle
                  id="Ellipse_61964"
                  data-name="Ellipse 61964"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.84 73.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61965"
                  data-name="Ellipse 61965"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.84 67.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61966"
                  data-name="Ellipse 61966"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.51 70.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61967"
                  data-name="Ellipse 61967"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.92 67.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61968"
                  data-name="Ellipse 61968"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.88 63.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61969"
                  data-name="Ellipse 61969"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.88 57.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61970"
                  data-name="Ellipse 61970"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(277.54 60.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61971"
                  data-name="Ellipse 61971"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.95 57.32)"
                  fill="#969696"
                />
                <circle id="Ellipse_61972" data-name="Ellipse 61972" cx="0.56" cy="0.56" r="0.56" transform="translate(279.78 71.4)" fill="#969696" />
                <circle
                  id="Ellipse_61973"
                  data-name="Ellipse 61973"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(279.78 65.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61974"
                  data-name="Ellipse 61974"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.45 68.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61975"
                  data-name="Ellipse 61975"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.86 65.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61976"
                  data-name="Ellipse 61976"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.39 93.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61977"
                  data-name="Ellipse 61977"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(271.39 87.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61978"
                  data-name="Ellipse 61978"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.06 90.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61979"
                  data-name="Ellipse 61979"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.47 87.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61980"
                  data-name="Ellipse 61980"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.25 85.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61981"
                  data-name="Ellipse 61981"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(273.25 79.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61982"
                  data-name="Ellipse 61982"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.92 82.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61983"
                  data-name="Ellipse 61983"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.33 79.32)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61984"
                  data-name="Ellipse 61984"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.95 90.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61985"
                  data-name="Ellipse 61985"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.95 85.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61986"
                  data-name="Ellipse 61986"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.62 88.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61987"
                  data-name="Ellipse 61987"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.03 84.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61988"
                  data-name="Ellipse 61988"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.99 80.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61989"
                  data-name="Ellipse 61989"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.99 75.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61990"
                  data-name="Ellipse 61990"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.65 78.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61991"
                  data-name="Ellipse 61991"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.06 74.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61992"
                  data-name="Ellipse 61992"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.89 88.82)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61993"
                  data-name="Ellipse 61993"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.89 83.19)"
                  fill="#969696"
                />
                <circle id="Ellipse_61994" data-name="Ellipse 61994" cx="0.56" cy="0.56" r="0.56" transform="translate(284.56 86.2)" fill="#969696" />
                <circle
                  id="Ellipse_61995"
                  data-name="Ellipse 61995"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.97 82.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61996"
                  data-name="Ellipse 61996"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.56 79.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61997"
                  data-name="Ellipse 61997"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.56 74.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61998"
                  data-name="Ellipse 61998"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.22 77.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_61999"
                  data-name="Ellipse 61999"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.63 73.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62000"
                  data-name="Ellipse 62000"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.42 72.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62001"
                  data-name="Ellipse 62001"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.42 66.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62002"
                  data-name="Ellipse 62002"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.08 69.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62003"
                  data-name="Ellipse 62003"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.49 66.13)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62004"
                  data-name="Ellipse 62004"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.12 77.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62005"
                  data-name="Ellipse 62005"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.12 71.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62006"
                  data-name="Ellipse 62006"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.78 74.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62007"
                  data-name="Ellipse 62007"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.19 71.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62008"
                  data-name="Ellipse 62008"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.15 67.57)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62009"
                  data-name="Ellipse 62009"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.15 61.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62010"
                  data-name="Ellipse 62010"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.82 64.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62011"
                  data-name="Ellipse 62011"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.23 61.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62012"
                  data-name="Ellipse 62012"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.06 75.63)"
                  fill="#969696"
                />
                <circle id="Ellipse_62013" data-name="Ellipse 62013" cx="0.56" cy="0.56" r="0.56" transform="translate(297.06 70)" fill="#969696" />
                <circle
                  id="Ellipse_62014"
                  data-name="Ellipse 62014"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.73 73.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_62015" data-name="Ellipse 62015" cx="0.56" cy="0.56" r="0.56" transform="translate(300.14 69.6)" fill="#969696" />
                <circle
                  id="Ellipse_62016"
                  data-name="Ellipse 62016"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.43 58.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62017"
                  data-name="Ellipse 62017"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(267.43 53.02)"
                  fill="#969696"
                />
                <circle id="Ellipse_62018" data-name="Ellipse 62018" cx="0.56" cy="0.56" r="0.56" transform="translate(269.1 56.03)" fill="#969696" />
                <circle
                  id="Ellipse_62019"
                  data-name="Ellipse 62019"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.51 52.62)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62020"
                  data-name="Ellipse 62020"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(269.29 50.92)"
                  fill="#969696"
                />
                <circle id="Ellipse_62021" data-name="Ellipse 62021" cx="0.56" cy="0.56" r="0.56" transform="translate(269.29 45.3)" fill="#969696" />
                <circle
                  id="Ellipse_62022"
                  data-name="Ellipse 62022"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(270.96 48.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_62023" data-name="Ellipse 62023" cx="0.56" cy="0.56" r="0.56" transform="translate(272.37 44.9)" fill="#969696" />
                <circle
                  id="Ellipse_62024"
                  data-name="Ellipse 62024"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.99 56.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62025"
                  data-name="Ellipse 62025"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(272.99 50.73)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62026"
                  data-name="Ellipse 62026"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(274.66 53.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62027"
                  data-name="Ellipse 62027"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.07 50.33)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62028"
                  data-name="Ellipse 62028"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.02 46.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62029"
                  data-name="Ellipse 62029"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(275.02 40.72)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62030"
                  data-name="Ellipse 62030"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(276.69 43.73)"
                  fill="#969696"
                />
                <circle id="Ellipse_62031" data-name="Ellipse 62031" cx="0.56" cy="0.56" r="0.56" transform="translate(278.1 40.32)" fill="#969696" />
                <circle id="Ellipse_62032" data-name="Ellipse 62032" cx="0.56" cy="0.56" r="0.56" transform="translate(278.93 54.4)" fill="#969696" />
                <circle
                  id="Ellipse_62033"
                  data-name="Ellipse 62033"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.93 48.77)"
                  fill="#969696"
                />
                <circle id="Ellipse_62034" data-name="Ellipse 62034" cx="0.56" cy="0.56" r="0.56" transform="translate(280.6 51.79)" fill="#969696" />
                <circle
                  id="Ellipse_62035"
                  data-name="Ellipse 62035"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.01 48.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62036"
                  data-name="Ellipse 62036"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.98 44.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62037"
                  data-name="Ellipse 62037"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.98 38.52)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62038"
                  data-name="Ellipse 62038"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.65 41.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62039"
                  data-name="Ellipse 62039"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(284.06 38.12)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62040"
                  data-name="Ellipse 62040"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(282.84 36.42)"
                  fill="#969696"
                />
                <circle id="Ellipse_62041" data-name="Ellipse 62041" cx="0.56" cy="0.56" r="0.56" transform="translate(282.84 30.8)" fill="#969696" />
                <circle
                  id="Ellipse_62042"
                  data-name="Ellipse 62042"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(284.51 33.81)"
                  fill="#969696"
                />
                <circle id="Ellipse_62043" data-name="Ellipse 62043" cx="0.56" cy="0.56" r="0.56" transform="translate(285.92 30.4)" fill="#969696" />
                <circle
                  id="Ellipse_62044"
                  data-name="Ellipse 62044"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.54 41.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62045"
                  data-name="Ellipse 62045"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.54 36.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62046"
                  data-name="Ellipse 62046"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.21 39.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62047"
                  data-name="Ellipse 62047"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.62 35.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62048"
                  data-name="Ellipse 62048"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.58 31.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62049"
                  data-name="Ellipse 62049"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.58 26.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62050"
                  data-name="Ellipse 62050"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.24 29.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62051"
                  data-name="Ellipse 62051"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.65 25.82)"
                  fill="#969696"
                />
                <circle id="Ellipse_62052" data-name="Ellipse 62052" cx="0.56" cy="0.56" r="0.56" transform="translate(292.48 39.9)" fill="#969696" />
                <circle
                  id="Ellipse_62053"
                  data-name="Ellipse 62053"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.48 34.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62054"
                  data-name="Ellipse 62054"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.15 37.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62055"
                  data-name="Ellipse 62055"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.56 33.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62056"
                  data-name="Ellipse 62056"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(284.09 61.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62057"
                  data-name="Ellipse 62057"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(284.09 55.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62058"
                  data-name="Ellipse 62058"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.76 58.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62059"
                  data-name="Ellipse 62059"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.17 55.54)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62060"
                  data-name="Ellipse 62060"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.95 53.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62061"
                  data-name="Ellipse 62061"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.95 48.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62062"
                  data-name="Ellipse 62062"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.62 51.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62063"
                  data-name="Ellipse 62063"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.03 47.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62064"
                  data-name="Ellipse 62064"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.65 59.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62065"
                  data-name="Ellipse 62065"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.65 53.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62066"
                  data-name="Ellipse 62066"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.32 56.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62067"
                  data-name="Ellipse 62067"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.73 53.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62068"
                  data-name="Ellipse 62068"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.69 49.25)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62069"
                  data-name="Ellipse 62069"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.69 43.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62070"
                  data-name="Ellipse 62070"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.35 46.64)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62071"
                  data-name="Ellipse 62071"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.76 43.23)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62072"
                  data-name="Ellipse 62072"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.59 57.31)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62073"
                  data-name="Ellipse 62073"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.59 51.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_62074" data-name="Ellipse 62074" cx="0.56" cy="0.56" r="0.56" transform="translate(297.26 54.7)" fill="#969696" />
                <circle
                  id="Ellipse_62075"
                  data-name="Ellipse 62075"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.67 51.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62076"
                  data-name="Ellipse 62076"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.26 48.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62077"
                  data-name="Ellipse 62077"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.26 42.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62078"
                  data-name="Ellipse 62078"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.92 45.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62079"
                  data-name="Ellipse 62079"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.33 42.35)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62080"
                  data-name="Ellipse 62080"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.12 40.65)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62081"
                  data-name="Ellipse 62081"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.12 35.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62082"
                  data-name="Ellipse 62082"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(301.78 38.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62083"
                  data-name="Ellipse 62083"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.19 34.63)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62084"
                  data-name="Ellipse 62084"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.82 46.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62085"
                  data-name="Ellipse 62085"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.82 40.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62086"
                  data-name="Ellipse 62086"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.48 43.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62087"
                  data-name="Ellipse 62087"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.89 40.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62088"
                  data-name="Ellipse 62088"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.85 36.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62089"
                  data-name="Ellipse 62089"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.85 30.44)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62090"
                  data-name="Ellipse 62090"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.52 33.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62091"
                  data-name="Ellipse 62091"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.93 30.04)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62092"
                  data-name="Ellipse 62092"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.76 44.13)"
                  fill="#969696"
                />
                <circle id="Ellipse_62093" data-name="Ellipse 62093" cx="0.56" cy="0.56" r="0.56" transform="translate(309.76 38.5)" fill="#969696" />
                <circle
                  id="Ellipse_62094"
                  data-name="Ellipse 62094"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.42 41.51)"
                  fill="#969696"
                />
                <circle id="Ellipse_62095" data-name="Ellipse 62095" cx="0.56" cy="0.56" r="0.56" transform="translate(312.83 38.1)" fill="#969696" />
                <circle
                  id="Ellipse_62096"
                  data-name="Ellipse 62096"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.75 65.81)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62097"
                  data-name="Ellipse 62097"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.75 60.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62098"
                  data-name="Ellipse 62098"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.41 63.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62099"
                  data-name="Ellipse 62099"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.82 59.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62100"
                  data-name="Ellipse 62100"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.61 58.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62101"
                  data-name="Ellipse 62101"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.61 52.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62102"
                  data-name="Ellipse 62102"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(304.27 55.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62103"
                  data-name="Ellipse 62103"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.68 52.06)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62104"
                  data-name="Ellipse 62104"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.31 63.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62105"
                  data-name="Ellipse 62105"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.31 57.89)"
                  fill="#969696"
                />
                <circle id="Ellipse_62106" data-name="Ellipse 62106" cx="0.56" cy="0.56" r="0.56" transform="translate(307.97 60.9)" fill="#969696" />
                <circle
                  id="Ellipse_62107"
                  data-name="Ellipse 62107"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.38 57.49)"
                  fill="#969696"
                />
                <circle id="Ellipse_62108" data-name="Ellipse 62108" cx="0.56" cy="0.56" r="0.56" transform="translate(308.34 53.5)" fill="#969696" />
                <circle
                  id="Ellipse_62109"
                  data-name="Ellipse 62109"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.34 47.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62110"
                  data-name="Ellipse 62110"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.01 50.89)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62111"
                  data-name="Ellipse 62111"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.42 47.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62112"
                  data-name="Ellipse 62112"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.25 61.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62113"
                  data-name="Ellipse 62113"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.25 55.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62114"
                  data-name="Ellipse 62114"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.92 58.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62115"
                  data-name="Ellipse 62115"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.33 55.53)"
                  fill="#969696"
                />
                <circle id="Ellipse_62116" data-name="Ellipse 62116" cx="0.56" cy="0.56" r="0.56" transform="translate(314.3 51.31)" fill="#969696" />
                <circle id="Ellipse_62117" data-name="Ellipse 62117" cx="0.56" cy="0.56" r="0.56" transform="translate(314.3 45.68)" fill="#969696" />
                <circle
                  id="Ellipse_62118"
                  data-name="Ellipse 62118"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.97 48.69)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62119"
                  data-name="Ellipse 62119"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.16 43.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62120"
                  data-name="Ellipse 62120"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.16 37.96)"
                  fill="#969696"
                />
                <circle id="Ellipse_62121" data-name="Ellipse 62121" cx="0.56" cy="0.56" r="0.56" transform="translate(287.22 99.3)" fill="#969696" />
                <circle
                  id="Ellipse_62122"
                  data-name="Ellipse 62122"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.22 93.68)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62123"
                  data-name="Ellipse 62123"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(288.89 96.69)"
                  fill="#969696"
                />
                <circle id="Ellipse_62124" data-name="Ellipse 62124" cx="0.56" cy="0.56" r="0.56" transform="translate(290.3 93.27)" fill="#969696" />
                <circle
                  id="Ellipse_62125"
                  data-name="Ellipse 62125"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.08 91.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62126"
                  data-name="Ellipse 62126"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.08 85.95)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62127"
                  data-name="Ellipse 62127"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(290.75 88.96)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62128"
                  data-name="Ellipse 62128"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.16 85.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62129"
                  data-name="Ellipse 62129"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.78 97.01)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62130"
                  data-name="Ellipse 62130"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(292.78 91.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62131"
                  data-name="Ellipse 62131"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.45 94.39)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62132"
                  data-name="Ellipse 62132"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.86 90.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62133"
                  data-name="Ellipse 62133"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.82 86.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62134"
                  data-name="Ellipse 62134"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(294.82 81.37)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62135"
                  data-name="Ellipse 62135"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.48 84.38)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62136"
                  data-name="Ellipse 62136"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.89 80.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62137"
                  data-name="Ellipse 62137"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.72 95.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62138"
                  data-name="Ellipse 62138"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.72 89.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62139"
                  data-name="Ellipse 62139"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.39 92.44)"
                  fill="#969696"
                />
                <circle id="Ellipse_62140" data-name="Ellipse 62140" cx="0.56" cy="0.56" r="0.56" transform="translate(301.8 89.03)" fill="#969696" />
                <circle id="Ellipse_62141" data-name="Ellipse 62141" cx="0.56" cy="0.56" r="0.56" transform="translate(300.77 84.8)" fill="#969696" />
                <circle
                  id="Ellipse_62142"
                  data-name="Ellipse 62142"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.77 79.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62143"
                  data-name="Ellipse 62143"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.44 82.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62144"
                  data-name="Ellipse 62144"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.85 78.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62145"
                  data-name="Ellipse 62145"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.63 77.08)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62146"
                  data-name="Ellipse 62146"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.63 71.45)"
                  fill="#969696"
                />
                <circle id="Ellipse_62147" data-name="Ellipse 62147" cx="0.56" cy="0.56" r="0.56" transform="translate(304.3 74.46)" fill="#969696" />
                <circle
                  id="Ellipse_62148"
                  data-name="Ellipse 62148"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.71 71.05)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62149"
                  data-name="Ellipse 62149"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.33 82.51)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62150"
                  data-name="Ellipse 62150"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.33 76.88)"
                  fill="#969696"
                />
                <circle id="Ellipse_62151" data-name="Ellipse 62151" cx="0.56" cy="0.56" r="0.56" transform="translate(308 79.89)" fill="#969696" />
                <circle
                  id="Ellipse_62152"
                  data-name="Ellipse 62152"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.41 76.48)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62153"
                  data-name="Ellipse 62153"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.37 72.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62154"
                  data-name="Ellipse 62154"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.37 66.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62155"
                  data-name="Ellipse 62155"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.03 69.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62156"
                  data-name="Ellipse 62156"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.44 66.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62157"
                  data-name="Ellipse 62157"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.27 80.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62158"
                  data-name="Ellipse 62158"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.27 74.93)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62159"
                  data-name="Ellipse 62159"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(313.94 77.94)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62160"
                  data-name="Ellipse 62160"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.35 74.53)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62161"
                  data-name="Ellipse 62161"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.88 102.21)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62162"
                  data-name="Ellipse 62162"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.88 96.59)"
                  fill="#969696"
                />
                <circle id="Ellipse_62163" data-name="Ellipse 62163" cx="0.56" cy="0.56" r="0.56" transform="translate(305.55 99.6)" fill="#969696" />
                <circle
                  id="Ellipse_62164"
                  data-name="Ellipse 62164"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.96 96.19)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62165"
                  data-name="Ellipse 62165"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.74 94.49)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62166"
                  data-name="Ellipse 62166"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.74 88.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62167"
                  data-name="Ellipse 62167"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.41 91.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62168"
                  data-name="Ellipse 62168"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.82 88.47)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62169"
                  data-name="Ellipse 62169"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.44 99.92)"
                  fill="#969696"
                />
                <circle id="Ellipse_62170" data-name="Ellipse 62170" cx="0.56" cy="0.56" r="0.56" transform="translate(309.44 94.3)" fill="#969696" />
                <circle
                  id="Ellipse_62171"
                  data-name="Ellipse 62171"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.11 97.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_62172" data-name="Ellipse 62172" cx="0.56" cy="0.56" r="0.56" transform="translate(312.52 93.9)" fill="#969696" />
                <circle
                  id="Ellipse_62173"
                  data-name="Ellipse 62173"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.48 89.91)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62174"
                  data-name="Ellipse 62174"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.48 84.28)"
                  fill="#969696"
                />
                <circle id="Ellipse_62175" data-name="Ellipse 62175" cx="0.56" cy="0.56" r="0.56" transform="translate(313.14 87.3)" fill="#969696" />
                <circle
                  id="Ellipse_62176"
                  data-name="Ellipse 62176"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.55 83.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62177"
                  data-name="Ellipse 62177"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.38 97.97)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62178"
                  data-name="Ellipse 62178"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.38 92.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62179"
                  data-name="Ellipse 62179"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.36 28.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62180"
                  data-name="Ellipse 62180"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(278.36 22.55)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62181"
                  data-name="Ellipse 62181"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.03 25.56)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62182"
                  data-name="Ellipse 62182"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.44 22.15)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62183"
                  data-name="Ellipse 62183"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.22 20.45)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62184"
                  data-name="Ellipse 62184"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(280.22 14.83)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62185"
                  data-name="Ellipse 62185"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(281.88 17.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62186"
                  data-name="Ellipse 62186"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.29 14.43)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62187"
                  data-name="Ellipse 62187"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.92 25.88)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62188"
                  data-name="Ellipse 62188"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(283.92 20.26)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62189"
                  data-name="Ellipse 62189"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.58 23.27)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62190"
                  data-name="Ellipse 62190"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(286.99 19.85)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62191"
                  data-name="Ellipse 62191"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.95 15.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62192"
                  data-name="Ellipse 62192"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(285.95 10.24)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62193"
                  data-name="Ellipse 62193"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(287.62 13.25)"
                  fill="#969696"
                />
                <circle id="Ellipse_62194" data-name="Ellipse 62194" cx="0.56" cy="0.56" r="0.56" transform="translate(289.03 9.84)" fill="#969696" />
                <circle
                  id="Ellipse_62195"
                  data-name="Ellipse 62195"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(289.86 23.93)"
                  fill="#969696"
                />
                <circle id="Ellipse_62196" data-name="Ellipse 62196" cx="0.56" cy="0.56" r="0.56" transform="translate(289.86 18.3)" fill="#969696" />
                <circle
                  id="Ellipse_62197"
                  data-name="Ellipse 62197"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.53 21.31)"
                  fill="#969696"
                />
                <circle id="Ellipse_62198" data-name="Ellipse 62198" cx="0.56" cy="0.56" r="0.56" transform="translate(292.94 17.9)" fill="#969696" />
                <circle
                  id="Ellipse_62199"
                  data-name="Ellipse 62199"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(291.91 13.67)"
                  fill="#969696"
                />
                <circle id="Ellipse_62200" data-name="Ellipse 62200" cx="0.56" cy="0.56" r="0.56" transform="translate(291.91 8.05)" fill="#969696" />
                <circle
                  id="Ellipse_62201"
                  data-name="Ellipse 62201"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(293.58 11.06)"
                  fill="#969696"
                />
                <circle id="Ellipse_62202" data-name="Ellipse 62202" cx="0.56" cy="0.56" r="0.56" transform="translate(294.99 7.65)" fill="#969696" />
                <circle id="Ellipse_62203" data-name="Ellipse 62203" cx="0.56" cy="0.56" r="0.56" transform="translate(293.77 5.95)" fill="#969696" />
                <circle id="Ellipse_62204" data-name="Ellipse 62204" cx="0.56" cy="0.56" r="0.56" transform="translate(293.77 0.33)" fill="#969696" />
                <circle id="Ellipse_62205" data-name="Ellipse 62205" cx="0.56" cy="0.56" r="0.56" transform="translate(295.43 3.34)" fill="#969696" />
                <circle
                  id="Ellipse_62206"
                  data-name="Ellipse 62206"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.84 -0.07)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62207"
                  data-name="Ellipse 62207"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(297.47 11.38)"
                  fill="#969696"
                />
                <circle id="Ellipse_62208" data-name="Ellipse 62208" cx="0.56" cy="0.56" r="0.56" transform="translate(297.47 5.76)" fill="#969696" />
                <circle id="Ellipse_62209" data-name="Ellipse 62209" cx="0.56" cy="0.56" r="0.56" transform="translate(299.13 8.77)" fill="#969696" />
                <circle id="Ellipse_62210" data-name="Ellipse 62210" cx="0.56" cy="0.56" r="0.56" transform="translate(300.54 5.36)" fill="#969696" />
                <circle id="Ellipse_62211" data-name="Ellipse 62211" cx="0.56" cy="0.56" r="0.56" transform="translate(299.5 1.37)" fill="#969696" />
                <circle id="Ellipse_62212" data-name="Ellipse 62212" cx="0.56" cy="0.56" r="0.56" transform="translate(303.41 9.43)" fill="#969696" />
                <circle id="Ellipse_62213" data-name="Ellipse 62213" cx="0.56" cy="0.56" r="0.56" transform="translate(303.41 3.8)" fill="#969696" />
                <circle id="Ellipse_62214" data-name="Ellipse 62214" cx="0.56" cy="0.56" r="0.56" transform="translate(305.08 6.81)" fill="#969696" />
                <circle id="Ellipse_62215" data-name="Ellipse 62215" cx="0.56" cy="0.56" r="0.56" transform="translate(306.49 3.4)" fill="#969696" />
                <circle
                  id="Ellipse_62216"
                  data-name="Ellipse 62216"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.02 31.09)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62217"
                  data-name="Ellipse 62217"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(295.02 25.46)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62218"
                  data-name="Ellipse 62218"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.69 28.47)"
                  fill="#969696"
                />
                <circle id="Ellipse_62219" data-name="Ellipse 62219" cx="0.56" cy="0.56" r="0.56" transform="translate(298.1 25.06)" fill="#969696" />
                <circle
                  id="Ellipse_62220"
                  data-name="Ellipse 62220"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.88 23.36)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62221"
                  data-name="Ellipse 62221"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(296.88 17.74)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62222"
                  data-name="Ellipse 62222"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(298.55 20.75)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62223"
                  data-name="Ellipse 62223"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(299.96 17.34)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62224"
                  data-name="Ellipse 62224"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.58 28.79)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62225"
                  data-name="Ellipse 62225"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(300.58 23.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62226"
                  data-name="Ellipse 62226"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.25 26.18)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62227"
                  data-name="Ellipse 62227"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(303.66 22.77)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62228"
                  data-name="Ellipse 62228"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.61 18.78)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62229"
                  data-name="Ellipse 62229"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(302.61 13.16)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62230"
                  data-name="Ellipse 62230"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(304.28 16.17)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62231"
                  data-name="Ellipse 62231"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(305.69 12.76)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62232"
                  data-name="Ellipse 62232"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.52 26.84)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62233"
                  data-name="Ellipse 62233"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(306.52 21.22)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62234"
                  data-name="Ellipse 62234"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(308.19 24.23)"
                  fill="#969696"
                />
                <circle id="Ellipse_62235" data-name="Ellipse 62235" cx="0.56" cy="0.56" r="0.56" transform="translate(309.6 20.82)" fill="#969696" />
                <circle id="Ellipse_62236" data-name="Ellipse 62236" cx="0.56" cy="0.56" r="0.56" transform="translate(309.18 17.9)" fill="#969696" />
                <circle
                  id="Ellipse_62237"
                  data-name="Ellipse 62237"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(309.18 12.28)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62238"
                  data-name="Ellipse 62238"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.85 15.29)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62239"
                  data-name="Ellipse 62239"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.26 11.87)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62240"
                  data-name="Ellipse 62240"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(311.04 10.18)"
                  fill="#969696"
                />
                <circle id="Ellipse_62241" data-name="Ellipse 62241" cx="0.56" cy="0.56" r="0.56" transform="translate(311.04 4.55)" fill="#969696" />
                <circle id="Ellipse_62242" data-name="Ellipse 62242" cx="0.56" cy="0.56" r="0.56" transform="translate(312.71 7.56)" fill="#969696" />
                <circle id="Ellipse_62243" data-name="Ellipse 62243" cx="0.56" cy="0.56" r="0.56" transform="translate(314.12 4.15)" fill="#969696" />
                <circle
                  id="Ellipse_62244"
                  data-name="Ellipse 62244"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.74 15.61)"
                  fill="#969696"
                />
                <circle id="Ellipse_62245" data-name="Ellipse 62245" cx="0.56" cy="0.56" r="0.56" transform="translate(314.74 9.98)" fill="#969696" />
                <circle
                  id="Ellipse_62246"
                  data-name="Ellipse 62246"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.41 12.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62247"
                  data-name="Ellipse 62247"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(307.72 -0.42)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62248"
                  data-name="Ellipse 62248"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(310.85 37.32)"
                  fill="#969696"
                />
                <circle id="Ellipse_62249" data-name="Ellipse 62249" cx="0.56" cy="0.56" r="0.56" transform="translate(310.85 31.7)" fill="#969696" />
                <circle
                  id="Ellipse_62250"
                  data-name="Ellipse 62250"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.51 34.71)"
                  fill="#969696"
                />
                <circle id="Ellipse_62251" data-name="Ellipse 62251" cx="0.56" cy="0.56" r="0.56" transform="translate(313.92 31.3)" fill="#969696" />
                <circle id="Ellipse_62252" data-name="Ellipse 62252" cx="0.56" cy="0.56" r="0.56" transform="translate(312.71 29.6)" fill="#969696" />
                <circle
                  id="Ellipse_62253"
                  data-name="Ellipse 62253"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(312.71 23.98)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62254"
                  data-name="Ellipse 62254"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(314.37 26.99)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62255"
                  data-name="Ellipse 62255"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(315.78 23.58)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62256"
                  data-name="Ellipse 62256"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.41 35.03)"
                  fill="#969696"
                />
                <circle
                  id="Ellipse_62257"
                  data-name="Ellipse 62257"
                  cx="0.56"
                  cy="0.56"
                  r="0.56"
                  transform="translate(316.41 29.41)"
                  fill="#969696"
                />
                <circle id="Ellipse_62258" data-name="Ellipse 62258" cx="0.56" cy="0.56" r="0.56" transform="translate(31.42 8.62)" fill="#969696" />
                <circle id="Ellipse_62259" data-name="Ellipse 62259" cx="0.56" cy="0.56" r="0.56" transform="translate(32.83 5.21)" fill="#969696" />
                <circle id="Ellipse_62260" data-name="Ellipse 62260" cx="0.56" cy="0.56" r="0.56" transform="translate(33.44 1.41)" fill="#969696" />
                <circle id="Ellipse_62261" data-name="Ellipse 62261" cx="0.56" cy="0.56" r="0.56" transform="translate(39 -0.88)" fill="#969696" />
                <circle id="Ellipse_62262" data-name="Ellipse 62262" cx="0.56" cy="0.56" r="0.56" transform="translate(50.1 4.33)" fill="#969696" />
                <circle id="Ellipse_62263" data-name="Ellipse 62263" cx="0.56" cy="0.56" r="0.56" transform="translate(51.77 1.71)" fill="#969696" />
                <circle id="Ellipse_62264" data-name="Ellipse 62264" cx="0.56" cy="0.56" r="0.56" transform="translate(55.66 2.03)" fill="#969696" />
                <circle id="Ellipse_62265" data-name="Ellipse 62265" cx="0.56" cy="0.56" r="0.56" transform="translate(57.33 -0.58)" fill="#969696" />
                <circle id="Ellipse_62266" data-name="Ellipse 62266" cx="0.56" cy="0.56" r="0.56" transform="translate(61.6 0.08)" fill="#969696" />
                <circle id="Ellipse_62267" data-name="Ellipse 62267" cx="0.56" cy="0.56" r="0.56" transform="translate(31.41 30.66)" fill="#969696" />
                <circle id="Ellipse_62268" data-name="Ellipse 62268" cx="0.56" cy="0.56" r="0.56" transform="translate(31.41 25.03)" fill="#969696" />
                <circle id="Ellipse_62269" data-name="Ellipse 62269" cx="0.56" cy="0.56" r="0.56" transform="translate(33.08 28.05)" fill="#969696" />
                <circle id="Ellipse_62270" data-name="Ellipse 62270" cx="0.56" cy="0.56" r="0.56" transform="translate(34.49 24.63)" fill="#969696" />
                <circle id="Ellipse_62271" data-name="Ellipse 62271" cx="0.56" cy="0.56" r="0.56" transform="translate(33.47 20.41)" fill="#969696" />
                <circle id="Ellipse_62272" data-name="Ellipse 62272" cx="0.56" cy="0.56" r="0.56" transform="translate(33.47 14.78)" fill="#969696" />
                <circle id="Ellipse_62273" data-name="Ellipse 62273" cx="0.56" cy="0.56" r="0.56" transform="translate(35.13 17.79)" fill="#969696" />
                <circle id="Ellipse_62274" data-name="Ellipse 62274" cx="0.56" cy="0.56" r="0.56" transform="translate(36.54 14.38)" fill="#969696" />
                <circle id="Ellipse_62275" data-name="Ellipse 62275" cx="0.56" cy="0.56" r="0.56" transform="translate(35.32 12.68)" fill="#969696" />
                <circle id="Ellipse_62276" data-name="Ellipse 62276" cx="0.56" cy="0.56" r="0.56" transform="translate(35.32 7.06)" fill="#969696" />
                <circle id="Ellipse_62277" data-name="Ellipse 62277" cx="0.56" cy="0.56" r="0.56" transform="translate(36.99 10.07)" fill="#969696" />
                <circle id="Ellipse_62278" data-name="Ellipse 62278" cx="0.56" cy="0.56" r="0.56" transform="translate(38.4 6.66)" fill="#969696" />
                <circle id="Ellipse_62279" data-name="Ellipse 62279" cx="0.56" cy="0.56" r="0.56" transform="translate(39.02 18.11)" fill="#969696" />
                <circle id="Ellipse_62280" data-name="Ellipse 62280" cx="0.56" cy="0.56" r="0.56" transform="translate(39.02 12.49)" fill="#969696" />
                <circle id="Ellipse_62281" data-name="Ellipse 62281" cx="0.56" cy="0.56" r="0.56" transform="translate(40.69 15.5)" fill="#969696" />
                <circle id="Ellipse_62282" data-name="Ellipse 62282" cx="0.56" cy="0.56" r="0.56" transform="translate(42.1 12.09)" fill="#969696" />
                <circle id="Ellipse_62283" data-name="Ellipse 62283" cx="0.56" cy="0.56" r="0.56" transform="translate(41.06 8.1)" fill="#969696" />
                <circle id="Ellipse_62284" data-name="Ellipse 62284" cx="0.56" cy="0.56" r="0.56" transform="translate(41.06 2.48)" fill="#969696" />
                <circle id="Ellipse_62285" data-name="Ellipse 62285" cx="0.56" cy="0.56" r="0.56" transform="translate(42.72 5.49)" fill="#969696" />
                <circle id="Ellipse_62286" data-name="Ellipse 62286" cx="0.56" cy="0.56" r="0.56" transform="translate(44.13 2.08)" fill="#969696" />
                <circle id="Ellipse_62287" data-name="Ellipse 62287" cx="0.56" cy="0.56" r="0.56" transform="translate(44.97 16.16)" fill="#969696" />
                <circle id="Ellipse_62288" data-name="Ellipse 62288" cx="0.56" cy="0.56" r="0.56" transform="translate(44.97 10.53)" fill="#969696" />
                <circle id="Ellipse_62289" data-name="Ellipse 62289" cx="0.56" cy="0.56" r="0.56" transform="translate(46.63 13.55)" fill="#969696" />
                <circle id="Ellipse_62290" data-name="Ellipse 62290" cx="0.56" cy="0.56" r="0.56" transform="translate(48.04 10.13)" fill="#969696" />
                <circle id="Ellipse_62291" data-name="Ellipse 62291" cx="0.56" cy="0.56" r="0.56" transform="translate(36.58 37.82)" fill="#969696" />
                <circle id="Ellipse_62292" data-name="Ellipse 62292" cx="0.56" cy="0.56" r="0.56" transform="translate(36.58 32.2)" fill="#969696" />
                <circle id="Ellipse_62293" data-name="Ellipse 62293" cx="0.56" cy="0.56" r="0.56" transform="translate(38.24 35.21)" fill="#969696" />
                <circle id="Ellipse_62294" data-name="Ellipse 62294" cx="0.56" cy="0.56" r="0.56" transform="translate(39.65 31.79)" fill="#969696" />
                <circle id="Ellipse_62295" data-name="Ellipse 62295" cx="0.56" cy="0.56" r="0.56" transform="translate(38.43 30.1)" fill="#969696" />
                <circle id="Ellipse_62296" data-name="Ellipse 62296" cx="0.56" cy="0.56" r="0.56" transform="translate(38.43 24.47)" fill="#969696" />
                <circle id="Ellipse_62297" data-name="Ellipse 62297" cx="0.56" cy="0.56" r="0.56" transform="translate(40.1 27.48)" fill="#969696" />
                <circle id="Ellipse_62298" data-name="Ellipse 62298" cx="0.56" cy="0.56" r="0.56" transform="translate(41.51 24.07)" fill="#969696" />
                <circle id="Ellipse_62299" data-name="Ellipse 62299" cx="0.56" cy="0.56" r="0.56" transform="translate(42.13 35.53)" fill="#969696" />
                <circle id="Ellipse_62300" data-name="Ellipse 62300" cx="0.56" cy="0.56" r="0.56" transform="translate(42.13 29.9)" fill="#969696" />
                <circle id="Ellipse_62301" data-name="Ellipse 62301" cx="0.56" cy="0.56" r="0.56" transform="translate(43.8 32.91)" fill="#969696" />
                <circle id="Ellipse_62302" data-name="Ellipse 62302" cx="0.56" cy="0.56" r="0.56" transform="translate(45.21 29.5)" fill="#969696" />
                <circle id="Ellipse_62303" data-name="Ellipse 62303" cx="0.56" cy="0.56" r="0.56" transform="translate(44.17 25.51)" fill="#969696" />
                <circle id="Ellipse_62304" data-name="Ellipse 62304" cx="0.56" cy="0.56" r="0.56" transform="translate(44.17 19.89)" fill="#969696" />
                <circle id="Ellipse_62305" data-name="Ellipse 62305" cx="0.56" cy="0.56" r="0.56" transform="translate(45.84 22.9)" fill="#969696" />
                <circle id="Ellipse_62306" data-name="Ellipse 62306" cx="0.56" cy="0.56" r="0.56" transform="translate(47.25 19.49)" fill="#969696" />
                <circle id="Ellipse_62307" data-name="Ellipse 62307" cx="0.56" cy="0.56" r="0.56" transform="translate(48.08 33.57)" fill="#969696" />
                <circle id="Ellipse_62308" data-name="Ellipse 62308" cx="0.56" cy="0.56" r="0.56" transform="translate(48.08 27.95)" fill="#969696" />
                <circle id="Ellipse_62309" data-name="Ellipse 62309" cx="0.56" cy="0.56" r="0.56" transform="translate(49.74 30.96)" fill="#969696" />
                <circle id="Ellipse_62310" data-name="Ellipse 62310" cx="0.56" cy="0.56" r="0.56" transform="translate(51.15 27.55)" fill="#969696" />
                <circle id="Ellipse_62311" data-name="Ellipse 62311" cx="0.56" cy="0.56" r="0.56" transform="translate(50.74 24.63)" fill="#969696" />
                <circle id="Ellipse_62312" data-name="Ellipse 62312" cx="0.56" cy="0.56" r="0.56" transform="translate(50.74 19.01)" fill="#969696" />
                <circle id="Ellipse_62313" data-name="Ellipse 62313" cx="0.56" cy="0.56" r="0.56" transform="translate(52.41 22.02)" fill="#969696" />
                <circle id="Ellipse_62314" data-name="Ellipse 62314" cx="0.56" cy="0.56" r="0.56" transform="translate(53.82 18.61)" fill="#969696" />
                <circle id="Ellipse_62315" data-name="Ellipse 62315" cx="0.56" cy="0.56" r="0.56" transform="translate(52.6 16.91)" fill="#969696" />
                <circle id="Ellipse_62316" data-name="Ellipse 62316" cx="0.56" cy="0.56" r="0.56" transform="translate(52.6 11.29)" fill="#969696" />
                <circle id="Ellipse_62317" data-name="Ellipse 62317" cx="0.56" cy="0.56" r="0.56" transform="translate(54.26 14.3)" fill="#969696" />
                <circle id="Ellipse_62318" data-name="Ellipse 62318" cx="0.56" cy="0.56" r="0.56" transform="translate(55.67 10.88)" fill="#969696" />
                <circle id="Ellipse_62319" data-name="Ellipse 62319" cx="0.56" cy="0.56" r="0.56" transform="translate(56.3 22.34)" fill="#969696" />
                <circle id="Ellipse_62320" data-name="Ellipse 62320" cx="0.56" cy="0.56" r="0.56" transform="translate(56.3 16.71)" fill="#969696" />
                <circle id="Ellipse_62321" data-name="Ellipse 62321" cx="0.56" cy="0.56" r="0.56" transform="translate(57.96 19.73)" fill="#969696" />
                <circle id="Ellipse_62322" data-name="Ellipse 62322" cx="0.56" cy="0.56" r="0.56" transform="translate(59.37 16.31)" fill="#969696" />
                <circle id="Ellipse_62323" data-name="Ellipse 62323" cx="0.56" cy="0.56" r="0.56" transform="translate(58.33 12.33)" fill="#969696" />
                <circle id="Ellipse_62324" data-name="Ellipse 62324" cx="0.56" cy="0.56" r="0.56" transform="translate(58.33 6.7)" fill="#969696" />
                <circle id="Ellipse_62325" data-name="Ellipse 62325" cx="0.56" cy="0.56" r="0.56" transform="translate(60 9.71)" fill="#969696" />
                <circle id="Ellipse_62326" data-name="Ellipse 62326" cx="0.56" cy="0.56" r="0.56" transform="translate(61.41 6.3)" fill="#969696" />
                <circle id="Ellipse_62327" data-name="Ellipse 62327" cx="0.56" cy="0.56" r="0.56" transform="translate(62.24 20.38)" fill="#969696" />
                <circle id="Ellipse_62328" data-name="Ellipse 62328" cx="0.56" cy="0.56" r="0.56" transform="translate(62.24 14.76)" fill="#969696" />
                <circle id="Ellipse_62329" data-name="Ellipse 62329" cx="0.56" cy="0.56" r="0.56" transform="translate(63.91 17.77)" fill="#969696" />
                <circle id="Ellipse_62330" data-name="Ellipse 62330" cx="0.56" cy="0.56" r="0.56" transform="translate(65.32 14.36)" fill="#969696" />
                <circle id="Ellipse_62331" data-name="Ellipse 62331" cx="0.56" cy="0.56" r="0.56" transform="translate(31.27 35.19)" fill="#969696" />
                <circle id="Ellipse_62332" data-name="Ellipse 62332" cx="0.56" cy="0.56" r="0.56" transform="translate(32.11 49.27)" fill="#969696" />
                <circle id="Ellipse_62333" data-name="Ellipse 62333" cx="0.56" cy="0.56" r="0.56" transform="translate(32.11 43.65)" fill="#969696" />
                <circle id="Ellipse_62334" data-name="Ellipse 62334" cx="0.56" cy="0.56" r="0.56" transform="translate(33.77 46.66)" fill="#969696" />
                <circle id="Ellipse_62335" data-name="Ellipse 62335" cx="0.56" cy="0.56" r="0.56" transform="translate(35.18 43.25)" fill="#969696" />
                <circle id="Ellipse_62336" data-name="Ellipse 62336" cx="0.56" cy="0.56" r="0.56" transform="translate(32.35 62.61)" fill="#969696" />
                <circle id="Ellipse_62337" data-name="Ellipse 62337" cx="0.56" cy="0.56" r="0.56" transform="translate(31.31 58.63)" fill="#969696" />
                <circle id="Ellipse_62338" data-name="Ellipse 62338" cx="0.56" cy="0.56" r="0.56" transform="translate(31.31 53)" fill="#969696" />
                <circle id="Ellipse_62339" data-name="Ellipse 62339" cx="0.56" cy="0.56" r="0.56" transform="translate(32.97 56.01)" fill="#969696" />
                <circle id="Ellipse_62340" data-name="Ellipse 62340" cx="0.56" cy="0.56" r="0.56" transform="translate(34.38 52.6)" fill="#969696" />
                <circle id="Ellipse_62341" data-name="Ellipse 62341" cx="0.56" cy="0.56" r="0.56" transform="translate(35.22 66.68)" fill="#969696" />
                <circle id="Ellipse_62342" data-name="Ellipse 62342" cx="0.56" cy="0.56" r="0.56" transform="translate(35.22 61.06)" fill="#969696" />
                <circle id="Ellipse_62343" data-name="Ellipse 62343" cx="0.56" cy="0.56" r="0.56" transform="translate(36.88 64.07)" fill="#969696" />
                <circle id="Ellipse_62344" data-name="Ellipse 62344" cx="0.56" cy="0.56" r="0.56" transform="translate(38.29 60.66)" fill="#969696" />
                <circle id="Ellipse_62345" data-name="Ellipse 62345" cx="0.56" cy="0.56" r="0.56" transform="translate(37.88 57.74)" fill="#969696" />
                <circle id="Ellipse_62346" data-name="Ellipse 62346" cx="0.56" cy="0.56" r="0.56" transform="translate(37.88 52.12)" fill="#969696" />
                <circle id="Ellipse_62347" data-name="Ellipse 62347" cx="0.56" cy="0.56" r="0.56" transform="translate(39.55 55.13)" fill="#969696" />
                <circle id="Ellipse_62348" data-name="Ellipse 62348" cx="0.56" cy="0.56" r="0.56" transform="translate(40.96 51.72)" fill="#969696" />
                <circle id="Ellipse_62349" data-name="Ellipse 62349" cx="0.56" cy="0.56" r="0.56" transform="translate(39.74 50.02)" fill="#969696" />
                <circle id="Ellipse_62350" data-name="Ellipse 62350" cx="0.56" cy="0.56" r="0.56" transform="translate(39.74 44.4)" fill="#969696" />
                <circle id="Ellipse_62351" data-name="Ellipse 62351" cx="0.56" cy="0.56" r="0.56" transform="translate(41.4 47.41)" fill="#969696" />
                <circle id="Ellipse_62352" data-name="Ellipse 62352" cx="0.56" cy="0.56" r="0.56" transform="translate(42.81 44)" fill="#969696" />
                <circle id="Ellipse_62353" data-name="Ellipse 62353" cx="0.56" cy="0.56" r="0.56" transform="translate(43.44 55.45)" fill="#969696" />
                <circle id="Ellipse_62354" data-name="Ellipse 62354" cx="0.56" cy="0.56" r="0.56" transform="translate(43.44 49.83)" fill="#969696" />
                <circle id="Ellipse_62355" data-name="Ellipse 62355" cx="0.56" cy="0.56" r="0.56" transform="translate(45.1 52.84)" fill="#969696" />
                <circle id="Ellipse_62356" data-name="Ellipse 62356" cx="0.56" cy="0.56" r="0.56" transform="translate(46.51 49.43)" fill="#969696" />
                <circle id="Ellipse_62357" data-name="Ellipse 62357" cx="0.56" cy="0.56" r="0.56" transform="translate(45.47 45.44)" fill="#969696" />
                <circle id="Ellipse_62358" data-name="Ellipse 62358" cx="0.56" cy="0.56" r="0.56" transform="translate(45.47 39.81)" fill="#969696" />
                <circle id="Ellipse_62359" data-name="Ellipse 62359" cx="0.56" cy="0.56" r="0.56" transform="translate(47.14 42.83)" fill="#969696" />
                <circle id="Ellipse_62360" data-name="Ellipse 62360" cx="0.56" cy="0.56" r="0.56" transform="translate(48.55 39.41)" fill="#969696" />
                <circle id="Ellipse_62361" data-name="Ellipse 62361" cx="0.56" cy="0.56" r="0.56" transform="translate(49.38 53.5)" fill="#969696" />
                <circle id="Ellipse_62362" data-name="Ellipse 62362" cx="0.56" cy="0.56" r="0.56" transform="translate(49.38 47.87)" fill="#969696" />
                <circle id="Ellipse_62363" data-name="Ellipse 62363" cx="0.56" cy="0.56" r="0.56" transform="translate(51.05 50.89)" fill="#969696" />
                <circle id="Ellipse_62364" data-name="Ellipse 62364" cx="0.56" cy="0.56" r="0.56" transform="translate(52.46 47.47)" fill="#969696" />
                <circle id="Ellipse_62365" data-name="Ellipse 62365" cx="0.56" cy="0.56" r="0.56" transform="translate(31.58 86.33)" fill="#969696" />
                <circle id="Ellipse_62366" data-name="Ellipse 62366" cx="0.56" cy="0.56" r="0.56" transform="translate(32.99 82.92)" fill="#969696" />
                <circle id="Ellipse_62367" data-name="Ellipse 62367" cx="0.56" cy="0.56" r="0.56" transform="translate(31.95 78.93)" fill="#969696" />
                <circle id="Ellipse_62368" data-name="Ellipse 62368" cx="0.56" cy="0.56" r="0.56" transform="translate(31.95 73.31)" fill="#969696" />
                <circle id="Ellipse_62369" data-name="Ellipse 62369" cx="0.56" cy="0.56" r="0.56" transform="translate(33.61 76.32)" fill="#969696" />
                <circle id="Ellipse_62370" data-name="Ellipse 62370" cx="0.56" cy="0.56" r="0.56" transform="translate(35.02 72.91)" fill="#969696" />
                <circle id="Ellipse_62371" data-name="Ellipse 62371" cx="0.56" cy="0.56" r="0.56" transform="translate(35.85 86.99)" fill="#969696" />
                <circle id="Ellipse_62372" data-name="Ellipse 62372" cx="0.56" cy="0.56" r="0.56" transform="translate(35.85 81.37)" fill="#969696" />
                <circle id="Ellipse_62373" data-name="Ellipse 62373" cx="0.56" cy="0.56" r="0.56" transform="translate(37.52 84.38)" fill="#969696" />
                <circle id="Ellipse_62374" data-name="Ellipse 62374" cx="0.56" cy="0.56" r="0.56" transform="translate(38.93 80.97)" fill="#969696" />
              </g>
            </g>
            <path
              id="Pipes-2"
              data-name="Pipes"
              d="M44.88,136.48h8.56a10.83,10.83,0,0,0,10.82-10.82V7.87H59.7v117.8a6.25,6.25,0,0,1-6.24,6.25H3v4.56H40.3V197.7h4.56v-6.64h257a10.81,10.81,0,0,0,10.82-10.81c0-42.77,0-172.58,0-172.58H308V180.26a6.24,6.24,0,0,1-6.24,6.24H44.88Z"
              fill="none"
              stroke="#969696"
              strokeWidth="1"
            />
            <g id="Membranes_Grey" data-name="Membranes Grey">
              <g id="Row4">
                <path
                  id="Path_12320"
                  data-name="Path 12320"
                  d="M319.5,104.89H306.56l-15.44-.8H80.97l-14.79.8H52.78V84.37h13.4l14.79.57H291.12l16.01-.57H319.5Z"
                  fill="#f8f8f8"
                  stroke="#969696"
                  strokeWidth="1"
                />
                <g id="Row4-2" data-name="Row4">
                  <rect
                    id="Rectangle_2539"
                    data-name="Rectangle 2539"
                    width="41.28"
                    height="16.26"
                    transform="translate(249.74 86.5)"
                    fill="#969696"
                  />
                  <path id="Path_12321" data-name="Path 12321" d="M290.77,86.75V102.5H250V86.75h40.78m.5-.5H249.49V103h41.78V86.25Z" fill="#969696" />
                  <rect
                    id="Rectangle_2540"
                    data-name="Rectangle 2540"
                    width="41.28"
                    height="16.26"
                    transform="translate(207.6 86.5)"
                    fill="#adadad"
                  />
                  <path id="Path_12322" data-name="Path 12322" d="M248.63,86.75V102.5H207.85V86.75h40.78m.5-.5H207.35V103h41.78Z" fill="#969696" />
                  <rect
                    id="Rectangle_2541"
                    data-name="Rectangle 2541"
                    width="41.28"
                    height="16.26"
                    transform="translate(165.41 86.5)"
                    fill="#c1c1c1"
                  />
                  <path id="Path_12323" data-name="Path 12323" d="M206.44,86.75V102.5H165.66V86.75h40.78m.5-.5H165.16V103h41.78Z" fill="#969696" />
                  <rect id="Rectangle_2542" data-name="Rectangle 2542" width="41.28" height="16.26" transform="translate(123.03 86.5)" fill="#ddd" />
                  <path id="Path_12324" data-name="Path 12324" d="M164.06,86.75V102.5H123.28V86.75h40.78m.5-.5H122.78V103h41.78Z" fill="#969696" />
                  <rect
                    id="Rectangle_2543"
                    data-name="Rectangle 2543"
                    width="41.28"
                    height="16.26"
                    transform="translate(80.63 86.5)"
                    fill="#f2f2f2"
                  />
                  <path id="Path_12325" data-name="Path 12325" d="M121.66,86.75V102.5H80.88V86.75h40.78m.5-.5H80.38V103h41.78Z" fill="#969696" />
                </g>
              </g>
              <g id="Row3">
                <path
                  id="Path_12326"
                  data-name="Path 12326"
                  d="M319.5,77.78H306.56l-15.44-.81H80.97l-14.79.81H52.78V57.25h13.4l14.79.58H291.12l16.01-.58H319.5Z"
                  fill="#f8f8f8"
                  stroke="#969696"
                  strokeWidth="1"
                />
                <g id="Row3-2" data-name="Row3">
                  <rect
                    id="Rectangle_2544"
                    data-name="Rectangle 2544"
                    width="41.28"
                    height="16.26"
                    transform="translate(80.66 59.42)"
                    fill="#f2f2f2"
                  />
                  <path id="Path_12327" data-name="Path 12327" d="M121.69,59.67V75.42H80.91V59.67h40.78m.5-.5H80.41V75.92h41.78Z" fill="#969696" />
                  <rect id="Rectangle_2545" data-name="Rectangle 2545" width="41.28" height="16.26" transform="translate(123.06 59.42)" fill="#ddd" />
                  <path id="Path_12328" data-name="Path 12328" d="M164.09,59.67V75.42H123.31V59.67h40.78m.5-.5H122.81V75.92h41.78Z" fill="#969696" />
                  <rect
                    id="Rectangle_2546"
                    data-name="Rectangle 2546"
                    width="41.11"
                    height="16.26"
                    transform="translate(165.44 59.42)"
                    fill="#c1c1c1"
                  />
                  <path id="Path_12329" data-name="Path 12329" d="M206.3,59.67V75.42H165.69V59.67H206.3m.5-.5H165.19V75.92H206.8Z" fill="#969696" />
                  <rect
                    id="Rectangle_2547"
                    data-name="Rectangle 2547"
                    width="41.11"
                    height="16.26"
                    transform="translate(207.62 59.42)"
                    fill="#adadad"
                  />
                  <path
                    id="Path_12330"
                    data-name="Path 12330"
                    d="M248.48,59.67V75.42H207.87V59.67h40.61m.5-.5H207.37V75.92H249V59.17Z"
                    fill="#969696"
                  />
                  <rect
                    id="Rectangle_2548"
                    data-name="Rectangle 2548"
                    width="41.11"
                    height="16.26"
                    transform="translate(249.77 59.42)"
                    fill="#969696"
                  />
                  <path
                    id="Path_12331"
                    data-name="Path 12331"
                    d="M290.63,59.67V75.42H250V59.67h40.61m.5-.5H249.52V75.92h41.61V59.17Z"
                    fill="#969696"
                  />
                </g>
              </g>
              <g id="Row2">
                <path
                  id="Path_12332"
                  data-name="Path 12332"
                  d="M319.5,50.66H306.56l-15.44-.8H80.97l-14.79.8H52.78V30.14h13.4l14.79.57H291.12l16.01-.57H319.5Z"
                  fill="#f8f8f8"
                  stroke="#969696"
                  strokeWidth="1"
                />
                <g id="Row2-2" data-name="Row2">
                  <rect
                    id="Rectangle_2549"
                    data-name="Rectangle 2549"
                    width="41.28"
                    height="16.26"
                    transform="translate(80.69 32.23)"
                    fill="#f2f2f2"
                  />
                  <path id="Path_12333" data-name="Path 12333" d="M121.72,32.48V48.23H80.94V32.48h40.78m.5-.5H80.44V48.73h41.78V32Z" fill="#969696" />
                  <rect id="Rectangle_2550" data-name="Rectangle 2550" width="41.28" height="16.26" transform="translate(123.09 32.23)" fill="#ddd" />
                  <path
                    id="Path_12334"
                    data-name="Path 12334"
                    d="M164.12,32.48V48.23H123.34V32.48h40.78m.5-.5H122.84V48.73h41.78V32Z"
                    fill="#969696"
                  />
                  <rect
                    id="Rectangle_2551"
                    data-name="Rectangle 2551"
                    width="41.11"
                    height="16.26"
                    transform="translate(165.47 32.23)"
                    fill="#c1c1c1"
                  />
                  <path
                    id="Path_12335"
                    data-name="Path 12335"
                    d="M206.33,32.48V48.23H165.72V32.48h40.61m.5-.5H165.22V48.73h41.61V32Z"
                    fill="#969696"
                  />
                  <rect
                    id="Rectangle_2552"
                    data-name="Rectangle 2552"
                    width="41.11"
                    height="16.26"
                    transform="translate(207.65 32.23)"
                    fill="#adadad"
                  />
                  <path id="Path_12336" data-name="Path 12336" d="M248.51,32.48V48.23H207.9V32.48h40.61m.5-.5H207.4V48.73H249V32Z" fill="#969696" />
                  <rect
                    id="Rectangle_2553"
                    data-name="Rectangle 2553"
                    width="41.11"
                    height="16.26"
                    transform="translate(249.8 32.23)"
                    fill="#969696"
                  />
                  <path
                    id="Path_12337"
                    data-name="Path 12337"
                    d="M290.66,32.48V48.23H250.05V32.48h40.61m.5-.5H249.55V48.73h41.61V32Z"
                    fill="#969696"
                  />
                </g>
              </g>
              <g id="Row1">
                <path
                  id="Path_12338"
                  data-name="Path 12338"
                  d="M319.5,23.55H306.56l-15.44-.8H80.97l-14.79.8H52.78V3.03h13.4l14.79.57H291.12l16.01-.57H319.5Z"
                  fill="#f8f8f8"
                  stroke="#969696"
                  strokeWidth="1"
                />
                <g id="Row1-2" data-name="Row1">
                  <rect
                    id="Rectangle_2554"
                    data-name="Rectangle 2554"
                    width="41.28"
                    height="16.26"
                    transform="translate(81.03 5.07)"
                    fill="#f2f2f2"
                  />
                  <path id="Path_12339" data-name="Path 12339" d="M122.06,5.32V21.08H81.28V5.32h40.78m.5-.5H80.78V21.58h41.78Z" fill="#969696" />
                  <rect id="Rectangle_2555" data-name="Rectangle 2555" width="41.28" height="16.26" transform="translate(123.43 5.07)" fill="#ddd" />
                  <path id="Path_12340" data-name="Path 12340" d="M164.46,5.32V21.08H123.68V5.32h40.78m.5-.5H123.18V21.58H165V4.82Z" fill="#969696" />
                  <rect
                    id="Rectangle_2556"
                    data-name="Rectangle 2556"
                    width="41.11"
                    height="16.26"
                    transform="translate(165.81 5.07)"
                    fill="#c1c1c1"
                  />
                  <path id="Path_12341" data-name="Path 12341" d="M206.67,5.32V21.08H166.06V5.32h40.61m.5-.5H165.56V21.58h41.61Z" fill="#969696" />
                  <rect id="Rectangle_2557" data-name="Rectangle 2557" width="41.11" height="16.26" transform="translate(208 5.07)" fill="#adadad" />
                  <path id="Path_12342" data-name="Path 12342" d="M248.85,5.32V21.08h-40.6V5.32h40.6m.5-.5h-41.6V21.58h41.6Z" fill="#969696" />
                  <rect
                    id="Rectangle_2558"
                    data-name="Rectangle 2558"
                    width="41.11"
                    height="16.26"
                    transform="translate(250.14 5.07)"
                    fill="#969696"
                  />
                  <path id="Path_12343" data-name="Path 12343" d="M291,5.32V21.08H250.39V5.32H291m.5-.5H249.89V21.58H291.5Z" fill="#969696" />
                </g>
              </g>
            </g>
            <g id="Device_01" data-name="Device 01">
              <rect
                id="Rectangle_2559"
                data-name="Rectangle 2559"
                width="10.9"
                height="6.4"
                transform="translate(10.88 64.63)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <path id="Path_12344" data-name="Path 12344" d="M27.45,38.61H5.2V32.88l1.76-2.2H25.69l1.76,2.2Z" fill="#969696" />
              <rect
                id="Rectangle_2560"
                data-name="Rectangle 2560"
                width="17.8"
                height="64.93"
                transform="translate(7.42 73.25)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2561"
                data-name="Rectangle 2561"
                width="3.83"
                height="7.15"
                transform="translate(2.38 46.94)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2562"
                data-name="Rectangle 2562"
                width="19.9"
                height="21.22"
                transform="translate(6.38 38.12)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <path id="Path_12345" data-name="Path 12345" d="M5.85,59.78H26.8l-1.47,3.03H7.32Z" fill="#969696" />
              <rect
                id="Rectangle_2563"
                data-name="Rectangle 2563"
                width="15.71"
                height="2.09"
                transform="translate(8.52 62.46)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2564"
                data-name="Rectangle 2564"
                width="19.9"
                height="2.09"
                transform="translate(6.42 71.14)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2565"
                data-name="Rectangle 2565"
                width="17.8"
                height="5.64"
                transform="translate(7.42 139.1)"
                fill="#fff"
                stroke="#969696"
                strokeWidth="1"
              />
              <line id="Line_255" data-name="Line 255" y2="56.97" transform="translate(9.93 73.15)" fill="none" stroke="#969696" strokeWidth="1" />
              <line id="Line_256" data-name="Line 256" y2="56.97" transform="translate(22.73 73.15)" fill="none" stroke="#969696" strokeWidth="1" />
              <path
                id="Path_12346"
                data-name="Path 12346"
                d="M29.09,125.34v6.13H25.67v-1.73H6.98v1.73H3.51v-6.13H0v17.81H3.51v-6.13H6.98v1.73H25.67v-1.73h3.42v6.13h3.52V125.34Z"
                fill="#969696"
              />
              <line id="Line_257" data-name="Line 257" y2="10.41" transform="translate(9.93 129.71)" fill="none" stroke="#fff" strokeWidth="1" />
              <line id="Line_258" data-name="Line 258" y2="10.41" transform="translate(22.73 129.71)" fill="none" stroke="#fff" strokeWidth="1" />
            </g>
            <g id="Device_02" data-name="Device 02">
              <rect
                id="Rectangle_2566"
                data-name="Rectangle 2566"
                width="10.9"
                height="6.4"
                transform="translate(174.93 154.47)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <path id="Path_12347" data-name="Path 12347" d="M191.5,128.44H169.25v-5.73l1.76-2.2h18.73l1.76,2.2Z" fill="#969696" />
              <rect
                id="Rectangle_2567"
                data-name="Rectangle 2567"
                width="17.8"
                height="36.37"
                transform="translate(171.48 163.08)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2568"
                data-name="Rectangle 2568"
                width="3.83"
                height="7.15"
                transform="translate(166.43 136.78)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2569"
                data-name="Rectangle 2569"
                width="19.9"
                height="21.22"
                transform="translate(170.43 127.95)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <path id="Path_12348" data-name="Path 12348" d="M169.91,149.61h20.94l-1.47,3.04H171.37Z" fill="#969696" />
              <rect
                id="Rectangle_2570"
                data-name="Rectangle 2570"
                width="15.71"
                height="2.09"
                transform="translate(172.57 152.29)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2571"
                data-name="Rectangle 2571"
                width="19.9"
                height="2.09"
                transform="translate(170.48 160.98)"
                fill="#f8f8f8"
                stroke="#969696"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_2572"
                data-name="Rectangle 2572"
                width="17.8"
                height="5.64"
                transform="translate(171.48 193.84)"
                fill="#fff"
                stroke="#969696"
                strokeWidth="1"
              />
              <line id="Line_259" data-name="Line 259" y2="21.26" transform="translate(173.99 162.98)" fill="none" stroke="#969696" strokeWidth="1" />
              <line id="Line_260" data-name="Line 260" y2="21.26" transform="translate(186.78 162.98)" fill="none" stroke="#969696" strokeWidth="1" />
              <path
                id="Path_12349"
                data-name="Path 12349"
                d="M193.15,179.86v6.19h-3.43v-1.8H171.04v1.8h-3.47v-6.19h-3.52v17.81h3.52v-6.19h3.47v1.8h18.68v-1.8h3.43v6.19h3.51V179.86Z"
                fill="#969696"
              />
              <line id="Line_261" data-name="Line 261" y2="10.25" transform="translate(173.99 184.3)" fill="none" stroke="#fff" strokeWidth="1" />
              <line id="Line_262" data-name="Line 262" y2="10.25" transform="translate(186.78 184.3)" fill="none" stroke="#fff" strokeWidth="1" />
            </g>
            <g id="Joint_01" data-name="Joint 01">
              <path id="Path_12350" data-name="Path 12350" d="M35.21,174.51v4.33h3.72v6.14h6.81v-6.14h3.88v-4.33Z" fill="#969696" />
              <path id="Path_12351" data-name="Path 12351" d="M45.74,198.17v-4.71H38.93v4.71H35.21v4.33H49.62v-4.33Z" fill="#969696" />
              <path id="Path_12352" data-name="Path 12352" d="M51.13,181.12v3.78h-4v6.85h4v3.78h4.33V181.12Z" fill="#969696" />
              <rect
                id="Rectangle_2573"
                data-name="Rectangle 2573"
                width="14.4"
                height="10.63"
                transform="translate(47.73 181.12) rotate(90)"
                fill="#969696"
                stroke="#f8f8f8"
                strokeWidth="1"
              />
            </g>
            <path id="Joint_02" data-name="Joint 02" d="M48.44,130.68H36.75v6.87h3.06v2.12h5.57v-2.12h3.06Z" fill="#969696" />
            <g id="Curved_Joint" data-name="Curved Joint">
              <path
                id="Path_12353"
                data-name="Path 12353"
                d="M299.09,192.13v-6.6h2.43v.5h0a5.92,5.92,0,0,0,5.91-5.92v-.25h-.4v-2.43h6.6v2.43h-.35v.24a11.63,11.63,0,0,1-11.62,11.61h-.18v.42Z"
                fill="#969696"
              />
              <path
                id="Path_12354"
                data-name="Path 12354"
                d="M313.17,177.93v1.43h-.36v.74a11.11,11.11,0,0,1-11.12,11.11H301v.42h-1.43V186H301v.5h.54a6.42,6.42,0,0,0,6.41-6.42v-.75h-.39V177.9h5.6m1-1h-7.6v3.43h.4a5.42,5.42,0,0,1-5,5.15V185h-3.43v7.6H302v-.42a12.14,12.14,0,0,0,11.8-11.85h.35V176.9Z"
                fill="#969696"
              />
            </g>
            <g id="Curved_Joint_02" data-name="Curved Joint 02">
              <path
                id="Path_12355"
                data-name="Path 12355"
                d="M50.68,137.35v-6.6h2.43v.49h0a5.91,5.91,0,0,0,5.91-5.91v-.25h-.4v-2.44h6.6v2.44H64.9v.23a11.64,11.64,0,0,1-11.62,11.62H53.1v.42Z"
                fill="#969696"
              />
              <path
                id="Path_12356"
                data-name="Path 12356"
                d="M64.76,123.14v1.44H64.4v.73a11.12,11.12,0,0,1-11.12,11.12H52.6v.41H51.18v-5.59h1.43v.49h.54a6.41,6.41,0,0,0,6.41-6.41v-.75h-.39v-1.44h5.6m1-1h-7.6v3.44h.39a5.42,5.42,0,0,1-4.94,5.14v-.47H50.18v7.59h3.43v-.42A12.12,12.12,0,0,0,65.4,125.58h.36v-3.44Z"
                fill="#969696"
              />
            </g>
          </g>
        </g>
        <g id="Status_Locked" transform="translate(738.302 90)">
          <g id="Group_17415" data-name="Group 17415">
            <circle
              id="Ellipse_247781"
              data-name="Ellipse 247781"
              cx="38.604"
              cy="38.604"
              r="38.604"
              transform="translate(1.245 1.245)"
              fill="#f8f8f8"
              stroke="#969696"
              strokeWidth="1"
            />
          </g>
          <path
            id="Path_15844"
            data-name="Path 15844"
            d="M12.749,47.849A2.807,2.807,0,0,1,9.91,45.01v-20.6a2.807,2.807,0,0,1,2.839-2.839h3.312V17.016A8.629,8.629,0,0,1,18.7,10.64,8.725,8.725,0,0,1,25.078,8a8.629,8.629,0,0,1,6.376,2.64,8.725,8.725,0,0,1,2.64,6.376v4.558h3.312a2.807,2.807,0,0,1,2.839,2.839v20.6a2.807,2.807,0,0,1-2.839,2.839Zm0-2.839H37.406v-20.6H12.749Zm12.328-6.65a3.571,3.571,0,0,0,2.59-1.046A3.372,3.372,0,0,0,28.739,34.8a3.659,3.659,0,0,0-1.071-2.59,3.451,3.451,0,0,0-5.18,0,3.7,3.7,0,0,0-1.071,2.59,3.411,3.411,0,0,0,1.071,2.515,3.571,3.571,0,0,0,2.59,1.046ZM18.9,21.574H31.229V17.016a6.123,6.123,0,0,0-6.152-6.152,6.123,6.123,0,0,0-6.152,6.152v4.558ZM12.724,45.01Z"
            transform="translate(14.772 11.925)"
            fill="#969696"
          />
        </g>
      </g>
    </svg>
  </span>
);

export default NoSystemAccessIcon;
